/* eslint-disable */
import require$$0, {useRef, useState, useImperativeHandle, useEffect} from 'react'

function I() {}
function We(l, e) {
  for (const t in e) l[t] = e[t]
  return /** @type {T & S} */ l
}
function co(l) {
  return l()
}
function Tl() {
  return /* @__PURE__ */ Object.create(null)
}
function Ee(l) {
  l.forEach(co)
}
function ot(l) {
  return typeof l == 'function'
}
function x(l, e) {
  return l != l ? e == e : l !== e || (l && typeof l == 'object') || typeof l == 'function'
}
function Wr(l) {
  return Object.keys(l).length === 0
}
function Lt(l) {
  for (
    var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1;
    _key < _len;
    _key++
  ) {
    e[_key - 1] = arguments[_key]
  }
  if (l == null) {
    for (const n of e) n(void 0)
    return I
  }
  const t = l.subscribe(...e)
  return t.unsubscribe ? () => t.unsubscribe() : t
}
function ce(l, e, t) {
  l.$$.on_destroy.push(Lt(e, t))
}
function Ie(l, e, t, n) {
  if (l) {
    const i = uo(l, e, t, n)
    return l[0](i)
  }
}
function uo(l, e, t, n) {
  return l[1] && n ? We(t.ctx.slice(), l[1](n(e))) : t.ctx
}
function Re(l, e, t, n) {
  if (l[2] && n) {
    const i = l[2](n(t))
    if (e.dirty === void 0) return i
    if (typeof i == 'object') {
      const s = [],
        o = Math.max(e.dirty.length, i.length)
      for (let a = 0; a < o; a += 1) s[a] = e.dirty[a] | i[a]
      return s
    }
    return e.dirty | i
  }
  return e.dirty
}
function Oe(l, e, t, n, i, s) {
  if (i) {
    const o = uo(e, t, n, s)
    l.p(o, i)
  }
}
function Ae(l) {
  if (l.ctx.length > 32) {
    const e = [],
      t = l.ctx.length / 32
    for (let n = 0; n < t; n++) e[n] = -1
    return e
  }
  return -1
}
function qe(l) {
  const e = {}
  for (const t in l) t[0] !== '$' && (e[t] = l[t])
  return e
}
function Ve(l) {
  return l ?? ''
}
function Cl(l, e, t) {
  return l.set(t), e
}
function nt(l) {
  return l && ot(l.destroy) ? l.destroy : I
}
function H(l, e) {
  l.appendChild(e)
}
function S(l, e, t) {
  l?.insertBefore(e, t || null)
}
function v(l) {
  l.parentNode && l.parentNode.removeChild(l)
}
function $e(l, e) {
  for (let t = 0; t < l.length; t += 1) l[t] && l[t].d(e)
}
function D(l) {
  return document.createElement(l)
}
function ll(l) {
  return document.createElementNS('http://www.w3.org/2000/svg', l)
}
// Helper function to convert React element to DOM node
function reactElementToDOMNode(element) {
  if (!element) return null

  // Convert React element to HTML string using a utility function
  const renderToString = require('react-dom/server').renderToString
  const htmlString = renderToString(element)

  // Parse the HTML string to DOM
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  return doc.body.firstChild
}

// Update re() function to be synchronous
function re(l) {
  // Handle direct HTML/React element objects
  if (l && typeof l === 'object') {
    if (l.type) {
      return reactElementToDOMNode(l)
    }
  }

  // Handle HTML strings
  if (typeof l === 'string') {
    const parser = new DOMParser()
    const doc = parser.parseFromString(l, 'text/html')

    return doc.body.children.length > 0
      ? doc.body.firstChild // Return first parsed element
      : document.createTextNode(l) // Fallback for plain text
  }

  // Fallback for other cases
  return document.createTextNode(String(l))
}
function Y() {
  return re(' ')
}
function se() {
  return re('')
}
function q(l, e, t, n) {
  return l.addEventListener(e, t, n), () => l.removeEventListener(e, t, n)
}
function En(l) {
  return function (e) {
    return e.stopPropagation(), l.call(this, e)
  }
}
function g(l, e, t) {
  t == null ? l?.removeAttribute(e) : l?.getAttribute(e) !== t && l?.setAttribute(e, t)
}
function il(l) {
  return l === '' ? null : +l
}
function Hr(l) {
  return Array.from(l.childNodes)
}
function me(l, e) {
  ;(e = '' + e), l.data !== e && (l.data = /** @type {string} */ e)
}
function Ue(l, e) {
  l.value = e ?? ''
}
function j(l, e, t, n) {
  t == null ? l?.style?.removeProperty(e) : l?.style?.setProperty(e, t, '')
}
let yn
function zr() {
  if (yn === void 0) {
    yn = !1
    try {
      typeof window < 'u' && window.parent && window.parent.document
    } catch {
      yn = !0
    }
  }
  return yn
}
function sl(l, e) {
  getComputedStyle(l).position === 'static' && (l.style.position = 'relative')
  const n = D('iframe')
  n.setAttribute(
    'style',
    'display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;'
  ),
    n.setAttribute('aria-hidden', 'true'),
    (n.tabIndex = -1)
  const i = zr()
  let s
  return (
    i
      ? ((n.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}</script>"),
        (s = q(
          window,
          'message',
          /** @param {MessageEvent} event */ (o) => {
            o.source === n.contentWindow && e()
          }
        )))
      : ((n.src = 'about:blank'),
        (n.onload = () => {
          ;(s = q(n.contentWindow, 'resize', e)), e()
        })),
    H(l, n),
    () => {
      ;(i || (s && n.contentWindow)) && s(), v(n)
    }
  )
}
function Q(l, e, t) {
  l?.classList?.toggle(e, !!t)
}
function Nr(l, e) {
  let {bubbles: t = !1, cancelable: n = !1} =
    arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
  return new CustomEvent(l, {detail: e, bubbles: t, cancelable: n})
}
class ol {
  /**
   * @private
   * @default false
   */ is_svg = (() => !1)()
  /** parent for creating node */ e = (() => void 0)()
  /** html tag nodes */ n = (() => void 0)()
  /** target */ t = (() => void 0)()
  /** anchor */ a = (() => void 0)()
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1
    ;(this.is_svg = e), (this.e = this.n = null)
  }
  /**
   * @param {string} html
   * @returns {void}
   */ c(e) {
    this.h(e)
  }
  /**
   * @param {string} html
   * @param {HTMLElement | SVGElement} target
   * @param {HTMLElement | SVGElement} anchor
   * @returns {void}
   */ m(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null
    this.e ||
      (this.is_svg
        ? (this.e = ll(/** @type {keyof SVGElementTagNameMap} */ t.nodeName))
        : (this.e = D(
            /** @type {keyof HTMLElementTagNameMap} */ t.nodeType === 11 ? 'TEMPLATE' : t.nodeName
          )),
      (this.t = t.tagName !== 'TEMPLATE' ? t : /** @type {HTMLTemplateElement} */ t.content),
      this.c(e)),
      this.i(n)
  }
  /**
   * @param {string} html
   * @returns {void}
   */ h(e) {
    ;(this.e.innerHTML = e),
      (this.n = Array.from(
        this.e.nodeName === 'TEMPLATE' ? this.e.content.childNodes : this.e.childNodes
      ))
  }
  /**
   * @returns {void} */ i(e) {
    for (let t = 0; t < this.n.length; t += 1) S(this.t, this.n[t], e)
  }
  /**
   * @param {string} html
   * @returns {void}
   */ p(e) {
    this.d(), this.h(e), this.i(this.a)
  }
  /**
   * @returns {void} */ d() {
    this.n.forEach(v)
  }
}
function Le(l, e) {
  return new l(e)
}
let dn
function cn(l) {
  dn = l
}
function $t() {
  if (!dn) throw new Error('Function called outside component initialization')
  return dn
}
function ht(l) {
  $t().$$.on_mount.push(l)
}
function kn(l) {
  $t().$$.after_update.push(l)
}
function rl(l) {
  $t().$$.on_destroy.push(l)
}
function He() {
  const l = $t()
  return function (e, t) {
    let {cancelable: n = !1} =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
    const i = l.$$.callbacks[e]
    if (i) {
      const s = Nr(/** @type {string} */ e, t, {cancelable: n})
      return (
        i.slice().forEach((o) => {
          o.call(l, s)
        }),
        !s.defaultPrevented
      )
    }
    return !0
  }
}
function It(l, e) {
  return $t().$$.context.set(l, e), e
}
function ze(l) {
  return $t().$$.context.get(l)
}
function De(l, e) {
  const t = l.$$.callbacks[e.type]
  t && t.slice().forEach((n) => n.call(this, e))
}
const qt = [],
  be = []
let Gt = []
const Gn = [],
  fo = /* @__PURE__ */ Promise.resolve()
let Xn = !1
function ho() {
  Xn || ((Xn = !0), fo.then(mo))
}
function Dn() {
  return ho(), fo
}
function Vt(l) {
  Gt.push(l)
}
function dt(l) {
  Gn.push(l)
}
const Bn = /* @__PURE__ */ new Set()
let Yt = 0
function mo() {
  if (Yt !== 0) return
  const l = dn
  do {
    try {
      for (; Yt < qt.length; ) {
        const e = qt[Yt]
        Yt++, cn(e), Lr(e.$$)
      }
    } catch (e) {
      throw ((qt.length = 0), (Yt = 0), e)
    }
    for (cn(null), qt.length = 0, Yt = 0; be.length; ) be.pop()()
    for (let e = 0; e < Gt.length; e += 1) {
      const t = Gt[e]
      Bn.has(t) || (Bn.add(t), t())
    }
    Gt.length = 0
  } while (qt.length)
  for (; Gn.length; ) Gn.pop()()
  ;(Xn = !1), Bn.clear(), cn(l)
}
function Lr(l) {
  if (l.fragment !== null) {
    l.update(), Ee(l.before_update)
    const e = l.dirty
    ;(l.dirty = [-1]), l.fragment && l.fragment.p(l.ctx, e), l.after_update.forEach(Vt)
  }
}
function Er(l) {
  const e = [],
    t = []
  Gt.forEach((n) => (l.indexOf(n) === -1 ? e.push(n) : t.push(n))), t.forEach((n) => n()), (Gt = e)
}
const Cn = /* @__PURE__ */ new Set()
let Et
function te() {
  Et = {
    r: 0,
    c: [],
    p: Et, // parent group
  }
}
function ne() {
  Et.r || Ee(Et.c), (Et = Et.p)
}
function k(l, e) {
  l && l.i && (Cn.delete(l), l.i(e))
}
function y(l, e, t, n) {
  if (l && l.o) {
    if (Cn.has(l)) return
    Cn.add(l),
      Et.c.push(() => {
        Cn.delete(l), n && (t && l.d(1), n())
      }),
      l.o(e)
  } else n && n()
}
function de(l) {
  return l?.length !== void 0 ? l : Array.from(l)
}
function al(l, e) {
  l.d(1), e.delete(l.key)
}
function en(l, e) {
  y(l, 1, 1, () => {
    e.delete(l.key)
  })
}
function kt(l, e, t, n, i, s, o, a, r, c, u, f) {
  let d = l.length,
    h = s.length,
    m = d
  const _ = {}
  for (; m--; ) _[l[m].key] = m
  const w = [],
    b = /* @__PURE__ */ new Map(),
    p = /* @__PURE__ */ new Map(),
    z = []
  for (m = h; m--; ) {
    const C = f(i, s, m),
      P = t(C)
    let X = o.get(P)
    X ? z.push(() => X.p(C, e)) : ((X = c(P, C)), X.c()),
      b.set(P, (w[m] = X)),
      P in _ && p.set(P, Math.abs(m - _[P]))
  }
  const T = /* @__PURE__ */ new Set(),
    W = /* @__PURE__ */ new Set()
  function M(C) {
    k(C, 1), C.m(a, u), o.set(C.key, C), (u = C.first), h--
  }
  for (; d && h; ) {
    const C = w[h - 1],
      P = l[d - 1],
      X = C.key,
      A = P.key
    C === P
      ? ((u = C.first), d--, h--)
      : b.has(A)
      ? !o.has(X) || T.has(X)
        ? M(C)
        : W.has(A)
        ? d--
        : p.get(X) > p.get(A)
        ? (W.add(X), M(C))
        : (T.add(A), d--)
      : (r(P, o), d--)
  }
  for (; d--; ) {
    const C = l[d]
    b.has(C.key) || r(C, o)
  }
  for (; h; ) M(w[h - 1])
  return Ee(z), w
}
function Ut(l, e) {
  const t = {},
    n = {},
    i = {$$scope: 1}
  let s = l.length
  for (; s--; ) {
    const o = l[s],
      a = e[s]
    if (a) {
      for (const r in o) r in a || (n[r] = 1)
      for (const r in a) i[r] || ((t[r] = a[r]), (i[r] = 1))
      l[s] = a
    } else for (const r in o) i[r] = 1
  }
  for (const o in n) o in t || (t[o] = void 0)
  return t
}
function Jt(l) {
  return typeof l == 'object' && l !== null ? l : {}
}
function rt(l, e, t) {
  const n = l.$$.props[e]
  n !== void 0 && ((l.$$.bound[n] = t), t(l.$$.ctx[n]))
}
function F(l) {
  l && l.c()
}
function R(l, e, t) {
  const {fragment: n, after_update: i} = l.$$
  n && n.m(e, t),
    Vt(() => {
      const s = l.$$.on_mount.map(co).filter(ot)
      l.$$.on_destroy ? l.$$.on_destroy.push(...s) : Ee(s), (l.$$.on_mount = [])
    }),
    i.forEach(Vt)
}
function O(l, e) {
  const t = l.$$
  t.fragment !== null &&
    (Er(t.after_update),
    Ee(t.on_destroy),
    t.fragment && t.fragment.d(e),
    (t.on_destroy = t.fragment = null),
    (t.ctx = []))
}
function Ir(l, e) {
  l.$$.dirty[0] === -1 && (qt.push(l), ho(), l.$$.dirty.fill(0)),
    (l.$$.dirty[(e / 31) | 0] |= 1 << e % 31)
}
function $(l, e, t, n, i, s) {
  let o = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null
  let a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [-1]
  const r = dn
  cn(l)
  const c = (l.$$ = {
    fragment: null,
    ctx: [], // state
    props: s,
    update: I,
    not_equal: i,
    bound: Tl(), // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (r ? r.$$.context : [])), // everything else
    callbacks: Tl(),
    dirty: a,
    skip_bound: !1,
    root: e.target || r.$$.root,
  })
  o && o(c.root)
  let u = !1
  if (
    ((c.ctx = t
      ? t(l, e.props || {}, function (f, d) {
          const m = (arguments.length <= 2 ? 0 : arguments.length - 2)
            ? arguments.length <= 2
              ? undefined
              : arguments[2]
            : d
          return (
            c.ctx &&
              i(c.ctx[f], (c.ctx[f] = m)) &&
              (!c.skip_bound && c.bound[f] && c.bound[f](m), u && Ir(l, f)),
            d
          )
        })
      : []),
    c.update(),
    (u = !0),
    Ee(c.before_update),
    (c.fragment = n ? n(c.ctx) : !1),
    e.target)
  ) {
    if (e.hydrate) {
      const f = Hr(e.target)
      c.fragment && c.fragment.l(f), f.forEach(v)
    } else c.fragment && c.fragment.c()
    e.intro && k(l.$$.fragment), R(l, e.target, e.anchor), mo()
  }
  cn(r)
}
class ee {
  /**
   * ### PRIVATE API
   *
   * Do not use, may change at any time
   *
   * @type {any}
   */ $$ = (() => void 0)()
  /**
   * ### PRIVATE API
   *
   * Do not use, may change at any time
   *
   * @type {any}
   */ $$set = (() => void 0)()
  /** @returns {void} */ $destroy() {
    O(this, 1), (this.$destroy = I)
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */ $on(e, t) {
    if (!ot(t)) return I
    const n = this.$$.callbacks[e] || (this.$$.callbacks[e] = [])
    return (
      n.push(t),
      () => {
        const i = n.indexOf(t)
        i !== -1 && n.splice(i, 1)
      }
    )
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */ $set(e) {
    this.$$set && !Wr(e) && ((this.$$.skip_bound = !0), this.$$set(e), (this.$$.skip_bound = !1))
  }
}
const Rr = '4'
typeof window < 'u' &&
  (window.__svelte || (window.__svelte = {v: /* @__PURE__ */ new Set()})).v.add(Rr)
const Bt = []
function cl(l) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : I
  let t
  const n = /* @__PURE__ */ new Set()
  function i(a) {
    if (x(l, a) && ((l = a), t)) {
      const r = !Bt.length
      for (const c of n) c[1](), Bt.push(c, l)
      if (r) {
        for (let c = 0; c < Bt.length; c += 2) Bt[c][0](Bt[c + 1])
        Bt.length = 0
      }
    }
  }
  function s(a) {
    i(a(l))
  }
  function o(a) {
    let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : I
    const c = [a, r]
    return (
      n.add(c),
      n.size === 1 && (t = e(i, s) || I),
      a(l),
      () => {
        n.delete(c), n.size === 0 && t && (t(), (t = null))
      }
    )
  }
  return {set: i, update: s, subscribe: o}
}
function wt(l) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data-id'
  let t = l
  for (!t.tagName && l.target && (t = l.target); t; ) {
    if (t.getAttribute && t.getAttribute(e)) return t
    t = t.parentNode
  }
  return null
}
function Or(l) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data-id'
  const t = wt(l, e)
  return t ? t.getAttribute(e) : null
}
function hn(l) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data-id'
  const t = wt(l, e)
  return t ? ul(t.getAttribute(e)) : null
}
function ul(l) {
  if (typeof l == 'string') {
    const e = l * 1
    if (!isNaN(e)) return e
  }
  return l
}
function Dl(l, e, t) {
  function n(i) {
    const s = wt(i)
    if (!s) return
    const o = ul(s.dataset.id)
    if (typeof e == 'function') return e(o, i)
    let a,
      r = i.target
    for (; r != s; ) {
      if (((a = r.dataset ? r.dataset.action : null), a && e[a])) {
        e[a](o, i)
        return
      }
      r = r.parentNode
    }
    e[t] && e[t](o, i)
  }
  l.addEventListener(t, n)
}
function In(l, e) {
  Dl(l, e, 'click'), e.dblclick && Dl(l, e.dblclick, 'dblclick')
}
function Ar(l, e) {
  for (let t = l.length - 1; t >= 0; t--)
    if (l[t] === e) {
      l.splice(t, 1)
      break
    }
}
let _o = /* @__PURE__ */ new Date(),
  Wn = !1
const Tt = [],
  Wl = (l) => {
    if (Wn) {
      Wn = !1
      return
    }
    for (let e = Tt.length - 1; e >= 0; e--) {
      const {node: t, date: n, props: i} = Tt[e]
      if (
        !(n > _o) &&
        !t.contains(l.target) &&
        t !== l.target &&
        (i.callback && i.callback(l), i.modal || l.defaultPrevented)
      )
        break
    }
  },
  Hl = ['click', 'contextmenu'],
  Fr = (l) => {
    ;(_o = /* @__PURE__ */ new Date()), (Wn = !0)
    for (let e = Tt.length - 1; e >= 0; e--) {
      const {node: t} = Tt[e]
      if (!t.contains(l.target) && t !== l.target) {
        Wn = !1
        break
      }
    }
  }
function Rn(l, e) {
  Tt.length ||
    (Hl.forEach((n) => document.addEventListener(n, Wl)),
    document.addEventListener('mousedown', Fr)),
    typeof e != 'object' && (e = {callback: e})
  const t = {node: l, date: /* @__PURE__ */ new Date(), props: e}
  return (
    Tt.push(t),
    {
      destroy() {
        Ar(Tt, t), Tt.length || Hl.forEach((n) => document.removeEventListener(n, Wl))
      },
    }
  )
}
const Pr = (l) => l.indexOf('bottom') !== -1,
  Yr = (l) => l.indexOf('left') !== -1,
  zl = (l) => l.indexOf('right') !== -1,
  Br = (l) => l.indexOf('top') !== -1,
  Nl = (l) => l.indexOf('fit') !== -1,
  Ll = (l) => l.indexOf('overlap') !== -1,
  jr = (l) => l.indexOf('center') !== -1
function Zr(l, e) {
  let t = 0
  for (; l && l !== document.body; ) {
    const n = getComputedStyle(l).position
    if (
      ((n === 'absolute' || n === 'relative' || n === 'fixed') &&
        (t = parseInt(getComputedStyle(l).zIndex) || 0),
      (l = l.parentNode),
      l === e)
    )
      break
  }
  return t
}
let Qe, vt, vn, st
const El = {x: 0, y: 0, z: 0, width: 'auto'}
function qr(l, e) {
  let t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'bottom'
  let n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0
  let i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0
  if (!l) return El
  ;(Qe = n), (vt = i)
  let s = 0,
    o = 0
  const a = Kr(l),
    r = Ll(t) ? document.body : a
  if (!a) return El
  const c = a.getBoundingClientRect(),
    u = l.getBoundingClientRect(),
    f = r.getBoundingClientRect()
  if (e) {
    const m = Zr(e, a)
    s = Math.max(m + 1, 20)
  }
  if (e) {
    if (((st = e.getBoundingClientRect()), (vn = Nl(t) ? st.width + 'px' : 'auto'), t !== 'point'))
      if (jr(t)) Nl(t) ? (Qe = 0) : ((Qe = f.width / 2), (o = 1)), (vt = (f.height - u.height) / 2)
      else {
        const m = Ll(t) ? 0 : 1
        ;(Qe = zl(t) ? st.right + m : st.left - m), (vt = Pr(t) ? st.bottom + 1 : st.top)
      }
  } else st = {left: n, right: n, top: i, bottom: i}
  Yr(t) && ((Qe = st.left), (o = 2)), Br(t) && (vt = st.top - u.height)
  const d = vt + u.height - f.bottom
  return (
    d > 0 && (vt -= d),
    Qe + u.width - f.right > 0 && (zl(t) ? (o = 2) : (Qe = st.right - u.width)),
    o && (Qe = Math.round(Qe - (u.width * o) / 2)),
    Qe < 0 && (t !== 'left' ? (Qe = 0) : (Qe = st.right)),
    (Qe += r.scrollLeft - c.left),
    (vt += r.scrollTop - c.top),
    (vn = vn || 'auto'),
    {x: Qe, y: vt, z: s, width: vn}
  )
}
function Kr(l) {
  for (; l; ) {
    l = l.parentNode
    const e = getComputedStyle(l).position
    if (l === document.body || e === 'relative' || e === 'absolute' || e === 'fixed') return l
  }
  return null
}
let Il = /* @__PURE__ */ new Date().valueOf()
function Rt() {
  return (Il += 1), Il
}
function xe(l) {
  return l < 10 ? '0' + l : l.toString()
}
function Gr(l) {
  const e = xe(l)
  return e.length == 2 ? '0' + e : e
}
function Xr(l) {
  let e = l.getDay()
  e === 0 && (e = 7)
  const t = new Date(l.valueOf())
  t.setDate(l.getDate() + (4 - e))
  const n = t.getFullYear(),
    i = Math.floor((t.getTime() - new Date(n, 0, 1).getTime()) / 864e5)
  return 1 + Math.floor(i / 7)
}
const Rl = ['', '']
function Vr(l, e, t) {
  switch (l) {
    case '%d':
      return xe(e.getDate())
    case '%m':
      return xe(e.getMonth() + 1)
    case '%j':
      return e.getDate()
    case '%n':
      return e.getMonth() + 1
    case '%y':
      return xe(e.getFullYear() % 100)
    case '%Y':
      return e.getFullYear()
    case '%D':
      return t.dayShort[e.getDay()]
    case '%l':
      return t.dayFull[e.getDay()]
    case '%M':
      return t.monthShort[e.getMonth()]
    case '%F':
      return t.monthFull[e.getMonth()]
    case '%h':
      return xe(((e.getHours() + 11) % 12) + 1)
    case '%g':
      return ((e.getHours() + 11) % 12) + 1
    case '%G':
      return e.getHours()
    case '%H':
      return xe(e.getHours())
    case '%i':
      return xe(e.getMinutes())
    case '%a':
      return ((e.getHours() > 11 ? t.pm : t.am) || Rl)[0]
    case '%A':
      return ((e.getHours() > 11 ? t.pm : t.am) || Rl)[1]
    case '%s':
      return xe(e.getSeconds())
    case '%S':
      return Gr(e.getMilliseconds())
    case '%W':
      return xe(Xr(e))
    case '%c': {
      let n = e.getFullYear() + ''
      return (
        (n += '-' + xe(e.getMonth() + 1)),
        (n += '-' + xe(e.getDate())),
        (n += 'T'),
        (n += xe(e.getHours())),
        (n += ':' + xe(e.getMinutes())),
        (n += ':' + xe(e.getSeconds())),
        n
      )
    }
    default:
      return l
  }
}
const Ur = /%[a-zA-Z]/g
function Jr(l, e) {
  return typeof l == 'function'
    ? l
    : function (t) {
        return t ? (t.getMonth || (t = new Date(t)), l.replace(Ur, (n) => Vr(n, t, e))) : ''
      }
}
function Ol(l) {
  return l && typeof l == 'object' && !Array.isArray(l)
}
function Vn(l, e) {
  for (const t in e) {
    const n = e[t]
    Ol(l[t]) && Ol(n) ? (l[t] = Vn({...l[t]}, e[t])) : (l[t] = e[t])
  }
  return l
}
function On(l) {
  return {
    getGroup(e) {
      const t = l[e]
      return (n) => (t && t[n]) || n
    },
    getRaw() {
      return l
    },
    extend(e, t) {
      if (!e) return this
      let n
      return t ? (n = Vn({...e}, l)) : (n = Vn({...l}, e)), On(n)
    },
  }
}
function Qr(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('textarea')),
        g(e, 'class', 'wx-textarea x2-1eba9c5'),
        g(e, 'id', /*id*/ l[1]),
        (e.disabled = /*disabled*/ l[4]),
        g(e, 'placeholder', /*placeholder*/ l[2]),
        (e.readOnly = /*readonly*/ l[6]),
        g(e, 'title', /*title*/ l[3]),
        Q(e, 'wx-error', /*error*/ l[5])
    },
    m(i, s) {
      S(i, e, s),
        Ue(e, /*value*/ l[0]),
        t ||
          ((n = [
            q(e, 'input', /*textarea_input_handler*/ l[8]),
            q(e, 'input', /*input_handler*/ l[9]),
            q(e, 'change', /*change_handler*/ l[10]),
          ]),
          (t = !0))
    },
    p(i, _ref) {
      let [s] = _ref
      s & /*id*/ 2 && g(e, 'id', /*id*/ i[1]),
        s & /*disabled*/ 16 && (e.disabled = /*disabled*/ i[4]),
        s & /*placeholder*/ 4 && g(e, 'placeholder', /*placeholder*/ i[2]),
        s & /*readonly*/ 64 && (e.readOnly = /*readonly*/ i[6]),
        s & /*title*/ 8 && g(e, 'title', /*title*/ i[3]),
        s & /*value*/ 1 && Ue(e, /*value*/ i[0]),
        s & /*error*/ 32 && Q(e, 'wx-error', /*error*/ i[5])
    },
    i: I,
    o: I,
    d(i) {
      i && v(e), (t = !1), Ee(n)
    },
  }
}
function xr(l, e, t) {
  let {value: n = ''} = e,
    {id: i = Rt()} = e,
    {placeholder: s = ''} = e,
    {title: o = ''} = e,
    {disabled: a = !1} = e,
    {error: r = !1} = e,
    {readonly: c = !1} = e
  const u = He()
  function f() {
    ;(n = this.value), t(0, n)
  }
  const d = () => u('change', {value: n, input: !0}),
    h = () => u('change', {value: n})
  return (
    (l.$$set = (m) => {
      'value' in m && t(0, (n = m.value)),
        'id' in m && t(1, (i = m.id)),
        'placeholder' in m && t(2, (s = m.placeholder)),
        'title' in m && t(3, (o = m.title)),
        'disabled' in m && t(4, (a = m.disabled)),
        'error' in m && t(5, (r = m.error)),
        'readonly' in m && t(6, (c = m.readonly))
    }),
    [n, i, s, o, a, r, c, u, f, d, h]
  )
}
class $r extends ee {
  constructor(e) {
    super(),
      $(this, e, xr, Qr, x, {
        value: 0,
        id: 1,
        placeholder: 2,
        title: 3,
        disabled: 4,
        error: 5,
        readonly: 6,
      })
  }
}
function Al(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')), g(e, 'class', (t = Ve(/*icon*/ l[0]) + ' x2-ap8ojf'))
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*icon*/ 1 && t !== (t = Ve(/*icon*/ n[0]) + ' x2-ap8ojf') && g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function ea(l) {
  let e
  return {
    c() {
      e = re(/*text*/ l[3])
    },
    m(t, n) {
      S(t, e, n)
    },
    p(t, n) {
      n & /*text*/ 8 && me(e, /*text*/ t[3])
    },
    i: I,
    o: I,
    d(t) {
      t && v(e)
    },
  }
}
function ta(l) {
  let e
  const t = /*#slots*/ l[11].default,
    n = Ie(t, l, /*$$scope*/ l[10], null)
  return {
    c() {
      n && n.c()
    },
    m(i, s) {
      n && n.m(i, s), (e = !0)
    },
    p(i, s) {
      n &&
        n.p &&
        (!e || s & /*$$scope*/ 1024) &&
        Oe(
          n,
          t,
          i,
          /*$$scope*/ i[10],
          e ? Re(t, /*$$scope*/ i[10], s, null) : Ae(/*$$scope*/ i[10]),
          null
        )
    },
    i(i) {
      e || (k(n, i), (e = !0))
    },
    o(i) {
      y(n, i), (e = !1)
    },
    d(i) {
      n && n.d(i)
    },
  }
}
function na(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r,
    c = /*icon*/ l[0] && Al(l)
  const u = [ta, ea],
    f = []
  function d(h, m) {
    return /*SLOTS*/ h[5] ? 0 : 1
  }
  return (
    (n = d(l)),
    (i = f[n] = u[n](l)),
    {
      c() {
        ;(e = D('button')),
          c && c.c(),
          (t = Y()),
          i.c(),
          g(e, 'title', /*title*/ l[2]),
          g(e, 'class', (s = Ve(`wx-button ${/*buttonCss*/ l[4]}`) + ' x2-ap8ojf')),
          (e.disabled = /*disabled*/ l[1]),
          Q(e, 'wx-icon', /*icon*/ l[0] && (!(/*SLOTS*/ l[5]) || !(/*SLOTS*/ l[5].default)))
      },
      m(h, m) {
        S(h, e, m),
          c && c.m(e, null),
          H(e, t),
          f[n].m(e, null),
          (o = !0),
          a || ((r = q(e, 'click', /*handleClick*/ l[6])), (a = !0))
      },
      p(h, _ref2) {
        let [m] = _ref2
        /*icon*/ h[0]
          ? c
            ? c.p(h, m)
            : ((c = Al(h)), c.c(), c.m(e, t))
          : c && (c.d(1), (c = null)),
          i.p(h, m),
          (!o || m & /*title*/ 4) && g(e, 'title', /*title*/ h[2]),
          (!o ||
            (m & /*buttonCss*/ 16 &&
              s !== (s = Ve(`wx-button ${/*buttonCss*/ h[4]}`) + ' x2-ap8ojf'))) &&
            g(e, 'class', s),
          (!o || m & /*disabled*/ 2) && (e.disabled = /*disabled*/ h[1]),
          (!o || m & /*buttonCss, icon, SLOTS*/ 49) &&
            Q(e, 'wx-icon', /*icon*/ h[0] && (!(/*SLOTS*/ h[5]) || !(/*SLOTS*/ h[5].default)))
      },
      i(h) {
        o || (k(i), (o = !0))
      },
      o(h) {
        y(i), (o = !1)
      },
      d(h) {
        h && v(e), c && c.d(), f[n].d(), (a = !1), r()
      },
    }
  )
}
function la(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {type: s = ''} = e,
    {css: o = ''} = e,
    {click: a} = e,
    {icon: r = ''} = e,
    {disabled: c = !1} = e,
    {title: u = ''} = e,
    {text: f = ''} = e
  const d = e.$$slots
  let h
  const m = He(),
    _ = (w) => {
      c || (m('click'), a && a(w))
    }
  return (
    (l.$$set = (w) => {
      t(13, (e = We(We({}, e), qe(w)))),
        'type' in w && t(7, (s = w.type)),
        'css' in w && t(8, (o = w.css)),
        'click' in w && t(9, (a = w.click)),
        'icon' in w && t(0, (r = w.icon)),
        'disabled' in w && t(1, (c = w.disabled)),
        'title' in w && t(2, (u = w.title)),
        'text' in w && t(3, (f = w.text)),
        '$$scope' in w && t(10, (i = w.$$scope))
    }),
    (l.$$.update = () => {
      if (l.$$.dirty & /*type, css*/ 384) {
        let w = s
          ? s
              .split(' ')
              .filter((b) => b !== '')
              .map((b) => 'wx-' + b)
              .join(' ')
          : ''
        t(4, (h = o + (o ? ' ' : '') + w))
      }
    }),
    (e = qe(e)),
    [r, c, u, f, h, d, _, s, o, a, i, n]
  )
}
let mn = class extends ee {
  constructor(e) {
    super(),
      $(this, e, la, na, x, {type: 7, css: 8, click: 9, icon: 0, disabled: 1, title: 2, text: 3})
  }
}
function ia(l) {
  let e, t, n, i, s
  const o = /*#slots*/ l[8].default,
    a = Ie(o, l, /*$$scope*/ l[7], null)
  return {
    c() {
      ;(e = D('div')),
        a && a.c(),
        g(e, 'class', (t = `wx-dropdown wx-${/*position*/ l[0]}-${/*align*/ l[1]} x2-1jzzq2v`)),
        j(e, 'width', /*width*/ l[2])
    },
    m(r, c) {
      S(r, e, c),
        a && a.m(e, null),
        l[9](e),
        (n = !0),
        i || ((s = nt(Rn.call(null, e, /*down*/ l[4]))), (i = !0))
    },
    p(r, _ref3) {
      let [c] = _ref3
      a &&
        a.p &&
        (!n || c & /*$$scope*/ 128) &&
        Oe(
          a,
          o,
          r,
          /*$$scope*/ r[7],
          n ? Re(o, /*$$scope*/ r[7], c, null) : Ae(/*$$scope*/ r[7]),
          null
        ),
        (!n ||
          (c & /*position, align*/ 3 &&
            t !== (t = `wx-dropdown wx-${/*position*/ r[0]}-${/*align*/ r[1]} x2-1jzzq2v`))) &&
          g(e, 'class', t),
        (!n || c & /*width*/ 4) && j(e, 'width', /*width*/ r[2])
    },
    i(r) {
      n || (k(a, r), (n = !0))
    },
    o(r) {
      y(a, r), (n = !1)
    },
    d(r) {
      r && v(e), a && a.d(r), l[9](null), (i = !1), s()
    },
  }
}
function sa(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {position: s = 'bottom'} = e,
    {align: o = 'start'} = e,
    {autoFit: a = !0} = e,
    {cancel: r = null} = e,
    {width: c = '100%'} = e,
    u
  kn(() => {
    if (a) {
      const h = u.getBoundingClientRect(),
        m = document.body.getBoundingClientRect()
      return (
        h.right >= m.right && t(1, (o = 'end')),
        h.bottom >= m.bottom && t(0, (s = 'top')),
        `${s}-${o}`
      )
    }
  })
  function f(h) {
    r && r(h)
  }
  function d(h) {
    be[h ? 'unshift' : 'push'](() => {
      ;(u = h), t(3, u)
    })
  }
  return (
    (l.$$set = (h) => {
      'position' in h && t(0, (s = h.position)),
        'align' in h && t(1, (o = h.align)),
        'autoFit' in h && t(5, (a = h.autoFit)),
        'cancel' in h && t(6, (r = h.cancel)),
        'width' in h && t(2, (c = h.width)),
        '$$scope' in h && t(7, (i = h.$$scope))
    }),
    [s, o, c, u, f, a, r, i, n, d]
  )
}
class pn extends ee {
  constructor(e) {
    super(), $(this, e, sa, ia, x, {position: 0, align: 1, autoFit: 5, cancel: 6, width: 2})
  }
}
function oa() {
  let l = null,
    e = !1,
    t,
    n,
    i,
    s
  const o = (d, h, m, _) => {
      ;(t = d), (n = h), (i = m), (s = _)
    },
    a = (d) => {
      ;(l = d), (e = l !== null), i(l)
    },
    r = (d, h) => {
      const m = d === null ? null : Math.max(0, Math.min(l + d, n.length - 1))
      m !== l && (a(m), t ? c(m, h) : requestAnimationFrame(() => c(m, h)))
    },
    c = (d, h) => {
      if (d !== null && t) {
        const m = t.querySelectorAll('.list > .item')[d]
        m && (m.scrollIntoView({block: 'nearest'}), h && h.preventDefault())
      }
    }
  return {
    move: (d) => {
      const h = hn(d),
        m = n.findIndex((_) => _.id == h)
      m !== l && a(m)
    },
    keydown: (d, h) => {
      switch (d.code) {
        case 'Enter':
          e ? s() : a(0)
          break
        case 'Space':
          e || a(0)
          break
        case 'Escape':
          i((l = null))
          break
        case 'Tab':
          i((l = null))
          break
        case 'ArrowDown':
          r(e ? 1 : h || 0, d)
          break
        case 'ArrowUp':
          r(e ? -1 : h || 0, d)
          break
      }
    },
    init: o,
    navigate: r,
  }
}
function Fl(l, e, t) {
  const n = l.slice()
  return (n[13] = e[t]), (n[15] = t), n
}
const ra = (l) => ({option: l & /*items*/ 1}),
  Pl = (l) => ({option: /*data*/ l[13]})
function Yl(l) {
  let e, t
  return (
    (e = new pn({props: {cancel: /*func*/ l[8], $$slots: {default: [fa]}, $$scope: {ctx: l}}})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*$$scope, list, items, navIndex*/ 519 && (s.$$scope = {dirty: i, ctx: n}), e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function aa(l) {
  let e
  return {
    c() {
      ;(e = D('div')), (e.textContent = 'No data'), g(e, 'class', 'wx-no-data x2-fl05h9')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    i: I,
    o: I,
    d(t) {
      t && v(e)
    },
  }
}
function ca(l) {
  let e = [],
    t = /* @__PURE__ */ new Map(),
    n,
    i,
    s = de(/*items*/ l[0])
  const o = (a) => /*data*/ a[13].id
  for (let a = 0; a < s.length; a += 1) {
    let r = Fl(l, s, a),
      c = o(r)
    t.set(c, (e[a] = Bl(c, r)))
  }
  return {
    c() {
      for (let a = 0; a < e.length; a += 1) e[a].c()
      n = se()
    },
    m(a, r) {
      for (let c = 0; c < e.length; c += 1) e[c] && e[c].m(a, r)
      S(a, n, r), (i = !0)
    },
    p(a, r) {
      r & /*items, navIndex, $$scope*/ 517 &&
        ((s = de(/*items*/ a[0])),
        te(),
        (e = kt(e, r, o, 1, a, s, t, n.parentNode, en, Bl, n, Fl)),
        ne())
    },
    i(a) {
      if (!i) {
        for (let r = 0; r < s.length; r += 1) k(e[r])
        i = !0
      }
    },
    o(a) {
      for (let r = 0; r < e.length; r += 1) y(e[r])
      i = !1
    },
    d(a) {
      a && v(n)
      for (let r = 0; r < e.length; r += 1) e[r].d(a)
    },
  }
}
function ua(l) {
  let e = /*data*/ l[13].name + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*items*/ 1 && e !== (e = /*data*/ n[13].name + '') && me(t, e)
    },
    d(n) {
      n && v(t)
    },
  }
}
function Bl(l, e) {
  let t, n, i, s
  const o = /*#slots*/ e[6].default,
    a = Ie(o, e, /*$$scope*/ e[9], Pl),
    r = a || ua(e)
  return {
    key: l,
    first: null,
    c() {
      ;(t = D('div')),
        r && r.c(),
        (n = Y()),
        g(t, 'class', 'wx-item x2-fl05h9'),
        g(t, 'data-id', (i = /*data*/ e[13].id)),
        Q(t, 'wx-focus', /*index*/ e[15] === /*navIndex*/ e[2]),
        (this.first = t)
    },
    m(c, u) {
      S(c, t, u), r && r.m(t, null), H(t, n), (s = !0)
    },
    p(c, u) {
      ;(e = c),
        a
          ? a.p &&
            (!s || u & /*$$scope, items*/ 513) &&
            Oe(
              a,
              o,
              e,
              /*$$scope*/ e[9],
              s ? Re(o, /*$$scope*/ e[9], u, ra) : Ae(/*$$scope*/ e[9]),
              Pl
            )
          : r && r.p && (!s || u & /*items*/ 1) && r.p(e, s ? u : -1),
        (!s || (u & /*items*/ 1 && i !== (i = /*data*/ e[13].id))) && g(t, 'data-id', i),
        (!s || u & /*items, navIndex*/ 5) && Q(t, 'wx-focus', /*index*/ e[15] === /*navIndex*/ e[2])
    },
    i(c) {
      s || (k(r, c), (s = !0))
    },
    o(c) {
      y(r, c), (s = !1)
    },
    d(c) {
      c && v(t), r && r.d(c)
    },
  }
}
function fa(l) {
  let e, t, n, i, s, o
  const a = [ca, aa],
    r = []
  function c(u, f) {
    return /*items*/ u[0].length ? 0 : 1
  }
  return (
    (t = c(l)),
    (n = r[t] = a[t](l)),
    {
      c() {
        ;(e = D('div')), n.c(), g(e, 'class', 'wx-list x2-fl05h9')
      },
      m(u, f) {
        S(u, e, f),
          r[t].m(e, null),
          l[7](e),
          (i = !0),
          s ||
            ((o = [q(e, 'click', En(/*select*/ l[5])), q(e, 'mousemove', /*move*/ l[3])]), (s = !0))
      },
      p(u, f) {
        let d = t
        ;(t = c(u)),
          t === d
            ? r[t].p(u, f)
            : (te(),
              y(r[d], 1, 1, () => {
                r[d] = null
              }),
              ne(),
              (n = r[t]),
              n ? n.p(u, f) : ((n = r[t] = a[t](u)), n.c()),
              k(n, 1),
              n.m(e, null))
      },
      i(u) {
        i || (k(n), (i = !0))
      },
      o(u) {
        y(n), (i = !1)
      },
      d(u) {
        u && v(e), r[t].d(), l[7](null), (s = !1), Ee(o)
      },
    }
  )
}
function da(l) {
  let e,
    t,
    n = /*navIndex*/ l[2] !== null && Yl(l)
  return {
    c() {
      n && n.c(), (e = se())
    },
    m(i, s) {
      n && n.m(i, s), S(i, e, s), (t = !0)
    },
    p(i, _ref4) {
      let [s] = _ref4
      /*navIndex*/ i[2] !== null
        ? n
          ? (n.p(i, s), s & /*navIndex*/ 4 && k(n, 1))
          : ((n = Yl(i)), n.c(), k(n, 1), n.m(e.parentNode, e))
        : n &&
          (te(),
          y(n, 1, 1, () => {
            n = null
          }),
          ne())
    },
    i(i) {
      t || (k(n), (t = !0))
    },
    o(i) {
      y(n), (t = !1)
    },
    d(i) {
      i && v(e), n && n.d(i)
    },
  }
}
function ha(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {items: s = []} = e,
    o,
    a = null
  const r = He(),
    {move: c, keydown: u, init: f, navigate: d} = oa(),
    h = () => r('select', {id: s[a]?.id})
  ht(() => {
    r('ready', {navigate: d, keydown: u, move: c})
  })
  function m(w) {
    be[w ? 'unshift' : 'push'](() => {
      ;(o = w), t(1, o)
    })
  }
  const _ = () => d(null)
  return (
    (l.$$set = (w) => {
      'items' in w && t(0, (s = w.items)), '$$scope' in w && t(9, (i = w.$$scope))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*list, items*/ 3 && f(o, s, (w) => t(2, (a = w)), h)
    }),
    [s, o, a, c, d, h, n, m, _, i]
  )
}
class fl extends ee {
  constructor(e) {
    super(), $(this, e, ha, da, x, {items: 0})
  }
}
const ma = (l) => ({option: l[1] & /*option*/ 4}),
  jl = (l) => ({option: /*option*/ l[33]})
function _a(l) {
  let e
  return {
    c() {
      ;(e = D('i')), g(e, 'class', 'wx-icon wxi-angle-down x2-1oh2bu')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    d(t) {
      t && v(e)
    },
  }
}
function ga(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('i')), g(e, 'class', 'wx-icon wxi-close x2-1oh2bu')
    },
    m(i, s) {
      S(i, e, s), t || ((n = q(e, 'click', En(/*doUnselect*/ l[14]))), (t = !0))
    },
    p: I,
    d(i) {
      i && v(e), (t = !1), n()
    },
  }
}
function Zl(l) {
  let e, t
  return (
    (e = new fl({
      props: {
        items: /*filterOptions*/ l[8],
        $$slots: {
          default: [
            ba,
            (_ref5) => {
              let {option: n} = _ref5
              return {33: n}
            },
            (_ref6) => {
              let {option: n} = _ref6
              return [0, n ? 4 : 0]
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    e.$on('ready', /*ready*/ l[12]),
    e.$on('select', /*selectByEvent*/ l[13]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i[0] & /*filterOptions*/ 256 && (s.items = /*filterOptions*/ n[8]),
          (i[0] & /*$$scope*/ 134217728) | (i[1] & /*option*/ 4) &&
            (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function wa(l) {
  let e = /*option*/ l[33].name + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i[1] & /*option*/ 4 && e !== (e = /*option*/ n[33].name + '') && me(t, e)
    },
    d(n) {
      n && v(t)
    },
  }
}
function ba(l) {
  let e
  const t = /*#slots*/ l[22].default,
    n = Ie(t, l, /*$$scope*/ l[27], jl),
    i = n || wa(l)
  return {
    c() {
      i && i.c()
    },
    m(s, o) {
      i && i.m(s, o), (e = !0)
    },
    p(s, o) {
      n
        ? n.p &&
          (!e || (o[0] & /*$$scope*/ 134217728) | (o[1] & /*option*/ 4)) &&
          Oe(
            n,
            t,
            s,
            /*$$scope*/ s[27],
            e ? Re(t, /*$$scope*/ s[27], o, ma) : Ae(/*$$scope*/ s[27]),
            jl
          )
        : i && i.p && (!e || o[1] & /*option*/ 4) && i.p(s, e ? o : [-1, -1])
    },
    i(s) {
      e || (k(i, s), (e = !0))
    },
    o(s) {
      y(i, s), (e = !1)
    },
    d(s) {
      i && i.d(s)
    },
  }
}
function ka(l) {
  let e, t, n, i, s, o, a
  function r(d, h) {
    return /*clearButton*/ d[6] && !(/*disabled*/ d[4]) && /*value*/ d[0] ? ga : _a
  }
  let c = r(l),
    u = c(l),
    f = !(/*disabled*/ l[4]) && Zl(l)
  return {
    c() {
      ;(e = D('div')),
        (t = D('input')),
        (n = Y()),
        u.c(),
        (i = Y()),
        f && f.c(),
        g(t, 'id', /*id*/ l[1]),
        (t.disabled = /*disabled*/ l[4]),
        g(t, 'placeholder', /*placeholder*/ l[2]),
        g(t, 'class', 'x2-1oh2bu'),
        Q(t, 'wx-error', /*error*/ l[5]),
        g(e, 'class', 'wx-combo x2-1oh2bu'),
        g(e, 'title', /*title*/ l[3])
    },
    m(d, h) {
      S(d, e, h),
        H(e, t),
        l[23](t),
        Ue(t, /*text*/ l[7]),
        H(e, n),
        u.m(e, null),
        H(e, i),
        f && f.m(e, null),
        (s = !0),
        o ||
          ((a = [
            q(t, 'input', /*input_1_input_handler*/ l[24]),
            q(t, 'focus', /*onFocus*/ l[16]),
            q(t, 'blur', /*onBlur*/ l[17]),
            q(t, 'input', /*input*/ l[15]),
            q(e, 'click', /*click_handler*/ l[25]),
            q(e, 'keydown', /*keydown_handler*/ l[26]),
          ]),
          (o = !0))
    },
    p(d, h) {
      ;(!s || h[0] & /*id*/ 2) && g(t, 'id', /*id*/ d[1]),
        (!s || h[0] & /*disabled*/ 16) && (t.disabled = /*disabled*/ d[4]),
        (!s || h[0] & /*placeholder*/ 4) && g(t, 'placeholder', /*placeholder*/ d[2]),
        h[0] & /*text*/ 128 && t.value !== /*text*/ d[7] && Ue(t, /*text*/ d[7]),
        (!s || h[0] & /*error*/ 32) && Q(t, 'wx-error', /*error*/ d[5]),
        c === (c = r(d)) && u ? u.p(d, h) : (u.d(1), (u = c(d)), u && (u.c(), u.m(e, i))),
        /*disabled*/ d[4]
          ? f &&
            (te(),
            y(f, 1, 1, () => {
              f = null
            }),
            ne())
          : f
          ? (f.p(d, h), h[0] & /*disabled*/ 16 && k(f, 1))
          : ((f = Zl(d)), f.c(), k(f, 1), f.m(e, null)),
        (!s || h[0] & /*title*/ 8) && g(e, 'title', /*title*/ d[3])
    },
    i(d) {
      s || (k(f), (s = !0))
    },
    o(d) {
      y(f), (s = !1)
    },
    d(d) {
      d && v(e), l[23](null), u.d(), f && f.d(), (o = !1), Ee(a)
    },
  }
}
function pa(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {value: s = ''} = e,
    {id: o = Rt()} = e,
    {options: a = []} = e,
    {textField: r = 'label'} = e,
    {placeholder: c = ''} = e,
    {title: u = ''} = e,
    {disabled: f = !1} = e,
    {error: d = !1} = e,
    {clearButton: h = !1} = e
  const m = He()
  let _ = '',
    w = [],
    b,
    p
  function z(K) {
    t(9, (b = K.detail.navigate)), t(10, (p = K.detail.keydown))
  }
  let T
  function W(K) {
    const ue = K.detail.id
    C(ue, !0)
  }
  function M(K) {
    if (!a.length) return
    if (K === '' && h) {
      P()
      return
    }
    let ue = a.find((ye) => ye[r] === K)
    ue || (ue = a.find((ye) => ye[r].toLowerCase().includes(K.toLowerCase())))
    const Ne = ue ? ue.id : T || a[0].id
    C(Ne, !1)
  }
  function C(K, ue) {
    if (K || K === 0) {
      let Ne = a.find((ye) => ye.id === K)
      t(7, (_ = Ne[r])),
        t(8, (w = a)),
        ue && b(null),
        s !== Ne.id && (t(0, (s = Ne.id)), m('select', {selected: Ne}))
    }
    !B && ue && A.focus()
  }
  function P() {
    t(7, (_ = t(0, (s = '')))), t(8, (w = a)), m('select', {selected: null})
  }
  function X() {
    t(8, (w = _ ? a.filter((K) => K[r].toLowerCase().includes(_.toLowerCase())) : a)),
      w.length ? b(0) : b(null)
  }
  let A, B
  function V() {
    B = !0
  }
  function fe() {
    ;(B = !1),
      setTimeout(() => {
        B || M(_)
      }, 200)
  }
  const L = () => w.findIndex((K) => K.id === s)
  function Ye(K) {
    be[K ? 'unshift' : 'push'](() => {
      ;(A = K), t(11, A)
    })
  }
  function G() {
    ;(_ = this.value), t(7, _), t(21, T), t(0, s), t(19, a), t(20, r)
  }
  const pe = () => b(L()),
    Se = (K) => p(K, L())
  return (
    (l.$$set = (K) => {
      'value' in K && t(0, (s = K.value)),
        'id' in K && t(1, (o = K.id)),
        'options' in K && t(19, (a = K.options)),
        'textField' in K && t(20, (r = K.textField)),
        'placeholder' in K && t(2, (c = K.placeholder)),
        'title' in K && t(3, (u = K.title)),
        'disabled' in K && t(4, (f = K.disabled)),
        'error' in K && t(5, (d = K.error)),
        'clearButton' in K && t(6, (h = K.clearButton)),
        '$$scope' in K && t(27, (i = K.$$scope))
    }),
    (l.$$.update = () => {
      l.$$.dirty[0] & /*prevValue, value, options, textField*/ 3670017 &&
        T != s &&
        (t(7, (_ = s || s === 0 ? a.find((K) => K.id === s)[r] : '')), t(21, (T = s))),
        l.$$.dirty[0] & /*options*/ 524288 && t(8, (w = a))
    }),
    [s, o, c, u, f, d, h, _, w, b, p, A, z, W, P, X, V, fe, L, a, r, T, n, Ye, G, pe, Se, i]
  )
}
let go = class extends ee {
  constructor(e) {
    super(),
      $(
        this,
        e,
        pa,
        ka,
        x,
        {
          value: 0,
          id: 1,
          options: 19,
          textField: 20,
          placeholder: 2,
          title: 3,
          disabled: 4,
          error: 5,
          clearButton: 6,
        },
        null,
        [-1, -1]
      )
  }
}
function ya(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('input')),
        g(e, 'id', /*id*/ l[2]),
        (e.readOnly = /*readonly*/ l[3]),
        (e.disabled = /*disabled*/ l[6]),
        g(e, 'placeholder', /*placeholder*/ l[5]),
        g(e, 'title', /*title*/ l[9]),
        g(e, 'style', /*inputStyle*/ l[8]),
        g(e, 'class', 'x2-1axmg32')
    },
    m(i, s) {
      S(i, e, s),
        Ue(e, /*value*/ l[0]),
        l[24](e),
        t ||
          ((n = [
            q(e, 'input', /*input_1_input_handler_2*/ l[23]),
            q(e, 'input', /*input_handler_2*/ l[25]),
            q(e, 'change', /*change_handler_2*/ l[26]),
          ]),
          (t = !0))
    },
    p(i, s) {
      s & /*id*/ 4 && g(e, 'id', /*id*/ i[2]),
        s & /*readonly*/ 8 && (e.readOnly = /*readonly*/ i[3]),
        s & /*disabled*/ 64 && (e.disabled = /*disabled*/ i[6]),
        s & /*placeholder*/ 32 && g(e, 'placeholder', /*placeholder*/ i[5]),
        s & /*title*/ 512 && g(e, 'title', /*title*/ i[9]),
        s & /*inputStyle*/ 256 && g(e, 'style', /*inputStyle*/ i[8]),
        s & /*value*/ 1 && e.value !== /*value*/ i[0] && Ue(e, /*value*/ i[0])
    },
    d(i) {
      i && v(e), l[24](null), (t = !1), Ee(n)
    },
  }
}
function va(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('input')),
        g(e, 'id', /*id*/ l[2]),
        (e.readOnly = /*readonly*/ l[3]),
        (e.disabled = /*disabled*/ l[6]),
        g(e, 'placeholder', /*placeholder*/ l[5]),
        g(e, 'type', 'number'),
        g(e, 'style', /*inputStyle*/ l[8]),
        g(e, 'title', /*title*/ l[9]),
        g(e, 'class', 'x2-1axmg32')
    },
    m(i, s) {
      S(i, e, s),
        Ue(e, /*value*/ l[0]),
        l[20](e),
        t ||
          ((n = [
            q(e, 'input', /*input_1_input_handler_1*/ l[19]),
            q(e, 'input', /*input_handler_1*/ l[21]),
            q(e, 'change', /*change_handler_1*/ l[22]),
          ]),
          (t = !0))
    },
    p(i, s) {
      s & /*id*/ 4 && g(e, 'id', /*id*/ i[2]),
        s & /*readonly*/ 8 && (e.readOnly = /*readonly*/ i[3]),
        s & /*disabled*/ 64 && (e.disabled = /*disabled*/ i[6]),
        s & /*placeholder*/ 32 && g(e, 'placeholder', /*placeholder*/ i[5]),
        s & /*inputStyle*/ 256 && g(e, 'style', /*inputStyle*/ i[8]),
        s & /*title*/ 512 && g(e, 'title', /*title*/ i[9]),
        s & /*value*/ 1 && il(e.value) !== /*value*/ i[0] && Ue(e, /*value*/ i[0])
    },
    d(i) {
      i && v(e), l[20](null), (t = !1), Ee(n)
    },
  }
}
function Sa(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('input')),
        g(e, 'id', /*id*/ l[2]),
        (e.readOnly = /*readonly*/ l[3]),
        (e.disabled = /*disabled*/ l[6]),
        g(e, 'placeholder', /*placeholder*/ l[5]),
        g(e, 'type', 'password'),
        g(e, 'style', /*inputStyle*/ l[8]),
        g(e, 'title', /*title*/ l[9]),
        g(e, 'class', 'x2-1axmg32')
    },
    m(i, s) {
      S(i, e, s),
        Ue(e, /*value*/ l[0]),
        l[16](e),
        t ||
          ((n = [
            q(e, 'input', /*input_1_input_handler*/ l[15]),
            q(e, 'input', /*input_handler*/ l[17]),
            q(e, 'change', /*change_handler*/ l[18]),
          ]),
          (t = !0))
    },
    p(i, s) {
      s & /*id*/ 4 && g(e, 'id', /*id*/ i[2]),
        s & /*readonly*/ 8 && (e.readOnly = /*readonly*/ i[3]),
        s & /*disabled*/ 64 && (e.disabled = /*disabled*/ i[6]),
        s & /*placeholder*/ 32 && g(e, 'placeholder', /*placeholder*/ i[5]),
        s & /*inputStyle*/ 256 && g(e, 'style', /*inputStyle*/ i[8]),
        s & /*title*/ 512 && g(e, 'title', /*title*/ i[9]),
        s & /*value*/ 1 && e.value !== /*value*/ i[0] && Ue(e, /*value*/ i[0])
    },
    d(i) {
      i && v(e), l[16](null), (t = !1), Ee(n)
    },
  }
}
function ql(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')), g(e, 'class', (t = 'wx-icon ' + /*icon*/ l[10] + ' x2-1axmg32'))
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*icon*/ 1024 &&
        t !== (t = 'wx-icon ' + /*icon*/ n[10] + ' x2-1axmg32') &&
        g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function Ma(l) {
  let e, t, n
  function i(r, c) {
    return /*type*/ r[4] == 'password' ? Sa : /*type*/ r[4] == 'number' ? va : ya
  }
  let s = i(l),
    o = s(l),
    a = /*icon*/ l[10] && ql(l)
  return {
    c() {
      ;(e = D('div')),
        o.c(),
        (t = Y()),
        a && a.c(),
        g(e, 'class', (n = 'wx-text ' + /*css*/ l[1] + ' x2-1axmg32')),
        Q(e, 'wx-error', /*error*/ l[7]),
        Q(e, 'wx-disabled', /*disabled*/ l[6])
    },
    m(r, c) {
      S(r, e, c), o.m(e, null), H(e, t), a && a.m(e, null)
    },
    p(r, _ref7) {
      let [c] = _ref7
      s === (s = i(r)) && o ? o.p(r, c) : (o.d(1), (o = s(r)), o && (o.c(), o.m(e, t))),
        /*icon*/ r[10]
          ? a
            ? a.p(r, c)
            : ((a = ql(r)), a.c(), a.m(e, null))
          : a && (a.d(1), (a = null)),
        c & /*css*/ 2 && n !== (n = 'wx-text ' + /*css*/ r[1] + ' x2-1axmg32') && g(e, 'class', n),
        c & /*css, error*/ 130 && Q(e, 'wx-error', /*error*/ r[7]),
        c & /*css, disabled*/ 66 && Q(e, 'wx-disabled', /*disabled*/ r[6])
    },
    i: I,
    o: I,
    d(r) {
      r && v(e), o.d(), a && a.d()
    },
  }
}
function Ta(l, e, t) {
  let {value: n = ''} = e,
    {id: i = Rt()} = e,
    {readonly: s = !1} = e,
    {focus: o = !1} = e,
    {select: a = !1} = e,
    {type: r = 'text'} = e,
    {placeholder: c = ''} = e,
    {disabled: u = !1} = e,
    {error: f = !1} = e,
    {inputStyle: d = ''} = e,
    {title: h = ''} = e,
    {css: m = ''} = e,
    {icon: _ = ''} = e
  const w = He()
  _ && m.indexOf('wx-icon-left') === -1 && (m = 'wx-icon-right ' + m)
  let b
  ht(() => {
    setTimeout(() => {
      o && b && b.focus(), a && b && b.select()
    }, 1)
  })
  function p() {
    ;(n = this.value), t(0, n)
  }
  function z(L) {
    be[L ? 'unshift' : 'push'](() => {
      ;(b = L), t(11, b)
    })
  }
  const T = () => w('change', {value: n, input: !0}),
    W = () => w('change', {value: n})
  function M() {
    ;(n = il(this.value)), t(0, n)
  }
  function C(L) {
    be[L ? 'unshift' : 'push'](() => {
      ;(b = L), t(11, b)
    })
  }
  const P = () => w('change', {value: n, input: !0}),
    X = () => w('change', {value: n})
  function A() {
    ;(n = this.value), t(0, n)
  }
  function B(L) {
    be[L ? 'unshift' : 'push'](() => {
      ;(b = L), t(11, b)
    })
  }
  const V = () => w('change', {value: n, input: !0}),
    fe = () => w('change', {value: n})
  return (
    (l.$$set = (L) => {
      'value' in L && t(0, (n = L.value)),
        'id' in L && t(2, (i = L.id)),
        'readonly' in L && t(3, (s = L.readonly)),
        'focus' in L && t(13, (o = L.focus)),
        'select' in L && t(14, (a = L.select)),
        'type' in L && t(4, (r = L.type)),
        'placeholder' in L && t(5, (c = L.placeholder)),
        'disabled' in L && t(6, (u = L.disabled)),
        'error' in L && t(7, (f = L.error)),
        'inputStyle' in L && t(8, (d = L.inputStyle)),
        'title' in L && t(9, (h = L.title)),
        'css' in L && t(1, (m = L.css)),
        'icon' in L && t(10, (_ = L.icon))
    }),
    [n, m, i, s, r, c, u, f, d, h, _, b, w, o, a, p, z, T, W, M, C, P, X, A, B, V, fe]
  )
}
let wo = class extends ee {
  constructor(e) {
    super(),
      $(this, e, Ta, Ma, x, {
        value: 0,
        id: 2,
        readonly: 3,
        focus: 13,
        select: 14,
        type: 4,
        placeholder: 5,
        disabled: 6,
        error: 7,
        inputStyle: 8,
        title: 9,
        css: 1,
        icon: 10,
      })
  }
}
function Ca(l) {
  let e
  return {
    c() {
      ;(e = D('span')), g(e, 'class', 'wx-spacer x2-wurt7c')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    d(t) {
      t && v(e)
    },
  }
}
function Da(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('i')), g(e, 'class', 'wx-pager wxi-angle-left x2-wurt7c')
    },
    m(i, s) {
      S(i, e, s), t || ((n = q(e, 'click', /*click_handler*/ l[8])), (t = !0))
    },
    p: I,
    d(i) {
      i && v(e), (t = !1), n()
    },
  }
}
function Wa(l) {
  let e
  return {
    c() {
      ;(e = D('span')), g(e, 'class', 'wx-spacer x2-wurt7c')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    d(t) {
      t && v(e)
    },
  }
}
function Ha(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('i')), g(e, 'class', 'wx-pager wxi-angle-right x2-wurt7c')
    },
    m(i, s) {
      S(i, e, s), t || ((n = q(e, 'click', /*click_handler_1*/ l[9])), (t = !0))
    },
    p: I,
    d(i) {
      i && v(e), (t = !1), n()
    },
  }
}
function za(l) {
  let e, t, n, i, s, o, a
  function r(m, _) {
    return /*part*/ m[1] != 'right' ? Da : Ca
  }
  let c = r(l),
    u = c(l)
  function f(m, _) {
    return /*part*/ m[1] != 'left' ? Ha : Wa
  }
  let d = f(l),
    h = d(l)
  return {
    c() {
      ;(e = D('div')),
        u.c(),
        (t = Y()),
        (n = D('span')),
        (i = re(/*label*/ l[2])),
        (s = Y()),
        h.c(),
        g(n, 'class', 'wx-label x2-wurt7c'),
        g(e, 'class', 'wx-header x2-wurt7c')
    },
    m(m, _) {
      S(m, e, _),
        u.m(e, null),
        H(e, t),
        H(e, n),
        H(n, i),
        H(e, s),
        h.m(e, null),
        o || ((a = q(n, 'click', /*changeType*/ l[4])), (o = !0))
    },
    p(m, _ref8) {
      let [_] = _ref8
      c === (c = r(m)) && u ? u.p(m, _) : (u.d(1), (u = c(m)), u && (u.c(), u.m(e, t))),
        _ & /*label*/ 4 && me(i, /*label*/ m[2]),
        d === (d = f(m)) && h ? h.p(m, _) : (h.d(1), (h = d(m)), h && (h.c(), h.m(e, null)))
    },
    i: I,
    o: I,
    d(m) {
      m && v(e), u.d(), h.d(), (o = !1), a()
    },
  }
}
function Na(l, e, t) {
  const n = He(),
    s = ze('wx-i18n').getRaw().calendar.monthFull
  let {date: o} = e,
    {type: a} = e,
    {part: r} = e,
    c,
    u,
    f
  function d() {
    n('shift', {diff: 0, type: a})
  }
  const h = () => n('shift', {diff: -1, type: a}),
    m = () => n('shift', {diff: 1, type: a})
  return (
    (l.$$set = (_) => {
      'date' in _ && t(5, (o = _.date)),
        'type' in _ && t(0, (a = _.type)),
        'part' in _ && t(1, (r = _.part))
    }),
    (l.$$.update = () => {
      if (l.$$.dirty & /*date, type, month, year*/ 225)
        switch ((t(6, (c = o.getMonth())), t(7, (u = o.getFullYear())), a)) {
          case 'month':
            t(2, (f = `${s[c]} ${u}`))
            break
          case 'year':
            t(2, (f = u))
            break
          case 'duodecade': {
            const _ = u - (u % 10),
              w = _ + 9
            t(2, (f = `${_} - ${w}`))
            break
          }
        }
    }),
    [a, r, f, n, d, o, c, u, h, m]
  )
}
class La extends ee {
  constructor(e) {
    super(), $(this, e, Na, za, x, {date: 5, type: 0, part: 1})
  }
}
function Ea(l) {
  let e, t, n, i
  const s = /*#slots*/ l[2].default,
    o = Ie(s, l, /*$$scope*/ l[1], null)
  return {
    c() {
      ;(e = D('button')), o && o.c(), g(e, 'class', 'x2-1f88uh6')
    },
    m(a, r) {
      S(a, e, r),
        o && o.m(e, null),
        (t = !0),
        n ||
          ((i = q(e, 'click', function () {
            ot(/*click*/ l[0]) && l[0].apply(this, arguments)
          })),
          (n = !0))
    },
    p(a, _ref9) {
      let [r] = _ref9
      ;(l = a),
        o &&
          o.p &&
          (!t || r & /*$$scope*/ 2) &&
          Oe(
            o,
            s,
            l,
            /*$$scope*/ l[1],
            t ? Re(s, /*$$scope*/ l[1], r, null) : Ae(/*$$scope*/ l[1]),
            null
          )
    },
    i(a) {
      t || (k(o, a), (t = !0))
    },
    o(a) {
      y(o, a), (t = !1)
    },
    d(a) {
      a && v(e), o && o.d(a), (n = !1), i()
    },
  }
}
function Ia(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {click: s} = e
  return (
    (l.$$set = (o) => {
      'click' in o && t(0, (s = o.click)), '$$scope' in o && t(1, (i = o.$$scope))
    }),
    [s, i, n]
  )
}
class _n extends ee {
  constructor(e) {
    super(), $(this, e, Ia, Ea, x, {click: 0})
  }
}
function Kl(l, e, t) {
  const n = l.slice()
  return (n[17] = e[t]), n
}
function Gl(l, e, t) {
  const n = l.slice()
  return (n[17] = e[t]), n
}
function Xl(l) {
  let e
  return {
    c() {
      ;(e = D('div')), (e.textContent = `${/*day*/ l[17]}`), g(e, 'class', 'wx-weekday x2-ee96p9')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    d(t) {
      t && v(e)
    },
  }
}
function Vl(l, e) {
  let t,
    n = /*day*/ e[17].day + '',
    i,
    s,
    o,
    a
  return {
    key: l,
    first: null,
    c() {
      ;(t = D('div')),
        (i = re(n)),
        (s = Y()),
        g(t, 'class', (o = 'wx-day ' + /*day*/ e[17].css + ' x2-ee96p9')),
        g(t, 'data-id', (a = /*day*/ e[17].date)),
        Q(t, 'wx-out', !(/*day*/ e[17].in)),
        (this.first = t)
    },
    m(r, c) {
      S(r, t, c), H(t, i), H(t, s)
    },
    p(r, c) {
      ;(e = r),
        c & /*days*/ 1 && n !== (n = /*day*/ e[17].day + '') && me(i, n),
        c & /*days*/ 1 &&
          o !== (o = 'wx-day ' + /*day*/ e[17].css + ' x2-ee96p9') &&
          g(t, 'class', o),
        c & /*days*/ 1 && a !== (a = /*day*/ e[17].date) && g(t, 'data-id', a),
        c & /*days, days*/ 1 && Q(t, 'wx-out', !(/*day*/ e[17].in))
    },
    d(r) {
      r && v(t)
    },
  }
}
function Ra(l) {
  let e,
    t,
    n,
    i,
    s = [],
    o = /* @__PURE__ */ new Map(),
    a,
    r,
    c = de(/*weekdays*/ l[1]),
    u = []
  for (let h = 0; h < c.length; h += 1) u[h] = Xl(Gl(l, c, h))
  let f = de(/*days*/ l[0])
  const d = (h) => /*day*/ h[17].date
  for (let h = 0; h < f.length; h += 1) {
    let m = Kl(l, f, h),
      _ = d(m)
    o.set(_, (s[h] = Vl(_, m)))
  }
  return {
    c() {
      ;(e = D('div')), (t = D('div'))
      for (let h = 0; h < u.length; h += 1) u[h].c()
      ;(n = Y()), (i = D('div'))
      for (let h = 0; h < s.length; h += 1) s[h].c()
      g(t, 'class', 'wx-weekdays x2-ee96p9'), g(i, 'class', 'wx-days x2-ee96p9')
    },
    m(h, m) {
      S(h, e, m), H(e, t)
      for (let _ = 0; _ < u.length; _ += 1) u[_] && u[_].m(t, null)
      H(e, n), H(e, i)
      for (let _ = 0; _ < s.length; _ += 1) s[_] && s[_].m(i, null)
      a || ((r = nt(In.call(null, i, /*selectDates*/ l[2]))), (a = !0))
    },
    p(h, _ref10) {
      let [m] = _ref10
      if (m & /*weekdays*/ 2) {
        c = de(/*weekdays*/ h[1])
        let _
        for (_ = 0; _ < c.length; _ += 1) {
          const w = Gl(h, c, _)
          u[_] ? u[_].p(w, m) : ((u[_] = Xl(w)), u[_].c(), u[_].m(t, null))
        }
        for (; _ < u.length; _ += 1) u[_].d(1)
        u.length = c.length
      }
      m & /*days*/ 1 &&
        ((f = de(/*days*/ h[0])), (s = kt(s, m, d, 1, h, f, o, i, al, Vl, null, Kl)))
    },
    i: I,
    o: I,
    d(h) {
      h && v(e), $e(u, h)
      for (let m = 0; m < s.length; m += 1) s[m].d()
      ;(a = !1), r()
    },
  }
}
function Oa(l) {
  const e = l.getDay()
  return e === 0 || e === 6
}
function Aa(l, e, t) {
  let {value: n} = e,
    {current: i} = e,
    {cancel: s} = e,
    {select: o} = e,
    {part: a} = e,
    {markers: r = null} = e
  const c = ze('wx-i18n').getRaw().calendar,
    u = (c.weekStart || 7) % 7,
    f = c.dayShort.slice(u).concat(c.dayShort.slice(0, u))
  let d, h
  const m = (T, W, M) => new Date(T.getFullYear(), T.getMonth() + (W || 0), T.getDate() + (M || 0))
  let _ = a !== 'normal'
  function w() {
    const T = m(i, 0, 1 - i.getDate())
    return T.setDate(T.getDate() - ((T.getDay() - (u - 7)) % 7)), T
  }
  function b() {
    const T = m(i, 1, -i.getDate())
    return T.setDate(T.getDate() + ((6 - T.getDay() + u) % 7)), T
  }
  const p = {click: z}
  function z(T, W) {
    o && (W.stopPropagation(), o(new Date(new Date(T)))), s && s()
  }
  return (
    (l.$$set = (T) => {
      'value' in T && t(3, (n = T.value)),
        'current' in T && t(4, (i = T.current)),
        'cancel' in T && t(5, (s = T.cancel)),
        'select' in T && t(6, (o = T.select)),
        'part' in T && t(7, (a = T.part)),
        'markers' in T && t(8, (r = T.markers))
    }),
    (l.$$.update = () => {
      if (l.$$.dirty & /*part, value, current, date, markers, days*/ 921) {
        a == 'normal'
          ? t(9, (h = [n ? m(n).valueOf() : 0]))
          : t(
              9,
              (h = n
                ? [n.start ? m(n.start).valueOf() : 0, n.end ? m(n.end).valueOf() : 0]
                : [0, 0])
            )
        const T = w(),
          W = b(),
          M = i.getMonth()
        t(0, (d = []))
        for (let C = T; C <= W; C.setDate(C.getDate() + 1)) {
          const P = {day: C.getDate(), in: C.getMonth() === M, date: C.valueOf()}
          let X = ''
          if (
            ((X += P.in ? '' : ' wx-inactive'),
            (X += h.indexOf(P.date) > -1 ? ' wx-selected' : ''),
            _)
          ) {
            const A = P.date == h[0],
              B = P.date == h[1]
            A && !B ? (X += ' wx-left') : B && !A && (X += ' wx-right'),
              P.date > h[0] && P.date < h[1] && (X += ' wx-inrange')
          }
          if (((X += Oa(C) ? ' wx-weekend' : ''), r)) {
            const A = r(C)
            A && (X += ' ' + A)
          }
          d.push({...P, css: X})
        }
      }
    }),
    [d, f, p, n, i, s, o, a, r, h]
  )
}
class Fa extends ee {
  constructor(e) {
    super(),
      $(this, e, Aa, Ra, x, {value: 3, current: 4, cancel: 5, select: 6, part: 7, markers: 8})
  }
}
function Ul(l, e, t) {
  const n = l.slice()
  return (n[9] = e[t]), (n[11] = t), n
}
function Jl(l) {
  let e
  return {
    c() {
      ;(e = D('div')),
        (e.textContent = `${/*month*/ l[9]} `),
        g(e, 'class', 'wx-month x2-pmn9ti'),
        g(e, 'data-id', /*i*/ l[11]),
        Q(e, 'wx-current', /*monthNum*/ l[1] === /*i*/ l[11])
    },
    m(t, n) {
      S(t, e, n)
    },
    p(t, n) {
      n & /*monthNum*/ 2 && Q(e, 'wx-current', /*monthNum*/ t[1] === /*i*/ t[11])
    },
    d(t) {
      t && v(e)
    },
  }
}
function Pa(l) {
  let e = /*locale*/ l[2].done + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p: I,
    d(n) {
      n && v(t)
    },
  }
}
function Ya(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r = de(/*months*/ l[3]),
    c = []
  for (let u = 0; u < r.length; u += 1) c[u] = Jl(Ul(l, r, u))
  return (
    (i = new _n({props: {click: /*cancel*/ l[0], $$slots: {default: [Pa]}, $$scope: {ctx: l}}})),
    {
      c() {
        e = D('div')
        for (let u = 0; u < c.length; u += 1) c[u].c()
        ;(t = Y()),
          (n = D('div')),
          F(i.$$.fragment),
          g(e, 'class', 'wx-months x2-pmn9ti'),
          g(n, 'class', 'wx-buttons x2-pmn9ti')
      },
      m(u, f) {
        S(u, e, f)
        for (let d = 0; d < c.length; d += 1) c[d] && c[d].m(e, null)
        S(u, t, f),
          S(u, n, f),
          R(i, n, null),
          (s = !0),
          o || ((a = nt(In.call(null, e, /*selectMonths*/ l[4]))), (o = !0))
      },
      p(u, _ref11) {
        let [f] = _ref11
        if (f & /*monthNum, months*/ 10) {
          r = de(/*months*/ u[3])
          let h
          for (h = 0; h < r.length; h += 1) {
            const m = Ul(u, r, h)
            c[h] ? c[h].p(m, f) : ((c[h] = Jl(m)), c[h].c(), c[h].m(e, null))
          }
          for (; h < c.length; h += 1) c[h].d(1)
          c.length = r.length
        }
        const d = {}
        f & /*cancel*/ 1 && (d.click = /*cancel*/ u[0]),
          f & /*$$scope*/ 4096 && (d.$$scope = {dirty: f, ctx: u}),
          i.$set(d)
      },
      i(u) {
        s || (k(i.$$.fragment, u), (s = !0))
      },
      o(u) {
        y(i.$$.fragment, u), (s = !1)
      },
      d(u) {
        u && (v(e), v(t), v(n)), $e(c, u), O(i), (o = !1), a()
      },
    }
  )
}
function Ba(l, e, t) {
  let {value: n} = e,
    {current: i} = e,
    {cancel: s} = e,
    {part: o} = e
  const a = ze('wx-i18n').getRaw().calendar,
    r = a.monthShort
  let c
  const u = {click: f}
  function f(d, h) {
    ;(d || d === 0) && (h.stopPropagation(), i.setMonth(d), t(6, i)),
      o === 'normal' && t(5, (n = new Date(i))),
      s()
  }
  return (
    (l.$$set = (d) => {
      'value' in d && t(5, (n = d.value)),
        'current' in d && t(6, (i = d.current)),
        'cancel' in d && t(0, (s = d.cancel)),
        'part' in d && t(7, (o = d.part))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*part, value, current*/ 224 &&
        (o !== 'normal' && n
          ? o === 'left' && n.start
            ? t(1, (c = n.start.getMonth()))
            : o === 'right' && n.end
            ? t(1, (c = n.end.getMonth()))
            : t(1, (c = i.getMonth()))
          : t(1, (c = i.getMonth())))
    }),
    [s, c, a, r, u, n, i, o]
  )
}
class ja extends ee {
  constructor(e) {
    super(), $(this, e, Ba, Ya, x, {value: 5, current: 6, cancel: 0, part: 7})
  }
}
function Ql(l, e, t) {
  const n = l.slice()
  return (n[9] = e[t]), (n[11] = t), n
}
function xl(l) {
  let e,
    t = /*y*/ l[9] + '',
    n,
    i,
    s
  return {
    c() {
      ;(e = D('div')),
        (n = re(t)),
        (i = Y()),
        g(e, 'class', 'wx-year x2-is1ghx'),
        g(e, 'data-id', (s = /*y*/ l[9])),
        Q(e, 'wx-current', /*year*/ l[2] == /*y*/ l[9]),
        Q(e, 'wx-prev-decade', /*i*/ l[11] === 0),
        Q(e, 'wx-next-decade', /*i*/ l[11] === 11)
    },
    m(o, a) {
      S(o, e, a), H(e, n), H(e, i)
    },
    p(o, a) {
      a & /*years*/ 2 && t !== (t = /*y*/ o[9] + '') && me(n, t),
        a & /*years*/ 2 && s !== (s = /*y*/ o[9]) && g(e, 'data-id', s),
        a & /*year, years*/ 6 && Q(e, 'wx-current', /*year*/ o[2] == /*y*/ o[9])
    },
    d(o) {
      o && v(e)
    },
  }
}
function Za(l) {
  let e = /*_*/ l[3].done + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p: I,
    d(n) {
      n && v(t)
    },
  }
}
function qa(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r = de(/*years*/ l[1]),
    c = []
  for (let u = 0; u < r.length; u += 1) c[u] = xl(Ql(l, r, u))
  return (
    (i = new _n({props: {click: /*cancel*/ l[0], $$slots: {default: [Za]}, $$scope: {ctx: l}}})),
    {
      c() {
        e = D('div')
        for (let u = 0; u < c.length; u += 1) c[u].c()
        ;(t = Y()),
          (n = D('div')),
          F(i.$$.fragment),
          g(e, 'class', 'wx-years x2-is1ghx'),
          g(n, 'class', 'wx-buttons x2-is1ghx')
      },
      m(u, f) {
        S(u, e, f)
        for (let d = 0; d < c.length; d += 1) c[d] && c[d].m(e, null)
        S(u, t, f),
          S(u, n, f),
          R(i, n, null),
          (s = !0),
          o || ((a = nt(In.call(null, e, /*selectYears*/ l[4]))), (o = !0))
      },
      p(u, _ref12) {
        let [f] = _ref12
        if (f & /*years, year*/ 6) {
          r = de(/*years*/ u[1])
          let h
          for (h = 0; h < r.length; h += 1) {
            const m = Ql(u, r, h)
            c[h] ? c[h].p(m, f) : ((c[h] = xl(m)), c[h].c(), c[h].m(e, null))
          }
          for (; h < c.length; h += 1) c[h].d(1)
          c.length = r.length
        }
        const d = {}
        f & /*cancel*/ 1 && (d.click = /*cancel*/ u[0]),
          f & /*$$scope*/ 4096 && (d.$$scope = {dirty: f, ctx: u}),
          i.$set(d)
      },
      i(u) {
        s || (k(i.$$.fragment, u), (s = !0))
      },
      o(u) {
        y(i.$$.fragment, u), (s = !1)
      },
      d(u) {
        u && (v(e), v(t), v(n)), $e(c, u), O(i), (o = !1), a()
      },
    }
  )
}
function Ka(l, e, t) {
  const n = ze('wx-i18n').getRaw().calendar
  let {value: i} = e,
    {current: s} = e,
    {cancel: o} = e,
    {part: a} = e,
    r,
    c
  const u = {click: f}
  function f(d, h) {
    d && (h.stopPropagation(), s.setFullYear(d), t(5, s)),
      a === 'normal' && t(6, (i = new Date(s))),
      o()
  }
  return (
    (l.$$set = (d) => {
      'value' in d && t(6, (i = d.value)),
        'current' in d && t(5, (s = d.current)),
        'cancel' in d && t(0, (o = d.cancel)),
        'part' in d && t(7, (a = d.part))
    }),
    (l.$$.update = () => {
      if (l.$$.dirty & /*current, year, years*/ 38) {
        t(2, (c = s.getFullYear()))
        const d = c - (c % 10) - 1,
          h = d + 12
        t(1, (r = []))
        for (let m = d; m < h; ++m) r.push(m)
      }
    }),
    [o, r, c, n, u, s, i, a]
  )
}
class Ga extends ee {
  constructor(e) {
    super(), $(this, e, Ka, qa, x, {value: 6, current: 5, cancel: 0, part: 7})
  }
}
const Un = {
  month: {component: Fa, next: Va, prev: Xa},
  year: {component: ja, next: Ja, prev: Ua},
  duodecade: {component: Ga, next: xa, prev: Qa},
}
function Xa(l) {
  let e = new Date(l)
  for (e.setMonth(l.getMonth() - 1); l.getMonth() === e.getMonth(); ) e.setDate(e.getDate() - 1)
  return e
}
function Va(l) {
  return (l = new Date(l)), l.setDate(1), l.setMonth(l.getMonth() + 1), l
}
function Ua(l) {
  return (l = new Date(l)), l.setFullYear(l.getFullYear() - 1), l
}
function Ja(l) {
  return (l = new Date(l)), l.setFullYear(l.getFullYear() + 1), l
}
function Qa(l) {
  return (l = new Date(l)), l.setFullYear(l.getFullYear() - 10), l
}
function xa(l) {
  return (l = new Date(l)), l.setFullYear(l.getFullYear() + 10), l
}
function $l(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r,
    c = /*done*/ l[2] && ei(l)
  return (
    (i = new _n({props: {click: /*func_1*/ l[14], $$slots: {default: [ec]}, $$scope: {ctx: l}}})),
    (a = new _n({props: {click: /*func_2*/ l[15], $$slots: {default: [tc]}, $$scope: {ctx: l}}})),
    {
      c() {
        ;(e = D('div')),
          c && c.c(),
          (t = Y()),
          (n = D('div')),
          F(i.$$.fragment),
          (s = Y()),
          (o = D('div')),
          F(a.$$.fragment),
          g(n, 'class', 'wx-button-item x2-9ihaic'),
          g(o, 'class', 'wx-button-item x2-9ihaic'),
          g(e, 'class', 'wx-buttons x2-9ihaic')
      },
      m(u, f) {
        S(u, e, f),
          c && c.m(e, null),
          H(e, t),
          H(e, n),
          R(i, n, null),
          H(e, s),
          H(e, o),
          R(a, o, null),
          (r = !0)
      },
      p(u, f) {
        /*done*/ u[2]
          ? c
            ? (c.p(u, f), f & /*done*/ 4 && k(c, 1))
            : ((c = ei(u)), c.c(), k(c, 1), c.m(e, t))
          : c &&
            (te(),
            y(c, 1, 1, () => {
              c = null
            }),
            ne())
        const d = {}
        f & /*$$scope*/ 131072 && (d.$$scope = {dirty: f, ctx: u}), i.$set(d)
        const h = {}
        f & /*$$scope*/ 131072 && (h.$$scope = {dirty: f, ctx: u}), a.$set(h)
      },
      i(u) {
        r || (k(c), k(i.$$.fragment, u), k(a.$$.fragment, u), (r = !0))
      },
      o(u) {
        y(c), y(i.$$.fragment, u), y(a.$$.fragment, u), (r = !1)
      },
      d(u) {
        u && v(e), c && c.d(), O(i), O(a)
      },
    }
  )
}
function ei(l) {
  let e, t, n
  return (
    (t = new _n({props: {click: /*func*/ l[13], $$slots: {default: [$a]}, $$scope: {ctx: l}}})),
    {
      c() {
        ;(e = D('div')), F(t.$$.fragment), g(e, 'class', 'wx-button-item x2-9ihaic')
      },
      m(i, s) {
        S(i, e, s), R(t, e, null), (n = !0)
      },
      p(i, s) {
        const o = {}
        s & /*$$scope*/ 131072 && (o.$$scope = {dirty: s, ctx: i}), t.$set(o)
      },
      i(i) {
        n || (k(t.$$.fragment, i), (n = !0))
      },
      o(i) {
        y(t.$$.fragment, i), (n = !1)
      },
      d(i) {
        i && v(e), O(t)
      },
    }
  )
}
function $a(l) {
  let e = /*_*/ l[7]('done') + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p: I,
    d(n) {
      n && v(t)
    },
  }
}
function ec(l) {
  let e = /*_*/ l[7]('clear') + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p: I,
    d(n) {
      n && v(t)
    },
  }
}
function tc(l) {
  let e = /*_*/ l[7]('today') + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p: I,
    d(n) {
      n && v(t)
    },
  }
}
function nc(l) {
  let e, t, n, i, s, o, a, r, c
  ;(n = new La({props: {date: /*current*/ l[1], part: /*part*/ l[3], type: /*type*/ l[6]}})),
    n.$on('shift', /*shift_handler*/ l[12])
  var u = Un[/*type*/ l[6]].component
  function f(h, m) {
    return {
      props: {
        value: /*value*/ h[0],
        current: /*current*/ h[1],
        part: /*part*/ h[3],
        markers: /*markers*/ h[4],
        select: /*select*/ h[11],
        cancel: /*cancel*/ h[9],
      },
    }
  }
  u && (o = Le(u, f(l)))
  let d = /*type*/ l[6] === 'month' && /*buttons*/ l[5] && $l(l)
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        F(n.$$.fragment),
        (i = Y()),
        (s = D('div')),
        o && F(o.$$.fragment),
        (a = Y()),
        d && d.c(),
        g(t, 'class', 'wx-wrap x2-9ihaic'),
        g(
          e,
          'class',
          (r =
            'wx-calendar ' +
            /*part*/ (l[3] !== 'normal' && /*part*/ l[3] !== 'both' ? 'wx-part' : '') +
            ' x2-9ihaic')
        )
    },
    m(h, m) {
      S(h, e, m),
        H(e, t),
        R(n, t, null),
        H(t, i),
        H(t, s),
        o && R(o, s, null),
        H(s, a),
        d && d.m(s, null),
        (c = !0)
    },
    p(h, _ref13) {
      let [m] = _ref13
      const _ = {}
      if (
        (m & /*current*/ 2 && (_.date = /*current*/ h[1]),
        m & /*part*/ 8 && (_.part = /*part*/ h[3]),
        m & /*type*/ 64 && (_.type = /*type*/ h[6]),
        n.$set(_),
        m & /*type*/ 64 && u !== (u = Un[/*type*/ h[6]].component))
      ) {
        if (o) {
          te()
          const w = o
          y(w.$$.fragment, 1, 0, () => {
            O(w, 1)
          }),
            ne()
        }
        u ? ((o = Le(u, f(h))), F(o.$$.fragment), k(o.$$.fragment, 1), R(o, s, a)) : (o = null)
      } else if (u) {
        const w = {}
        m & /*value*/ 1 && (w.value = /*value*/ h[0]),
          m & /*current*/ 2 && (w.current = /*current*/ h[1]),
          m & /*part*/ 8 && (w.part = /*part*/ h[3]),
          m & /*markers*/ 16 && (w.markers = /*markers*/ h[4]),
          o.$set(w)
      }
      /*type*/ h[6] === 'month' && /*buttons*/ h[5]
        ? d
          ? (d.p(h, m), m & /*type, buttons*/ 96 && k(d, 1))
          : ((d = $l(h)), d.c(), k(d, 1), d.m(s, null))
        : d &&
          (te(),
          y(d, 1, 1, () => {
            d = null
          }),
          ne()),
        (!c ||
          (m & /*part*/ 8 &&
            r !==
              (r =
                'wx-calendar ' +
                /*part*/ (h[3] !== 'normal' && /*part*/ h[3] !== 'both' ? 'wx-part' : '') +
                ' x2-9ihaic'))) &&
          g(e, 'class', r)
    },
    i(h) {
      c || (k(n.$$.fragment, h), o && k(o.$$.fragment, h), k(d), (c = !0))
    },
    o(h) {
      y(n.$$.fragment, h), o && y(o.$$.fragment, h), y(d), (c = !1)
    },
    d(h) {
      h && v(e), O(n), o && O(o), d && d.d()
    },
  }
}
function lc(l, e, t) {
  const n = He(),
    i = ze('wx-i18n').getGroup('calendar')
  let {value: s} = e,
    {current: o} = e,
    {done: a = !1} = e,
    {part: r = 'normal'} = e,
    {markers: c = null} = e,
    {buttons: u = !0} = e,
    f = 'month'
  function d(T, W) {
    T.preventDefault(), n('change', {value: W})
  }
  function h() {
    f === 'duodecade' ? t(6, (f = 'year')) : f === 'year' && t(6, (f = 'month'))
  }
  function m(T) {
    T.diff == 0
      ? f === 'month'
        ? t(6, (f = 'year'))
        : f === 'year' && t(6, (f = 'duodecade'))
      : n('shift', T)
  }
  function _(T) {
    n('change', {select: !0, value: T})
  }
  const w = (T) => m(T.detail),
    b = (T) => d(T, -1),
    p = (T) => d(T, null),
    z = (T) => d(T, /* @__PURE__ */ new Date())
  return (
    (l.$$set = (T) => {
      'value' in T && t(0, (s = T.value)),
        'current' in T && t(1, (o = T.current)),
        'done' in T && t(2, (a = T.done)),
        'part' in T && t(3, (r = T.part)),
        'markers' in T && t(4, (c = T.markers)),
        'buttons' in T && t(5, (u = T.buttons))
    }),
    [s, o, a, r, c, u, f, i, d, h, m, _, w, b, p, z]
  )
}
class ic extends ee {
  constructor(e) {
    super(), $(this, e, lc, nc, x, {value: 0, current: 1, done: 2, part: 3, markers: 4, buttons: 5})
  }
}
function sc(l) {
  let e, t
  return (
    (e = new ic({
      props: {
        value: /*value*/ l[0],
        current: /*current*/ l[1],
        markers: /*markers*/ l[2],
        buttons: /*buttons*/ l[3],
      },
    })),
    e.$on('shift', /*shift_handler*/ l[6]),
    e.$on('change', /*change_handler*/ l[7]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, _ref14) {
        let [i] = _ref14
        const s = {}
        i & /*value*/ 1 && (s.value = /*value*/ n[0]),
          i & /*current*/ 2 && (s.current = /*current*/ n[1]),
          i & /*markers*/ 4 && (s.markers = /*markers*/ n[2]),
          i & /*buttons*/ 8 && (s.buttons = /*buttons*/ n[3]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function oc(l, e, t) {
  const n = He()
  let {value: i} = e,
    {current: s} = e,
    {markers: o = null} = e,
    {buttons: a = !0} = e
  function r() {
    s || t(1, (s = i ? new Date(i) : /* @__PURE__ */ new Date()))
  }
  function c(_ref15) {
    let {diff: h, type: m} = _ref15
    const _ = Un[m]
    t(1, (s = h > 0 ? _.next(s) : _.prev(s)))
  }
  function u(h) {
    const m = h.value
    m ? (t(1, (s = new Date(m))), t(0, (i = new Date(m)))) : t(0, (i = null)),
      n('change', {value: i})
  }
  const f = (h) => c(h.detail),
    d = (h) => u(h.detail)
  return (
    (l.$$set = (h) => {
      'value' in h && t(0, (i = h.value)),
        'current' in h && t(1, (s = h.current)),
        'markers' in h && t(2, (o = h.markers)),
        'buttons' in h && t(3, (a = h.buttons))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*value*/ 1 && r()
    }),
    [i, s, o, a, c, u, f, d]
  )
}
class bo extends ee {
  constructor(e) {
    super(), $(this, e, oc, sc, x, {value: 0, current: 1, markers: 2, buttons: 3})
  }
}
function ti(l) {
  let e, t
  return (
    (e = new pn({
      props: {
        cancel: /*cancel*/ l[13],
        width: /*width*/ l[4],
        align: /*align*/ l[5],
        autoFit: !!(/*align*/ l[5]),
        $$slots: {default: [rc]},
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*width*/ 16 && (s.width = /*width*/ n[4]),
          i & /*align*/ 32 && (s.align = /*align*/ n[5]),
          i & /*align*/ 32 && (s.autoFit = !!(/*align*/ n[5])),
          i & /*$$scope, buttons, value*/ 16777345 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function rc(l) {
  let e, t
  return (
    (e = new bo({props: {buttons: /*buttons*/ l[7], value: /*value*/ l[0]}})),
    e.$on('change', /*change_handler*/ l[17]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*buttons*/ 128 && (s.buttons = /*buttons*/ n[7]),
          i & /*value*/ 1 && (s.value = /*value*/ n[0]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function ac(l) {
  let e, t, n, i, s, o
  ;(t = new wo({
    props: {
      css: /*css*/ l[8],
      title: /*title*/ l[9],
      value: /*formattedValue*/ l[12],
      id: /*id*/ l[1],
      readonly: !(/*editable*/ l[10]),
      disabled: /*disabled*/ l[2],
      error: /*error*/ l[3],
      placeholder: /*placeholder*/ l[6],
      icon: 'wxi-calendar',
      inputStyle:
        'cursor: pointer; width: 100%; padding-right: calc(var(--wx-input-icon-size) + var(--wx-input-icon-indent) * 2);',
    },
  })),
    t.$on('input', /*cancel*/ l[13]),
    t.$on('change', /*doChangeInput*/ l[15])
  let a = /*popup*/ l[11] && !(/*disabled*/ l[2]) && ti(l)
  return {
    c() {
      ;(e = D('div')),
        F(t.$$.fragment),
        (n = Y()),
        a && a.c(),
        g(e, 'class', 'wx-datepicker x2-1k3rk87')
    },
    m(r, c) {
      S(r, e, c),
        R(t, e, null),
        H(e, n),
        a && a.m(e, null),
        (i = !0),
        s ||
          ((o = [q(window, 'scroll', /*cancel*/ l[13]), q(e, 'click', /*click_handler*/ l[18])]),
          (s = !0))
    },
    p(r, _ref16) {
      let [c] = _ref16
      const u = {}
      c & /*css*/ 256 && (u.css = /*css*/ r[8]),
        c & /*title*/ 512 && (u.title = /*title*/ r[9]),
        c & /*formattedValue*/ 4096 && (u.value = /*formattedValue*/ r[12]),
        c & /*id*/ 2 && (u.id = /*id*/ r[1]),
        c & /*editable*/ 1024 && (u.readonly = !(/*editable*/ r[10])),
        c & /*disabled*/ 4 && (u.disabled = /*disabled*/ r[2]),
        c & /*error*/ 8 && (u.error = /*error*/ r[3]),
        c & /*placeholder*/ 64 && (u.placeholder = /*placeholder*/ r[6]),
        t.$set(u),
        /*popup*/ r[11] && !(/*disabled*/ r[2])
          ? a
            ? (a.p(r, c), c & /*popup, disabled*/ 2052 && k(a, 1))
            : ((a = ti(r)), a.c(), k(a, 1), a.m(e, null))
          : a &&
            (te(),
            y(a, 1, 1, () => {
              a = null
            }),
            ne())
    },
    i(r) {
      i || (k(t.$$.fragment, r), k(a), (i = !0))
    },
    o(r) {
      y(t.$$.fragment, r), y(a), (i = !1)
    },
    d(r) {
      r && v(e), O(t), a && a.d(), (s = !1), Ee(o)
    },
  }
}
function cc(l, e, t) {
  let {value: n} = e,
    {id: i = Rt()} = e,
    {disabled: s = !1} = e,
    {error: o = !1} = e,
    {width: a = 'unset'} = e,
    {align: r = 'start'} = e,
    {placeholder: c = ''} = e,
    {format: u} = e,
    {buttons: f = !0} = e,
    {css: d = ''} = e,
    {title: h = ''} = e,
    {editable: m = !1} = e
  const _ = He(),
    {calendar: w, formats: b} = ze('wx-i18n').getRaw(),
    p = u || b.dateFormat
  let z = typeof p == 'function' ? p : Jr(p, w),
    T
  function W() {
    t(11, (T = !1))
  }
  function M(B) {
    const V = B === n || (B && n && B.valueOf() === n.valueOf()) || (!B && !n)
    t(0, (n = B)), V || _('select', {selected: B}), setTimeout(W, 1)
  }
  let C
  function P(B) {
    if (!m) return
    const {value: V, input: fe} = B.detail
    if (fe) return
    t(12, (C = ''))
    let L = typeof m == 'function' ? m(V) : V ? new Date(V) : null
    ;(L = isNaN(L) ? n || null : L || null), M(L)
  }
  const X = (B) => M(B.detail.value),
    A = () => t(11, (T = !0))
  return (
    (l.$$set = (B) => {
      'value' in B && t(0, (n = B.value)),
        'id' in B && t(1, (i = B.id)),
        'disabled' in B && t(2, (s = B.disabled)),
        'error' in B && t(3, (o = B.error)),
        'width' in B && t(4, (a = B.width)),
        'align' in B && t(5, (r = B.align)),
        'placeholder' in B && t(6, (c = B.placeholder)),
        'format' in B && t(16, (u = B.format)),
        'buttons' in B && t(7, (f = B.buttons)),
        'css' in B && t(8, (d = B.css)),
        'title' in B && t(9, (h = B.title)),
        'editable' in B && t(10, (m = B.editable))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*value*/ 1 && t(12, (C = n ? z(n) : ''))
    }),
    [n, i, s, o, a, r, c, f, d, h, m, T, C, W, M, P, u, X, A]
  )
}
class uc extends ee {
  constructor(e) {
    super(),
      $(this, e, cc, ac, x, {
        value: 0,
        id: 1,
        disabled: 2,
        error: 3,
        width: 4,
        align: 5,
        placeholder: 6,
        format: 16,
        buttons: 7,
        css: 8,
        title: 9,
        editable: 10,
      })
  }
}
function ni(l) {
  let e, t
  return {
    c() {
      ;(e = D('label')),
        (t = re(/*label*/ l[2])),
        g(e, 'for', /*id*/ l[1]),
        g(e, 'class', 'x2-vxce8u')
    },
    m(n, i) {
      S(n, e, i), H(e, t)
    },
    p(n, i) {
      i & /*label*/ 4 && me(t, /*label*/ n[2]), i & /*id*/ 2 && g(e, 'for', /*id*/ n[1])
    },
    d(n) {
      n && v(e)
    },
  }
}
function fc(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r = /*label*/ l[2] && ni(l)
  return {
    c() {
      ;(e = D('div')),
        r && r.c(),
        (t = Y()),
        (n = D('div')),
        (i = D('input')),
        g(i, 'id', /*id*/ l[1]),
        g(i, 'type', 'range'),
        g(i, 'min', /*min*/ l[4]),
        g(i, 'max', /*max*/ l[5]),
        g(i, 'step', /*step*/ l[6]),
        (i.disabled = /*disabled*/ l[8]),
        g(i, 'style', /*bgStyle*/ l[9]),
        g(i, 'class', 'x2-vxce8u'),
        g(n, 'class', 'x2-vxce8u'),
        g(e, 'class', 'wx-slider x2-vxce8u'),
        g(e, 'style', (s = /*width*/ l[3] ? `width: ${/*width*/ l[3]}` : '')),
        g(e, 'title', /*title*/ l[7])
    },
    m(c, u) {
      S(c, e, u),
        r && r.m(e, null),
        H(e, t),
        H(e, n),
        H(n, i),
        Ue(i, /*value*/ l[0]),
        o ||
          ((a = [
            q(i, 'change', /*input_change_input_handler*/ l[13]),
            q(i, 'input', /*input_change_input_handler*/ l[13]),
            q(i, 'change', /*onChange*/ l[10]),
          ]),
          (o = !0))
    },
    p(c, _ref17) {
      let [u] = _ref17
      /*label*/ c[2]
        ? r
          ? r.p(c, u)
          : ((r = ni(c)), r.c(), r.m(e, t))
        : r && (r.d(1), (r = null)),
        u & /*id*/ 2 && g(i, 'id', /*id*/ c[1]),
        u & /*min*/ 16 && g(i, 'min', /*min*/ c[4]),
        u & /*max*/ 32 && g(i, 'max', /*max*/ c[5]),
        u & /*step*/ 64 && g(i, 'step', /*step*/ c[6]),
        u & /*disabled*/ 256 && (i.disabled = /*disabled*/ c[8]),
        u & /*bgStyle*/ 512 && g(i, 'style', /*bgStyle*/ c[9]),
        u & /*value*/ 1 && Ue(i, /*value*/ c[0]),
        u & /*width*/ 8 &&
          s !== (s = /*width*/ c[3] ? `width: ${/*width*/ c[3]}` : '') &&
          g(e, 'style', s),
        u & /*title*/ 128 && g(e, 'title', /*title*/ c[7])
    },
    i: I,
    o: I,
    d(c) {
      c && v(e), r && r.d(), (o = !1), Ee(a)
    },
  }
}
function dc(l, e, t) {
  const n = He()
  let {id: i = Rt()} = e,
    {label: s = ''} = e,
    {width: o = ''} = e,
    {min: a = 0} = e,
    {max: r = 100} = e,
    {value: c = 0} = e,
    {step: u = 1} = e,
    {title: f = ''} = e,
    {disabled: d = !1} = e,
    h = 0,
    m = '',
    _
  function w(_ref18) {
    let {target: p} = _ref18
    const z = p.value * 1
    n('change', {value: z}), t(0, (c = z))
  }
  function b() {
    ;(c = il(this.value)), t(0, c), t(4, a), t(5, r), t(8, d), t(11, h), t(12, _)
  }
  return (
    (l.$$set = (p) => {
      'id' in p && t(1, (i = p.id)),
        'label' in p && t(2, (s = p.label)),
        'width' in p && t(3, (o = p.width)),
        'min' in p && t(4, (a = p.min)),
        'max' in p && t(5, (r = p.max)),
        'value' in p && t(0, (c = p.value)),
        'step' in p && t(6, (u = p.step)),
        'title' in p && t(7, (f = p.title)),
        'disabled' in p && t(8, (d = p.disabled))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*value, min, max, disabled, progress, previous*/ 6449 &&
        (t(11, (h = ((c - a) / (r - a)) * 100 + '%')),
        t(
          9,
          (m = d
            ? ''
            : `background: linear-gradient(90deg, var(--wx-slider-primary) 0% ${h}, var(--wx-slider-background) ${h} 100%);`)
        ),
        isNaN(c) && t(0, (c = 0)),
        _ !== c && (n('change', {value: c, previous: _, input: !0}), t(12, (_ = c))))
    }),
    [c, i, s, o, a, r, u, f, d, m, w, h, _, b]
  )
}
class hc extends ee {
  constructor(e) {
    super(),
      $(this, e, dc, fc, x, {
        id: 1,
        label: 2,
        width: 3,
        min: 4,
        max: 5,
        value: 0,
        step: 6,
        title: 7,
        disabled: 8,
      })
  }
}
const mc = (l) => ({}),
  li = (l) => ({id: /*id*/ l[5]})
function ii(l) {
  let e, t
  return {
    c() {
      ;(e = D('label')),
        (t = re(/*label*/ l[0])),
        g(e, 'for', /*id*/ l[5]),
        g(e, 'class', 'x2-16h42zq')
    },
    m(n, i) {
      S(n, e, i), H(e, t)
    },
    p(n, i) {
      i & /*label*/ 1 && me(t, /*label*/ n[0])
    },
    d(n) {
      n && v(e)
    },
  }
}
function _c(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r = /*label*/ l[0] && ii(l)
  const c = /*#slots*/ l[7].default,
    u = Ie(c, l, /*$$scope*/ l[6], li)
  return {
    c() {
      ;(e = D('div')),
        r && r.c(),
        (t = Y()),
        (n = D('div')),
        u && u.c(),
        g(n, 'class', (i = 'wx-field-control wx-' + /*type*/ l[4] + ' x2-16h42zq')),
        g(e, 'class', (s = 'wx-field wx-' + /*position*/ l[1] + ' x2-16h42zq')),
        g(e, 'style', (o = /*width*/ l[2] ? `width: ${/*width*/ l[2]}` : '')),
        Q(e, 'wx-error', /*error*/ l[3])
    },
    m(f, d) {
      S(f, e, d), r && r.m(e, null), H(e, t), H(e, n), u && u.m(n, null), (a = !0)
    },
    p(f, _ref19) {
      let [d] = _ref19
      /*label*/ f[0]
        ? r
          ? r.p(f, d)
          : ((r = ii(f)), r.c(), r.m(e, t))
        : r && (r.d(1), (r = null)),
        u &&
          u.p &&
          (!a || d & /*$$scope*/ 64) &&
          Oe(
            u,
            c,
            f,
            /*$$scope*/ f[6],
            a ? Re(c, /*$$scope*/ f[6], d, mc) : Ae(/*$$scope*/ f[6]),
            li
          ),
        (!a ||
          (d & /*type*/ 16 &&
            i !== (i = 'wx-field-control wx-' + /*type*/ f[4] + ' x2-16h42zq'))) &&
          g(n, 'class', i),
        (!a ||
          (d & /*position*/ 2 && s !== (s = 'wx-field wx-' + /*position*/ f[1] + ' x2-16h42zq'))) &&
          g(e, 'class', s),
        (!a || (d & /*width*/ 4 && o !== (o = /*width*/ f[2] ? `width: ${/*width*/ f[2]}` : ''))) &&
          g(e, 'style', o),
        (!a || d & /*position, error*/ 10) && Q(e, 'wx-error', /*error*/ f[3])
    },
    i(f) {
      a || (k(u, f), (a = !0))
    },
    o(f) {
      y(u, f), (a = !1)
    },
    d(f) {
      f && v(e), r && r.d(), u && u.d(f)
    },
  }
}
function gc(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {label: s = ''} = e,
    {position: o = ''} = e,
    {width: a = ''} = e,
    {error: r = !1} = e,
    {type: c = ''} = e,
    u = Rt()
  return (
    (l.$$set = (f) => {
      'label' in f && t(0, (s = f.label)),
        'position' in f && t(1, (o = f.position)),
        'width' in f && t(2, (a = f.width)),
        'error' in f && t(3, (r = f.error)),
        'type' in f && t(4, (c = f.type)),
        '$$scope' in f && t(6, (i = f.$$scope))
    }),
    [s, o, a, r, c, u, i, n]
  )
}
class Ot extends ee {
  constructor(e) {
    super(), $(this, e, gc, _c, x, {label: 0, position: 1, width: 2, error: 3, type: 4})
  }
}
const wc = (l) => ({}),
  si = (l) => ({mount: /*mount*/ l[1]})
function bc(l) {
  let e, t, n, i
  const s = /*#slots*/ l[5].default,
    o = Ie(s, l, /*$$scope*/ l[4], si)
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        o && o.c(),
        g(t, 'class', (n = 'wx-' + /*theme*/ l[0] + '-theme x2-1dixdmq')),
        g(e, 'class', 'wx-portal x2-1dixdmq')
    },
    m(a, r) {
      S(a, e, r), H(e, t), o && o.m(t, null), l[6](t), (i = !0)
    },
    p(a, _ref20) {
      let [r] = _ref20
      o &&
        o.p &&
        (!i || r & /*$$scope*/ 16) &&
        Oe(
          o,
          s,
          a,
          /*$$scope*/ a[4],
          i ? Re(s, /*$$scope*/ a[4], r, wc) : Ae(/*$$scope*/ a[4]),
          si
        ),
        (!i || (r & /*theme*/ 1 && n !== (n = 'wx-' + /*theme*/ a[0] + '-theme x2-1dixdmq'))) &&
          g(t, 'class', n)
    },
    i(a) {
      i || (k(o, a), (i = !0))
    },
    o(a) {
      y(o, a), (i = !1)
    },
    d(a) {
      a && v(e), o && o.d(a), l[6](null)
    },
  }
}
function kc(l) {
  for (; l !== document.body && !l.getAttribute('data-wx-portal-root'); ) l = l.parentNode
  return l
}
function pc(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    s,
    {theme: o = ''} = e,
    {target: a = void 0} = e,
    r = []
  const c = (f) => {
    r && r.push(f)
  }
  o === '' && (o = ze('wx-theme')),
    ht(() => {
      ;(a || kc(s)).appendChild(s), r && r.forEach((d) => d())
    }),
    rl(() => {
      s && s.parentNode && s.parentNode.removeChild(s)
    })
  function u(f) {
    be[f ? 'unshift' : 'push'](() => {
      ;(s = f), t(2, s)
    })
  }
  return (
    (l.$$set = (f) => {
      'theme' in f && t(0, (o = f.theme)),
        'target' in f && t(3, (a = f.target)),
        '$$scope' in f && t(4, (i = f.$$scope))
    }),
    [o, c, s, a, i, n, u]
  )
}
class yc extends ee {
  constructor(e) {
    super(), $(this, e, pc, bc, x, {theme: 0, target: 3, mount: 1})
  }
  get mount() {
    return this.$$.ctx[1]
  }
}
const Ic = {
    monthFull: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    dayFull: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    hours: 'Hours',
    minutes: 'Minutes',
    done: 'Done',
    clear: 'Clear',
    today: 'Today',
    am: ['am', 'AM'],
    pm: ['pm', 'PM'],
    weekStart: 7,
    clockFormat: 24,
  },
  Rc = {ok: 'OK', cancel: 'Cancel'},
  Oc = {timeFormat: '%H:%i', dateFormat: '%m/%d/%Y'},
  So = {core: Rc, calendar: Ic, formats: Oc}
function Ac(l) {
  let e
  const t = /*#slots*/ l[3].default,
    n = Ie(t, l, /*$$scope*/ l[2], null)
  return {
    c() {
      n && n.c()
    },
    m(i, s) {
      n && n.m(i, s), (e = !0)
    },
    p(i, _ref24) {
      let [s] = _ref24
      n &&
        n.p &&
        (!e || s & /*$$scope*/ 4) &&
        Oe(
          n,
          t,
          i,
          /*$$scope*/ i[2],
          e ? Re(t, /*$$scope*/ i[2], s, null) : Ae(/*$$scope*/ i[2]),
          null
        )
    },
    i(i) {
      e || (k(n, i), (e = !0))
    },
    o(i) {
      y(n, i), (e = !1)
    },
    d(i) {
      n && n.d(i)
    },
  }
}
function Fc(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {words: s = null} = e,
    {optional: o = !1} = e,
    a = ze('wx-i18n')
  return (
    a || (a = On(So)),
    (a = a.extend(s, o)),
    It('wx-i18n', a),
    (l.$$set = (r) => {
      'words' in r && t(0, (s = r.words)),
        'optional' in r && t(1, (o = r.optional)),
        '$$scope' in r && t(2, (i = r.$$scope))
    }),
    [s, o, i, n]
  )
}
class Mo extends ee {
  constructor(e) {
    super(), $(this, e, Fc, Ac, x, {words: 0, optional: 1})
  }
}
const dl = {
  gantt: {
    // Header / sidebar
    'Task name': 'Task name',
    'Start date': 'Start date',
    Duration: 'Duration',
    Task: 'Task',
    Milestone: 'Milestone',
    'Summary task': 'Summary task', // Sidebar
    Save: 'Save',
    Delete: 'Delete',
    Name: 'Name',
    Description: 'Description',
    'Select type': 'Select type',
    Type: 'Type',
    'End date': 'End date',
    Progress: 'Progress',
    Predecessors: 'Predecessors',
    Successors: 'Successors',
    'Add task name': 'Add task name',
    'Add description': 'Add description',
    'Select link type': 'Select link type',
    'End-to-start': 'End-to-start',
    'Start-to-start': 'Start-to-start',
    'End-to-end': 'End-to-end',
    'Start-to-end': 'Start-to-end', // Context menu / toolbar
    Add: 'Add',
    'Child task': 'Child task',
    'Task above': 'Task above',
    'Task below': 'Task below',
    'Convert to': 'Convert to',
    Edit: 'Edit',
    Cut: 'Cut',
    Copy: 'Copy',
    Paste: 'Paste',
    Move: 'Move',
    Up: 'Up',
    Down: 'Down',
    Indent: 'Indent',
    Outdent: 'Outdent',
    'Split task': 'Split task', // Toolbar
    'New task': 'New task',
    'Move up': 'Move up',
    'Move down': 'Move down',
  },
}
let Pc = /* @__PURE__ */ new Date().valueOf()
const Yc = () => Pc++
class To {
  constructor(e) {
    ;(this._nextHandler = null), (this._dispatch = e), (this.exec = this.exec.bind(this))
  }
  async exec(e, t) {
    return this._dispatch(e, t), this._nextHandler && (await this._nextHandler.exec(e, t)), t
  }
  setNext(e) {
    return (this._nextHandler = e)
  }
}
let Co = /* @__PURE__ */ new Date().valueOf()
const Do = () => Co++
function Wo() {
  return 'temp://' + Co++
}
class ci {
  constructor(e) {
    ;(this._data = e), (this._pool = /* @__PURE__ */ new Map())
    for (let t = 0; t < e.length; t++) {
      const n = e[t]
      this._pool.set(n.id, n)
    }
  }
  add(e) {
    ;(e = {id: Do(), ...e}), this._data.push(e), this._pool.set(e.id, e)
  }
  update(e, t) {
    const n = this._data.findIndex((s) => s.id == e),
      i = {...this._data[n], ...t}
    ;(this._data[n] = i), this._pool.set(i.id, i)
  }
  remove(e) {
    ;(this._data = this._data.filter((t) => t.id != e)), this._pool.delete(e)
  }
  filter(e) {
    this._data = this._data.filter((t) => {
      const n = e(t)
      return n || this._pool.delete(t.id), n
    })
  }
  byId(e) {
    return this._pool.get(e)
  }
  map(e) {
    return this._data.map(e)
  }
  forEach(e) {
    this._data.forEach(e)
  }
}
class Bc {
  constructor(e) {
    const t = {id: 0, $level: 0, data: [], parent: null},
      n = /* @__PURE__ */ new Map()
    n.set(0, t), (this._pool = n), e && e.length && this.parse(e, 0)
  }
  parse(e, t) {
    const n = this._pool
    for (let s = 0; s < e.length; s++) {
      const o = e[s]
      ;(o.parent = o.parent || t), (o.data = null), n.set(o.id, o)
    }
    for (let s = 0; s < e.length; s++) {
      const o = e[s],
        a = n.get(o.parent)
      a && (a.data || (a.data = []), a.data.push(o))
    }
    const i = n.get(t)
    Jn(i.data, i.$level + 1)
  }
  add(e, t) {
    this._pool.set(e.id, e)
    const n = this._pool.get(e.parent || 0)
    ;(e.$level = n.$level + 1),
      n.data ? (t === -1 ? n.data.push(e) : n.data.splice(t, -1, e)) : (n.data = [e])
  }
  addAfter(e, t) {
    if (!t) return this.add(e, -1)
    const n = this.byId(t),
      i = this.byId(n.parent),
      s = i.data.indexOf(n) + 1
    ;(e.parent = i.id), (e.$level = i.$level + 1), this.add(e, s)
  }
  remove(e) {
    const t = this._pool.get(e)
    this._remove(t)
    const n = this._pool.get(t.parent)
    ;(n.data = n.data.filter((i) => i.id != e)), this._clearBranch(n)
  }
  _remove(e) {
    e.data && e.data.forEach((t) => this._remove(t)), this._pool.delete(e.id)
  }
  update(e, t) {
    let n = this._pool.get(e)
    const i = this._pool.get(n.parent),
      s = i.data.indexOf(n)
    ;(n = {...n, ...t}), (i.data[s] = n), this._pool.set(n.id, n)
  }
  move(e, t, n) {
    const i = this._pool.get(e),
      s = t === 'child',
      o = this._pool.get(n),
      a = o.$level + (s ? 1 : 0)
    if (!i || !o) return
    const r = this._pool.get(i.parent),
      c = s ? o : this._pool.get(o.parent)
    c.data || (c.data = [])
    const u = r.data.indexOf(i)
    r.data.splice(u, 1)
    const f = s ? c.data.length : c.data.indexOf(o) + (t === 'after' ? 1 : 0)
    if ((c.data.splice(f, -1, i), r === c && u === f)) return null
    ;(i.parent = c.id), i.$level !== a && Jn([i], a), this._clearBranch(r)
  }
  _clearBranch(e) {
    e.data && !e.data.length && (e.open && delete e.open, (e.data = null))
  }
  toArray() {
    const e = [],
      t = this._pool.get(0).data
    return t && Ho(t, e), e
  }
  byId(e) {
    return this._pool.get(e)
  }
  getBranch(e) {
    return this._pool.get(e).data
  }
  forEach(e) {
    this._pool.forEach((t, n) => {
      n !== 0 && e(t)
    })
  }
  eachChild(e, t) {
    const n = this.byId(t)
    !n ||
      !n.data ||
      n.data.forEach((i, s) => {
        e(this.byId(i.id), s), this.eachChild(e, i.id)
      })
  }
}
function Ho(l, e) {
  l.forEach((t) => {
    e.push(t), t.open === !0 && Ho(t.data, e)
  })
}
function Jn(l, e) {
  for (let t = 0; t < l.length; t++) {
    const n = l[t]
    ;(n.$level = e), n.data && Jn(n.data, e + 1)
  }
}
const zo = 2
class jc {
  constructor(e) {
    e && ((this._writable = e.writable), (this._async = e.async)),
      (this._values = {}),
      (this._state = {})
  }
  setState(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0
    const n = {}
    return this._wrapProperties(e, this._state, this._values, '', n, t), n
  }
  getState() {
    return this._values
  }
  getReactive() {
    return this._state
  }
  _wrapProperties(e, t, n, i, s, o) {
    for (const a in e) {
      const r = t[a],
        c = n[a],
        u = e[a]
      if (
        r &&
        ((c === u && typeof u != 'object') ||
          (u instanceof Date && c instanceof Date && c.getTime() === u.getTime()))
      )
        continue
      const f = i + (i ? '.' : '') + a
      r
        ? (r.__parse(u, f, s, o) && (n[a] = u), o & zo ? (s[f] = r.__trigger) : r.__trigger())
        : (u && u.__reactive
            ? (t[a] = this._wrapNested(u, u, f, s))
            : (t[a] = this._wrapWritable(u)),
          (n[a] = u)),
        (s[f] = s[f] || null)
    }
  }
  _wrapNested(e, t, n, i) {
    const s = this._wrapWritable(e)
    return (
      this._wrapProperties(e, s, t, n, i, 0),
      (s.__parse = (o, a, r, c) => (this._wrapProperties(o, s, t, a, r, c), !1)),
      s
    )
  }
  _wrapWritable(e) {
    const t = [],
      n = function () {
        for (let i = 0; i < t.length; i++) t[i](e)
      }
    return {
      subscribe: (i) => (
        t.push(i),
        this._async ? setTimeout(i, 1, e) : i(e),
        () => {
          const s = t.indexOf(i)
          s >= 0 && t.splice(s, 1)
        }
      ),
      __trigger: () => {
        t.length && (this._async ? setTimeout(n, 1) : n())
      },
      __parse: function (i) {
        return (e = i), !0
      },
    }
  }
}
class Zc {
  constructor(e, t, n, i) {
    typeof e == 'function' ? (this._setter = e) : (this._setter = e.setState.bind(e)),
      (this._routes = t),
      (this._parsers = n),
      (this._prev = {}),
      (this._triggers = /* @__PURE__ */ new Map()),
      (this._sources = /* @__PURE__ */ new Map()),
      this._routes.forEach((s) => {
        s.in.forEach((o) => {
          const a = this._triggers.get(o) || []
          a.push(s), this._triggers.set(o, a)
        }),
          s.out.forEach((o) => {
            const a = this._sources.get(o) || {}
            s.in.forEach((r) => (a[r] = !0)), this._sources.set(o, a)
          })
      }),
      this._routes.forEach((s) => {
        s.length = Math.max(...s.in.map((o) => No(o, this._sources, 1)))
      }),
      (this._bus = i)
  }
  init(e) {
    const t = {}
    for (const n in e)
      if (this._prev[n] !== e[n]) {
        const i = this._parsers[n]
        t[n] = i ? i(e[n]) : e[n]
      }
    ;(this._prev = this._prev ? {...this._prev, ...e} : {...e}),
      this.setState(t),
      this._bus && this._bus.exec('init-state', t)
  }
  setStateAsync(e) {
    const t = this._setter(e, zo)
    return (
      this._async
        ? Object.assign(this._async.signals, t)
        : (this._async = {signals: t, timer: setTimeout(this._applyState.bind(this), 1)}),
      t
    )
  }
  _applyState() {
    const e = this._async
    if (e) {
      ;(this._async = null), this._triggerUpdates(e.signals, [])
      for (const t in e.signals) {
        const n = e.signals[t]
        n && n()
      }
    }
  }
  setState(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []
    const n = this._setter(e)
    return this._triggerUpdates(n, t), n
  }
  _triggerUpdates(e, t) {
    const n = Object.keys(e),
      i = !t.length
    t = t || []
    for (let s = 0; s < n.length; s++) {
      const o = n[s],
        a = this._triggers.get(o)
      a &&
        a.forEach((r) => {
          t.indexOf(r) == -1 && t.push(r)
        })
    }
    i && this._execNext(t)
  }
  _execNext(e) {
    for (; e.length; ) {
      e.sort((n, i) => (n.length < i.length ? 1 : -1))
      const t = e[e.length - 1]
      e.splice(e.length - 1), t.exec(e)
    }
  }
}
function No(l, e, t) {
  const n = e.get(l)
  if (!n) return t
  const i = Object.keys(n).map((s) => No(s, e, t + 1))
  return Math.max(...i)
}
class qc {
  constructor() {
    ;(this._nextHandler = null),
      (this._handlers = {}),
      (this._tag = /* @__PURE__ */ new WeakMap()),
      (this.exec = this.exec.bind(this))
  }
  on(e, t, n) {
    let i = this._handlers[e]
    i ? (n && n.intercept ? i.unshift(t) : i.push(t)) : (i = this._handlers[e] = [t]),
      n && n.tag && this._tag.set(t, n.tag)
  }
  intercept(e, t, n) {
    this.on(e, t, {...n, intercept: !0})
  }
  detach(e) {
    for (const t in this._handlers) {
      const n = this._handlers[t]
      for (let i = n.length - 1; i >= 0; i--) this._tag.get(n[i]) === e && n.splice(i, 1)
    }
  }
  async exec(e, t) {
    const n = this._handlers[e]
    if (n)
      for (let i = 0; i < n.length; i++) {
        const s = n[i](t)
        if (s === !1 || (s && s.then && (await s) === !1)) return
      }
    return this._nextHandler && (await this._nextHandler.exec(e, t)), t
  }
  setNext(e) {
    return (this._nextHandler = e)
  }
}
function Kc(l, e) {
  return l.sort(Vc(e))
}
function Gc(l, e) {
  return typeof l == 'string'
    ? l.localeCompare(e, void 0, {numeric: !0})
    : typeof l == 'object'
    ? l.getTime() - e.getTime()
    : (l ?? 0) - (e ?? 0)
}
function Xc(l, e) {
  return typeof l == 'string'
    ? -l.localeCompare(e, void 0, {numeric: !0})
    : typeof e == 'object'
    ? e.getTime() - l.getTime()
    : (e ?? 0) - (l ?? 0)
}
function Vc(_ref25) {
  let {key: l, order: e} = _ref25
  const t = e === 'asc' ? Gc : Xc
  return (n, i) => t(n[l], i[l])
}
function he(l) {
  const e = Object.prototype.toString.call(l)
  return l instanceof Date || (typeof l == 'object' && e === '[object Date]')
    ? new l.constructor(+l)
    : typeof l == 'number' ||
      e === '[object Number]' ||
      typeof l == 'string' ||
      e === '[object String]'
    ? new Date(l)
    : /* @__PURE__ */ new Date(NaN)
}
function lt(l, e) {
  return l instanceof Date ? new l.constructor(e) : new Date(e)
}
function Lo(l, e) {
  const t = he(l)
  return isNaN(e) ? lt(l, NaN) : (e && t.setDate(t.getDate() + e), t)
}
function hl(l, e) {
  const t = he(l)
  if (isNaN(e)) return lt(l, NaN)
  if (!e) return t
  const n = t.getDate(),
    i = lt(l, t.getTime())
  i.setMonth(t.getMonth() + e + 1, 0)
  const s = i.getDate()
  return n >= s ? i : (t.setFullYear(i.getFullYear(), i.getMonth(), n), t)
}
function Uc(l, e) {
  const t = +he(l)
  return lt(l, t + e)
}
const An = 6048e5,
  Jc = 864e5,
  Qc = 6e4,
  Eo = 36e5
function xc(l, e) {
  return Uc(l, e * Eo)
}
let $c = {}
function Fn() {
  return $c
}
function Ct(l, e) {
  const t = Fn(),
    n =
      e?.weekStartsOn ??
      e?.locale?.options?.weekStartsOn ??
      t.weekStartsOn ??
      t.locale?.options?.weekStartsOn ??
      0,
    i = he(l),
    s = i.getDay(),
    o = (s < n ? 7 : 0) + s - n
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i
}
function Qt(l) {
  return Ct(l, {weekStartsOn: 1})
}
function Io(l) {
  const e = he(l),
    t = e.getFullYear(),
    n = lt(l, 0)
  n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0)
  const i = Qt(n),
    s = lt(l, 0)
  s.setFullYear(t, 0, 4), s.setHours(0, 0, 0, 0)
  const o = Qt(s)
  return e.getTime() >= i.getTime() ? t + 1 : e.getTime() >= o.getTime() ? t : t - 1
}
function gn(l) {
  const e = he(l)
  return e.setHours(0, 0, 0, 0), e
}
function Hn(l) {
  const e = he(l),
    t = new Date(
      Date.UTC(
        e.getFullYear(),
        e.getMonth(),
        e.getDate(),
        e.getHours(),
        e.getMinutes(),
        e.getSeconds(),
        e.getMilliseconds()
      )
    )
  return t.setUTCFullYear(e.getFullYear()), +l - +t
}
function ml(l, e) {
  const t = gn(l),
    n = gn(e),
    i = +t - Hn(t),
    s = +n - Hn(n)
  return Math.round((i - s) / Jc)
}
function Qn(l) {
  const e = Io(l),
    t = lt(l, 0)
  return t.setFullYear(e, 0, 4), t.setHours(0, 0, 0, 0), Qt(t)
}
function eu(l, e) {
  const t = e * 3
  return hl(l, t)
}
function Ro(l, e) {
  const t = e * 7
  return Lo(l, t)
}
function tu(l, e) {
  return hl(l, e * 12)
}
function un(l, e) {
  const t = he(l),
    n = he(e),
    i = t.getTime() - n.getTime()
  return i < 0 ? -1 : i > 0 ? 1 : i
}
function nu(l, e) {
  const t = gn(l),
    n = gn(e)
  return +t == +n
}
function lu(l) {
  return (
    l instanceof Date ||
    (typeof l == 'object' && Object.prototype.toString.call(l) === '[object Date]')
  )
}
function iu(l) {
  if (!lu(l) && typeof l != 'number') return !1
  const e = he(l)
  return !isNaN(Number(e))
}
function _l(l, e) {
  const t = Qt(l),
    n = Qt(e),
    i = +t - Hn(t),
    s = +n - Hn(n)
  return Math.round((i - s) / An)
}
function su(l, e) {
  const t = he(l),
    n = he(e),
    i = t.getFullYear() - n.getFullYear(),
    s = t.getMonth() - n.getMonth()
  return i * 12 + s
}
function ou(l, e) {
  const t = he(l),
    n = he(e)
  return t.getFullYear() - n.getFullYear()
}
function gl(l) {
  return (e) => {
    const t = (l ? Math[l] : Math.trunc)(e)
    return t === 0 ? 0 : t
  }
}
function Oo(l, e) {
  return +he(l) - +he(e)
}
function ru(l, e, t) {
  const n = Oo(l, e) / Eo
  return gl(t?.roundingMethod)(n)
}
function au(l, e, t) {
  const n = Oo(l, e) / Qc
  return gl(t?.roundingMethod)(n)
}
function Ao(l) {
  const e = he(l)
  return e.setHours(23, 59, 59, 999), e
}
function wl(l) {
  const e = he(l),
    t = e.getMonth()
  return e.setFullYear(e.getFullYear(), t + 1, 0), e.setHours(23, 59, 59, 999), e
}
function cu(l) {
  const e = he(l)
  return +Ao(e) == +wl(e)
}
function Fo(l, e) {
  const t = he(l),
    n = he(e),
    i = un(t, n),
    s = Math.abs(su(t, n))
  let o
  if (s < 1) o = 0
  else {
    t.getMonth() === 1 && t.getDate() > 27 && t.setDate(30), t.setMonth(t.getMonth() - i * s)
    let a = un(t, n) === -i
    cu(he(l)) && s === 1 && un(l, n) === 1 && (a = !1), (o = i * (s - Number(a)))
  }
  return o === 0 ? 0 : o
}
function uu(l, e, t) {
  const n = Fo(l, e) / 3
  return gl(t?.roundingMethod)(n)
}
function fu(l, e) {
  const t = he(l),
    n = he(e),
    i = un(t, n),
    s = Math.abs(ou(t, n))
  t.setFullYear(1584), n.setFullYear(1584)
  const o = un(t, n) === -i,
    a = i * (s - +o)
  return a === 0 ? 0 : a
}
function wn(l) {
  const e = he(l),
    t = e.getMonth(),
    n = t - (t % 3)
  return e.setMonth(n, 1), e.setHours(0, 0, 0, 0), e
}
function Po(l) {
  const e = he(l)
  return e.setDate(1), e.setHours(0, 0, 0, 0), e
}
function du(l) {
  const e = he(l),
    t = e.getFullYear()
  return e.setFullYear(t + 1, 0, 0), e.setHours(23, 59, 59, 999), e
}
function Yo(l) {
  const e = he(l),
    t = lt(l, 0)
  return t.setFullYear(e.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t
}
function hu(l) {
  const e = he(l)
  return e.setMinutes(59, 59, 999), e
}
function mu(l, e) {
  const t = e?.weekStartsOn,
    n = he(l),
    i = n.getDay(),
    s = (i < t ? -7 : 0) + 6 - (i - t)
  return n.setDate(n.getDate() + s), n.setHours(23, 59, 59, 999), n
}
function bl(l) {
  const e = he(l),
    t = e.getMonth(),
    n = t - (t % 3) + 3
  return e.setMonth(n, 0), e.setHours(23, 59, 59, 999), e
}
const _u = {
    lessThanXSeconds: {one: 'less than a second', other: 'less than {{count}} seconds'},
    xSeconds: {one: '1 second', other: '{{count}} seconds'},
    halfAMinute: 'half a minute',
    lessThanXMinutes: {one: 'less than a minute', other: 'less than {{count}} minutes'},
    xMinutes: {one: '1 minute', other: '{{count}} minutes'},
    aboutXHours: {one: 'about 1 hour', other: 'about {{count}} hours'},
    xHours: {one: '1 hour', other: '{{count}} hours'},
    xDays: {one: '1 day', other: '{{count}} days'},
    aboutXWeeks: {one: 'about 1 week', other: 'about {{count}} weeks'},
    xWeeks: {one: '1 week', other: '{{count}} weeks'},
    aboutXMonths: {one: 'about 1 month', other: 'about {{count}} months'},
    xMonths: {one: '1 month', other: '{{count}} months'},
    aboutXYears: {one: 'about 1 year', other: 'about {{count}} years'},
    xYears: {one: '1 year', other: '{{count}} years'},
    overXYears: {one: 'over 1 year', other: 'over {{count}} years'},
    almostXYears: {one: 'almost 1 year', other: 'almost {{count}} years'},
  },
  gu = (l, e, t) => {
    let n
    const i = _u[l]
    return (
      typeof i == 'string'
        ? (n = i)
        : e === 1
        ? (n = i.one)
        : (n = i.other.replace('{{count}}', e.toString())),
      t?.addSuffix ? (t.comparison && t.comparison > 0 ? 'in ' + n : n + ' ago') : n
    )
  }
function jn(l) {
  return function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
    const t = e.width ? String(e.width) : l.defaultWidth
    return l.formats[t] || l.formats[l.defaultWidth]
  }
}
const wu = {full: 'EEEE, MMMM do, y', long: 'MMMM do, y', medium: 'MMM d, y', short: 'MM/dd/yyyy'},
  bu = {full: 'h:mm:ss a zzzz', long: 'h:mm:ss a z', medium: 'h:mm:ss a', short: 'h:mm a'},
  ku = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}',
  },
  pu = {
    date: jn({formats: wu, defaultWidth: 'full'}),
    time: jn({formats: bu, defaultWidth: 'full'}),
    dateTime: jn({formats: ku, defaultWidth: 'full'}),
  },
  yu = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P',
  },
  vu = (l, e, t, n) => yu[l]
function on(l) {
  return (e, t) => {
    const n = t?.context ? String(t.context) : 'standalone'
    let i
    if (n === 'formatting' && l.formattingValues) {
      const o = l.defaultFormattingWidth || l.defaultWidth,
        a = t?.width ? String(t.width) : o
      i = l.formattingValues[a] || l.formattingValues[o]
    } else {
      const o = l.defaultWidth,
        a = t?.width ? String(t.width) : l.defaultWidth
      i = l.values[a] || l.values[o]
    }
    const s = l.argumentCallback ? l.argumentCallback(e) : e
    return i[s]
  }
}
const Su = {narrow: ['B', 'A'], abbreviated: ['BC', 'AD'], wide: ['Before Christ', 'Anno Domini']},
  Mu = {
    narrow: ['1', '2', '3', '4'],
    abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
    wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'],
  },
  Tu = {
    narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
    abbreviated: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    wide: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  },
  Cu = {
    narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  },
  Du = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night',
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night',
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night',
    },
  },
  Wu = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night',
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night',
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night',
    },
  },
  Hu = (l, e) => {
    const t = Number(l),
      n = t % 100
    if (n > 20 || n < 10)
      switch (n % 10) {
        case 1:
          return t + 'st'
        case 2:
          return t + 'nd'
        case 3:
          return t + 'rd'
      }
    return t + 'th'
  },
  zu = {
    ordinalNumber: Hu,
    era: on({values: Su, defaultWidth: 'wide'}),
    quarter: on({values: Mu, defaultWidth: 'wide', argumentCallback: (l) => l - 1}),
    month: on({values: Tu, defaultWidth: 'wide'}),
    day: on({values: Cu, defaultWidth: 'wide'}),
    dayPeriod: on({
      values: Du,
      defaultWidth: 'wide',
      formattingValues: Wu,
      defaultFormattingWidth: 'wide',
    }),
  }
function rn(l) {
  return function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    const n = t.width,
      i = (n && l.matchPatterns[n]) || l.matchPatterns[l.defaultMatchWidth],
      s = e.match(i)
    if (!s) return null
    const o = s[0],
      a = (n && l.parsePatterns[n]) || l.parsePatterns[l.defaultParseWidth],
      r = Array.isArray(a) ? Lu(a, (f) => f.test(o)) : Nu(a, (f) => f.test(o))
    let c
    ;(c = l.valueCallback ? l.valueCallback(r) : r), (c = t.valueCallback ? t.valueCallback(c) : c)
    const u = e.slice(o.length)
    return {value: c, rest: u}
  }
}
function Nu(l, e) {
  for (const t in l) if (Object.prototype.hasOwnProperty.call(l, t) && e(l[t])) return t
}
function Lu(l, e) {
  for (let t = 0; t < l.length; t++) if (e(l[t])) return t
}
function Eu(l) {
  return function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
    const n = e.match(l.matchPattern)
    if (!n) return null
    const i = n[0],
      s = e.match(l.parsePattern)
    if (!s) return null
    let o = l.valueCallback ? l.valueCallback(s[0]) : s[0]
    o = t.valueCallback ? t.valueCallback(o) : o
    const a = e.slice(i.length)
    return {value: o, rest: a}
  }
}
const Iu = /^(\d+)(th|st|nd|rd)?/i,
  Ru = /\d+/i,
  Ou = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i,
  },
  Au = {any: [/^b/i, /^(a|c)/i]},
  Fu = {narrow: /^[1234]/i, abbreviated: /^q[1234]/i, wide: /^[1234](th|st|nd|rd)? quarter/i},
  Pu = {any: [/1/i, /2/i, /3/i, /4/i]},
  Yu = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
  },
  Bu = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [
      /^ja/i,
      /^f/i,
      /^mar/i,
      /^ap/i,
      /^may/i,
      /^jun/i,
      /^jul/i,
      /^au/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i,
    ],
  },
  ju = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
  },
  Zu = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
  },
  qu = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
  },
  Ku = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i,
    },
  },
  Gu = {
    ordinalNumber: Eu({matchPattern: Iu, parsePattern: Ru, valueCallback: (l) => parseInt(l, 10)}),
    era: rn({
      matchPatterns: Ou,
      defaultMatchWidth: 'wide',
      parsePatterns: Au,
      defaultParseWidth: 'any',
    }),
    quarter: rn({
      matchPatterns: Fu,
      defaultMatchWidth: 'wide',
      parsePatterns: Pu,
      defaultParseWidth: 'any',
      valueCallback: (l) => l + 1,
    }),
    month: rn({
      matchPatterns: Yu,
      defaultMatchWidth: 'wide',
      parsePatterns: Bu,
      defaultParseWidth: 'any',
    }),
    day: rn({
      matchPatterns: ju,
      defaultMatchWidth: 'wide',
      parsePatterns: Zu,
      defaultParseWidth: 'any',
    }),
    dayPeriod: rn({
      matchPatterns: qu,
      defaultMatchWidth: 'any',
      parsePatterns: Ku,
      defaultParseWidth: 'any',
    }),
  },
  Xu = {
    code: 'en-US',
    formatDistance: gu,
    formatLong: pu,
    formatRelative: vu,
    localize: zu,
    match: Gu,
    options: {weekStartsOn: 0, firstWeekContainsDate: 1},
  }
function Vu(l) {
  const e = he(l)
  return ml(e, Yo(e)) + 1
}
function Uu(l) {
  const e = he(l),
    t = +Qt(e) - +Qn(e)
  return Math.round(t / An) + 1
}
function Bo(l, e) {
  const t = he(l),
    n = t.getFullYear(),
    i = Fn(),
    s =
      e?.firstWeekContainsDate ??
      e?.locale?.options?.firstWeekContainsDate ??
      i.firstWeekContainsDate ??
      i.locale?.options?.firstWeekContainsDate ??
      1,
    o = lt(l, 0)
  o.setFullYear(n + 1, 0, s), o.setHours(0, 0, 0, 0)
  const a = Ct(o, e),
    r = lt(l, 0)
  r.setFullYear(n, 0, s), r.setHours(0, 0, 0, 0)
  const c = Ct(r, e)
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= c.getTime() ? n : n - 1
}
function Ju(l, e) {
  const t = Fn(),
    n =
      e?.firstWeekContainsDate ??
      e?.locale?.options?.firstWeekContainsDate ??
      t.firstWeekContainsDate ??
      t.locale?.options?.firstWeekContainsDate ??
      1,
    i = Bo(l, e),
    s = lt(l, 0)
  return s.setFullYear(i, 0, n), s.setHours(0, 0, 0, 0), Ct(s, e)
}
function Qu(l, e) {
  const t = he(l),
    n = +Ct(t, e) - +Ju(t, e)
  return Math.round(n / An) + 1
}
function Ce(l, e) {
  const t = l < 0 ? '-' : '',
    n = Math.abs(l).toString().padStart(e, '0')
  return t + n
}
const St = {
    y(l, e) {
      const t = l.getFullYear(),
        n = t > 0 ? t : 1 - t
      return Ce(e === 'yy' ? n % 100 : n, e.length)
    },
    M(l, e) {
      const t = l.getMonth()
      return e === 'M' ? String(t + 1) : Ce(t + 1, 2)
    },
    d(l, e) {
      return Ce(l.getDate(), e.length)
    },
    a(l, e) {
      const t = l.getHours() / 12 >= 1 ? 'pm' : 'am'
      switch (e) {
        case 'a':
        case 'aa':
          return t.toUpperCase()
        case 'aaa':
          return t
        case 'aaaaa':
          return t[0]
        case 'aaaa':
        default:
          return t === 'am' ? 'a.m.' : 'p.m.'
      }
    },
    h(l, e) {
      return Ce(l.getHours() % 12 || 12, e.length)
    },
    H(l, e) {
      return Ce(l.getHours(), e.length)
    },
    m(l, e) {
      return Ce(l.getMinutes(), e.length)
    },
    s(l, e) {
      return Ce(l.getSeconds(), e.length)
    },
    S(l, e) {
      const t = e.length,
        n = l.getMilliseconds(),
        i = Math.trunc(n * Math.pow(10, t - 3))
      return Ce(i, e.length)
    },
  },
  jt = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night',
  },
  ui = {
    G: function (l, e, t) {
      const n = l.getFullYear() > 0 ? 1 : 0
      switch (e) {
        case 'G':
        case 'GG':
        case 'GGG':
          return t.era(n, {width: 'abbreviated'})
        case 'GGGGG':
          return t.era(n, {width: 'narrow'})
        case 'GGGG':
        default:
          return t.era(n, {width: 'wide'})
      }
    },
    y: function (l, e, t) {
      if (e === 'yo') {
        const n = l.getFullYear(),
          i = n > 0 ? n : 1 - n
        return t.ordinalNumber(i, {unit: 'year'})
      }
      return St.y(l, e)
    },
    Y: function (l, e, t, n) {
      const i = Bo(l, n),
        s = i > 0 ? i : 1 - i
      if (e === 'YY') {
        const o = s % 100
        return Ce(o, 2)
      }
      return e === 'Yo' ? t.ordinalNumber(s, {unit: 'year'}) : Ce(s, e.length)
    },
    R: function (l, e) {
      const t = Io(l)
      return Ce(t, e.length)
    },
    u: function (l, e) {
      const t = l.getFullYear()
      return Ce(t, e.length)
    },
    Q: function (l, e, t) {
      const n = Math.ceil((l.getMonth() + 1) / 3)
      switch (e) {
        case 'Q':
          return String(n)
        case 'QQ':
          return Ce(n, 2)
        case 'Qo':
          return t.ordinalNumber(n, {unit: 'quarter'})
        case 'QQQ':
          return t.quarter(n, {width: 'abbreviated', context: 'formatting'})
        case 'QQQQQ':
          return t.quarter(n, {width: 'narrow', context: 'formatting'})
        case 'QQQQ':
        default:
          return t.quarter(n, {width: 'wide', context: 'formatting'})
      }
    },
    q: function (l, e, t) {
      const n = Math.ceil((l.getMonth() + 1) / 3)
      switch (e) {
        case 'q':
          return String(n)
        case 'qq':
          return Ce(n, 2)
        case 'qo':
          return t.ordinalNumber(n, {unit: 'quarter'})
        case 'qqq':
          return t.quarter(n, {width: 'abbreviated', context: 'standalone'})
        case 'qqqqq':
          return t.quarter(n, {width: 'narrow', context: 'standalone'})
        case 'qqqq':
        default:
          return t.quarter(n, {width: 'wide', context: 'standalone'})
      }
    },
    M: function (l, e, t) {
      const n = l.getMonth()
      switch (e) {
        case 'M':
        case 'MM':
          return St.M(l, e)
        case 'Mo':
          return t.ordinalNumber(n + 1, {unit: 'month'})
        case 'MMM':
          return t.month(n, {width: 'abbreviated', context: 'formatting'})
        case 'MMMMM':
          return t.month(n, {width: 'narrow', context: 'formatting'})
        case 'MMMM':
        default:
          return t.month(n, {width: 'wide', context: 'formatting'})
      }
    },
    L: function (l, e, t) {
      const n = l.getMonth()
      switch (e) {
        case 'L':
          return String(n + 1)
        case 'LL':
          return Ce(n + 1, 2)
        case 'Lo':
          return t.ordinalNumber(n + 1, {unit: 'month'})
        case 'LLL':
          return t.month(n, {width: 'abbreviated', context: 'standalone'})
        case 'LLLLL':
          return t.month(n, {width: 'narrow', context: 'standalone'})
        case 'LLLL':
        default:
          return t.month(n, {width: 'wide', context: 'standalone'})
      }
    },
    w: function (l, e, t, n) {
      const i = Qu(l, n)
      return e === 'wo' ? t.ordinalNumber(i, {unit: 'week'}) : Ce(i, e.length)
    },
    I: function (l, e, t) {
      const n = Uu(l)
      return e === 'Io' ? t.ordinalNumber(n, {unit: 'week'}) : Ce(n, e.length)
    },
    d: function (l, e, t) {
      return e === 'do' ? t.ordinalNumber(l.getDate(), {unit: 'date'}) : St.d(l, e)
    },
    D: function (l, e, t) {
      const n = Vu(l)
      return e === 'Do' ? t.ordinalNumber(n, {unit: 'dayOfYear'}) : Ce(n, e.length)
    },
    E: function (l, e, t) {
      const n = l.getDay()
      switch (e) {
        case 'E':
        case 'EE':
        case 'EEE':
          return t.day(n, {width: 'abbreviated', context: 'formatting'})
        case 'EEEEE':
          return t.day(n, {width: 'narrow', context: 'formatting'})
        case 'EEEEEE':
          return t.day(n, {width: 'short', context: 'formatting'})
        case 'EEEE':
        default:
          return t.day(n, {width: 'wide', context: 'formatting'})
      }
    },
    e: function (l, e, t, n) {
      const i = l.getDay(),
        s = (i - n.weekStartsOn + 8) % 7 || 7
      switch (e) {
        case 'e':
          return String(s)
        case 'ee':
          return Ce(s, 2)
        case 'eo':
          return t.ordinalNumber(s, {unit: 'day'})
        case 'eee':
          return t.day(i, {width: 'abbreviated', context: 'formatting'})
        case 'eeeee':
          return t.day(i, {width: 'narrow', context: 'formatting'})
        case 'eeeeee':
          return t.day(i, {width: 'short', context: 'formatting'})
        case 'eeee':
        default:
          return t.day(i, {width: 'wide', context: 'formatting'})
      }
    },
    c: function (l, e, t, n) {
      const i = l.getDay(),
        s = (i - n.weekStartsOn + 8) % 7 || 7
      switch (e) {
        case 'c':
          return String(s)
        case 'cc':
          return Ce(s, e.length)
        case 'co':
          return t.ordinalNumber(s, {unit: 'day'})
        case 'ccc':
          return t.day(i, {width: 'abbreviated', context: 'standalone'})
        case 'ccccc':
          return t.day(i, {width: 'narrow', context: 'standalone'})
        case 'cccccc':
          return t.day(i, {width: 'short', context: 'standalone'})
        case 'cccc':
        default:
          return t.day(i, {width: 'wide', context: 'standalone'})
      }
    },
    i: function (l, e, t) {
      const n = l.getDay(),
        i = n === 0 ? 7 : n
      switch (e) {
        case 'i':
          return String(i)
        case 'ii':
          return Ce(i, e.length)
        case 'io':
          return t.ordinalNumber(i, {unit: 'day'})
        case 'iii':
          return t.day(n, {width: 'abbreviated', context: 'formatting'})
        case 'iiiii':
          return t.day(n, {width: 'narrow', context: 'formatting'})
        case 'iiiiii':
          return t.day(n, {width: 'short', context: 'formatting'})
        case 'iiii':
        default:
          return t.day(n, {width: 'wide', context: 'formatting'})
      }
    },
    a: function (l, e, t) {
      const n = l.getHours() / 12 >= 1 ? 'pm' : 'am'
      switch (e) {
        case 'a':
        case 'aa':
          return t.dayPeriod(n, {width: 'abbreviated', context: 'formatting'})
        case 'aaa':
          return t.dayPeriod(n, {width: 'abbreviated', context: 'formatting'}).toLowerCase()
        case 'aaaaa':
          return t.dayPeriod(n, {width: 'narrow', context: 'formatting'})
        case 'aaaa':
        default:
          return t.dayPeriod(n, {width: 'wide', context: 'formatting'})
      }
    },
    b: function (l, e, t) {
      const n = l.getHours()
      let i
      switch (
        (n === 12 ? (i = jt.noon) : n === 0 ? (i = jt.midnight) : (i = n / 12 >= 1 ? 'pm' : 'am'),
        e)
      ) {
        case 'b':
        case 'bb':
          return t.dayPeriod(i, {width: 'abbreviated', context: 'formatting'})
        case 'bbb':
          return t.dayPeriod(i, {width: 'abbreviated', context: 'formatting'}).toLowerCase()
        case 'bbbbb':
          return t.dayPeriod(i, {width: 'narrow', context: 'formatting'})
        case 'bbbb':
        default:
          return t.dayPeriod(i, {width: 'wide', context: 'formatting'})
      }
    },
    B: function (l, e, t) {
      const n = l.getHours()
      let i
      switch (
        (n >= 17
          ? (i = jt.evening)
          : n >= 12
          ? (i = jt.afternoon)
          : n >= 4
          ? (i = jt.morning)
          : (i = jt.night),
        e)
      ) {
        case 'B':
        case 'BB':
        case 'BBB':
          return t.dayPeriod(i, {width: 'abbreviated', context: 'formatting'})
        case 'BBBBB':
          return t.dayPeriod(i, {width: 'narrow', context: 'formatting'})
        case 'BBBB':
        default:
          return t.dayPeriod(i, {width: 'wide', context: 'formatting'})
      }
    },
    h: function (l, e, t) {
      if (e === 'ho') {
        let n = l.getHours() % 12
        return n === 0 && (n = 12), t.ordinalNumber(n, {unit: 'hour'})
      }
      return St.h(l, e)
    },
    H: function (l, e, t) {
      return e === 'Ho' ? t.ordinalNumber(l.getHours(), {unit: 'hour'}) : St.H(l, e)
    },
    K: function (l, e, t) {
      const n = l.getHours() % 12
      return e === 'Ko' ? t.ordinalNumber(n, {unit: 'hour'}) : Ce(n, e.length)
    },
    k: function (l, e, t) {
      let n = l.getHours()
      return n === 0 && (n = 24), e === 'ko' ? t.ordinalNumber(n, {unit: 'hour'}) : Ce(n, e.length)
    },
    m: function (l, e, t) {
      return e === 'mo' ? t.ordinalNumber(l.getMinutes(), {unit: 'minute'}) : St.m(l, e)
    },
    s: function (l, e, t) {
      return e === 'so' ? t.ordinalNumber(l.getSeconds(), {unit: 'second'}) : St.s(l, e)
    },
    S: function (l, e) {
      return St.S(l, e)
    },
    X: function (l, e, t) {
      const n = l.getTimezoneOffset()
      if (n === 0) return 'Z'
      switch (e) {
        case 'X':
          return di(n)
        case 'XXXX':
        case 'XX':
          return Nt(n)
        case 'XXXXX':
        case 'XXX':
        default:
          return Nt(n, ':')
      }
    },
    x: function (l, e, t) {
      const n = l.getTimezoneOffset()
      switch (e) {
        case 'x':
          return di(n)
        case 'xxxx':
        case 'xx':
          return Nt(n)
        case 'xxxxx':
        case 'xxx':
        default:
          return Nt(n, ':')
      }
    },
    O: function (l, e, t) {
      const n = l.getTimezoneOffset()
      switch (e) {
        case 'O':
        case 'OO':
        case 'OOO':
          return 'GMT' + fi(n, ':')
        case 'OOOO':
        default:
          return 'GMT' + Nt(n, ':')
      }
    },
    z: function (l, e, t) {
      const n = l.getTimezoneOffset()
      switch (e) {
        case 'z':
        case 'zz':
        case 'zzz':
          return 'GMT' + fi(n, ':')
        case 'zzzz':
        default:
          return 'GMT' + Nt(n, ':')
      }
    },
    t: function (l, e, t) {
      const n = Math.trunc(l.getTime() / 1e3)
      return Ce(n, e.length)
    },
    T: function (l, e, t) {
      const n = l.getTime()
      return Ce(n, e.length)
    },
  }
function fi(l) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  const t = l > 0 ? '-' : '+',
    n = Math.abs(l),
    i = Math.trunc(n / 60),
    s = n % 60
  return s === 0 ? t + String(i) : t + String(i) + e + Ce(s, 2)
}
function di(l, e) {
  return l % 60 === 0 ? (l > 0 ? '-' : '+') + Ce(Math.abs(l) / 60, 2) : Nt(l, e)
}
function Nt(l) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  const t = l > 0 ? '-' : '+',
    n = Math.abs(l),
    i = Ce(Math.trunc(n / 60), 2),
    s = Ce(n % 60, 2)
  return t + i + e + s
}
const hi = (l, e) => {
    switch (l) {
      case 'P':
        return e.date({width: 'short'})
      case 'PP':
        return e.date({width: 'medium'})
      case 'PPP':
        return e.date({width: 'long'})
      case 'PPPP':
      default:
        return e.date({width: 'full'})
    }
  },
  jo = (l, e) => {
    switch (l) {
      case 'p':
        return e.time({width: 'short'})
      case 'pp':
        return e.time({width: 'medium'})
      case 'ppp':
        return e.time({width: 'long'})
      case 'pppp':
      default:
        return e.time({width: 'full'})
    }
  },
  xu = (l, e) => {
    const t = l.match(/(P+)(p+)?/) || [],
      n = t[1],
      i = t[2]
    if (!i) return hi(l, e)
    let s
    switch (n) {
      case 'P':
        s = e.dateTime({width: 'short'})
        break
      case 'PP':
        s = e.dateTime({width: 'medium'})
        break
      case 'PPP':
        s = e.dateTime({width: 'long'})
        break
      case 'PPPP':
      default:
        s = e.dateTime({width: 'full'})
        break
    }
    return s.replace('{{date}}', hi(n, e)).replace('{{time}}', jo(i, e))
  },
  $u = {p: jo, P: xu},
  ef = /^D+$/,
  tf = /^Y+$/,
  nf = ['D', 'DD', 'YY', 'YYYY']
function lf(l) {
  return ef.test(l)
}
function sf(l) {
  return tf.test(l)
}
function of(l, e, t) {
  const n = rf(l, e, t)
  if ((console.warn(n), nf.includes(l))) throw new RangeError(n)
}
function rf(l, e, t) {
  const n = l[0] === 'Y' ? 'years' : 'days of the month'
  return `Use \`${l.toLowerCase()}\` instead of \`${l}\` (in \`${e}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`
}
const af = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  cf = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  uf = /^'([^]*?)'?$/,
  ff = /''/g,
  df = /[a-zA-Z]/
function xn(l, e, t) {
  const n = Fn(),
    i = t?.locale ?? n.locale ?? Xu,
    s =
      t?.firstWeekContainsDate ??
      t?.locale?.options?.firstWeekContainsDate ??
      n.firstWeekContainsDate ??
      n.locale?.options?.firstWeekContainsDate ??
      1,
    o =
      t?.weekStartsOn ??
      t?.locale?.options?.weekStartsOn ??
      n.weekStartsOn ??
      n.locale?.options?.weekStartsOn ??
      0,
    a = he(l)
  if (!iu(a)) throw new RangeError('Invalid time value')
  let r = e
    .match(cf)
    .map((u) => {
      const f = u[0]
      if (f === 'p' || f === 'P') {
        const d = $u[f]
        return d(u, i.formatLong)
      }
      return u
    })
    .join('')
    .match(af)
    .map((u) => {
      if (u === "''") return {isToken: !1, value: "'"}
      const f = u[0]
      if (f === "'") return {isToken: !1, value: hf(u)}
      if (ui[f]) return {isToken: !0, value: u}
      if (f.match(df))
        throw new RangeError(
          'Format string contains an unescaped latin alphabet character `' + f + '`'
        )
      return {isToken: !1, value: u}
    })
  i.localize.preprocessor && (r = i.localize.preprocessor(a, r))
  const c = {firstWeekContainsDate: s, weekStartsOn: o, locale: i}
  return r
    .map((u) => {
      if (!u.isToken) return u.value
      const f = u.value
      ;((!t?.useAdditionalWeekYearTokens && sf(f)) ||
        (!t?.useAdditionalDayOfYearTokens && lf(f))) &&
        of(f, e, String(l))
      const d = ui[f[0]]
      return d(a, f, i.localize, c)
    })
    .join('')
}
function hf(l) {
  const e = l.match(uf)
  return e ? e[1].replace(ff, "'") : l
}
function Zo(l) {
  const e = he(l),
    t = e.getFullYear(),
    n = e.getMonth(),
    i = lt(l, 0)
  return i.setFullYear(t, n + 1, 0), i.setHours(0, 0, 0, 0), i.getDate()
}
function mf(l) {
  const e = he(l).getFullYear()
  return e % 400 === 0 || (e % 4 === 0 && e % 100 !== 0)
}
function qo(l) {
  const e = he(l)
  return String(new Date(e)) === 'Invalid Date' ? NaN : mf(e) ? 366 : 365
}
function _f(l) {
  const e = Qn(l),
    t = +Qn(Ro(e, 60)) - +e
  return Math.round(t / An)
}
function Kt(l, e) {
  const t = he(l),
    n = he(e)
  return +t == +n
}
function gf(l) {
  const e = he(l)
  return e.setMinutes(0, 0, 0), e
}
function wf(l, e, t) {
  const n = Ct(l, t),
    i = Ct(e, t)
  return +n == +i
}
function bf(l, e) {
  const t = he(l),
    n = he(e)
  return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth()
}
function kf(l, e) {
  const t = wn(l),
    n = wn(e)
  return +t == +n
}
function pf(l, e) {
  const t = he(l),
    n = he(e)
  return t.getFullYear() === n.getFullYear()
}
const mi = {year: fu, quarter: uu, month: Fo, week: _l, day: ml, hour: ru, minute: au},
  bn = {
    year: {quarter: 4, month: 12, week: _f, day: yf, hour: vf},
    quarter: {month: 3, week: Sf, day: Ko, hour: Mf},
    month: {week: Tf, day: Cf, hour: Df},
    week: {day: 7, hour: 24 * 7},
    day: {hour: 24},
    hour: {minute: 60},
  }
function yf(l) {
  return l ? qo(l) : 365
}
function vf(l) {
  return qo(l) * 24
}
function Sf(l) {
  const e = wn(l),
    t = bl(l)
  return _l(t, e)
}
function Ko(l) {
  if (l) {
    const e = wn(l),
      t = bl(l)
    return ml(t, e)
  }
  return 91
}
function Mf(l) {
  return Ko(l) * 24
}
function Tf(l) {
  if (l) {
    const e = Po(l),
      t = wl(l)
    return _l(t, e)
  }
  return 5
}
function Cf(l) {
  return l ? Zo(l) : 30
}
function Df(l) {
  return Zo(l) * 24
}
function zn(l, e, t) {
  const n = bn[l][e]
  return n ? (typeof n == 'number' ? n : n(t)) : 1
}
function Wf(l, e) {
  return l === e || !!(bn[l] && bn[l][e])
}
const Go = {year: tu, quarter: eu, month: hl, week: Ro, day: Lo, hour: xc}
function kl(l) {
  return (e, t, n, i) =>
    !bn[l][n] || typeof bn[l][n] == 'number' || Xo(l, e, t) ? an(l, e, t, n, i) : Hf(e, t, l, n, i)
}
function an(l, e, t, n, i) {
  const s = n || l
  let o = t,
    a = e
  if ((i && ((o = bt(s, t)), (a = bt(s, e)), a < e && (a = ft(s)(a, 1))), l !== s)) {
    const r = mi[s](a, o),
      c = zn(l, s, t)
    return r / c
  } else return mi[s](a, o)
}
function Hf(l, e, t, n, i) {
  let s = 0
  if (e > bt(t, e)) {
    const a = zf(t, e)
    ;(s = an(t, a, e, n)), (e = a)
  }
  let o = 0
  return (
    Xo(t, e, l) || ((o = an(t, bt(t, l), e)), (e = Go[t](e, o))),
    (o += s + an(t, l, e, n)),
    !o && i && (o = an(t, l, e, n, i)),
    o
  )
}
function ft(l) {
  return Go[l]
}
function bt(l, e) {
  switch (l) {
    case 'year':
      return Yo(e)
    case 'quarter':
      return wn(e)
    case 'month':
      return Po(e)
    case 'week':
      return Ct(e, {weekStartsOn: 1})
    case 'day':
      return gn(e)
    case 'hour':
      return gf(e)
    default:
      return new Date(e)
  }
}
function zf(l, e) {
  switch (l) {
    case 'year':
      return du(e)
    case 'quarter':
      return bl(e)
    case 'month':
      return wl(e)
    case 'week':
      return mu(e, {weekStartsOn: 1})
    case 'day':
      return Ao(e)
    case 'hour':
      return hu(e)
    default:
      return new Date(e)
  }
}
function Xo(l, e, t) {
  switch (l) {
    case 'year':
      return pf(e, t)
    case 'quarter':
      return kf(e, t)
    case 'month':
      return bf(e, t)
    case 'week':
      return wf(e, t, {weekStartsOn: 1})
    case 'day':
      return nu(e, t)
    default:
      return !1
  }
}
const $n = 8,
  Vo = 4,
  Nf = 3,
  _i = 7,
  Lf = $n + Vo
function Uo(l, e) {
  l.open &&
    l.data?.forEach((t) => {
      ;(t.$x += e), Uo(t, e)
    })
}
function el(l, e, t, n) {
  const i = l.getSummaryId(e.id)
  if (i) {
    const s = l.byId(i),
      o = {xMin: 1 / 0, xMax: 0}
    Jo(s, o, t, n), (s.$x = o.xMin), (s.$w = o.xMax - o.xMin), el(l, s, t, n)
  }
}
function Jo(l, e, t, n) {
  const {lengthUnit: i, start: s} = t
  l.data?.forEach((o) => {
    typeof o.$x > 'u' &&
      ((o.$x = Math.round(t.diff(o.start, s, i) * n)),
      (o.$w = Math.round(t.diff(o.end, o.start, i, !0) * n)))
    const a = o.type === 'milestone' && o.$h ? o.$h / 2 : 0
    e.xMin > o.$x && (e.xMin = o.$x + a)
    const r = o.$x + o.$w - a
    e.xMax < r && (e.xMax = r), o.type !== 'summary' && Jo(o, e, t, n)
  })
}
function pl(l, e) {
  let t
  e && (t = e.filter((i) => i.parent == l.id))
  const n = {data: t, ...l}
  if (n.data?.length)
    n.data.forEach((i) => {
      ;(e || (i.type != 'summary' && i.data)) && (i = pl(i, e)),
        (!n.start || n.start > i.start) && (n.start = new Date(i.start)),
        (!n.end || n.end < i.end || (i.type === 'milestone' && n.end < i.start)) &&
          (n.end = new Date(i.end || i.start))
    })
  else if (l.type === 'summary')
    throw Error('Summary tasks must have start and end dates if they have no subtasks')
  return n
}
function Ef(l, e, t, n, i, s) {
  return gi(l, e, t, n, i, s, !1), s && gi(l, e, t, n, i, s, !0), l
}
function gi(l, e, t, n, i, s, o) {
  const {start: a, end: r, lengthUnit: c, diff: u} = i,
    f = (o ? 'base_' : '') + 'start',
    d = (o ? 'base_' : '') + 'end',
    h = '$x' + (o ? '_base' : ''),
    m = '$y' + (o ? '_base' : ''),
    _ = '$w' + (o ? '_base' : ''),
    w = '$h' + (o ? '_base' : ''),
    b = '$skip' + (o ? '_baseline' : '')
  let p = l[f],
    z = l[d]
  if (o && !p) {
    l[b] = !0
    return
  }
  l[f] < a && (l[d] < a || Kt(l[d], a)) ? (p = z = a) : l[f] > r && (p = z = r),
    (l[h] = Math.round(u(p, a, c) * t)),
    (l[m] = o ? l.$y + l.$h + Vo : n * e + Nf),
    (l[_] = Math.round(u(z, p, c, !0) * t)),
    (l[w] = o ? $n : s ? n - _i - Lf : n - _i),
    l.type === 'milestone' &&
      ((l[h] = l[h] - l.$h / 2), (l[_] = l.$h), o && ((l[m] = l.$y + $n), (l[_] = l[w] = l.$h))),
    (l[b] = Kt(p, z))
}
const If = ft('day'),
  Rf = kl('day')
class Of extends Bc {
  _sort
  constructor(e) {
    super(), this.parse(e, 0)
  }
  parse(e, t) {
    if (!e || !e.length) return
    const n = e.map((i) => this.normalizeTask(i, e))
    super.parse(n, t), this._sort && this.sortBranch(this._sort, t)
  }
  getBounds(e, t) {
    return (
      e || (e = new Date(3e3, 0, 0)),
      t || (t = /* @__PURE__ */ new Date(0)),
      this._pool.forEach((n) => {
        ;(!e || n.start <= e) && (e = n.start), (!t || n.end >= t) && (t = n.end)
      }),
      {start: e, end: t}
    )
  }
  getBranch(e) {
    const t = this._pool.get(e)
    return this._pool.get(t.parent || 0).data
  }
  contains(e, t) {
    const n = this._pool.get(e).data
    let i = !1
    if (n)
      for (let s = 0; s < n.length; s++) {
        if (n[s].id === t) {
          i = !0
          break
        }
        if (n[s].data && ((i = this.contains(n[s].id, t)), i)) break
      }
    return i
  }
  getIndexById(e) {
    return this.getBranch(e).findIndex((t) => t.id === e)
  }
  add(e, t) {
    const n = this.normalizeTask(e)
    return super.add(n, t), n
  }
  update(e, t) {
    this.fillDates(e, t),
      this.normalizeDates(t),
      this.byId(e).base_start && (this.fillDates(e, t, !0), this.normalizeDates(t, !0)),
      super.update(e, t)
  }
  copy(e, t, n) {
    const i = this.add({...e, id: null, data: null, parent: t}, n)
    let s = [[e.id, i.id]]
    return (
      e.data?.forEach((o, a) => {
        const r = this.copy(o, i.id, a)
        s = s.concat(r)
      }),
      s
    )
  }
  normalizeDates(e, t) {
    const {start: n, end: i, duration: s} = this.getFields(t)
    e.type === 'milestone'
      ? (e[s] = 0)
      : e[n] &&
        (e[s]
          ? e[i] || (e[i] = If(e[n], e[s]))
          : e[i]
          ? (e[s] = Rf(e[i], e[n]))
          : ((e[i] = e[n]), (e[s] = 0)))
  }
  normalizeTask(e, t) {
    const n = e.id || Wo(),
      i = e.parent || 0,
      s = e.text || '',
      o = e.type || 'task',
      a = e.progress || 0,
      r = e.details || ''
    this.normalizeDates(e), e.base_start && this.normalizeDates(e, !0)
    const c = {...e, id: n, text: s, parent: i, progress: a, type: o, details: r}
    if ((this.normalizeDates(c), c.type === 'summary' && !(c.start && c.end))) {
      const {start: u, end: f} = pl({...c}, t)
      ;(c.start = u), (c.end = f)
    }
    return c
  }
  getSummaryId(e) {
    const t = this._pool.get(e)
    if (!t.parent) return null
    const n = this._pool.get(t.parent)
    return n.type === 'summary' ? n.id : this.getSummaryId(n.id)
  }
  fillDates(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1
    const i = this.byId(e)
    t.type = t.type || i.type
    const {start: s, end: o, duration: a} = this.getFields(n)
    t.type !== 'milestone'
      ? ((i[o] && t[s]) || (t[s] = i[s]),
        t[s] && !(t[a] || t[o])
          ? ((t[o] = i[o] > t[s] ? i[o] : null), t[o] || (t[a] = 1))
          : t[o] && !(t[a] || t[s])
          ? ((t[s] = i[s] < t[o] ? i[s] : t[o]), t[s] === t[o] && ((t[a] = 1), delete t[o]))
          : t[a] && !(t[s] || t[o]) && (t[s] = i[s]))
      : (t[o] && delete t[o], i[o] && delete i[o])
  }
  getFields(e) {
    return {
      start: (e ? 'base_' : '') + 'start',
      end: (e ? 'base_' : '') + 'end',
      duration: (e ? 'base_' : '') + 'duration',
    }
  }
  sort(e) {
    ;(this._sort = e), e && this.sortBranch(e, 0)
  }
  sortBranch(e, t) {
    const n = this._pool.get(t || 0).data
    n &&
      (Kc(n, e),
      n.forEach((i) => {
        this.sortBranch(e, i.id)
      }))
  }
}
function xt(l) {
  const e = /* @__PURE__ */ new Date()
  return l
    .map((t) => ({item: t, len: ft(t.unit)(e, 1)}))
    .sort((t, n) => (t.len < n.len ? -1 : 1))[0].item
}
const Mt = ['year', 'quarter', 'month', 'week', 'day', 'hour'],
  wi = {year: 'yyyy', quarter: 'QQQ', month: 'MMM', week: 'w', day: 'MMM d', hour: 'HH:mm'},
  tl = 50,
  nl = 300
function Af(l, e, t, n) {
  let i = l,
    s = e,
    o = !1,
    a = !1
  n &&
    n.forEach((c) => {
      !l && (!i || c.start <= i) && ((i = c.start), (o = !0))
      const u = c.type === 'milestone' ? c.start : c.end
      !e && (!s || u >= s) && ((s = u), (a = !0))
    })
  const r = ft(t || 'day')
  return (
    i ? o && (i = r(i, -1)) : (i = /* @__PURE__ */ new Date()),
    s ? a && (s = r(s, 1)) : (s = r(i, 30)),
    {_start: i, _end: s}
  )
}
function Ff(l, e, t, n, i, s) {
  const o = xt(s).unit,
    a = kl(o),
    r = a(e, l, '', !0),
    c = bt(o, e)
  ;(l = bt(o, l)), (e = c < e ? ft(o)(c, 1) : c)
  const u = r * n,
    f = i * s.length,
    d = s.map((m) => {
      const _ = [],
        w = ft(m.unit)
      let b = bt(m.unit, l)
      for (; b < e; ) {
        let p = w(b, m.step)
        b < l && (b = l), p > e && (p = e)
        const z = a(p, b, '', !0) * n,
          T =
            typeof m.format == 'function'
              ? m.format(b, p)
              : xn(b, m.format, {firstWeekContainsDate: 4, weekStartsOn: 1})
        let W = ''
        m.css && (W += typeof m.css == 'function' ? m.css(b) : m.css),
          _.push({width: z, value: T, date: b, css: W, unit: m.unit}),
          (b = p)
      }
      return {cells: _, add: w, height: i}
    })
  let h = n
  return (
    o !== t && (h = Math.round(h / zn(o, t)) || 1),
    {
      rows: d,
      width: u,
      height: f,
      diff: a,
      start: l,
      end: e,
      lengthUnit: t,
      minUnit: o,
      lengthUnitWidth: h,
    }
  )
}
function Pf(l, e, t) {
  const n = typeof l == 'boolean' ? {} : l,
    i = Mt.indexOf(xt(e).unit)
  if ((typeof n.level > 'u' && (n.level = i), n.levels))
    n.levels.forEach((a) => {
      a.minCellWidth || (a.minCellWidth = Sn(n.minCellWidth, tl)),
        a.maxCellWidth || (a.maxCellWidth = Sn(n.maxCellWidth, nl))
    })
  else {
    const a = [],
      r = e.length || 1,
      c = Sn(n.minCellWidth, tl),
      u = Sn(n.maxCellWidth, nl)
    Mt.forEach((f, d) => {
      if (d === i) a.push({minCellWidth: c, maxCellWidth: u, scales: e})
      else {
        const h = []
        if (d)
          for (let m = r - 1; m > 0; m--)
            Mt[d - m] && h.push({unit: Mt[d - m], step: 1, format: wi[Mt[d - m]]})
        h.push({unit: f, step: 1, format: wi[f]}),
          a.push({minCellWidth: c, maxCellWidth: u, scales: h})
      }
    }),
      (n.levels = a)
  }
  n.levels[n.level] || (n.level = 0)
  const s = n.levels[n.level],
    o = Math.min(Math.max(t, s.minCellWidth), s.maxCellWidth)
  return {_zoom: n, scales: s.scales, cellWidth: o}
}
function Yf(l, e, t, n, i, s, o) {
  l.level = t
  let a
  const r = n.scales || n,
    c = xt(r).unit,
    u = Bf(c, i)
  if (e === -1) {
    const h = zn(c, i)
    a = o * h
  } else {
    const h = zn(xt(s).unit, c)
    a = Math.round(o / h)
  }
  const f = n.minCellWidth ?? tl,
    d = n.maxCellWidth ?? nl
  return {scales: r, cellWidth: Math.min(d, Math.max(f, a)), lengthUnit: u, zoom: l}
}
function Bf(l, e) {
  const t = Mt.indexOf(l),
    n = Mt.indexOf(e)
  return n >= t ? (l === 'hour' ? 'hour' : 'day') : Mt[n]
}
function Sn(l, e) {
  return l ?? e
}
const Zn = 20,
  jf = function (l, e, t, n, i) {
    const s = Math.round(n / 2) - 3
    if (!e || !t || !e.$y || !t.$y || e.$skip || t.$skip) return (l.$p = ''), l
    let o = !1,
      a = !1
    switch (l.type) {
      case 'e2s':
        a = !0
        break
      case 's2s':
        ;(o = !0), (a = !0)
        break
      case 's2e':
        o = !0
        break
    }
    const r = o ? e.$x : e.$x + e.$w,
      c = i ? e.$y - 7 : e.$y,
      u = a ? t.$x : t.$x + t.$w,
      f = i ? t.$y - 7 : t.$y
    if (r !== u || c !== f) {
      const d = Zf(r, c + s, u, f + s, o, a, n / 2, i),
        h = qf(u, f + s, a)
      l.$p = `${d},${h}`
    }
    return l
  }
function Zf(l, e, t, n, i, s, o, a) {
  const r = Zn * (i ? -1 : 1),
    c = Zn * (s ? -1 : 1),
    u = l + r,
    f = t + c,
    d = [l, e, u, e, 0, 0, 0, 0, f, n, t, n],
    h = f - u
  let m = n - e
  const _ = s === i
  return (
    _ || (((f <= l + Zn - 2 && s) || (f > l && !s)) && (m = a ? m - o + 6 : m - o)),
    (_ && s && u > f) || (_ && !s && u < f)
      ? ((d[4] = d[2] + h), (d[5] = d[3]), (d[6] = d[4]), (d[7] = d[5] + m))
      : ((d[4] = d[2]), (d[5] = d[3] + m), (d[6] = d[4] + h), (d[7] = d[5])),
    d.join(',')
  )
}
function qf(l, e, t) {
  return t
    ? `${l - 5},${e - 3},${l - 5},${e + 3},${l},${e}`
    : `${l + 5},${e + 3},${l + 5},${e - 3},${l},${e}`
}
function Kf(l) {
  if (!l || !l.length) return []
  const e = l.find((t) => t.id === 'action')
  return (
    // e || (l = [...l, Xf]),
    e || (l = l),
    l.map((t) => {
      const n = t.align || 'left',
        i = t.id === 'action',
        s = !i && t.flexgrow ? t.flexgrow : null,
        o = s ? 1 : t.width || (i ? 50 : 120)
      let a
      t.id === 'action' && (a = e ? 'add-task' : 'expand')
      let r = t.template
      if (!r)
        switch (t.id) {
          case 'start':
            r = (c) => xn(c, 'dd-MM-yyyy')
            break
          case 'end':
            r = (c) => xn(c, 'dd-MM-yyyy')
            break
        }
      return {
        width: o,
        align: n,
        header: t.header,
        resize: !0,
        id: t.id,
        template: r,
        ...(s && {flexgrow: s}),
        ...(a && {action: a}),
        sort: !!t.sort,
      }
    })
  )
}
const Gf = [
    {id: 'text', header: 'Task name', flexgrow: 1, sort: !0},
    {id: 'start', header: 'Start date', align: 'center', sort: !0},
    {id: 'duration', header: 'Duration', width: 100, align: 'center', sort: !0},
    // {id: 'action', header: '', width: 50, align: 'center'},
  ],
  // Xf = {id: 'action', header: '', align: 'center', width: 50},
  Qo = [
    {key: 'text', type: 'text', label: 'Name', config: {placeholder: 'Add task name', focus: !0}},
    {
      key: 'details',
      type: 'textarea',
      label: 'Description',
      config: {placeholder: 'Add description'},
    },
    {key: 'type', type: 'select', label: 'Type'},
    {key: 'start', type: 'date', label: 'Start date'},
    {key: 'end', type: 'date', label: 'End date'},
    {key: 'duration', type: 'counter', label: 'Duration', config: {min: 1, max: 100}},
    {key: 'progress', type: 'slider', label: 'Progress'},
    {key: 'links', type: 'links'},
  ]
function Vf(l) {
  return (l.editorShape || Qo).map(
    (e) => (
      e.type === 'select' && e.key === 'type' && (e.options = l.taskTypes), (e.id = e.id || Do()), e
    )
  )
}
class Uf extends jc {
  in
  _router
  constructor(e) {
    super(e),
      (this._router = new Zc(
        super.setState.bind(this),
        [
          {
            in: ['tasks', 'start', 'end', 'scales'],
            out: ['_start', '_end'],
            exec: (i) => {
              const {_end: s, _start: o, start: a, end: r, tasks: c, scales: u} = this.getState()
              if (!a || !r) {
                const f = xt(u).unit,
                  d = Af(a, r, f, c)
                ;(d._end != s || d._start != o) && this.setState(d, i)
              } else this.setState({_start: a, _end: r}, i)
            },
          },
          {
            in: ['_start', '_end', 'cellWidth', 'scaleHeight', 'scales', 'lengthUnit'],
            out: ['_scales'],
            exec: (i) => {
              const s = this.getState()
              let {lengthUnit: o} = s
              const {_start: a, _end: r, cellWidth: c, scaleHeight: u, scales: f} = s,
                d = xt(f).unit
              Wf(d, o) || (o = d)
              const h = Ff(a, r, o, c, u, f)
              this.setState({_scales: h}, i)
            },
          },
          {
            in: ['_scales', 'tasks', 'cellHeight', 'baselines'],
            out: ['_tasks'],
            exec: (i) => {
              const {
                  cellWidth: s,
                  cellHeight: o,
                  tasks: a,
                  _scales: r,
                  baselines: c,
                } = this.getState(),
                u = a.toArray().map((f, d) => Ef(f, d, s, o, r, c))
              this.setState({_tasks: u}, i)
            },
          },
          {
            in: ['_tasks', 'links', 'cellHeight'],
            out: ['_links'],
            exec: (i) => {
              const {tasks: s, links: o, cellHeight: a, baselines: r} = this.getState(),
                c = o
                  .map((u) => {
                    const f = s.byId(u.source),
                      d = s.byId(u.target)
                    return jf(u, f, d, a, r)
                  })
                  .filter((u) => u !== null)
              this.setState({_links: c}, i)
            },
          },
          {
            in: ['tasks', 'activeTask'],
            out: ['_activeTask'],
            exec: (i) => {
              const {tasks: s, activeTask: o} = this.getState()
              this.setState({_activeTask: s.byId(o) || null}, i)
            },
          },
          {
            in: ['tasks', 'selected'],
            out: ['_selected'],
            exec: (i) => {
              const {tasks: s, selected: o, _scrollSelected: a} = this.getState(),
                r = {_selected: o.map((c) => s.byId(c)).filter((c) => !!c)}
              typeof a > 'u' && (r._scrollSelected = !1), this.setState(r, i)
            },
          },
          {
            in: ['start', 'end'],
            out: ['cellWidth'],
            exec: (i) => {
              const {_cellWidth: s, cellWidth: o} = this.getState()
              s != o && this.setState({cellWidth: s}, i)
            },
          },
        ],
        {tasks: (i) => new Of(i), links: (i) => new ci(i), columns: (i) => Kf(i)}
      ))
    const t = (this.in = new qc())
    t.on('show-editor', (_ref26) => {
      let {id: i} = _ref26
      this.setStateAsync({activeTask: i})
    }),
      t.on('select-task', (_ref27) => {
        let {id: i, toggle: s, range: o, show: a} = _ref27
        const {selected: r, _tasks: c, activeTask: u} = this.getState()
        let f = !1,
          d
        if (r.length && (s || o)) {
          const h = [...r]
          if (o) {
            const m = h[h.length - 1],
              _ = c.findIndex((z) => z.id == m),
              w = c.findIndex((z) => z.id == i),
              b = Math.min(_, w),
              p = Math.max(_, w) + 1
            c.slice(b, p)
              .map((z) => z.id)
              .forEach((z) => {
                h.includes(z) || h.push(z)
              })
          } else if (s) {
            const m = h.findIndex((_) => _ == i)
            m === -1 ? h.push(i) : ((f = !0), h.splice(m, 1))
          }
          d = h
        } else d = [i]
        this.setStateAsync({selected: d, _scrollSelected: !!a}),
          !f && u && u != i && t.exec('show-editor', {id: i})
      }),
      t.on('delete-link', (_ref28) => {
        let {id: i} = _ref28
        const {links: s} = this.getState()
        s.remove(i), this.setStateAsync({links: s})
      }),
      t.on('update-link', (i) => {
        const {links: s} = this.getState(),
          {id: o, link: a} = i
        s.update(o, a), this.setStateAsync({links: s}), (i.link = s.byId(o))
      }),
      t.on('add-link', (i) => {
        const {link: s} = i,
          {links: o} = this.getState()
        !s.source ||
          !s.target ||
          (s.type || (s.type = 'e2s'),
          (s.id = s.id || Wo()),
          o.add(s),
          this.setStateAsync({links: o}),
          (i.id = s.id),
          (i.link = o.byId(s.id)))
      })
    let n = null
    t.on('move-task', (i) => {
      const {tasks: s} = this.getState()
      let {mode: o, target: a} = i
      const {id: r, inProgress: c} = i,
        u = s.byId(r)
      if ((typeof c > 'u' ? (i.source = u.parent) : (i.source = n = n ?? u.parent), c === !1)) {
        ;(u.$reorder = !1), this.setState({tasks: s}), (n = null)
        return
      }
      if (a === r || s.contains(r, a)) {
        i.skipProvider = !0
        return
      }
      if (o === 'up' || o === 'down') {
        const f = s.getBranch(r)
        let d = s.getIndexById(r)
        if (o === 'up') {
          const h = u.parent === 0
          if (d === 0 && h) {
            i.skipProvider = !0
            return
          }
          ;(d -= 1), (o = 'before')
        } else if (o === 'down') {
          const h = d === f.length - 1,
            m = u.parent === 0
          if (h && m) {
            i.skipProvider = !0
            return
          }
          ;(d += 1), (o = 'after')
        }
        if (((a = (f[d] && f[d].id) || u.parent), a)) {
          const h = s.getBranch(a)
          let m = s.getIndexById(a),
            _ = h[m]
          if (_.data) {
            if (o === 'before') {
              if (_.parent === u.parent) {
                for (; _.data; )
                  _.open || t.exec('open-task', {id: _.id, mode: !0}),
                    (_ = _.data[_.data.length - 1])
                a = _.id
              }
            } else if (o === 'after') {
              let p
              _.parent === u.parent
                ? ((p = _), (_ = _.data[0]), (a = _.id), (o = 'before'))
                : h.length - 1 !== m &&
                  ((p = _),
                  (m += 1),
                  (_ = h[m]),
                  u.$level > _.$level && _.data
                    ? ((p = _), (_ = _.data[0]), (a = _.id), (o = 'before'))
                    : (a = _.id)),
                p && !p.open && t.exec('open-task', {id: p.id, mode: !0})
            }
          }
          const w = s.getSummaryId(u.id)
          s.move(r, o, a)
          const b = s.getSummaryId(r)
          w != b &&
            (w && this.resetSummaryDates(w, 'move-task'),
            b && this.resetSummaryDates(b, 'move-task'))
        }
      } else {
        const f = s.byId(a)
        let d = f,
          h = !1
        for (; d.$level > u.$level; ) (d = s.byId(d.parent)), d.id === r && (h = !0)
        if (h) return
        const m = s.getSummaryId(u.id)
        if ((s.move(r, o, a), o == 'child')) {
          let w = f
          for (; w.id !== 0 && !w.open; )
            t.exec('open-task', {id: w.id, mode: !0}), (w = s.byId(w.parent))
        }
        const _ = s.getSummaryId(r)
        m != _ &&
          (m && this.resetSummaryDates(m, 'move-task'), _ && this.resetSummaryDates(_, 'move-task'))
      }
      c ? this.setState({tasks: s}) : this.setStateAsync({tasks: s}), (i.target = a), (i.mode = o)
    }),
      t.on('drag-task', (i) => {
        const {id: s, width: o, left: a, top: r, inProgress: c} = i,
          u = this.getState(),
          {tasks: f, _tasks: d, _selected: h, _scales: m, cellWidth: _} = u,
          w = {_tasks: d, _selected: h},
          b = f.byId(s)
        typeof o < 'u' && ((b.$w = o), el(f, b, m, _)),
          typeof a < 'u' && (b.type === 'summary' && Uo(b, a - b.$x), (b.$x = a), el(f, b, m, _)),
          typeof r < 'u' && ((b.$y = r + 4), (b.$reorder = c)),
          typeof o < 'u' && (b.$w = o),
          typeof a < 'u' && (b.$x = a),
          typeof r < 'u' && ((b.$y = r + 4), (b.$reorder = c)),
          this.setState(w)
      }),
      t.on('update-task', (i) => {
        const {id: s, task: o, eventSource: a} = i
        let r = i.diff
        const {tasks: c, _scales: u} = this.getState()
        if (
          a === 'add-task' ||
          a === 'copy-task' ||
          a === 'move-task' ||
          a === 'update-task' ||
          a === 'delete-task'
        ) {
          c.update(s, o)
          return
        }
        const f = u.lengthUnit,
          d = ft(f),
          h = kl(f),
          m = c.byId(s)
        if (
          (r && (o.start && (o.start = d(o.start, r)), o.end && (o.end = d(o.end, r))),
          o.start && o.end)
        ) {
          if (
            (!Kt(o.start, m.start) || !Kt(o.end, m.end)) &&
            m.type == 'summary' &&
            m.data?.length
          ) {
            if (!r && ((r = h(o.start, m.start)), h(o.end, m.end) !== r)) return
            this.moveSummaryKids(m, (w) => d(w, r), 'update-task')
          }
        } else if (
          m.type == 'summary' &&
          ((o.start && !o.end) || (o.end && !o.start) || o.duration)
        )
          return
        c.update(s, o),
          o.type === 'summary' && m.type !== 'summary' && this.resetSummaryDates(s, 'update-task')
        const _ = c.getSummaryId(s)
        _ && this.resetSummaryDates(_, 'update-task'),
          this.setStateAsync({tasks: c}),
          (i.task = c.byId(s))
      }),
      t.on('add-task', (i) => {
        const {tasks: s, _scales: o, baselines: a} = this.getState(),
          {target: r, mode: c, task: u} = i
        let f = -1,
          d,
          h
        if (
          (r
            ? ((h = s.byId(r)),
              c == 'child'
                ? ((d = h), (u.parent = d.id))
                : (h.parent !== null && ((d = s.byId(h.parent)), (u.parent = d.id)),
                  (f = s.getIndexById(r)),
                  c == 'after' && (f += 1)))
            : u.parent && (d = s.byId(u.parent)),
          !u.start)
        ) {
          if (d?.start) u.start = new Date(d.start.valueOf())
          else if (h) u.start = new Date(h.start.valueOf())
          else {
            const w = s.getBranch(0)
            let b
            if (w.length) {
              const p = w[w.length - 1]
              if (!p.$skip) {
                const z = new Date(p.start.valueOf())
                o.start <= z && (b = z)
              }
            }
            u.start = b || ft('day')(o.start, 1)
          }
          ;(u.duration = 1), a && ((u.base_start = u.start), (u.base_duration = u.duration))
        }
        const m = s.add(u, f)
        if (d) for (; d && d.id; ) t.exec('open-task', {id: d.id, mode: !0}), (d = s.byId(d.parent))
        i.id = m.id
        const _ = s.getSummaryId(m.id)
        _ && this.resetSummaryDates(_, 'add-task'),
          this.setStateAsync({tasks: s}),
          t.exec('select-task', {id: m.id}),
          t.exec('show-editor', {id: m.id}),
          (i.id = m.id),
          (i.task = m)
      }),
      t.on('delete-task', (i) => {
        const {id: s} = i,
          {tasks: o, links: a, selected: r} = this.getState()
        i.source = o.byId(s).parent
        const c = o.getSummaryId(s),
          u = [s]
        o.eachChild((d) => u.push(d.id), s),
          a.filter((d) => !(u.includes(d.source) || u.includes(d.target))),
          o.remove(s),
          c && this.resetSummaryDates(c, 'delete-task')
        const f = {tasks: o, links: a}
        r.includes(s) && (f.selected = r.filter((d) => d !== s)), this.setStateAsync(f)
      }),
      t.on('indent-task', (_ref29) => {
        let {id: i, mode: s} = _ref29
        const {tasks: o} = this.getState()
        if (s) {
          const a = o.getBranch(i)[o.getIndexById(i) - 1]
          a && t.exec('move-task', {id: i, mode: 'child', target: a.id})
        } else {
          const a = o.byId(i),
            r = o.byId(a.parent)
          r && r.parent !== null && t.exec('move-task', {id: i, mode: 'after', target: a.parent})
        }
      }),
      t.on('copy-task', (i) => {
        const {id: s, target: o, mode: a, eventSource: r} = i
        if (r === 'copy-task') return
        const {tasks: c, links: u} = this.getState()
        if (c.contains(s, o)) {
          i.skipProvider = !0
          return
        }
        const f = c.getSummaryId(s),
          d = c.getSummaryId(o)
        let h = c.getIndexById(o)
        a == 'before' && (h -= 1)
        const m = c.byId(s),
          _ = c.copy(m, c.byId(o).parent, h + 1)
        ;(i.source = i.id),
          (i.id = _[0][1]),
          m.lazy && (i.lazy = !0),
          f != d && d && this.resetSummaryDates(d, 'copy-task')
        let w = []
        for (let b = 1; b < _.length; b++) {
          const [p, z] = _[b]
          u.forEach((T) => {
            if (T.source === p) {
              const W = {...T}
              delete W.target, w.push({...W, source: z})
            } else if (T.target === p) {
              const W = {...T}
              delete W.source, w.push({...W, target: z})
            }
          })
        }
        w = w.reduce((b, p) => {
          const z = b.findIndex((T) => T.id === p.id)
          return z > -1 ? (b[z] = {...b[z], ...p}) : b.push(p), b
        }, [])
        for (let b = 1; b < _.length; b++) {
          const [p, z] = _[b],
            T = c.byId(z)
          t.exec('copy-task', {
            source: p,
            id: z,
            lazy: !!T.lazy,
            eventSource: 'copy-task',
            target: T.parent,
            mode: 'child',
          })
        }
        w.forEach((b) => {
          t.exec('add-link', {link: {source: b.source, target: b.target, type: b.type}})
        }),
          this.setStateAsync({tasks: c})
      }),
      t.on('open-task', (_ref30) => {
        let {id: i, mode: s} = _ref30
        const {tasks: o} = this.getState(),
          a = o.byId(i)
        a.lazy
          ? t.exec('request-data', {id: a.id})
          : (o.toArray().forEach((r) => (r.$y = 0)),
            o.update(i, {open: s}),
            this.setState({tasks: o}))
      }),
      t.on('scroll-chart', (_ref31) => {
        let {left: i, top: s} = _ref31
        isNaN(i) || this.setState({scrollLeft: i}), isNaN(s) || this.setState({scrollTop: s})
      }),
      t.on('render-data', (i) => {
        this.setState({area: i})
      }),
      t.on('provide-data', (i) => {
        const {tasks: s, links: o} = this.getState(),
          a = s.byId(i.id)
        a.lazy ? ((a.lazy = !1), (a.open = !0)) : (a.data = []),
          s.parse(i.data.tasks, i.id),
          this.setStateAsync({tasks: s, links: new ci(o.map((r) => r).concat(i.data.links))})
      }),
      t.on('zoom-scale', (_ref32) => {
        let {dir: i, date: s, offset: o} = _ref32
        const {zoom: a, cellWidth: r, _cellWidth: c} = this.getState()
        let u = r
        i < 0 && (u = c || r)
        const f = u + i * 50,
          d = a.levels[a.level],
          h = i < 0 && r > d.maxCellWidth
        if (f < d.minCellWidth || f > d.maxCellWidth || h) {
          if (!this.changeScale(a, i)) return
        } else this.setState({cellWidth: f, _cellWidth: f})
        const {_scales: m, _start: _, cellWidth: w} = this.getState(),
          b = bt(m.minUnit, _),
          p = m.diff(s, b, 'hour')
        typeof o > 'u' && (o = w)
        let z = Math.round(p * w) - o
        z < 0 && (z = 0), this.setState({scrollLeft: z})
      }),
      t.on('expand-scale', (_ref33) => {
        let {minWidth: i, date: s, offset: o} = _ref33
        const {_start: a, _scales: r, start: c, end: u, _end: f, cellWidth: d} = this.getState(),
          h = ft(r.minUnit)
        let m = r.width
        if (c && u) {
          if (m < i && m) {
            const z = i / m
            this.setState({cellWidth: d * z})
          }
          return !0
        }
        let _ = 0
        for (; m < i; ) (m += d), _++
        const w = _ ? (u ? -_ : -1) : 0,
          b = c || h(a, w)
        let p = 0
        if (s) {
          const z = r.diff(s, b, 'hour')
          p = Math.max(0, Math.round(z * d) - (o || 0))
        }
        this.setState({_start: b, _end: u || h(f, _), scrollLeft: p})
      }),
      t.on('sort-tasks', (_ref34) => {
        let {key: i, order: s} = _ref34
        const {tasks: o} = this.getState(),
          a = {key: i, order: s}
        o.sort(a), this.setState({_sort: a, tasks: o})
      })
  }
  init(e) {
    const t = this.getState().area
      ? {}
      : {scrollLeft: 0, scrollTop: 0, area: {from: 0, start: 0, end: 0}}
    if (
      (e.cellWidth && (e._cellWidth = e.cellWidth),
      (e._sort = null),
      (e.editorShape = Vf(e)),
      this._router.init({selected: [], ...t, ...e}),
      e.zoom)
    ) {
      const n = Pf(e.zoom, e.scales, e.cellWidth)
      this.setState({
        zoom: n._zoom,
        cellWidth: n.cellWidth,
        _cellWidth: n.cellWidth,
        scales: n.scales,
      })
    }
  }
  setState(e, t) {
    return this._router.setState(e, t)
  }
  setStateAsync(e) {
    this._router.setStateAsync(e)
  }
  getTask(e) {
    const {tasks: t} = this.getState()
    return t.byId(e)
  }
  changeScale(e, t) {
    const n = e.level + t,
      i = e.levels[n]
    if (i) {
      const {cellWidth: s, scales: o, _scales: a} = this.getState(),
        r = Yf(e, t, n, i, a.lengthUnit, o, s)
      return (r._cellWidth = r.cellWidth), this.setState(r), !0
    }
    return !1
  }
  resetSummaryDates(e, t) {
    const {tasks: n} = this.getState(),
      i = n.byId(e),
      s = i.data
    if (s?.length > 1 || (s?.length && s[0].type !== 'milestone')) {
      const o = pl({...i, start: void 0, end: void 0, duration: void 0})
      if (!Kt(i.start, o.start) || !Kt(i.end, o.end)) {
        this.in.exec('update-task', {id: e, task: o, eventSource: t})
        const a = n.getSummaryId(e)
        a && this.resetSummaryDates(a, t)
      }
    }
  }
  moveSummaryKids(e, t, n) {
    const {tasks: i} = this.getState()
    e.data.forEach((s) => {
      const o = {...i.byId(s.id), start: t(s.start)}
      o.type !== 'milestone' && (o.end = t(s.end)),
        delete o.id,
        this.in.exec('update-task', {id: s.id, task: o, eventSource: n}),
        s.data?.length && this.moveSummaryKids(s, t, n)
    })
  }
}
function bi(l, e, t, n) {
  const i = document.createElement('canvas')
  {
    const s = Jf(i, l, e, 1, t)
    Qf(s, n, 0, l, 0, e)
  }
  return i.toDataURL()
}
function Jf(l, e, t, n, i) {
  l.setAttribute('width', (e * n).toString()), l.setAttribute('height', (t * n).toString())
  const s = l.getContext('2d')
  return s.translate(-0.5, -0.5), (s.strokeStyle = i), s
}
function Qf(l, e, t, n, i, s) {
  l.beginPath(), l.moveTo(n, i), l.lineTo(n, s), e === 'full' && l.lineTo(t, s), l.stroke()
}
function xo(l, e, t, n) {
  const {selected: i, tasks: s} = l.getState(),
    o = i.length,
    a = !o && e === 'add-task',
    r = ['edit-task', 'paste-task'],
    c = ['copy-task', 'cut-task'],
    u = ['copy-task', 'cut-task', 'delete-task', 'indent-task:remove', 'move-task:down'],
    f = ['indent-task:add', 'move-task:down', 'move-task:up'],
    d = {'indent-task:remove': 2},
    h = {parent: f.includes(e), level: d[e]}
  if (((t = t || (o ? i[i.length - 1] : null)), !(!t && !a))) {
    if ((e !== 'paste-task' && (l._temp = null), r.includes(e) || a || i.length === 1))
      ki(l, e, t, n)
    else if (o) {
      const m = c.includes(e) ? i : xf(i, s, h)
      u.includes(e) && m.reverse(), m.forEach((_) => ki(l, e, _, n))
    }
  }
}
function xf(l, e, t) {
  let n = l.map((i) => {
    const s = e.byId(i)
    return {id: i, level: s.$level, parent: s.parent, index: e.getIndexById(i)}
  })
  return (
    (t.parent || t.level) &&
      (n = n.filter((i) => (t.level && i.level <= t.level) || !l.includes(i.parent))),
    n.sort((i, s) => i.level - s.level || i.index - s.index),
    n.map((i) => i.id)
  )
}
function ki(l, e, t, n) {
  let i = e.split(':')[0],
    s = e.split(':')[1],
    o = {id: t},
    a = {}
  if (i == 'copy-task' || i == 'cut-task') {
    l._temp || (l._temp = []), l._temp.push({id: t, cut: i == 'cut-task'})
    return
  } else if (i == 'paste-task') {
    l._temp &&
      l._temp.length &&
      (l._temp.forEach((r) => {
        l.exec(r.cut ? 'move-task' : 'copy-task', {id: r.id, target: t, mode: 'after'})
      }),
      (l._temp = null))
    return
  } else
    i === 'add-task'
      ? ((a = {task: {type: 'task', text: n('New Task')}, target: t}), (o = {}))
      : i === 'edit-task'
      ? (i = 'show-editor')
      : i === 'convert-task'
      ? ((i = 'update-task'), (a = {task: {type: s}}), (s = void 0))
      : i === 'indent-task' && (s = s === 'add')
  typeof s < 'u' && (a = {mode: s, ...a}), (o = {...o, ...a}), l.exec(i, o)
}
function yl(l) {
  return l.map((e) => {
    switch ((e.data && yl(e.data), e.id)) {
      case 'add-task:before':
      case 'move-task:up':
        e.check = (t, n) => !ed(t, n)
        break
      case 'move-task:down':
        e.check = (t, n) => !td(t, n)
        break
      case 'indent-task:add':
        e.check = (t, n) => nd(t, n) !== t.parent
        break
      case 'indent-task:remove':
        e.check = (t) => !$f(t)
        break
    }
    return e
  })
}
function $f(l) {
  return l.parent === 0
}
function ed(l, e) {
  return e[0]?.id === l.id
}
function td(l, e) {
  return e[e.length - 1]?.id === l.id
}
function nd(l, e) {
  const t = e.findIndex((n) => n.id === l.id)
  return e[t - 1]?.id ?? l.parent
}
const ld = (l) => (e) => e.type !== l,
  id = yl([
    {
      id: 'add-task',
      text: 'Add',
      icon: 'wxi-plus',
      data: [
        {id: 'add-task:child', text: 'Child task'},
        {id: 'add-task:before', text: 'Task above'},
        {id: 'add-task:after', text: 'Task below'},
      ],
    },
    {type: 'separator'},
    {
      id: 'convert-task',
      text: 'Convert to',
      icon: 'wxi-swap-horizontal',
      dataFactory: (l) => ({id: `convert-task:${l.id}`, text: `${l.label}`, check: ld(l.id)}),
    },
    {id: 'edit-task', text: 'Edit', icon: 'wxi-edit'},
    {id: 'cut-task', text: 'Cut', icon: 'wxi-content-cut'},
    {id: 'copy-task', text: 'Copy', icon: 'wxi-content-copy'},
    {id: 'paste-task', text: 'Paste', icon: 'wxi-content-paste'},
    {
      id: 'move-task',
      text: 'Move',
      icon: 'wxi-swap-vertical',
      data: [
        {id: 'move-task:up', text: 'Up'},
        {id: 'move-task:down', text: 'Down'},
      ],
    },
    {type: 'separator'},
    {id: 'indent-task:add', text: 'Indent', icon: 'wxi-indent'},
    {id: 'indent-task:remove', text: 'Outdent', icon: 'wxi-unindent'},
    {type: 'separator'},
    {id: 'delete-task', icon: 'wxi-delete', text: 'Delete'},
  ]),
  sd = yl([
    {id: 'add-task', comp: 'button', icon: 'wxi-plus', text: 'New task', type: 'primary'},
    {id: 'edit-task', comp: 'icon', icon: 'wxi-edit', menuText: 'Edit'},
    {id: 'delete-task', comp: 'icon', icon: 'wxi-delete', menuText: 'Delete'},
    {comp: 'separator'},
    {id: 'move-task:up', comp: 'icon', icon: 'wxi-angle-up', menuText: 'Move up'},
    {id: 'move-task:down', comp: 'icon', icon: 'wxi-angle-down', menuText: 'Move down'},
    {comp: 'separator'},
    {id: 'copy-task', comp: 'icon', icon: 'wxi-content-copy', menuText: 'Copy'},
    {id: 'cut-task', comp: 'icon', icon: 'wxi-content-cut', menuText: 'Cut'},
    {id: 'paste-task', comp: 'icon', icon: 'wxi-content-paste', menuText: 'Paste'},
    {comp: 'separator'},
    {id: 'indent-task:add', comp: 'icon', icon: 'wxi-indent', menuText: 'Indent'},
    {id: 'indent-task:remove', comp: 'icon', icon: 'wxi-unindent', menuText: 'Outdent'},
  ])
function pi(l, e, t) {
  const n = l.slice()
  return (n[6] = e[t]), n
}
function yi(l, e, t) {
  const n = l.slice()
  return (n[9] = e[t]), n
}
// Modified version with dangerouslySetInnerHTML:
function vi(l) {
  let e,
    t = /*cell*/ l[9].value + '',
    i
  return {
    c() {
      ;(e = D('div')),
        // Set innerHTML directly
        (e.innerHTML = t),
        g(
          e,
          'class',
          (i =
            'wx-cell ' +
            /*cell*/ l[9].css +
            ' ' +
            /*highlightTime*/ (l[0]
              ? /*highlightTime*/ l[0](/*cell*/ l[9].date, /*cell*/ l[9].unit)
              : '') +
            ' x2-nufjbd')
        ),
        j(e, 'width', /*cell*/ l[9].width + 'px')
    },
    m(s, o) {
      S(s, e, o)
    },
    p(s, o) {
      // Update innerHTML when value changes
      o & /*$scales*/ 2 && t !== (t = /*cell*/ s[9].value + '') && (e.innerHTML = t),
        o & /*$scales, highlightTime*/ 3 &&
          i !==
            (i =
              'wx-cell ' +
              /*cell*/ s[9].css +
              ' ' +
              /*highlightTime*/ (s[0]
                ? /*highlightTime*/ s[0](/*cell*/ s[9].date, /*cell*/ s[9].unit)
                : '') +
              ' x2-nufjbd') &&
          g(e, 'class', i),
        o & /*$scales*/ 2 && j(e, 'width', /*cell*/ s[9].width + 'px')
    },
    d(s) {
      s && v(e)
    },
  }
}
function Si(l) {
  let e,
    t,
    n = de(/*row*/ l[6].cells),
    i = []
  for (let s = 0; s < n.length; s += 1) i[s] = vi(yi(l, n, s))
  return {
    c() {
      e = D('div')
      // Create cells for each column in the row
      for (let s = 0; s < i.length; s += 1) i[s].c()
      ;(t = Y()), g(e, 'class', 'wx-row x2-nufjbd'), j(e, 'height', /*row*/ l[6].height + 'px')
    },
    m(s, o) {
      S(s, e, o)
      for (let a = 0; a < i.length; a += 1) i[a] && i[a].m(e, null)
      H(e, t)
    },
    p(s, o) {
      if (o & /*$scales, highlightTime*/ 3) {
        n = de(/*row*/ s[6].cells)
        let a
        for (a = 0; a < n.length; a += 1) {
          const r = yi(s, n, a)
          // Update existing cells or create new ones
          i[a] ? i[a].p(r, o) : ((i[a] = vi(r)), i[a].c(), i[a].m(e, t))
        }
        for (; a < i.length; a += 1) i[a].d(1)
        i.length = n.length
      }
      o & /*$scales*/ 2 && j(e, 'height', /*row*/ s[6].height + 'px')
    },
    d(s) {
      s && v(e), $e(i, s)
    },
  }
}
function od(l) {
  let e,
    t = de(/*$scales*/ l[1].rows),
    n = []
  for (let i = 0; i < t.length; i += 1) n[i] = Si(pi(l, t, i))
  return {
    c() {
      e = D('div')
      for (let i = 0; i < n.length; i += 1) n[i].c()
      g(e, 'class', 'wx-scale x2-nufjbd'),
        j(e, 'width', /*$scales*/ l[1].width + 'px'),
        j(e, 'left', -(/*$scrollLeft*/ l[2]) + 'px')
    },
    m(i, s) {
      S(i, e, s)
      for (let o = 0; o < n.length; o += 1) n[o] && n[o].m(e, null)
    },
    p(i, _ref35) {
      let [s] = _ref35
      if (s & /*$scales, highlightTime*/ 3) {
        t = de(/*$scales*/ i[1].rows)
        let o
        for (o = 0; o < t.length; o += 1) {
          const a = pi(i, t, o)
          n[o] ? n[o].p(a, s) : ((n[o] = Si(a)), n[o].c(), n[o].m(e, null))
        }
        for (; o < n.length; o += 1) n[o].d(1)
        n.length = t.length
      }
      s & /*$scales*/ 2 && j(e, 'width', /*$scales*/ i[1].width + 'px'),
        s & /*$scrollLeft*/ 4 && j(e, 'left', -(/*$scrollLeft*/ i[2]) + 'px')
    },
    i: I,
    o: I,
    d(i) {
      i && v(e), $e(n, i)
    },
  }
}
function rd(l, e, t) {
  let n,
    i,
    {highlightTime: s} = e
  const o = ze('gantt-store'),
    {_scales: a, scrollLeft: r} = o.getReactiveState()
  return (
    ce(l, a, (c) => t(1, (n = c))),
    ce(l, r, (c) => t(2, (i = c))),
    (l.$$set = (c) => {
      'highlightTime' in c && t(0, (s = c.highlightTime))
    }),
    [s, n, i, a, r]
  )
}
class ad extends ee {
  constructor(e) {
    super(), $(this, e, rd, od, x, {highlightTime: 0})
  }
}
function fn(l) {
  const e = l.getAttribute('data-id'),
    t = parseInt(e)
  return isNaN(t) || t.toString() != e ? e : t
}
function cd(l, e, t) {
  const n = l.getBoundingClientRect(),
    i = e.querySelector('.wx-body').getBoundingClientRect()
  return {
    top: n.top - i.top,
    left: n.left - i.left,
    dt: n.bottom - t.clientY,
    db: t.clientY - n.top,
  }
}
const Mi = 5
function ud(l, e) {
  let t, n, i, s, o, a, r, c, u

  function getDragHandle(element) {
    // Check if this is a header cell
    if (element && element.classList.contains('wx-header-cell')) {
      return null
    }
    return element?.querySelector('.wx-drag-handle')
  }

  function isValidDragStart(event) {
    const target = wt(event)
    const dragHandle = getDragHandle(target)

    // Check if we clicked directly on the drag handle or its children
    const clickedElement = event.target
    return dragHandle && (clickedElement === dragHandle || dragHandle.contains(clickedElement))
  }
  function f(M) {
    ;(s = M.clientX),
      (o = M.clientY),
      (a = {...cd(t, l, M), y: e.getTask(i).$y}),
      (document.body.style.userSelect = 'none')
  }
  function d(M) {
    // Only start drag if clicking on drag handle
    if (!isValidDragStart(M)) return

    t = wt(M)
    if (t) {
      i = fn(t)
      u = setTimeout(() => {
        c = !0
        e && e.touchStart && e.touchStart()
        f(M.touches[0])
      }, 500)
      l.addEventListener('touchmove', p)
      l.addEventListener('contextmenu', h)
      window.addEventListener('touchend', z)
    }
  }
  function h(M) {
    if (c || u) return M.preventDefault(), !1
  }
  function m(M) {
    // Only start drag if clicking on drag handle
    if (!isValidDragStart(M)) return

    if (M.which === 1) {
      t = wt(M)
      if (t) {
        i = fn(t)
        l.addEventListener('mousemove', b)
        window.addEventListener('mouseup', T)
        f(M)
      }
    }
  }
  function _(M) {
    l.removeEventListener('mousemove', b),
      l.removeEventListener('touchmove', p),
      document.body.removeEventListener('mouseup', T),
      document.body.removeEventListener('touchend', z),
      (document.body.style.userSelect = ''),
      M && (l.removeEventListener('mousedown', m), l.removeEventListener('touchstart', d))
  }
  function w(M) {
    const C = M.clientX - s,
      P = M.clientY - o
    if (!n) {
      if ((Math.abs(C) < Mi && Math.abs(P) < Mi) || (e && e.start && e.start({id: i, e: M}) === !1))
        return
      ;(n = t.cloneNode(!0)),
        (n.style.pointerEvents = 'none'),
        n.classList.add('wx-reorder-task'),
        (n.style.position = 'absolute'),
        (n.style.left = a.left + 'px'),
        (n.style.top = a.top + 'px'),
        (t.style.visibility = 'hidden'),
        t.parentNode.insertBefore(n, t)
    }
    if (n) {
      const X = Math.round(Math.max(0, a.top + P))
      if (e && e.move && e.move({id: i, top: X, detail: r}) === !1) return
      const A = e.getTask(i).$y
      if (!a.start && a.y == A) return W()
      ;(a.start = !0), (a.y = e.getTask(i).$y - 4), (n.style.top = X + 'px')
      const B = document.elementFromPoint(M.clientX, M.clientY),
        V = wt(B)
      if (V && V !== t) {
        const fe = fn(V),
          L = V.getBoundingClientRect(),
          Ye = L.top + L.height / 2,
          G = M.clientY + a.db > Ye && V.nextElementSibling !== t,
          pe = M.clientY - a.dt < Ye && V.previousElementSibling !== t
        r?.after == fe || r?.before == fe
          ? (r = null)
          : G
          ? (r = {id: i, after: fe})
          : pe && (r = {id: i, before: fe})
      }
    }
  }
  function b(M) {
    w(M)
  }
  function p(M) {
    c ? (M.preventDefault(), w(M.touches[0])) : u && (clearTimeout(u), (u = null))
  }
  function z() {
    ;(c = null), u && (clearTimeout(u), (u = null)), W()
  }
  function T() {
    W()
  }
  function W() {
    t && (t.style.visibility = ''),
      n && (n.parentNode.removeChild(n), e && e.end && e.end({id: i, top: a.top})),
      (i = t = n = a = r = null),
      _()
  }
  return (
    l.style.position !== 'absolute' && (l.style.position = 'relative'),
    l.addEventListener('mousedown', m),
    l.addEventListener('touchstart', d),
    {
      destroy() {
        _(!0)
      },
    }
  )
}
const fd = {
  grid: {'Add before': 'Add before', 'Add after': 'Add after', Copy: 'Copy', Delete: 'Delete'},
}
/* @__PURE__ */ new Date().valueOf()
const $o = 2
class dd {
  constructor(e) {
    e && ((this._writable = e.writable), (this._async = e.async)),
      (this._values = {}),
      (this._state = {})
  }
  setState(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0
    const n = {}
    return this._wrapProperties(e, this._state, this._values, '', n, t), n
  }
  getState() {
    return this._values
  }
  getReactive() {
    return this._state
  }
  _wrapProperties(e, t, n, i, s, o) {
    for (const a in e) {
      const r = t[a],
        c = n[a],
        u = e[a]
      if (
        r &&
        ((c === u && typeof u != 'object') ||
          (u instanceof Date && c instanceof Date && c.getTime() === u.getTime()))
      )
        continue
      const f = i + (i ? '.' : '') + a
      r
        ? (r.__parse(u, f, s, o) && (n[a] = u), o & $o ? (s[f] = r.__trigger) : r.__trigger())
        : (u && u.__reactive
            ? (t[a] = this._wrapNested(u, u, f, s))
            : (t[a] = this._wrapWritable(u)),
          (n[a] = u)),
        (s[f] = s[f] || null)
    }
  }
  _wrapNested(e, t, n, i) {
    const s = this._wrapWritable(e)
    return (
      this._wrapProperties(e, s, t, n, i, 0),
      (s.__parse = (o, a, r, c) => (this._wrapProperties(o, s, t, a, r, c), !1)),
      s
    )
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _wrapWritable(e) {
    const t = [],
      n = function () {
        for (let i = 0; i < t.length; i++) t[i](e)
      }
    return {
      subscribe: (i) => (
        t.push(i),
        this._async ? setTimeout(i, 1, e) : i(e),
        () => {
          const s = t.indexOf(i)
          s >= 0 && t.splice(s, 1)
        }
      ),
      __trigger: () => {
        t.length && (this._async ? setTimeout(n, 1) : n())
      },
      __parse: function (i) {
        return (e = i), !0
      },
    }
  }
}
class hd {
  constructor(e, t, n, i) {
    typeof e == 'function' ? (this._setter = e) : (this._setter = e.setState.bind(e)),
      (this._routes = t),
      (this._parsers = n),
      (this._prev = {}),
      (this._triggers = /* @__PURE__ */ new Map()),
      (this._sources = /* @__PURE__ */ new Map()),
      this._routes.forEach((s) => {
        s.in.forEach((o) => {
          const a = this._triggers.get(o) || []
          a.push(s), this._triggers.set(o, a)
        }),
          s.out.forEach((o) => {
            const a = this._sources.get(o) || {}
            s.in.forEach((r) => (a[r] = !0)), this._sources.set(o, a)
          })
      }),
      this._routes.forEach((s) => {
        s.length = Math.max(...s.in.map((o) => er(o, this._sources, 1)))
      }),
      (this._bus = i)
  }
  init(e) {
    const t = {}
    for (const n in e)
      if (this._prev[n] !== e[n]) {
        const i = this._parsers[n]
        t[n] = i ? i(e[n]) : e[n]
      }
    ;(this._prev = this._prev ? {...this._prev, ...e} : {...e}),
      this.setState(t),
      this._bus && this._bus.exec('init-state', t)
  }
  setStateAsync(e) {
    const t = this._setter(e, $o)
    return (
      this._async
        ? Object.assign(this._async.signals, t)
        : (this._async = {signals: t, timer: setTimeout(this._applyState.bind(this), 1)}),
      t
    )
  }
  _applyState() {
    const e = this._async
    if (e) {
      ;(this._async = null), this._triggerUpdates(e.signals, [])
      for (const t in e.signals) {
        const n = e.signals[t]
        n && n()
      }
    }
  }
  setState(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []
    const n = this._setter(e)
    return this._triggerUpdates(n, t), n
  }
  _triggerUpdates(e, t) {
    const n = Object.keys(e),
      i = !t.length
    t = t || []
    for (let s = 0; s < n.length; s++) {
      const o = n[s],
        a = this._triggers.get(o)
      a &&
        a.forEach((r) => {
          t.indexOf(r) == -1 && t.push(r)
        })
    }
    i && this._execNext(t)
  }
  _execNext(e) {
    for (; e.length; ) {
      e.sort((n, i) => (n.length < i.length ? 1 : -1))
      const t = e[e.length - 1]
      e.splice(e.length - 1), t.exec(e)
    }
  }
}
function er(l, e, t) {
  const n = e.get(l)
  if (!n) return t
  const i = Object.keys(n).map((s) => er(s, e, t + 1))
  return Math.max(...i)
}
class md {
  constructor() {
    ;(this._nextHandler = null),
      (this._handlers = {}),
      (this._tag = /* @__PURE__ */ new WeakMap()),
      (this.exec = this.exec.bind(this))
  }
  on(e, t, n) {
    let i = this._handlers[e]
    i ? (n && n.intercept ? i.unshift(t) : i.push(t)) : (i = this._handlers[e] = [t]),
      n && n.tag && this._tag.set(t, n.tag)
  }
  intercept(e, t, n) {
    this.on(e, t, {...n, intercept: !0})
  }
  detach(e) {
    for (const t in this._handlers) {
      const n = this._handlers[t]
      for (let i = n.length - 1; i >= 0; i--) this._tag.get(n[i]) === e && n.splice(i, 1)
    }
  }
  async exec(e, t) {
    const n = this._handlers[e]
    if (n)
      for (let i = 0; i < n.length; i++) {
        const s = n[i](t)
        if (s === !1 || (s && s.then && (await s) === !1)) return
      }
    return this._nextHandler && (await this._nextHandler.exec(e, t)), t
  }
  setNext(e) {
    return (this._nextHandler = e)
  }
}
function _d(l) {
  return (e) => e[l]
}
function gd(l) {
  return (e, t) => (e[l] = t)
}
function tr(l, e) {
  return (e.getter || _d(e.id))(l) ?? ''
}
function Ti(l, e, t) {
  return (e.setter || gd(e.id))(l, t)
}
function Ci(l, e) {
  const t = document.createElement('a')
  ;(t.href = URL.createObjectURL(l)),
    (t.download = e),
    document.body.appendChild(t),
    t.click(),
    document.body.removeChild(t)
}
function Dt(l, e) {
  let t = tr(l, e)
  // Apply template if exists
  if (e.template) {
    t = e.template(l)
    // Check if template returned a React element
    if (t && t.type) {
      return t
    }
  }

  // Handle optionsMap for non-HTML elements
  if (e.optionsMap) {
    const mapValue = e.optionsMap.get(t)
    if (Array.isArray(t)) {
      return t.map((n) => e.optionsMap.get(n))
    }
    return mapValue
  }

  // Convert to string only if not already a string or HTML element
  return t == null ? '' : String(t)
}
function wd(l, e) {
  const t = /\n|"|;|,/
  let n = ''
  const i =
      e.rows ||
      `
`,
    s = e.cols || '	',
    o = l._columns,
    a = l.data
  e.header !== !1 && o[0].header && (n = Di('header', o, n, s, i))
  for (let r = 0; r < a.length; r++) {
    const c = []
    for (let u = 0; u < o.length; u++) {
      let f = Dt(a[r], o[u])
      t.test(f) && (f = '"' + f.replace(/"/g, '""') + '"'), c.push(f)
    }
    n += (n ? i : '') + c.join(s)
  }
  return e.footer !== !1 && o[0].footer && (n = Di('footer', o, n, s, i)), n
}
function Di(l, e, t, n, i) {
  const s = /\n|"|;|,/
  for (let o = 0; o < e[0][l].length; o++) {
    const a = []
    for (let r = 0; r < e.length; r++) {
      let c = (e[r][l][o].text || '') + ''
      s.test(c) && (c = '"' + c.replace(/"/g, '""') + '"'), a.push(c)
    }
    t += (t ? i : '') + a.join(n)
  }
  return t
}
function bd(l, e) {
  const t = [],
    n = [],
    i = []
  let s = []
  const o = l._columns,
    a = l.data,
    r = l._sizes
  for (let u = 0; u < o.length; u++) i.push({width: o[u].width || r.colWidth})
  let c = 0
  e.header !== !1 &&
    o[0].header &&
    (Wi('header', o, t, n, c),
    (s = s.concat(r.headerRowHeights.map((u) => ({height: u})))),
    (c += o[0].header.length))
  for (let u = 0; u < a.length; u++) {
    const f = []
    for (let d = 0; d < o.length; d++) f.push({v: Dt(a[u], o[d]), s: 2})
    t.push(f), s.push({height: r.rowHeight})
  }
  return (
    (c += a.length),
    e.footer !== !1 &&
      o[0].footer &&
      (Wi('footer', o, t, n, c), (s = s.concat(r.footerRowHeights.map((u) => ({height: u}))))),
    {cells: t, merged: n, rowSizes: s, colSizes: i}
  )
}
function Wi(l, e, t, n, i) {
  for (let s = 0; s < e[0][l].length; s++) {
    const o = []
    for (let a = 0; a < e.length; a++) {
      const r = e[a][l][s],
        c = r.colspan ? r.colspan - 1 : 0,
        u = r.rowspan ? r.rowspan - 1 : 0
      ;(c || u) && n.push({from: {row: s + i, column: a}, to: {row: s + i + u, column: a + c}})
      const f = (r.text || '') + ''
      let d
      l == 'header' ? (s == e[0][l].length - 1 ? (d = 1) : (d = 0)) : s ? (d = 4) : (d = 3),
        o.push({v: f, s: d})
    }
    t.push(o)
  }
}
function kd() {
  const l = {
    fontWeight: 'bold',
    color: '#000000b3',
    background: '#f4f5f9',
    verticalAlign: 'center',
    align: 'left',
  }
  return {
    cell: {color: '#000000b3', verticalAlign: 'center', align: 'left'},
    header: {...l},
    footer: {...l},
    lastHeaderCell: {...l, borderBottom: '0.5px solid #3498ff'},
    firstFooterCell: {...l, borderTop: '0.5px solid #3498ff'},
  }
}
function nr(l, e) {
  return typeof l > 'u' || l === null
    ? -1
    : typeof e > 'u' || e === null
    ? 1
    : l === e
    ? 0
    : l > e
    ? 1
    : -1
}
function pd(l, e) {
  return -nr(l, e)
}
function yd(l, e) {
  const t = e === 'asc' ? nr : pd
  return function (n, i) {
    return t(n[l], i[l])
  }
}
function vd(l) {
  if (!l || !l.length) return
  const e = l.map((t) => yd(t.key, t.order))
  return l.length === 1
    ? e[0]
    : function (t, n) {
        for (let i = 0; i < e.length; i++) {
          const s = e[i](t, n)
          if (s !== 0) return s
        }
        return 0
      }
}
const Hi = 28,
  Sd = 16
function Md() {
  const l = document.querySelector('[class^="wx"][class$="theme"]')
  return l ? l.className.substr(3, l.className.length - 9) : 'willow'
}
function Nn(l, e, t, n, i) {
  const s = document.createElement('div'),
    o = document.createElement('div'),
    a = document.body
  i = i ? `${i}px` : 'auto'
  let r, c
  ;(o.className = e),
    s.classList.add(`wx-${t}-theme`),
    (s.style.cssText = `height:auto;position:absolute;top:0px;left:100px;overflow:hidden;width=${i};white-space:nowrap;`),
    s.appendChild(o),
    a.appendChild(s),
    typeof l != 'object' && (l = [l])
  for (let u = 0; u < l.length; u++) {
    o.innerText = l[u] + ''
    const f = s.getBoundingClientRect(),
      d = Math.ceil(f.width) + (n && n.length ? n[u] : 0),
      h = Math.ceil(f.height)
    ;(r = Math.max(r || 0, d)), (c = Math.max(c || 0, h))
  }
  return s.remove(), {width: r, height: c}
}
function zi(l, e, t, n, i) {
  const s = []
  for (let o = 0; o < l.length; o++) {
    const a = l[o][e],
      r = a.length
    for (let c = 0; c < r; c++) {
      const {text: u, vertical: f, collapsed: d, rowspan: h, css: m} = a[c]
      if (!u) {
        s[c] = Math.max(s[c] || 0, n)
        continue
      }
      let _ = 0
      if (f && !d) {
        let w = `wx-measure-cell-${e} wx-measure-vertical`
        if (((w += m ? ` ${m}` : ''), (_ = Nn(u, w, i).width), (h > 1 || !a[c + 1]) && t > c + 1)) {
          const b = h || t - c,
            p = s.slice(c, c + b).reduce((z, T) => z + T, 0)
          if (p < _) {
            const z = Math.ceil((_ - p) / b)
            for (let T = c; T < c + b; T++) s[T] = (s[T] || n) + z
          }
          continue
        }
      }
      s[c] = Math.max(s[c] || n, _)
    }
  }
  return s
}
function Td(l, e, t) {
  const n = [],
    i = []
  let s = 'wx-measure-cell-body'
  s += l.css ? ` ${l.css}` : ''
  for (let o = 0; o < e.length; o++) {
    const a = e[o],
      r = Dt(a, l)
    r && (n.push(r), l.treetoggle && i.push(e[o].$level * Hi + (e[o].$count ? Hi : 0)))
  }
  return Nn(n, s, t, i).width
}
function Cd(l, e) {
  const t = 'wx-measure-cell-header',
    n = l.sort ? Sd : 0
  let i = l.header
  if (typeof i == 'string') return Nn(i, t, e).width + n
  let s
  Array.isArray(i) || (i = [i])
  for (let o = 0; o < i.length; o++) {
    const a = i[o],
      r = typeof a == 'string' ? a : a.text,
      c = t + (typeof a == 'string' ? '' : ` ${a.css}`)
    let u = Nn(r, c, e).width
    o === i.length - 1 && (u += n), (s = Math.max(s || 0, u))
  }
  return s
}
class Dd extends dd {
  in
  _router
  _branches
  _xlsxWorker
  constructor(e) {
    super({writable: e, async: !1})
    const t = {rowHeight: 37, colWidth: 160, headerHeight: 36, footerHeight: 36}
    this._router = new hd(
      super.setState.bind(this), // data recalculation dependencies
      [
        // normalize columns, headers and footers
        {
          in: ['columns', 'sizes', '_skin'],
          out: ['_columns', '_sizes'],
          exec: (i) => {
            const {columns: s, sizes: o, _skin: a} = this.getState(),
              r = this.copyColumns(s),
              c = r.reduce((d, h) => Math.max(h.header.length, d), 0),
              u = r.reduce((d, h) => Math.max(h.footer.length, d), 0)
            r.forEach(this.setCollapsibleColumns)
            const f = this.normalizeSizes(r, o, c, u, a)
            r.forEach((d, h) => {
              this.normalizeColumns(r, h, 'header', c, f),
                this.normalizeColumns(r, h, 'footer', u, f)
            }),
              this.setState({_columns: r, _sizes: f}, i)
          },
        },
        {
          in: ['data', 'tree'],
          out: ['flatData'],
          exec: (i) => {
            const {data: s, tree: o} = this.getState()
            this.setState({flatData: o ? this.flattenRows(s) : s}, i)
          },
        },
      ],
      {
        // data initializers
        data: (i) => (this._branches ? this.normalizeTreeRows(i) : this.normalizeRows(i)), // accept partially filles size structure
        sizes: (i) => ({...t, ...i}),
      }
    )
    const n = (this.in = new md())
    n.on('close-editor', (_ref36) => {
      let {ignore: i} = _ref36
      const {editor: s} = this.getState()
      s && (i || n.exec('update-cell', s), this.setState({editor: null}))
    }),
      n.on('open-editor', (_ref37) => {
        let {id: i, column: s} = _ref37
        let o = this.getState().editor
        o && n.exec('close-editor', {})
        const a = s ? this.getColumn(s) : this.getNextEditor()
        if (a?.editor) {
          const r = this.getRow(i)
          ;(o = {column: a.id, id: i, value: tr(r, a), renderedValue: Dt(r, a)}),
            typeof a.editor != 'string' && a.editor.config && (o.config = a.editor.config),
            a.options && (o.options = a.options),
            this.setState({editor: o})
        }
      }),
      n.on('editor', (_ref38) => {
        let {value: i} = _ref38
        const s = this.getState().editor
        s && ((s.value = i), this.setState({editor: s}))
      }),
      n.on('add-row', (i) => {
        let {data: s} = this.getState()
        const {row: o, before: a, after: r} = i
        if (((i.id = o.id = i.id || o.id || qn()), a || r)) {
          const c = a || r,
            u = s.findIndex((f) => f.id === c)
          s.splice(u + (r ? 1 : 0), 0, i.row), (s = [...s])
        } else s = [...s, i.row]
        this.setState({data: s}), n.exec('select-row', {id: o.id})
      }),
      n.on('delete-row', (i) => {
        const {data: s, selected: o, selectedRows: a} = this.getState(),
          {id: r} = i,
          c = {data: s.filter((u) => u.id !== r)}
        this.isSelected(r) &&
          ((c.selectedRows = a.filter((u) => u !== r)),
          o == r && (c.selected = c.selectedRows[c.selectedRows.length - 1] || null)),
          this.setState(c)
      }),
      n.on('update-cell', (i) => {
        let {data: s} = this.getState()
        s = [...s]
        const {tree: o} = this.getState(),
          {id: a, column: r, value: c} = i,
          u = this.getColumn(r)
        if (o) {
          const f = {...this._branches[a]}
          Ti(f, u, c), (this._branches[a] = f)
          const d = this._branches[f.$parent],
            h = d.data.findIndex((m) => m.id == a)
          f.$parent === 0 && (s = d.data), (d.data = [...d.data]), (d.data[h] = f)
        } else {
          const f = s.findIndex((h) => h.id == a),
            d = {...s[f]}
          Ti(d, u, c), (s[f] = d)
        }
        this.setState({data: s})
      }),
      n.on('update-row', (i) => {
        let {data: s} = this.getState()
        const {id: o, row: a} = i,
          r = s.findIndex((c) => c.id == o)
        ;(s = [...s]), (s[r] = {...s[r], ...a}), this.setState({data: s})
      }),
      n.on('select-row', (_ref39) => {
        let {id: i, toggle: s, range: o, mode: a, show: r, column: c} = _ref39
        let {selected: u, selectedRows: f} = this.getState()
        if (o) {
          const {data: d} = this.getState()
          u || (u = i)
          let h = d.findIndex((_) => _.id == u),
            m = d.findIndex((_) => _.id == i)
          h > m && ([h, m] = [m, h]),
            d.slice(h, m + 1).forEach((_) => {
              f.indexOf(_.id) === -1 && f.push(_.id)
            }),
            (u = i)
        } else if (s && this.isSelected(i)) {
          if (a === !0) return
          ;(f = f.filter((d) => d !== i)), (u = f[f.length - 1] || null)
        } else if (((u = i), s)) {
          if (a === !1) return
          f.push(i)
        } else f = [i]
        this.setState({selected: u, selectedRows: f}),
          r && this.in.exec('scroll', {row: i, column: c})
      }),
      n.on('resize-column', (i) => {
        const {id: s, auto: o, maxRows: a} = i
        let r = i.width || 0
        const c = [...this.getState().columns],
          u = c.find((f) => f.id == s)
        if (o) {
          if (o == 'data' || o === !0) {
            const {flatData: f, _skin: d} = this.getState()
            let h = f.length
            a && (h = Math.min(a, h))
            const m = f.slice(0, h)
            r = Td(u, m, d)
          }
          if (o == 'header' || o === !0) {
            const {_skin: f} = this.getState()
            r = Math.max(Cd(u, f), r)
          }
        }
        ;(u.width = Math.max(17, r)), delete u.flexgrow, this.setState({columns: c})
      }),
      n.on('hide-column', (_ref40) => {
        let {id: i, mode: s} = _ref40
        const o = [...this.getState().columns],
          a = o.find((c) => c.id == i),
          r = o.reduce((c, u) => c + (u.hidden ? 0 : 1), 0)
        ;(!s || r > 1) && ((a.hidden = !a.hidden), this.setState({columns: o}))
      }),
      n.on('sort-rows', (i) => {
        const s = {key: i.key, order: i.order || 'asc'}
        let o = this.getState().sort
        const {columns: a, data: r, tree: c} = this.getState()
        let u = o.length
        o.forEach((d, h) => {
          d.key === s.key && ((s.order = d.order === 'asc' ? 'desc' : 'asc'), (u = h))
        }),
          a.forEach((d) => {
            d.$sort = null
          }),
          i.add ? ((o = [...o]), (o[u] = s)) : (o = [s]),
          this.setState({sort: o}),
          o.forEach((d, h) => {
            ;(d.index = o.length === 1 ? 0 : h + 1), (a.find((m) => m.id == d.key).$sort = d)
          }),
          this.setState({columns: a})
        const f = vd(o)
        if (f) {
          const d = [...r]
          c ? this.sortTree(d, f) : d.sort(f), this.setState({data: d})
        }
      }),
      n.on('filter-rows', (i) => {
        this.setState({filter: i.handler})
      }),
      n.on('collapse-column', (i) => {
        const {id: s, row: o, mode: a} = i,
          r = [...this.getState().columns],
          c = this.getColumn(s).header,
          u = Array.isArray(c) ? c[o] : c
        typeof u == 'object' && ((u.collapsed = a ?? !u.collapsed), this.setState({columns: r}))
      }),
      n.on('open-row', (i) => {
        const {id: s, nested: o} = i,
          {data: a} = this.getState()
        this.toggleBranch(s, !0, o), this.setState({data: a})
      }),
      n.on('close-row', (i) => {
        const {id: s, nested: o} = i,
          {data: a} = this.getState()
        this.toggleBranch(s, !1, o), this.setState({data: a})
      }),
      n.on(
        'export',
        (i) =>
          new Promise((s, o) => {
            const a = i.options || {},
              r = `${a.fileName || 'data'}.${a.format}`
            if (a.format == 'csv') {
              const c = wd(this.getState(), a)
              a.download !== !1
                ? Ci(new Blob(['\uFEFF' + c], {type: 'text/csv'}), r)
                : (i.result = c),
                s(!0)
            } else if (a.format == 'xlsx') {
              const {cells: c, merged: u, rowSizes: f, colSizes: d} = bd(this.getState(), a),
                h = a.cdn || 'https://cdn.dhtmlx.com/libs/json2excel/next/worker.js',
                m = this.getXlsxWorker(h),
                _ = a.styles || kd()
              m.then((w) => {
                ;(w.onmessage = (b) => {
                  if (b.data.type == 'ready') {
                    const p = b.data.blob
                    a.download !== !1 ? Ci(p, r) : (i.result = p), s(!0)
                  }
                }),
                  w.postMessage({
                    type: 'convert',
                    data: {
                      data: [{name: a.sheetName || 'data', cells: c, cols: d, rows: f, merged: u}],
                      styles: [
                        {id: 'header', ..._.header},
                        {id: 'lastHeaderCell', ...(_.lastHeaderCell || _.header)},
                        {id: 'cell', ..._.cell},
                        {id: 'firstFooterCell', ...(_.firstFooterCell || _.footer)},
                        {id: 'footer', ..._.footer},
                      ],
                    },
                  })
              })
            } else o()
          })
      ),
      n.on('hotkey', (_ref41) => {
        let {key: i, event: s} = _ref41
        switch (i) {
          case 'arrowup': {
            const {selected: o, editor: a, flatData: r} = this.getState()
            if (!a) {
              s.preventDefault()
              const c = o ? this.getPrevRow(o)?.id : r[r.length - 1]?.id
              c && this.in.exec('select-row', {id: c, show: !0})
            }
            break
          }
          case 'arrowdown': {
            const {selected: o, editor: a, flatData: r} = this.getState()
            if (!a) {
              s.preventDefault()
              const c = o ? this.getNextRow(o)?.id : r[0]?.id
              c && this.in.exec('select-row', {id: c, show: !0})
            }
            break
          }
          case 'tab': {
            const {editor: o} = this.getState()
            if (o) {
              s.preventDefault()
              const a = o.column
              let r = o.id,
                c = this.getNextEditor(a)
              if (c) this.in.exec('select-row', {id: r, show: !0, column: c.id})
              else {
                const u = this.getNextRow(r)
                u &&
                  ((r = u.id),
                  (c = this.getNextEditor()),
                  this.in.exec('select-row', {id: r, show: !0, column: c.id}))
              }
              c && this.in.exec('open-editor', {id: r, column: c.id})
            }
            break
          }
          case 'shift+tab': {
            const {editor: o} = this.getState()
            if (o) {
              s.preventDefault()
              const a = o.column
              let r = o.id,
                c = this.getPrevEditor(a)
              if (c) this.in.exec('select-row', {id: r, show: !0, column: c.id})
              else {
                const u = this.getPrevRow(r)
                u &&
                  ((r = u.id),
                  (c = this.getPrevEditor()),
                  this.in.exec('select-row', {id: r, show: !0, column: c.id}))
              }
              c && this.in.exec('open-editor', {id: r, column: c.id})
            }
            break
          }
          case 'escape': {
            const {editor: o} = this.getState()
            o && this.in.exec('close-editor', {ignore: !0})
            break
          }
          case 'f2': {
            const {editor: o, selected: a} = this.getState()
            !o && a && this.in.exec('open-editor', {id: a})
            break
          }
        }
      }),
      n.on('scroll', (i) => {
        const {_columns: s, split: o, _sizes: a, data: r} = this.getState()
        let c = -1,
          u = -1,
          f = 0
        if (i.column) {
          c = 0
          const d = s.findIndex((h) => h.id === i.column)
          f = s[d].width
          for (let h = o.left; h < d; h++) {
            const m = s[h]
            m.hidden || (c += m.width)
          }
        }
        i.row && (u = a.rowHeight * r.findIndex((d) => d.id === i.row)),
          this.setState({scroll: {top: u, left: c, width: f, height: a.rowHeight}})
      })
  }
  getXlsxWorker(e) {
    if (!this._xlsxWorker) {
      const t = window.URL.createObjectURL(
        new Blob([`importScripts('${e}');`], {type: 'text/javascript'})
      )
      this._xlsxWorker = new Promise((n) => {
        const i = new Worker(t)
        i.addEventListener('message', (s) => {
          s.data.type === 'init' && n(i)
        })
      })
    }
    return this._xlsxWorker
  }
  init(e) {
    e.hasOwnProperty('_skin') && !e._skin && (e._skin = Md()),
      e.columns &&
        e.columns.forEach((t) => {
          t.options && (t.optionsMap = new Map(t.options.map((n) => [n.id, n.name])))
        }),
      e.tree && (this._branches = {0: {data: e.data}}),
      this._router.init({sort: [], filter: null, scroll: null, ...e})
  }
  setState(e, t) {
    return this._router.setState(e, t)
  }
  getRow(e) {
    const {tree: t} = this.getState()
    return t ? this._branches[e] : this.getState().data.find((n) => n.id == e)
  }
  getNextRow(e) {
    const t = this.getState().flatData,
      n = t.findIndex((i) => i.id == e)
    return t[n + 1]
  }
  getPrevRow(e) {
    const t = this.getState().flatData,
      n = t.findIndex((i) => i.id == e)
    return t[n - 1]
  }
  getColumn(e) {
    return this.getState().columns.find((t) => t.id == e)
  }
  getNextEditor(e) {
    let t = this.getState().columns
    if (e) {
      const n = t.findIndex((i) => i.id == e)
      t = t.slice(n + 1)
    }
    return t.find((n) => n.editor && !n.hidden)
  }
  getPrevEditor(e) {
    let t = this.getState().columns
    if (e) {
      const n = t.findLastIndex((i) => i.id == e)
      t = t.slice(0, n)
    }
    return t.findLast((n) => n.editor && !n.hidden)
  }
  toggleBranch(e, t, n) {
    const i = this._branches[e]
    e !== 0 && (i.open = t),
      n &&
        i.data?.length &&
        i.data.forEach((s) => {
          this.toggleKids(s, t, n)
        })
  }
  toggleKids(e, t, n) {
    ;(e.open = t),
      n &&
        e.data?.length &&
        e.data.forEach((i) => {
          this.toggleKids(i, t, n)
        })
  }
  isSelected(e) {
    return this.getState().selectedRows.indexOf(e) !== -1
  }
  copyColumns(e) {
    const t = []
    return (
      e.forEach((n) => {
        const i = {...n}
        this.copyHeaderFooter(i, 'header'), this.copyHeaderFooter(i, 'footer'), t.push(i)
      }),
      t
    )
  }
  copyHeaderFooter(e, t) {
    let n = e[t]
    ;(n = Array.isArray(n) ? [...n] : [n]),
      n.forEach((i, s) => {
        n[s] = typeof i == 'string' ? {text: i} : {...i}
      }),
      (e[t] = n)
  }
  setCollapsibleColumns(e, t, n) {
    let i = e.header
    for (let s = 0; s < i.length; s++) {
      const o = i[s]
      if (o.collapsible && o.collapsed) {
        if (o.collapsible !== 'first') {
          ;(e.collapsed = !0), (e.width = 36), (o.vertical = !0)
          const r = i.length - s
          ;(i = i.slice(0, s + 1)), (i[s].rowspan = r)
        }
        const a = o.colspan
        if (a) {
          const r = i[s + 1]
          let c = 1
          r && r.colspan && !r.collapsed && (c = r.colspan)
          for (let u = c; u < a; u++) {
            const f = n[t + u]
            f && (f.hidden = !0)
          }
        }
      }
    }
  }
  normalizeColumns(e, t, n, i, s) {
    const o = e[t]
    o.width || (o.width = o.flexgrow ? 17 : s.colWidth),
      o.editor && typeof o.editor == 'string' && (o.editor = {type: o.editor})
    const a = o[n],
      r = s[`${n}RowHeights`]
    for (let c = 0; c < i; c++) {
      const u = a[c]
      ;(u.id = o.id),
        c === a.length - 1 && (u.rowspan = u.rowspan ? Math.min(u.rowspan, i - c) : i - c)
      for (let f = 1; f < u.rowspan; f++) {
        a.splice(c + f, 0, {})
        for (let d = 1; d < u.colspan; d++) e[t + d][n].splice(c + f, 0, {})
      }
      if (u.rowspan) {
        const f = (u.rowspan === i ? r : r.slice(c, u.rowspan + c)).reduce((d, h) => d + h, 0)
        ;(u.height = f), c + u.rowspan != i && u.height--
      }
      if (u.colspan) {
        let f = o.width,
          d = o.flexgrow || 0
        const h = u.colspan
        for (let m = 1; m < h; m++) {
          const _ = e[t + m]
          _ &&
            (_.hidden
              ? (u.colspan -= 1)
              : _.flexgrow
              ? (d += _.flexgrow)
              : (f += _.width || s.colWidth)),
            d ? (u.flexgrow = d) : (u.width = f)
        }
      } else (u.width = o.width), (u.flexgrow = o.flexgrow)
    }
    a.length > i && (a.length = i), (o[n] = a)
  }
  normalizeRows(e) {
    return (
      e.forEach((t) => {
        t.id || (t.id = qn())
      }),
      e
    )
  }
  normalizeTreeRows(e, t, n) {
    return (
      e.forEach((i) => {
        i.id || (i.id = qn()),
          (i.$level = t || 0),
          (i.$parent = n || 0),
          (this._branches[i.id] = i),
          i.data?.length &&
            ((i.$count = i.data.length), this.normalizeTreeRows(i.data, i.$level + 1, i.id))
      }),
      e
    )
  }
  sortTree(e, t) {
    e.sort(t),
      e.forEach((n) => {
        n.data && this.sortTree(n.data, t)
      })
  }
  flattenRows(e, t) {
    const n = t || []
    return (
      e.forEach((i) => {
        n.push(i), i.data?.length && i.open !== !1 && this.flattenRows(i.data, n)
      }),
      n
    )
  }
  normalizeSizes(e, t, n, i, s) {
    const o = zi(e, 'header', n, t.headerHeight, s),
      a = zi(e, 'footer', i, t.footerHeight, s),
      r = o.reduce((u, f) => u + f, 0),
      c = a.reduce((u, f) => u + f, 0)
    return {...t, headerRowHeights: o, footerRowHeights: a, headerHeight: r, footerHeight: c}
  }
}
let Wd = /* @__PURE__ */ new Date().valueOf()
function qn() {
  return 'temp://' + Wd++
}
function Hd(l, _ref42) {
  let {keys: e, exec: t} = _ref42
  for (const i in e) {
    const s = i.toLowerCase().replace(/ /g, '')
    s !== i && (e[s] = e[i])
  }
  function n(i) {
    let s = i.code.toLowerCase()
    s === ' ' && (s = 'space')
    const o = `${i.ctrlKey || i.metaKey ? 'ctrl+' : ''}${i.shiftKey ? 'shift+' : ''}${
        i.altKey ? 'alt+' : ''
      }${s}`,
      a = e[o]
    if (typeof a < 'u') {
      const r = i.target.tagName === 'INPUT' || i.target.tagName === 'TEXTAREA'
      typeof a == 'function'
        ? a({key: o, event: i, node: l, isInput: r})
        : a && t({key: o, event: i, node: l, isInput: r})
    }
  }
  return (
    l.addEventListener('keydown', n),
    {
      destroy: () => {
        l.removeEventListener('keydown', n)
      },
    }
  )
}
function zd(l, e) {
  let t = null
  e.scroll.subscribe((n) => {
    if (!n || n === t) return
    t = n
    const {left: i, top: s, height: o, width: a} = n,
      r = e.getHeight(),
      c = e.getWidth()
    if (s >= 0) {
      const u = l.scrollTop
      s < u ? (l.scrollTop = s) : s + o > u + r && (l.scrollTop = s - r + o)
    }
    if (i >= 0) {
      const u = l.scrollLeft
      i < u ? (l.scrollLeft = i) : i + a > u + c && (l.scrollLeft = i - c + a)
    }
  })
}
function Nd(l, e) {
  const t = new ResizeObserver((n) => e(n[0].contentRect))
  return (
    t.observe(l.parentNode),
    {
      destroy() {
        t.disconnect()
      },
    }
  )
}
function Pn(l, e, t, n, i) {
  const s = l ? `width:${l}px;` : '',
    o = l ? `min-width:${l}px;` : '',
    a = e ? `flex-grow:${e};` : '',
    r = i ? `height:${i}px;` : '',
    c = t ? `position:sticky;left:${n}px;` : ''
  return `${o}${s}${r}${a}${c}`
}
function lr(l, e, t) {
  let n = ''
  return (
    (n += l.fixed ? (l.fixed === -1 ? 'wx-shadow ' : 'wx-fixed ') : ''),
    (n += e.rowspan > 1 ? 'wx-rowspan ' : ''),
    (n += e.colspan > 1 ? 'wx-colspan ' : ''),
    (n += e.vertical ? 'wx-vertical ' : ''),
    (n += t ? t(l) + ' ' : ''),
    n
  )
}
function Ld(l) {
  let e
  const t = /*#slots*/ l[7].default,
    n = Ie(t, l, /*$$scope*/ l[6], null),
    i = n || Id(l)
  return {
    c() {
      i && i.c()
    },
    m(s, o) {
      i && i.m(s, o), (e = !0)
    },
    p(s, o) {
      n
        ? n.p &&
          (!e || o & /*$$scope*/ 64) &&
          Oe(
            n,
            t,
            s,
            /*$$scope*/ s[6],
            e ? Re(t, /*$$scope*/ s[6], o, null) : Ae(/*$$scope*/ s[6]),
            null
          )
        : i && i.p && (!e || o & /*row, col*/ 3) && i.p(s, e ? o : -1)
    },
    i(s) {
      e || (k(i, s), (e = !0))
    },
    o(s) {
      y(i, s), (e = !1)
    },
    d(s) {
      i && i.d(s)
    },
  }
}
function Ed(l) {
  let e,
    t,
    n,
    i,
    s,
    o = /*row*/ l[0].$count && Ni(l)
  const a = /*#slots*/ l[7].default,
    r = Ie(a, l, /*$$scope*/ l[6], null),
    c = r || Rd(l)
  return {
    c() {
      ;(e = D('div')),
        (t = D('span')),
        (n = Y()),
        o && o.c(),
        (i = Y()),
        c && c.c(),
        j(t, 'margin-left', /*row*/ l[0].$level * 28 + 'px'),
        g(e, 'class', 'wx-tree-cell x2-1wbpy33')
    },
    m(u, f) {
      S(u, e, f), H(e, t), H(e, n), o && o.m(e, null), H(e, i), c && c.m(e, null), (s = !0)
    },
    p(u, f) {
      ;(!s || f & /*row*/ 1) && j(t, 'margin-left', /*row*/ u[0].$level * 28 + 'px'),
        /*row*/ u[0].$count
          ? o
            ? o.p(u, f)
            : ((o = Ni(u)), o.c(), o.m(e, i))
          : o && (o.d(1), (o = null)),
        r
          ? r.p &&
            (!s || f & /*$$scope*/ 64) &&
            Oe(
              r,
              a,
              u,
              /*$$scope*/ u[6],
              s ? Re(a, /*$$scope*/ u[6], f, null) : Ae(/*$$scope*/ u[6]),
              null
            )
          : c && c.p && (!s || f & /*row, col*/ 3) && c.p(u, s ? f : -1)
    },
    i(u) {
      s || (k(c, u), (s = !0))
    },
    o(u) {
      y(c, u), (s = !1)
    },
    d(u) {
      u && v(e), o && o.d(), c && c.d(u)
    },
  }
}

function Id(l) {
  let e = Dt(/*row*/ l[0], /*col*/ l[1]),
    t,
    prevRowId = l[0]?.id,
    prevColValue = l[0]?.[l[1].id], // Store the actual value for the column
    prevColId = l[1]?.id

  return {
    // Create the node (initially)
    c() {
      // Create node based on type
      t = e && typeof e === 'object' ? re(e) : re(String(e || ''))
    },

    // Mount the node into the DOM
    m(n, i) {
      S(n, t, i)
    },

    // Update the node only if there are changes to row or column
    p(n, i) {
      // Only process if row or column changed (bitwise check)
      const isRowOrColChanged = i & 3 // Check if row or column index changed

      if (isRowOrColChanged) {
        const currentRowId = n[0]?.id
        const currentColId = n[1]?.id
        const currentColValue = n[0]?.[n[1].id]

        // Skip if neither row ID nor relevant column value changed
        if (
          prevRowId === currentRowId &&
          prevColId === currentColId &&
          prevColValue === currentColValue
        ) {
          return
        }

        // Update tracking values
        prevRowId = currentRowId
        prevColId = currentColId
        prevColValue = currentColValue

        // Get new value
        const newValue = Dt(n[0], n[1])

        // Skip if reference equal (optimization for object references)
        if (Object.is(e, newValue)) {
          return
        }

        // Update stored value
        e = newValue

        // Handle DOM/React elements
        if (newValue && typeof newValue === 'object') {
          const newNode = re(newValue)

          // Only replace if nodes are different
          if (!t.isEqualNode(newNode)) {
            t.parentNode?.replaceChild(newNode, t)
            t = newNode
          }
        }
        // Handle primitive values
        else {
          const newText = String(newValue || '')
          if (t.textContent !== newText) {
            me(t, newText)
          }
        }
      }
    },

    // Remove the node from the DOM
    d(n) {
      n && v(t)
    },
  }
}
function Ni(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')),
        g(e, 'data-action', 'toggle-row'),
        g(
          e,
          'class',
          (t =
            'wx-table-tree-toggle wxi-menu-' +
            /*row*/ (l[0].open !== !1 ? 'down' : 'right') +
            ' x2-1wbpy33')
        )
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*row*/ 1 &&
        t !==
          (t =
            'wx-table-tree-toggle wxi-menu-' +
            /*row*/ (n[0].open !== !1 ? 'down' : 'right') +
            ' x2-1wbpy33') &&
        g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function Rd(l) {
  let e = Dt(/*row*/ l[0], /*col*/ l[1]) + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*row, col*/ 3 && e !== (e = Dt(/*row*/ n[0], /*col*/ n[1]) + '') && me(t, e)
    },
    d(n) {
      n && v(t)
    },
  }
}
function Od(l) {
  let e, t, n, i, s, o, a
  const r = [Ed, Ld],
    c = []
  function u(f, d) {
    return /*col*/ f[1].treetoggle ? 0 : 1
  }
  return (
    (t = u(l)),
    (n = c[t] = r[t](l)),
    {
      c() {
        ;(e = D('div')),
          n.c(),
          g(e, 'class', (i = Ve(/*css*/ l[3]) + ' x2-1wbpy33')),
          g(e, 'style', /*style*/ l[2]),
          g(e, 'data-row-id', (s = /*row*/ l[0].id)),
          g(e, 'data-col-id', (o = /*col*/ l[1].id)),
          Q(e, 'wx-shadow', /*col*/ l[1].fixed === -1)
      },
      m(f, d) {
        S(f, e, d), c[t].m(e, null), (a = !0)
      },
      p(f, _ref43) {
        let [d] = _ref43
        let h = t
        ;(t = u(f)),
          t === h
            ? c[t].p(f, d)
            : (te(),
              y(c[h], 1, 1, () => {
                c[h] = null
              }),
              ne(),
              (n = c[t]),
              n ? n.p(f, d) : ((n = c[t] = r[t](f)), n.c()),
              k(n, 1),
              n.m(e, null)),
          (!a || (d & /*css*/ 8 && i !== (i = Ve(/*css*/ f[3]) + ' x2-1wbpy33'))) &&
            g(e, 'class', i),
          (!a || d & /*style*/ 4) && g(e, 'style', /*style*/ f[2]),
          (!a || (d & /*row*/ 1 && s !== (s = /*row*/ f[0].id))) && g(e, 'data-row-id', s),
          (!a || (d & /*col*/ 2 && o !== (o = /*col*/ f[1].id))) && g(e, 'data-col-id', o),
          (!a || d & /*css, col*/ 10) && Q(e, 'wx-shadow', /*col*/ f[1].fixed === -1)
      },
      i(f) {
        a || (k(n), (a = !0))
      },
      o(f) {
        y(n), (a = !1)
      },
      d(f) {
        f && v(e), c[t].d()
      },
    }
  )
}
function Ad(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {row: s} = e,
    {col: o} = e,
    {cellStyle: a = null} = e,
    {columnStyle: r = null} = e,
    c,
    u
  function f(d, h) {
    let m = 'wx-cell'
    return (m += d ? ' ' + d(o) : ''), (m += h ? ' ' + h(s, o) : ''), m
  }
  return (
    (l.$$set = (d) => {
      'row' in d && t(0, (s = d.row)),
        'col' in d && t(1, (o = d.col)),
        'cellStyle' in d && t(4, (a = d.cellStyle)),
        'columnStyle' in d && t(5, (r = d.columnStyle)),
        '$$scope' in d && t(6, (i = d.$$scope))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*col*/ 2 && t(2, (c = Pn(o.width, o.flexgrow, o.fixed, o.left))),
        l.$$.dirty & /*columnStyle, cellStyle*/ 48 && t(3, (u = f(r, a)))
    }),
    [s, o, c, u, a, r, i, n]
  )
}
class vl extends ee {
  constructor(e) {
    super(), $(this, e, Ad, Od, x, {row: 0, col: 1, cellStyle: 4, columnStyle: 5})
  }
}
function Fd(l, e) {
  let t, n
  function i(a) {
    ;(t = a.clientX),
      (l.style.opacity = 1),
      (document.body.style.cursor = 'ew-resize'),
      (document.body.style.userSelect = 'none'),
      window.addEventListener('mousemove', s),
      window.addEventListener('mouseup', o),
      e && e.down && e.down(l)
  }
  function s(a) {
    ;(n = a.clientX - t), e && e.move && e.move(n)
  }
  function o() {
    ;(l.style.opacity = ''),
      (document.body.style.cursor = ''),
      (document.body.style.userSelect = ''),
      e && e.up && e.up(),
      window.removeEventListener('mousemove', s),
      window.removeEventListener('mouseup', o)
  }
  return (
    l.addEventListener('mousedown', i),
    {
      destroy() {
        l.removeEventListener('mousedown', i)
      },
    }
  )
}
function Pd(l) {
  let e,
    t,
    n,
    i = /*cell*/ (l[0].text || '') + '',
    s,
    o,
    a,
    r,
    c,
    u = /*cell*/ l[0].collapsible && Li(l),
    f = /*column*/ l[1].resize && /*lastRow*/ l[2] && Ei(l),
    d = /*column*/ l[1].sort && Ii(l)
  return {
    c() {
      ;(e = D('div')),
        u && u.c(),
        (t = Y()),
        (n = D('div')),
        (s = re(i)),
        (o = Y()),
        f && f.c(),
        (a = Y()),
        d && d.c(),
        g(n, 'class', 'wx-text x2-hek2za'),
        g(
          e,
          'class',
          (r = 'wx-cell ' + /*css*/ l[4] + ' ' + /*cell*/ (l[0].css || '') + ' x2-hek2za')
        ),
        g(e, 'style', /*style*/ l[3]),
        g(e, 'data-header-id', (c = /*column*/ l[1].id))
    },
    m(h, m) {
      S(h, e, m),
        u && u.m(e, null),
        H(e, t),
        H(e, n),
        H(n, s),
        H(e, o),
        f && f.m(e, null),
        H(e, a),
        d && d.m(e, null)

      // Add click handler for the entire header cell if column is sortable
      if (l[1].sort) {
        e.addEventListener('click', l[7])
      }
    },
    p(h, m) {
      /*cell*/ h[0].collapsible
        ? u
          ? u.p(h, m)
          : ((u = Li(h)), u.c(), u.m(e, t))
        : u && (u.d(1), (u = null)),
        m & /*cell*/ 1 && i !== (i = /*cell*/ (h[0].text || '') + '') && me(s, i),
        /*column*/ h[1].resize && /*lastRow*/ h[2]
          ? f
            ? f.p(h, m)
            : ((f = Ei(h)), f.c(), f.m(e, a))
          : f && (f.d(1), (f = null)),
        /*column*/ h[1].sort
          ? d
            ? d.p(h, m)
            : ((d = Ii(h)), d.c(), d.m(e, null))
          : d && (d.d(1), (d = null)),
        m & /*css, cell*/ 17 &&
          r !== (r = 'wx-cell ' + /*css*/ h[4] + ' ' + /*cell*/ (h[0].css || '') + ' x2-hek2za') &&
          g(e, 'class', r),
        m & /*style*/ 8 && g(e, 'style', /*style*/ h[3]),
        m & /*column*/ 2 && c !== (c = /*column*/ h[1].id) && g(e, 'data-header-id', c)

      // Update click handler when sort property changes
      if (m & /*column*/ 2) {
        if (h[1].sort) {
          e.addEventListener('click', h[7])
        } else {
          e.removeEventListener('click', h[7])
        }
      }
    },
    d(h) {
      h && v(e), u && u.d(), f && f.d(), d && d.d()

      // Clean up click handler
      if (l[1].sort) {
        e.removeEventListener('click', l[7])
      }
    },
  }
}
function Yd(l) {
  let e,
    t,
    n = /*cell*/ (l[0].text || '') + '',
    i,
    s,
    o,
    a,
    r
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        (i = re(n)),
        g(t, 'class', 'wx-text x2-hek2za'),
        g(
          e,
          'class',
          (s =
            'wx-cell ' + /*css*/ l[4] + ' ' + /*cell*/ (l[0].css || '') + ' wx-collapsed x2-hek2za')
        ),
        g(e, 'style', /*style*/ l[3]),
        g(e, 'data-header-id', (o = /*column*/ l[1].id))
    },
    m(c, u) {
      S(c, e, u), H(e, t), H(t, i), a || ((r = q(e, 'click', En(/*collapse*/ l[8]))), (a = !0))
    },
    p(c, u) {
      u & /*cell*/ 1 && n !== (n = /*cell*/ (c[0].text || '') + '') && me(i, n),
        u & /*css, cell*/ 17 &&
          s !==
            (s =
              'wx-cell ' +
              /*css*/ c[4] +
              ' ' +
              /*cell*/ (c[0].css || '') +
              ' wx-collapsed x2-hek2za') &&
          g(e, 'class', s),
        u & /*style*/ 8 && g(e, 'style', /*style*/ c[3]),
        u & /*column*/ 2 && o !== (o = /*column*/ c[1].id) && g(e, 'data-header-id', o)
    },
    d(c) {
      c && v(e), (a = !1), r()
    },
  }
}
function Li(l) {
  let e, t, n, i, s
  return {
    c() {
      ;(e = D('div')),
        (t = D('i')),
        g(t, 'class', (n = 'wxi-angle-' + /*cell*/ (l[0].collapsed ? 'down' : 'right'))),
        g(e, 'class', 'wx-collapse x2-hek2za')
    },
    m(o, a) {
      S(o, e, a), H(e, t), i || ((s = q(e, 'click', En(/*collapse*/ l[8]))), (i = !0))
    },
    p(o, a) {
      a & /*cell*/ 1 &&
        n !== (n = 'wxi-angle-' + /*cell*/ (o[0].collapsed ? 'down' : 'right')) &&
        g(t, 'class', n)
    },
    d(o) {
      o && v(e), (i = !1), s()
    },
  }
}
function Ei(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('div')), g(e, 'class', 'wx-grip x2-hek2za')
    },
    m(i, s) {
      S(i, e, s),
        t || ((n = nt(Fd.call(null, e, {down: /*down*/ l[5], move: /*move*/ l[6]}))), (t = !0))
    },
    p: I,
    d(i) {
      i && v(e), (t = !1), n()
    },
  }
}
function Ii(l) {
  let e, t, n
  let i = Ri(l)

  return {
    c() {
      e = D('div')
      i && i.c()
      g(e, 'class', 'wx-sort x2-hek2za')
    },
    m(s, o) {
      S(s, e, o)
      i && i.m(e, null)
      // Remove click handler from sort icon since we handle clicks on the cell
      t = !0
    },
    p(s, o) {
      i && i.p(s, o)
    },
    d(s) {
      s && v(e)
      i && i.d()
      t = !1
    },
  }
}
function Ri(l) {
  let e, t, n
  let i = /*column*/ l[1].$sort?.index > 0 && Oi(l)

  return {
    c() {
      i && i.c()
      e = Y()
      t = D('fragment')
    },
    m(s, o) {
      i && i.m(s, o)
      S(s, e, o)
      S(s, t, o)
    },
    p(s, o) {
      if (/*column*/ s[1].$sort?.index > 0) {
        i ? i.p(s, o) : ((i = Oi(s)), i.c(), i.m(e.parentNode, e))
      } else {
        i && (i.d(1), (i = null))
      }

      // Update arrows based on sort state
      if (o & /*column*/ 2) {
        if (s[1].$sort && s[1].$sort.order) {
          t.innerHTML = `<i class="bi bi-caret-${
            s[1].$sort.order === 'asc' ? 'up' : 'down'
          }-fill fs-8"></i>`
        } else {
          t.innerHTML = `
            <div class='sort-both-arrow'>
              <div class='sort-top-arrow lh-1'>
                <i class='bi bi-caret-up-fill fs-8 lh-1 '></i>
              </div>
              <div class='sort-bottom-arrow lh-1'>
                <i class='bi bi-caret-down-fill fs-8 lh-1 '></i>
              </div>
            </div>
          `
        }
      }
    },
    d(s) {
      s && (v(e), v(t))
      i && i.d(s)
    },
  }
}
function Oi(l) {
  let e,
    t = /*column*/ l[1].$sort.index + '',
    n
  return {
    c() {
      ;(e = D('div')), (n = re(t)), g(e, 'class', 'wx-order x2-hek2za')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*column*/ 2 && t !== (t = /*column*/ i[1].$sort.index + '') && me(n, t)
    },
    d(i) {
      i && v(e)
    },
  }
}
function Bd(l) {
  let e
  function t(s, o) {
    return /*cell*/ s[0].collapsed && /*column*/ s[1].collapsed ? Yd : Pd
  }
  let n = t(l),
    i = n(l)
  return {
    c() {
      i.c(), (e = se())
    },
    m(s, o) {
      i.m(s, o), S(s, e, o)
    },
    p(s, _ref44) {
      let [o] = _ref44
      n === (n = t(s)) && i ? i.p(s, o) : (i.d(1), (i = n(s)), i && (i.c(), i.m(e.parentNode, e)))
    },
    i: I,
    o: I,
    d(s) {
      s && v(e), i.d(s)
    },
  }
}
function jd(l, e, t) {
  let {cell: n} = e,
    {column: i} = e,
    {row: s} = e,
    {lastRow: o} = e,
    {columnStyle: a} = e
  const r = He()
  let c
  function u(w) {
    c = n.flexgrow ? w.parentNode.clientWidth : n.width
  }
  function f(w) {
    r('action', {action: 'resize-column', data: {id: n.id, width: Math.max(1, c + w)}})
  }
  function d(w) {
    r('action', {action: 'sort-rows', data: {key: n.id, add: w.ctrlKey}})
  }
  function h() {
    r('action', {action: 'collapse-column', data: {id: n.id, row: s}})
  }
  let m,
    _ = ''
  return (
    (l.$$set = (w) => {
      'cell' in w && t(0, (n = w.cell)),
        'column' in w && t(1, (i = w.column)),
        'row' in w && t(9, (s = w.row)),
        'lastRow' in w && t(2, (o = w.lastRow)),
        'columnStyle' in w && t(10, (a = w.columnStyle))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*cell, column*/ 3 &&
        t(3, (m = Pn(n.width, n.flexgrow, i.fixed, i.left, n.height))),
        l.$$.dirty & /*column, cell, columnStyle*/ 1027 && t(4, (_ = lr(i, n, a)))
    }),
    [n, i, o, m, _, u, f, d, h, s, a]
  )
}
class Zd extends ee {
  constructor(e) {
    super(), $(this, e, jd, Bd, x, {cell: 0, column: 1, row: 9, lastRow: 2, columnStyle: 10})
  }
}
function Ai(l) {
  let e,
    t = /*cell*/ (l[0].text || '') + '',
    n
  return {
    c() {
      ;(e = D('div')), (n = re(t)), g(e, 'class', 'wx-text x2-1pgtgrd')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*cell*/ 1 && t !== (t = /*cell*/ (i[0].text || '') + '') && me(n, t)
    },
    d(i) {
      i && v(e)
    },
  }
}
function qd(l) {
  let e,
    t,
    n = !(/*column*/ l[1].collapsed) && !(/*cell*/ l[0].collapsed) && Ai(l)
  return {
    c() {
      ;(e = D('div')),
        n && n.c(),
        g(
          e,
          'class',
          (t = 'wx-cell ' + /*css*/ l[3] + ' ' + /*cell*/ (l[0].css || '') + ' x2-1pgtgrd')
        ),
        g(e, 'style', /*style*/ l[2])
    },
    m(i, s) {
      S(i, e, s), n && n.m(e, null)
    },
    p(i, _ref45) {
      let [s] = _ref45
      !(/*column*/ i[1].collapsed) && !(/*cell*/ i[0].collapsed)
        ? n
          ? n.p(i, s)
          : ((n = Ai(i)), n.c(), n.m(e, null))
        : n && (n.d(1), (n = null)),
        s & /*css, cell*/ 9 &&
          t !== (t = 'wx-cell ' + /*css*/ i[3] + ' ' + /*cell*/ (i[0].css || '') + ' x2-1pgtgrd') &&
          g(e, 'class', t),
        s & /*style*/ 4 && g(e, 'style', /*style*/ i[2])
    },
    i: I,
    o: I,
    d(i) {
      i && v(e), n && n.d()
    },
  }
}
function Kd(l, e, t) {
  let {cell: n} = e,
    {column: i} = e,
    {columnStyle: s} = e,
    o,
    a = ''
  return (
    (l.$$set = (r) => {
      'cell' in r && t(0, (n = r.cell)),
        'column' in r && t(1, (i = r.column)),
        'columnStyle' in r && t(4, (s = r.columnStyle))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*cell, column*/ 3 &&
        t(2, (o = Pn(n.width, n.flexgrow, i.fixed, i.left, n.height))),
        l.$$.dirty & /*column, cell, columnStyle*/ 19 && t(3, (a = lr(i, n, s)))
    }),
    [n, i, o, a, s]
  )
}
class Gd extends ee {
  constructor(e) {
    super(), $(this, e, Kd, qd, x, {cell: 0, column: 1, columnStyle: 4})
  }
}
function Fi(l, e, t) {
  const n = l.slice()
  return (n[10] = e[t]), (n[12] = t), n
}
function Pi(l, e, t) {
  const n = l.slice()
  return (n[13] = e[t]), n
}
function Xd(l) {
  let e, t
  return (
    (e = new Gd({
      props: {
        cell: /*cell*/ l[13],
        columnStyle: /*columnStyle*/ l[4],
        column: /*getColumn*/ l[6](/*cell*/ l[13].id),
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*renderedHeader*/ 32 && (s.cell = /*cell*/ n[13]),
          i & /*columnStyle*/ 16 && (s.columnStyle = /*columnStyle*/ n[4]),
          i & /*renderedHeader*/ 32 && (s.column = /*getColumn*/ n[6](/*cell*/ n[13].id)),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Vd(l) {
  let e, t
  return (
    (e = new Zd({
      props: {
        cell: /*cell*/ l[13],
        columnStyle: /*columnStyle*/ l[4],
        column: /*getColumn*/ l[6](/*cell*/ l[13].id),
        row: /*i*/ l[12],
        lastRow: /*isLast*/ l[7](/*cell*/ l[13], /*i*/ l[12]),
      },
    })),
    e.$on('action', /*action_handler*/ l[9]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*renderedHeader*/ 32 && (s.cell = /*cell*/ n[13]),
          i & /*columnStyle*/ 16 && (s.columnStyle = /*columnStyle*/ n[4]),
          i & /*renderedHeader*/ 32 && (s.column = /*getColumn*/ n[6](/*cell*/ n[13].id)),
          i & /*renderedHeader*/ 32 && (s.lastRow = /*isLast*/ n[7](/*cell*/ n[13], /*i*/ n[12])),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Yi(l, e) {
  let t, n, i, s, o
  const a = [Vd, Xd],
    r = []
  function c(u, f) {
    return /*type*/ u[3] === 'header' ? 0 : 1
  }
  return (
    (n = c(e)),
    (i = r[n] = a[n](e)),
    {
      key: l,
      first: null,
      c() {
        ;(t = se()), i.c(), (s = se()), (this.first = t)
      },
      m(u, f) {
        S(u, t, f), r[n].m(u, f), S(u, s, f), (o = !0)
      },
      p(u, f) {
        e = u
        let d = n
        ;(n = c(e)),
          n === d
            ? r[n].p(e, f)
            : (te(),
              y(r[d], 1, 1, () => {
                r[d] = null
              }),
              ne(),
              (i = r[n]),
              i ? i.p(e, f) : ((i = r[n] = a[n](e)), i.c()),
              k(i, 1),
              i.m(s.parentNode, s))
      },
      i(u) {
        o || (k(i), (o = !0))
      },
      o(u) {
        y(i), (o = !1)
      },
      d(u) {
        u && (v(t), v(s)), r[n].d(u)
      },
    }
  )
}
function Bi(l) {
  let e,
    t = [],
    n = /* @__PURE__ */ new Map(),
    i,
    s,
    o,
    a = de(/*row*/ l[10])
  const r = (c) => /*cell*/ c[13].id
  for (let c = 0; c < a.length; c += 1) {
    let u = Pi(l, a, c),
      f = r(u)
    n.set(f, (t[c] = Yi(f, u)))
  }
  return {
    c() {
      e = D('div')
      for (let c = 0; c < t.length; c += 1) t[c].c()
      ;(i = Y()),
        g(
          e,
          'class',
          (s = Ve(/*type*/ l[3] === 'header' ? 'wx-h-row' : 'wx-f-row') + ' x2-1byhgan')
        ),
        j(e, 'height', /*rowHeights*/ l[2][/*i*/ l[12]] + 'px'),
        j(e, 'display', 'flex')
    },
    m(c, u) {
      S(c, e, u)
      for (let f = 0; f < t.length; f += 1) t[f] && t[f].m(e, null)
      H(e, i), (o = !0)
    },
    p(c, u) {
      u & /*renderedHeader, columnStyle, getColumn, isLast, type*/ 248 &&
        ((a = de(/*row*/ c[10])), te(), (t = kt(t, u, r, 1, c, a, n, e, en, Yi, i, Pi)), ne()),
        (!o ||
          (u & /*type*/ 8 &&
            s !==
              (s = Ve(/*type*/ c[3] === 'header' ? 'wx-h-row' : 'wx-f-row') + ' x2-1byhgan'))) &&
          g(e, 'class', s),
        (!o || u & /*rowHeights*/ 4) && j(e, 'height', /*rowHeights*/ c[2][/*i*/ c[12]] + 'px')
    },
    i(c) {
      if (!o) {
        for (let u = 0; u < a.length; u += 1) k(t[u])
        o = !0
      }
    },
    o(c) {
      for (let u = 0; u < t.length; u += 1) y(t[u])
      o = !1
    },
    d(c) {
      c && v(e)
      for (let u = 0; u < t.length; u += 1) t[u].d()
    },
  }
}
function Ud(l) {
  let e,
    t,
    n,
    i = de(/*renderedHeader*/ l[5]),
    s = []
  for (let a = 0; a < i.length; a += 1) s[a] = Bi(Fi(l, i, a))
  const o = (a) =>
    y(s[a], 1, 1, () => {
      s[a] = null
    })
  return {
    c() {
      e = D('div')
      for (let a = 0; a < s.length; a += 1) s[a].c()
      g(e, 'class', (t = Ve(`wx-${/*type*/ l[3]}`) + ' x2-1byhgan')),
        j(e, 'padding-left', /*deltaLeft*/ l[0] + 'px'),
        j(e, 'width', /*contentWidth*/ l[1] + 'px')
    },
    m(a, r) {
      S(a, e, r)
      for (let c = 0; c < s.length; c += 1) s[c] && s[c].m(e, null)
      n = !0
    },
    p(a, _ref46) {
      let [r] = _ref46
      if (r & /*type, rowHeights, renderedHeader, columnStyle, getColumn, isLast*/ 252) {
        i = de(/*renderedHeader*/ a[5])
        let c
        for (c = 0; c < i.length; c += 1) {
          const u = Fi(a, i, c)
          s[c]
            ? (s[c].p(u, r), k(s[c], 1))
            : ((s[c] = Bi(u)), s[c].c(), k(s[c], 1), s[c].m(e, null))
        }
        for (te(), c = i.length; c < s.length; c += 1) o(c)
        ne()
      }
      ;(!n || (r & /*type*/ 8 && t !== (t = Ve(`wx-${/*type*/ a[3]}`) + ' x2-1byhgan'))) &&
        g(e, 'class', t),
        (!n || r & /*deltaLeft*/ 1) && j(e, 'padding-left', /*deltaLeft*/ a[0] + 'px'),
        (!n || r & /*contentWidth*/ 2) && j(e, 'width', /*contentWidth*/ a[1] + 'px')
    },
    i(a) {
      if (!n) {
        for (let r = 0; r < i.length; r += 1) k(s[r])
        n = !0
      }
    },
    o(a) {
      s = s.filter(Boolean)
      for (let r = 0; r < s.length; r += 1) y(s[r])
      n = !1
    },
    d(a) {
      a && v(e), $e(s, a)
    },
  }
}
function Jd(l, e, t) {
  let {deltaLeft: n} = e,
    {contentWidth: i} = e,
    {rowHeights: s} = e,
    {columns: o} = e,
    {type: a = 'header'} = e,
    {columnStyle: r} = e,
    c = []
  function u(h) {
    return o.find((m) => m.id === h)
  }
  function f(h, m) {
    return h.rowspan && (m += h.rowspan - 1), m === c.length - 1
  }
  function d(h) {
    De.call(this, l, h)
  }
  return (
    (l.$$set = (h) => {
      'deltaLeft' in h && t(0, (n = h.deltaLeft)),
        'contentWidth' in h && t(1, (i = h.contentWidth)),
        'rowHeights' in h && t(2, (s = h.rowHeights)),
        'columns' in h && t(8, (o = h.columns)),
        'type' in h && t(3, (a = h.type)),
        'columnStyle' in h && t(4, (r = h.columnStyle))
    }),
    (l.$$.update = () => {
      if (l.$$.dirty & /*columns, type, renderedHeader*/ 296 && o.length) {
        const h = o[0][a].length
        t(5, (c = []))
        for (let m = 0; m < h; m++) {
          let _ = 0
          c.push([]),
            o.forEach((w) => {
              _ || c[m].push(w[a][m]), w[a][m].colspan > 1 ? (_ = w[a][m].colspan - 1) : _ && _--
            })
        }
      }
    }),
    [n, i, s, a, r, c, u, f, o, d]
  )
}
class ir extends ee {
  constructor(e) {
    super(),
      $(this, e, Jd, Ud, x, {
        deltaLeft: 0,
        contentWidth: 1,
        rowHeights: 2,
        columns: 8,
        type: 3,
        columnStyle: 4,
      })
  }
}
function Qd(l) {
  let e
  return {
    c() {
      e = re(/*overlay*/ l[0])
    },
    m(t, n) {
      S(t, e, n)
    },
    p(t, n) {
      n & /*overlay*/ 1 && me(e, /*overlay*/ t[0])
    },
    i: I,
    o: I,
    d(t) {
      t && v(e)
    },
  }
}
function xd(l) {
  let e, t, n
  var i = /*overlay*/ l[0]
  function s(o, a) {
    return {}
  }
  return (
    i && ((e = Le(i, s())), e.$on('action', /*action_handler*/ l[1])),
    {
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a & /*overlay*/ 1 && i !== (i = /*overlay*/ o[0])) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s())),
              e.$on('action', /*action_handler*/ o[1]),
              F(e.$$.fragment),
              k(e.$$.fragment, 1),
              R(e, t.parentNode, t))
            : (e = null)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function $d(l) {
  let e, t, n, i, s
  const o = [xd, Qd],
    a = []
  function r(c, u) {
    return u & /*overlay*/ 1 && (t = null), t == null && (t = !!eh(/*overlay*/ c[0])), t ? 0 : 1
  }
  return (
    (n = r(l, -1)),
    (i = a[n] = o[n](l)),
    {
      c() {
        ;(e = D('div')), i.c(), g(e, 'class', 'wx-overlay x2-zjaxrx')
      },
      m(c, u) {
        S(c, e, u), a[n].m(e, null), (s = !0)
      },
      p(c, _ref47) {
        let [u] = _ref47
        let f = n
        ;(n = r(c, u)),
          n === f
            ? a[n].p(c, u)
            : (te(),
              y(a[f], 1, 1, () => {
                a[f] = null
              }),
              ne(),
              (i = a[n]),
              i ? i.p(c, u) : ((i = a[n] = o[n](c)), i.c()),
              k(i, 1),
              i.m(e, null))
      },
      i(c) {
        s || (k(i), (s = !0))
      },
      o(c) {
        y(i), (s = !1)
      },
      d(c) {
        c && v(e), a[n].d()
      },
    }
  )
}
function eh(l) {
  return typeof l == 'function'
}
function th(l, e, t) {
  let {overlay: n} = e
  function i(s) {
    De.call(this, l, s)
  }
  return (
    (l.$$set = (s) => {
      'overlay' in s && t(0, (n = s.overlay))
    }),
    [n, i]
  )
}
class nh extends ee {
  constructor(e) {
    super(), $(this, e, th, $d, x, {overlay: 0})
  }
}
function lh(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('input')),
        g(e, 'class', 'wx-text x2-1a713m7'),
        g(e, 'type', 'text'),
        (e.value = /*value*/ l[0])
    },
    m(i, s) {
      S(i, e, s),
        l[6](e),
        t ||
          ((n = [q(e, 'input', /*updateValue*/ l[2]), q(e, 'keydown', /*closeAndSave*/ l[3])]),
          (t = !0))
    },
    p(i, _ref48) {
      let [s] = _ref48
      s & /*value*/ 1 && e.value !== /*value*/ i[0] && (e.value = /*value*/ i[0])
    },
    i: I,
    o: I,
    d(i) {
      i && v(e), l[6](null), (t = !1), Ee(n)
    },
  }
}
function ih(l, e, t) {
  let {actions: n} = e,
    {editor: i} = e,
    s = ''
  const o = (f) => t(0, (s = f.value))
  let a
  ht(() => a.focus())
  function r() {
    t(0, (s = a.value)), n.updateValue(a.value)
  }
  function c(_ref49) {
    let {key: f} = _ref49
    f === 'Enter' && n.save()
  }
  function u(f) {
    be[f ? 'unshift' : 'push'](() => {
      ;(a = f), t(1, a)
    })
  }
  return (
    (l.$$set = (f) => {
      'actions' in f && t(4, (n = f.actions)), 'editor' in f && t(5, (i = f.editor))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*editor*/ 32 && o(i)
    }),
    [s, a, r, c, n, i, u]
  )
}
class sh extends ee {
  constructor(e) {
    super(), $(this, e, ih, lh, x, {actions: 4, editor: 5})
  }
}
const oh = (l) => ({option: l & /*option*/ 131072}),
  ji = (l) => ({option: /*option*/ l[17]})
function rh(l) {
  let e = /*option*/ l[17].name + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*option*/ 131072 && e !== (e = /*option*/ n[17].name + '') && me(t, e)
    },
    d(n) {
      n && v(t)
    },
  }
}
function ah(l) {
  let e = /*template*/ l[0](/*option*/ l[17]) + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*template, option*/ 131073 &&
        e !== (e = /*template*/ n[0](/*option*/ n[17]) + '') &&
        me(t, e)
    },
    d(n) {
      n && v(t)
    },
  }
}
function ch(l) {
  let e
  function t(s, o) {
    return /*template*/ s[0] ? ah : rh
  }
  let n = t(l),
    i = n(l)
  return {
    c() {
      i.c(), (e = se())
    },
    m(s, o) {
      i.m(s, o), S(s, e, o)
    },
    p(s, o) {
      n === (n = t(s)) && i ? i.p(s, o) : (i.d(1), (i = n(s)), i && (i.c(), i.m(e.parentNode, e)))
    },
    d(s) {
      s && v(e), i.d(s)
    },
  }
}
function uh(l) {
  let e
  const t = /*#slots*/ l[11].default,
    n = Ie(t, l, /*$$scope*/ l[15], ji),
    i = n || ch(l)
  return {
    c() {
      i && i.c()
    },
    m(s, o) {
      i && i.m(s, o), (e = !0)
    },
    p(s, o) {
      n
        ? n.p &&
          (!e || o & /*$$scope, option*/ 163840) &&
          Oe(
            n,
            t,
            s,
            /*$$scope*/ s[15],
            e ? Re(t, /*$$scope*/ s[15], o, oh) : Ae(/*$$scope*/ s[15]),
            ji
          )
        : i && i.p && (!e || o & /*template, option*/ 131073) && i.p(s, e ? o : -1)
    },
    i(s) {
      e || (k(i, s), (e = !0))
    },
    o(s) {
      y(i, s), (e = !1)
    },
    d(s) {
      i && i.d(s)
    },
  }
}
function fh(l) {
  let e, t, n, i, s, o
  return (
    (n = new fl({
      props: {
        items: /*filterOptions*/ l[2],
        $$slots: {
          default: [
            uh,
            (_ref50) => {
              let {option: a} = _ref50
              return {17: a}
            },
            (_ref51) => {
              let {option: a} = _ref51
              return a ? 131072 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    n.$on('ready', /*ready*/ l[6]),
    n.$on('select', /*updateValue*/ l[5]),
    {
      c() {
        ;(e = D('input')), (t = Y()), F(n.$$.fragment), g(e, 'class', 'wx-input x2-1s4pc76')
      },
      m(a, r) {
        S(a, e, r),
          l[12](e),
          Ue(e, /*text*/ l[1]),
          S(a, t, r),
          R(n, a, r),
          (i = !0),
          s ||
            ((o = [
              q(e, 'input', /*input_1_input_handler*/ l[13]),
              q(e, 'input', /*input*/ l[7]),
              q(e, 'keydown', /*keydown_handler*/ l[14]),
            ]),
            (s = !0))
      },
      p(a, _ref52) {
        let [r] = _ref52
        r & /*text*/ 2 && e.value !== /*text*/ a[1] && Ue(e, /*text*/ a[1])
        const c = {}
        r & /*filterOptions*/ 4 && (c.items = /*filterOptions*/ a[2]),
          r & /*$$scope, template, option*/ 163841 && (c.$$scope = {dirty: r, ctx: a}),
          n.$set(c)
      },
      i(a) {
        i || (k(n.$$.fragment, a), (i = !0))
      },
      o(a) {
        y(n.$$.fragment, a), (i = !1)
      },
      d(a) {
        a && (v(e), v(t)), l[12](null), O(n, a), (s = !1), Ee(o)
      },
    }
  )
}
function dh(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {actions: s} = e,
    {editor: o} = e,
    a
  o.config && o.config.template && (a = o.config.template)
  let r = o.renderedValue,
    c = o.options
  function u(_ref53) {
    let {detail: T} = _ref53
    const W = T.id
    s.updateValue(W), s.save()
  }
  let f, d
  function h(T) {
    ;(f = T.detail.navigate), t(3, (d = T.detail.keydown)), f(w())
  }
  function m() {
    t(
      2,
      (c = r ? o.options.filter((T) => T.name.toLowerCase().includes(r.toLowerCase())) : o.options)
    ),
      c.length ? f(-1 / 0) : f(null)
  }
  let _
  ht(() => {
    _.focus()
  })
  const w = () => c.findIndex((T) => T.id === o.value)
  function b(T) {
    be[T ? 'unshift' : 'push'](() => {
      ;(_ = T), t(4, _)
    })
  }
  function p() {
    ;(r = this.value), t(1, r)
  }
  const z = (T) => d(T, w())
  return (
    (l.$$set = (T) => {
      'actions' in T && t(9, (s = T.actions)),
        'editor' in T && t(10, (o = T.editor)),
        '$$scope' in T && t(15, (i = T.$$scope))
    }),
    [a, r, c, d, _, u, h, m, w, s, o, n, b, p, z, i]
  )
}
class hh extends ee {
  constructor(e) {
    super(), $(this, e, dh, fh, x, {actions: 9, editor: 10})
  }
}
function mh(l) {
  let e,
    t = /*editor*/ l[1].renderedValue + '',
    n
  return {
    c() {
      ;(e = D('span')), (n = re(t)), g(e, 'class', 'wx-text x2-1eq9nh5')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*editor*/ 2 && t !== (t = /*editor*/ i[1].renderedValue + '') && me(n, t)
    },
    i: I,
    o: I,
    d(i) {
      i && v(e)
    },
  }
}
function _h(l) {
  let e, t, n
  var i = /*cell*/ l[4]
  function s(o, a) {
    return {props: {data: /*value*/ o[2]}}
  }
  return (
    i && ((e = Le(i, s(l))), e.$on('action', /*action_handler*/ l[6])),
    {
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a & /*cell*/ 16 && i !== (i = /*cell*/ o[4])) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s(o))),
              e.$on('action', /*action_handler*/ o[6]),
              F(e.$$.fragment),
              k(e.$$.fragment, 1),
              R(e, t.parentNode, t))
            : (e = null)
        } else if (i) {
          const r = {}
          a & /*value*/ 4 && (r.data = /*value*/ o[2]), e.$set(r)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function gh(l) {
  let e = /*template*/ l[3](/*value*/ l[2]) + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*template, value*/ 12 && e !== (e = /*template*/ n[3](/*value*/ n[2]) + '') && me(t, e)
    },
    i: I,
    o: I,
    d(n) {
      n && v(t)
    },
  }
}
function wh(l) {
  let e, t, n
  function i(o) {
    l[7](o)
  }
  let s = {}
  return (
    /*value*/ l[2] !== void 0 && (s.value = /*value*/ l[2]),
    (e = new bo({props: s})),
    be.push(() => rt(e, 'value', i)),
    e.$on('change', /*updateValue*/ l[5]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(o, a) {
        R(e, o, a), (n = !0)
      },
      p(o, a) {
        const r = {}
        !t && a & /*value*/ 4 && ((t = !0), (r.value = /*value*/ o[2]), dt(() => (t = !1))),
          e.$set(r)
      },
      i(o) {
        n || (k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        O(e, o)
      },
    }
  )
}
function bh(l) {
  let e, t, n, i, s, o, a, r
  const c = [gh, _h, mh],
    u = []
  function f(d, h) {
    return /*template*/ d[3] ? 0 : /*cell*/ d[4] ? 1 : 2
  }
  return (
    (t = f(l)),
    (n = u[t] = c[t](l)),
    (s = new pn({props: {width: 'auto', $$slots: {default: [wh]}, $$scope: {ctx: l}}})),
    {
      c() {
        ;(e = D('div')), n.c(), (i = Y()), F(s.$$.fragment), g(e, 'class', 'wx-value x2-1eq9nh5')
      },
      m(d, h) {
        S(d, e, h),
          u[t].m(e, null),
          S(d, i, h),
          R(s, d, h),
          (o = !0),
          a ||
            ((r = q(e, 'click', function () {
              ot(/*actions*/ l[0].cancel()) && l[0].cancel().apply(this, arguments)
            })),
            (a = !0))
      },
      p(d, _ref54) {
        let [h] = _ref54
        l = d
        let m = t
        ;(t = f(l)),
          t === m
            ? u[t].p(l, h)
            : (te(),
              y(u[m], 1, 1, () => {
                u[m] = null
              }),
              ne(),
              (n = u[t]),
              n ? n.p(l, h) : ((n = u[t] = c[t](l)), n.c()),
              k(n, 1),
              n.m(e, null))
        const _ = {}
        h & /*$$scope, value*/ 260 && (_.$$scope = {dirty: h, ctx: l}), s.$set(_)
      },
      i(d) {
        o || (k(n), k(s.$$.fragment, d), (o = !0))
      },
      o(d) {
        y(n), y(s.$$.fragment, d), (o = !1)
      },
      d(d) {
        d && (v(e), v(i)), u[t].d(), O(s, d), (a = !1), r()
      },
    }
  )
}
function kh(l, e, t) {
  let {actions: n} = e,
    {editor: i} = e,
    s = i.value || /* @__PURE__ */ new Date(),
    o,
    a
  function r(_ref55) {
    let {detail: f} = _ref55
    const d = f.value
    n.updateValue(d), n.save()
  }
  ht(() => {
    window.getSelection && window.getSelection().removeAllRanges()
  })
  function c(f) {
    De.call(this, l, f)
  }
  function u(f) {
    ;(s = f), t(2, s)
  }
  return (
    (l.$$set = (f) => {
      'actions' in f && t(0, (n = f.actions)), 'editor' in f && t(1, (i = f.editor))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*editor*/ 2 &&
        i.config &&
        t(3, ({template: o, cell: a} = i.config), o, (t(4, a), t(1, i)))
    }),
    [n, i, s, o, a, r, c, u]
  )
}
class ph extends ee {
  constructor(e) {
    super(), $(this, e, kh, bh, x, {actions: 0, editor: 1})
  }
}
const yh = (l) => ({option: l & /*option*/ 131072}),
  Zi = (l) => ({option: /*option*/ l[17]})
function vh(l) {
  let e,
    t = /*editor*/ l[1].renderedValue + '',
    n
  return {
    c() {
      ;(e = D('span')), (n = re(t)), g(e, 'class', 'wx-text x2-z4gexz')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*editor*/ 2 && t !== (t = /*editor*/ i[1].renderedValue + '') && me(n, t)
    },
    i: I,
    o: I,
    d(i) {
      i && v(e)
    },
  }
}
function Sh(l) {
  let e, t, n
  var i = /*cell*/ l[3]
  function s(o, a) {
    return {props: {data: /*data*/ o[6]}}
  }
  return (
    i && ((e = Le(i, s(l))), e.$on('action', /*action_handler*/ l[11])),
    {
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a & /*cell*/ 8 && i !== (i = /*cell*/ o[3])) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s(o))),
              e.$on('action', /*action_handler*/ o[11]),
              F(e.$$.fragment),
              k(e.$$.fragment, 1),
              R(e, t.parentNode, t))
            : (e = null)
        } else if (i) {
          const r = {}
          a & /*data*/ 64 && (r.data = /*data*/ o[6]), e.$set(r)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function Mh(l) {
  let e = /*template*/ l[2](/*data*/ l[6]) + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*template, data*/ 68 && e !== (e = /*template*/ n[2](/*data*/ n[6]) + '') && me(t, e)
    },
    i: I,
    o: I,
    d(n) {
      n && v(t)
    },
  }
}
function Th(l) {
  let e = /*option*/ l[17].name + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*option*/ 131072 && e !== (e = /*option*/ n[17].name + '') && me(t, e)
    },
    i: I,
    o: I,
    d(n) {
      n && v(t)
    },
  }
}
function Ch(l) {
  let e, t, n
  var i = /*cell*/ l[3]
  function s(o, a) {
    return {props: {data: /*option*/ o[17]}}
  }
  return (
    i && ((e = Le(i, s(l))), e.$on('action', /*action_handler_1*/ l[14])),
    {
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a & /*cell*/ 8 && i !== (i = /*cell*/ o[3])) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s(o))),
              e.$on('action', /*action_handler_1*/ o[14]),
              F(e.$$.fragment),
              k(e.$$.fragment, 1),
              R(e, t.parentNode, t))
            : (e = null)
        } else if (i) {
          const r = {}
          a & /*option*/ 131072 && (r.data = /*option*/ o[17]), e.$set(r)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function Dh(l) {
  let e = /*template*/ l[2](/*option*/ l[17]) + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*template, option*/ 131076 &&
        e !== (e = /*template*/ n[2](/*option*/ n[17]) + '') &&
        me(t, e)
    },
    i: I,
    o: I,
    d(n) {
      n && v(t)
    },
  }
}
function Wh(l) {
  let e, t, n, i
  const s = [Dh, Ch, Th],
    o = []
  function a(r, c) {
    return /*template*/ r[2] ? 0 : /*cell*/ r[3] ? 1 : 2
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        let u = e
        ;(e = a(r)),
          e === u
            ? o[e].p(r, c)
            : (te(),
              y(o[u], 1, 1, () => {
                o[u] = null
              }),
              ne(),
              (t = o[e]),
              t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
              k(t, 1),
              t.m(n.parentNode, n))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function Hh(l) {
  let e
  const t = /*#slots*/ l[10].default,
    n = Ie(t, l, /*$$scope*/ l[15], Zi),
    i = n || Wh(l)
  return {
    c() {
      i && i.c()
    },
    m(s, o) {
      i && i.m(s, o), (e = !0)
    },
    p(s, o) {
      n
        ? n.p &&
          (!e || o & /*$$scope, option*/ 163840) &&
          Oe(
            n,
            t,
            s,
            /*$$scope*/ s[15],
            e ? Re(t, /*$$scope*/ s[15], o, yh) : Ae(/*$$scope*/ s[15]),
            Zi
          )
        : i && i.p && (!e || o & /*template, option, cell*/ 131084) && i.p(s, e ? o : -1)
    },
    i(s) {
      e || (k(i, s), (e = !0))
    },
    o(s) {
      y(i, s), (e = !1)
    },
    d(s) {
      i && i.d(s)
    },
  }
}
function zh(l) {
  let e, t, n, i, s, o, a, r
  const c = [Mh, Sh, vh],
    u = []
  function f(d, h) {
    return /*template*/ d[2] ? 0 : /*cell*/ d[3] ? 1 : 2
  }
  return (
    (t = f(l)),
    (n = u[t] = c[t](l)),
    (s = new fl({
      props: {
        items: /*editor*/ l[1].options,
        $$slots: {
          default: [
            Hh,
            (_ref56) => {
              let {option: d} = _ref56
              return {17: d}
            },
            (_ref57) => {
              let {option: d} = _ref57
              return d ? 131072 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    s.$on('ready', /*ready*/ l[8]),
    s.$on('select', /*updateValue*/ l[7]),
    {
      c() {
        ;(e = D('div')),
          n.c(),
          (i = Y()),
          F(s.$$.fragment),
          g(e, 'class', 'wx-value x2-z4gexz'),
          g(e, 'tabindex', '0')
      },
      m(d, h) {
        S(d, e, h),
          u[t].m(e, null),
          l[12](e),
          S(d, i, h),
          R(s, d, h),
          (o = !0),
          a ||
            ((r = [
              q(e, 'click', function () {
                ot(/*actions*/ l[0].cancel()) && l[0].cancel().apply(this, arguments)
              }),
              q(e, 'keydown', /*keydown_handler*/ l[13]),
            ]),
            (a = !0))
      },
      p(d, _ref58) {
        let [h] = _ref58
        l = d
        let m = t
        ;(t = f(l)),
          t === m
            ? u[t].p(l, h)
            : (te(),
              y(u[m], 1, 1, () => {
                u[m] = null
              }),
              ne(),
              (n = u[t]),
              n ? n.p(l, h) : ((n = u[t] = c[t](l)), n.c()),
              k(n, 1),
              n.m(e, null))
        const _ = {}
        h & /*editor*/ 2 && (_.items = /*editor*/ l[1].options),
          h & /*$$scope, template, option, cell*/ 163852 && (_.$$scope = {dirty: h, ctx: l}),
          s.$set(_)
      },
      i(d) {
        o || (k(n), k(s.$$.fragment, d), (o = !0))
      },
      o(d) {
        y(n), y(s.$$.fragment, d), (o = !1)
      },
      d(d) {
        d && (v(e), v(i)), u[t].d(), l[12](null), O(s, d), (a = !1), Ee(r)
      },
    }
  )
}
function Nh(l, e, t) {
  let n,
    {$$slots: i = {}, $$scope: s} = e,
    {actions: o} = e,
    {editor: a} = e,
    r,
    c
  function u(_ref59) {
    let {detail: T} = _ref59
    const W = T.id
    o.updateValue(W), o.save()
  }
  let f, d
  function h(T) {
    ;(f = T.detail.navigate), t(4, (d = T.detail.keydown)), f(m())
  }
  const m = () => a.options.findIndex((T) => T.id === a.value)
  let _
  ht(() => {
    _.focus(), window && window.getSelection && window.getSelection().removeAllRanges()
  })
  function w(T) {
    De.call(this, l, T)
  }
  function b(T) {
    be[T ? 'unshift' : 'push'](() => {
      ;(_ = T), t(5, _)
    })
  }
  const p = (T) => d(T, m())
  function z(T) {
    De.call(this, l, T)
  }
  return (
    (l.$$set = (T) => {
      'actions' in T && t(0, (o = T.actions)),
        'editor' in T && t(1, (a = T.editor)),
        '$$scope' in T && t(15, (s = T.$$scope))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*editor*/ 2 && t(6, (n = a.options.find((T) => T.id === a.value))),
        l.$$.dirty & /*editor*/ 2 &&
          a.config &&
          t(2, ({template: r, cell: c} = a.config), r, (t(3, c), t(1, a)))
    }),
    [o, a, r, c, d, _, n, u, h, m, i, w, b, p, z, s]
  )
}
class Lh extends ee {
  constructor(e) {
    super(), $(this, e, Nh, zh, x, {actions: 0, editor: 1})
  }
}
const qi = {text: sh, combo: hh, datepicker: ph, richselect: Lh}
function Eh(l) {
  let e, t, n, i, s
  var o = qi[/*col*/ l[0].editor.type]
  function a(r, c) {
    return {
      props: {
        editor: /*editor*/ r[1],
        actions: {save: /*save*/ r[3], cancel: /*cancel*/ r[4], updateValue: /*updateValue*/ r[5]},
      },
    }
  }
  return (
    o && ((t = Le(o, a(l))), t.$on('action', /*action_handler*/ l[6])),
    {
      c() {
        ;(e = D('div')),
          t && F(t.$$.fragment),
          g(e, 'class', 'wx-cell x2-1hzozeb'),
          g(e, 'style', /*style*/ l[2]),
          Q(e, 'wx-shadow', /*col*/ l[0].fixed === -1)
      },
      m(r, c) {
        S(r, e, c),
          t && R(t, e, null),
          (n = !0),
          i || ((s = nt(Rn.call(null, e, /*save*/ l[3]))), (i = !0))
      },
      p(r, _ref60) {
        let [c] = _ref60
        if (c & /*col*/ 1 && o !== (o = qi[/*col*/ r[0].editor.type])) {
          if (t) {
            te()
            const u = t
            y(u.$$.fragment, 1, 0, () => {
              O(u, 1)
            }),
              ne()
          }
          o
            ? ((t = Le(o, a(r))),
              t.$on('action', /*action_handler*/ r[6]),
              F(t.$$.fragment),
              k(t.$$.fragment, 1),
              R(t, e, null))
            : (t = null)
        } else if (o) {
          const u = {}
          c & /*editor*/ 2 && (u.editor = /*editor*/ r[1]), t.$set(u)
        }
        ;(!n || c & /*style*/ 4) && g(e, 'style', /*style*/ r[2]),
          (!n || c & /*col*/ 1) && Q(e, 'wx-shadow', /*col*/ r[0].fixed === -1)
      },
      i(r) {
        n || (t && k(t.$$.fragment, r), (n = !0))
      },
      o(r) {
        t && y(t.$$.fragment, r), (n = !1)
      },
      d(r) {
        r && v(e), t && O(t), (i = !1), s()
      },
    }
  )
}
function Ih(l, e, t) {
  let {col: n} = e,
    {editor: i} = e
  const s = He()
  function o() {
    s('action', {action: 'close-editor', data: {ignore: !1}})
  }
  function a() {
    s('action', {action: 'close-editor', data: {ignore: !0}})
  }
  function r(f) {
    s('action', {action: 'editor', data: {value: f}})
  }
  let c
  function u(f) {
    De.call(this, l, f)
  }
  return (
    (l.$$set = (f) => {
      'col' in f && t(0, (n = f.col)), 'editor' in f && t(1, (i = f.editor))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*col*/ 1 && t(2, (c = Pn(n.width, n.flexgrow, n.fixed, n.left)))
    }),
    [n, i, c, o, a, r, u]
  )
}
class Rh extends ee {
  constructor(e) {
    super(), $(this, e, Ih, Eh, x, {col: 0, editor: 1})
  }
}
// Virtual rendering calculator
/* Calculates virtual rendering bounds:
 * - Determines visible row range
 * - Manages render buffer
 * - Optimizes DOM updates
 */
function Ki(l, e, t) {
  const n = l.slice()
  return (n[89] = e[t]), n
}
function Gi(l, e, t) {
  const n = l.slice()
  return (n[92] = e[t]), n
}
function Xi(l) {
  let e, t, n
  return (
    (t = new ir({
      props: {
        contentWidth: /*contentWidth*/ l[11],
        deltaLeft: /*deltaLeftH*/ l[23],
        rowHeights: /*$_sizes*/ l[18].headerRowHeights,
        columns: /*renderColumnsH*/ l[21],
        columnStyle: /*columnStyle*/ l[5],
      },
    })),
    t.$on('action', /*action_handler*/ l[69]),
    {
      c() {
        ;(e = D('div')), F(t.$$.fragment), g(e, 'class', 'wx-header-wrapper x2-1rhm7gj')
      },
      m(i, s) {
        S(i, e, s), R(t, e, null), (n = !0)
      },
      p(i, s) {
        const o = {}
        s[0] & /*contentWidth*/ 2048 && (o.contentWidth = /*contentWidth*/ i[11]),
          s[0] & /*deltaLeftH*/ 8388608 && (o.deltaLeft = /*deltaLeftH*/ i[23]),
          s[0] & /*$_sizes*/ 262144 && (o.rowHeights = /*$_sizes*/ i[18].headerRowHeights),
          s[0] & /*renderColumnsH*/ 2097152 && (o.columns = /*renderColumnsH*/ i[21]),
          s[0] & /*columnStyle*/ 32 && (o.columnStyle = /*columnStyle*/ i[5]),
          t.$set(o)
      },
      i(i) {
        n || (k(t.$$.fragment, i), (n = !0))
      },
      o(i) {
        y(t.$$.fragment, i), (n = !1)
      },
      d(i) {
        i && v(e), O(t)
      },
    }
  )
}
// Grid overlay manager
/* Manages grid overlays:
 * - Handles loading states
 * - Manages editor overlays
 * - Controls modal dialogs
 */
function Vi(l) {
  let e, t
  return (
    (e = new nh({props: {overlay: /*overlay*/ l[3]}})),
    e.$on('action', /*action_handler_1*/ l[70]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i[0] & /*overlay*/ 8 && (s.overlay = /*overlay*/ n[3]), e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Oh(l) {
  let e, t
  return (
    (e = new vl({
      props: {
        row: /*row*/ l[89],
        col: /*col*/ l[92],
        columnStyle: /*columnStyle*/ l[5],
        cellStyle: /*cellStyle*/ l[6],
      },
    })),
    e.$on('action', /*action_handler_4*/ l[73]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i[0] & /*renderRows*/ 524288 && (s.row = /*row*/ n[89]),
          i[0] & /*renderColumns*/ 1048576 && (s.col = /*col*/ n[92]),
          i[0] & /*columnStyle*/ 32 && (s.columnStyle = /*columnStyle*/ n[5]),
          i[0] & /*cellStyle*/ 64 && (s.cellStyle = /*cellStyle*/ n[6]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
// Grid cell rendering function Ah:
// Handles individual cell rendering with:
// - Custom cell templates
// - Cell styling
// - Cell events
// Renders individual grid cells with:
// - Cell content/template
// - Event handlers
// - Dynamic styling
/* Handles cell rendering with:
 * - Initializes cell components based on column configuration
 * - Manages cell props including api, row, column data
 * - Handles cell component lifecycle (mount/unmount)
 * - Manages cell action events and bubbling
 * - Optimizes cell re-renders through dirty checking
 * - Tree column
 */
function Ah(l) {
  let e, t, n
  // Get the cell template component from column definition
  var i = /*col*/ l[92].cell

  // Setup props for the cell template
  function s(o, a) {
    return {
      props: {
        api: /*api*/ o[0],
        row: /*row*/ o[89],
        col: /*col*/ o[92],
        columnStyle: /*columnStyle*/ o[5],
        cellStyle: /*cellStyle*/ o[6],
      },
    }
  }

  // Render the cell template if defined
  return (
    i && ((e = Le(i, s(l))), e.$on('action', /*action_handler_3*/ l[72])),
    {
      // Component lifecycle methods
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a[0] & /*renderColumns*/ 1048576 && i !== (i = /*col*/ o[92].cell)) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s(o))),
              e.$on('action', /*action_handler_3*/ o[72]),
              F(e.$$.fragment),
              k(e.$$.fragment, 1),
              R(e, t.parentNode, t))
            : (e = null)
        } else if (i) {
          const r = {}
          a[0] & /*api*/ 1 && (r.api = /*api*/ o[0]),
            a[0] & /*renderRows*/ 524288 && (r.row = /*row*/ o[89]),
            a[0] & /*renderColumns*/ 1048576 && (r.col = /*col*/ o[92]),
            a[0] & /*columnStyle*/ 32 && (r.columnStyle = /*columnStyle*/ o[5]),
            a[0] & /*cellStyle*/ 64 && (r.cellStyle = /*cellStyle*/ o[6]),
            e.$set(r)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function Fh(l) {
  let e, t
  return (
    (e = new Rh({props: {editor: /*$editor*/ l[16], col: /*col*/ l[92]}})),
    e.$on('action', /*action_handler_2*/ l[71]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i[0] & /*$editor*/ 65536 && (s.editor = /*$editor*/ n[16]),
          i[0] & /*renderColumns*/ 1048576 && (s.col = /*col*/ n[92]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Ph(l) {
  let e
  return {
    c() {
      ;(e = D('div')), g(e, 'class', 'wx-cell wx-collapsed x2-1rhm7gj')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    i: I,
    o: I,
    d(t) {
      t && v(e)
    },
  }
}
function Ui(l, e) {
  let t, n, i, s, o
  const a = [Ph, Fh, Ah, Oh],
    r = []
  function c(u, f) {
    return /*col*/ u[92].collapsed
      ? 0
      : /*$editor*/ u[16]?.id === /*row*/ u[89].id && /*$editor*/ u[16].column == /*col*/ u[92].id
      ? 1
      : /*col*/ u[92].cell
      ? 2
      : 3
  }
  // drag icon
  function modifyCellContent(content) {
    if (!e[89].$header && e[92].id === e[20][0].id && !content.querySelector('.wx-drag-handle')) {
      const dragHandle = D('span')
      const dragIcon = re('⠿')
      H(dragHandle, dragIcon)
      g(dragHandle, 'class', 'wx-drag-handle')
      g(
        dragHandle,
        'style',
        'cursor: grab; margin-right: 8px; color: #999; user-select: none; display: inline-flex; align-items: center;'
      )

      // Insert drag handle at the beginning of wx-content
      content.insertBefore(dragHandle, content.firstChild)
    }
  }

  return (
    (n = c(e)),
    (i = r[n] = a[n](e)),
    {
      key: l,
      first: null,
      c() {
        t = D('div')
        i.c()
        g(t, 'class', 'wx-cell-wrapper x2-1rhm7gj')
        this.first = t
      },
      m(u, f) {
        S(u, t, f)
        i.m(t, null)

        // Find the wx-content element and modify it
        const contentEl = t.querySelector('.wx-content')
        if (contentEl) {
          modifyCellContent(contentEl)
        }

        o = !0
      },
      p(u, f) {
        let d = n
        ;(n = c(u)),
          n === d
            ? r[n].p(u, f)
            : (te(),
              y(r[d], 1, 1, () => {
                r[d] = null
              }),
              ne(),
              (i = r[n]),
              i ? i.p(u, f) : ((i = r[n] = a[n](u)), i.c()),
              k(i, 1),
              i.m(t, null))

        // Update content after any changes
        const contentEl = t.querySelector('.wx-content')
        if (contentEl && !contentEl.querySelector('.wx-drag-handle')) {
          modifyCellContent(contentEl)
        }
      },
      i(u) {
        o || (k(i), (o = !0))
      },
      o(u) {
        y(i), (o = !1)
      },
      d(u) {
        u && v(t), r[n].d()
      },
    }
  )
}
// Row renderer
/* Handles individual row rendering:
 * - Manages row templates
 * - Handles row events
 * - Controls row styling
 * - Manages row lifecycle
 */
function Ji(l, e) {
  let t,
    n = [],
    i = /* @__PURE__ */ new Map(),
    s,
    o,
    a,
    r,
    c,
    u,
    f = de(/*renderColumns*/ e[20])
  const d = (h) => /*col*/ h[92].id
  for (let h = 0; h < f.length; h += 1) {
    let m = Gi(e, f, h),
      _ = d(m)
    i.set(_, (n[h] = Ui(_, m)))
  }
  return {
    key: l,
    first: null,
    c() {
      t = D('div')
      for (let h = 0; h < n.length; h += 1) n[h].c()
      ;(s = Y()),
        g(
          t,
          'class',
          (o =
            Ve('wx-row' + /*rowStyle*/ (e[4] ? ' ' + /*rowStyle*/ e[4](/*row*/ e[89]) : '')) +
            ' x2-1rhm7gj')
        ),
        g(t, 'data-id', (a = /*row*/ e[89].id)),
        g(t, 'data-context-id', (r = /*row*/ e[89].id)),
        g(
          t,
          'style',
          (c = `${/*autoRowHeight*/ e[7] ? 'min-height' : 'height'}:${
            /*defaultRowHeight*/ e[15]
          }px;`)
        ),
        Q(t, 'wx-autoheight', /*autoRowHeight*/ e[7]),
        Q(t, 'wx-selected', /*$selectedRows*/ e[29].indexOf(/*row*/ e[89].id) !== -1),
        (this.first = t)
    },
    m(h, m) {
      S(h, t, m)
      for (let _ = 0; _ < n.length; _ += 1) n[_] && n[_].m(t, null)
      H(t, s), (u = !0)
    },
    p(h, m) {
      ;(e = h),
        m[0] & /*renderColumns, $editor, renderRows, api, columnStyle, cellStyle*/ 1638497 &&
          ((f = de(/*renderColumns*/ e[20])),
          te(),
          (n = kt(n, m, d, 1, e, f, i, t, en, Ui, s, Gi)),
          ne()),
        (!u ||
          (m[0] & /*rowStyle, renderRows*/ 524304 &&
            o !==
              (o =
                Ve('wx-row' + /*rowStyle*/ (e[4] ? ' ' + /*rowStyle*/ e[4](/*row*/ e[89]) : '')) +
                ' x2-1rhm7gj'))) &&
          g(t, 'class', o),
        (!u || (m[0] & /*renderRows*/ 524288 && a !== (a = /*row*/ e[89].id))) &&
          g(t, 'data-id', a),
        (!u || (m[0] & /*renderRows*/ 524288 && r !== (r = /*row*/ e[89].id))) &&
          g(t, 'data-context-id', r),
        (!u ||
          (m[0] & /*autoRowHeight, defaultRowHeight*/ 32896 &&
            c !==
              (c = `${/*autoRowHeight*/ e[7] ? 'min-height' : 'height'}:${
                /*defaultRowHeight*/ e[15]
              }px;`))) &&
          g(t, 'style', c),
        (!u || m[0] & /*rowStyle, renderRows, autoRowHeight*/ 524432) &&
          Q(t, 'wx-autoheight', /*autoRowHeight*/ e[7]),
        (!u || m[0] & /*rowStyle, renderRows, $selectedRows, renderRows*/ 537395216) &&
          Q(t, 'wx-selected', /*$selectedRows*/ e[29].indexOf(/*row*/ e[89].id) !== -1)
    },
    i(h) {
      if (!u) {
        for (let m = 0; m < f.length; m += 1) k(n[m])
        u = !0
      }
    },
    o(h) {
      for (let m = 0; m < n.length; m += 1) y(n[m])
      u = !1
    },
    d(h) {
      h && v(t)
      for (let m = 0; m < n.length; m += 1) n[m].d()
    },
  }
}
// Footer renderer
/* Renders grid footer:
 * - Manages footer columns
 * - Handles footer styling
 * - Controls footer events
 */
function Qi(l) {
  let e, t
  return (
    (e = new ir({
      props: {
        type: 'footer',
        contentWidth: /*contentWidth*/ l[11],
        deltaLeft: /*deltaLeftF*/ l[24],
        rowHeights: /*$_sizes*/ l[18].footerRowHeights,
        columns: /*renderColumnsF*/ l[22],
        columnStyle: /*columnStyle*/ l[5],
      },
    })),
    e.$on('action', /*action_handler_5*/ l[76]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i[0] & /*contentWidth*/ 2048 && (s.contentWidth = /*contentWidth*/ n[11]),
          i[0] & /*deltaLeftF*/ 16777216 && (s.deltaLeft = /*deltaLeftF*/ n[24]),
          i[0] & /*$_sizes*/ 262144 && (s.rowHeights = /*$_sizes*/ n[18].footerRowHeights),
          i[0] & /*renderColumnsF*/ 4194304 && (s.columns = /*renderColumnsF*/ n[22]),
          i[0] & /*columnStyle*/ 32 && (s.columnStyle = /*columnStyle*/ n[5]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}

// Main grid rendering function Yh handles:
// - Header rendering
// - Body rendering with virtualization
// - Footer rendering
// - Scroll handling
// - Selection management
// Renders the main grid structure with:
// - Header section (if enabled)
// - Scrollable body section
// - Footer section (if enabled)
// - Handles dynamic row/column sizing
// - Manages scroll virtualization
/* Main grid structure renderer:
 * - Manages virtual DOM structure for grid
 * - Handles header/body/footer sections
 * - Implements row virtualization
 * - Manages overlay layers (loading, editor)
 * - Handles row map maintenance
 * - Controls grid resize behavior
 * - Manages scroll containers and sync
 */
function Yh(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r = [],
    c = /* @__PURE__ */ new Map(),
    u,
    f,
    d,
    h,
    m,
    _,
    w,
    b = /*header*/ l[1] && Xi(l),
    p = /*overlay*/ l[3] && Vi(l),
    z = de(/*renderRows*/ l[19])
  const T = (M) => /*row*/ M[89].id
  for (let M = 0; M < z.length; M += 1) {
    let C = Ki(l, z, M),
      P = T(C)
    c.set(P, (r[M] = Ji(P, C)))
  }
  let W = /*footer*/ l[2] && /*$data*/ l[17].length && Qi(l)
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        (n = D('div')),
        b && b.c(),
        (i = Y()),
        (s = D('div')),
        p && p.c(),
        (o = Y()),
        (a = D('div'))
      for (let M = 0; M < r.length; M += 1) r[M].c()
      ;(u = Y()),
        W && W.c(),
        g(a, 'class', 'wx-data x2-1rhm7gj'),
        j(a, 'padding-top', /*deltaTop*/ l[13] + 'px'),
        j(a, 'padding-left', /*deltaLeft*/ l[14] + 'px'),
        g(s, 'class', 'wx-body x2-1rhm7gj'),
        j(s, 'width', /*contentWidth*/ l[11] + 'px'),
        j(s, 'height', /*fullHeight*/ l[9] + 'px'),
        g(n, 'class', 'wx-scroll x2-1rhm7gj'),
        g(t, 'class', 'wx-table-box x2-1rhm7gj'),
        g(t, 'style', /*style*/ l[28]),
        g(t, 'tabindex', '0'),
        Q(t, 'wx-active', /*activeTable*/ l[27]),
        g(e, 'class', 'wx-grid x2-1rhm7gj'),
        j(e, '--header-height', /*header*/ (l[1] ? /*$_sizes*/ l[18].headerHeight : 0) + 'px'),
        j(e, '--footer-height', /*footer*/ (l[2] ? /*$_sizes*/ l[18].footerHeight : 0) + 'px'),
        j(e, '--split-left-width', /*leftWidth*/ l[10] + 'px')
    },
    m(M, C) {
      S(M, e, C),
        H(e, t),
        H(t, n),
        b && b.m(n, null),
        H(n, i),
        H(n, s),
        p && p.m(s, null),
        H(s, o),
        H(s, a)
      for (let P = 0; P < r.length; P += 1) r[P] && r[P].m(a, null)
      l[74](a),
        H(n, u),
        W && W.m(n, null),
        l[79](t),
        (m = !0),
        _ ||
          ((w = [
            q(s, 'mousedown', /*mousedown_handler*/ l[75]),
            nt(In.call(null, s, /*bodyClickHandlers*/ l[42])),
            q(n, 'scroll', /*onScroll*/ l[39]),
            nt(
              (f = zd.call(null, n, {
                scroll: /*scroll*/ l[38],
                getWidth: /*scrollTo_function*/ l[77],
                getHeight: /*scrollTo_function_1*/ l[78],
              }))
            ),
            nt((d = Rn.call(null, t, /*clickOutside_function*/ l[80]))),
            q(t, 'click', /*click_handler*/ l[81]),
            nt(Nd.call(null, t, /*resize*/ l[40])),
            nt(
              (h = Hd.call(null, t, {
                keys: {tab: !0, 'shift+tab': !0, arrowup: !0, arrowdown: !0, escape: !0, f2: !0},
                exec: /*hotkeys_function*/ l[82],
              }))
            ),
          ]),
          (_ = !0))
    },
    p(M, C) {
      /*header*/ M[1]
        ? b
          ? (b.p(M, C), C[0] & /*header*/ 2 && k(b, 1))
          : ((b = Xi(M)), b.c(), k(b, 1), b.m(n, i))
        : b &&
          (te(),
          y(b, 1, 1, () => {
            b = null
          }),
          ne()),
        /*overlay*/ M[3]
          ? p
            ? (p.p(M, C), C[0] & /*overlay*/ 8 && k(p, 1))
            : ((p = Vi(M)), p.c(), k(p, 1), p.m(s, o))
          : p &&
            (te(),
            y(p, 1, 1, () => {
              p = null
            }),
            ne()),
        // Handles updates to rendered cells including templates
        C[0] &
          /*rowStyle, renderRows, autoRowHeight, defaultRowHeight, $selectedRows, renderColumns, $editor, api, columnStyle, cellStyle*/ 538542321 &&
          ((z = de(/*renderRows*/ M[19])),
          te(),
          (r = kt(r, C, T, 1, M, z, c, a, en, Ji, null, Ki)),
          ne()),
        (!m || C[0] & /*deltaTop*/ 8192) && j(a, 'padding-top', /*deltaTop*/ M[13] + 'px'),
        (!m || C[0] & /*deltaLeft*/ 16384) && j(a, 'padding-left', /*deltaLeft*/ M[14] + 'px'),
        (!m || C[0] & /*contentWidth*/ 2048) && j(s, 'width', /*contentWidth*/ M[11] + 'px'),
        (!m || C[0] & /*fullHeight*/ 512) && j(s, 'height', /*fullHeight*/ M[9] + 'px'),
        /*footer*/ M[2] && /*$data*/ M[17].length
          ? W
            ? (W.p(M, C), C[0] & /*footer, $data*/ 131076 && k(W, 1))
            : ((W = Qi(M)), W.c(), k(W, 1), W.m(n, null))
          : W &&
            (te(),
            y(W, 1, 1, () => {
              W = null
            }),
            ne()),
        f &&
          ot(f.update) &&
          C[0] & /*clientWidth, visibleRowsHeight*/ 4352 &&
          f.update.call(null, {
            scroll: /*scroll*/ M[38],
            getWidth: /*scrollTo_function*/ M[77],
            getHeight: /*scrollTo_function_1*/ M[78],
          }),
        (!m || C[0] & /*style*/ 268435456) && g(t, 'style', /*style*/ M[28]),
        d &&
          ot(d.update) &&
          C[0] & /*activeTable*/ 134217728 &&
          d.update.call(null, /*clickOutside_function*/ M[80]),
        h &&
          ot(h.update) &&
          C[0] & /*api*/ 1 &&
          h.update.call(null, {
            keys: {tab: !0, 'shift+tab': !0, arrowup: !0, arrowdown: !0, escape: !0, f2: !0},
            exec: /*hotkeys_function*/ M[82],
          }),
        (!m || C[0] & /*activeTable*/ 134217728) && Q(t, 'wx-active', /*activeTable*/ M[27]),
        (!m || C[0] & /*header, $_sizes*/ 262146) &&
          j(e, '--header-height', /*header*/ (M[1] ? /*$_sizes*/ M[18].headerHeight : 0) + 'px'),
        (!m || C[0] & /*footer, $_sizes*/ 262148) &&
          j(e, '--footer-height', /*footer*/ (M[2] ? /*$_sizes*/ M[18].footerHeight : 0) + 'px'),
        (!m || C[0] & /*leftWidth*/ 1024) && j(e, '--split-left-width', /*leftWidth*/ M[10] + 'px')
    },
    i(M) {
      if (!m) {
        k(b), k(p)
        for (let C = 0; C < z.length; C += 1) k(r[C])
        k(W), (m = !0)
      }
    },
    o(M) {
      y(b), y(p)
      for (let C = 0; C < r.length; C += 1) y(r[C])
      y(W), (m = !1)
    },
    d(M) {
      M && v(e), b && b.d(), p && p.d()
      for (let C = 0; C < r.length; C += 1) r[C].d()
      l[74](null), W && W.d(), l[79](null), (_ = !1), Ee(w)
    },
  }
}
const Mn = 2,
  Bh = 1
// Scroll width calculation utility
/* Calculates browser scrollbar width:
 * - Creates temporary scrollable div
 * - Measures offset vs client width
 * - Removes temporary element
 * - Returns scrollbar width for calculations
 */
function jh() {
  const l = document.createElement('div')
  ;(l.style.cssText =
    'position:absolute;left:-1000px;width:100px;padding:0px;margin:0px;min-height:100px;overflow-y:scroll;'),
    document.body.appendChild(l)
  const e = l.offsetWidth - l.clientWidth
  return document.body.removeChild(l), e
}
// Grid state management function Zh:
// Manages grid state including:
// - Selection
// - Scrolling
// - Sizing
// - Events
// Manages:
// - Row/column selection state
// - Scroll position tracking
// - Grid dimensions
// - Event handling
// - Keyboard navigation
/* Core grid state manager:
 * - Initializes reactive stores and subscriptions
 * - Manages scroll state and virtualization
 * - Handles selection models (single/multi)
 * - Controls focus management
 * - Manages column/row sizing
 * - Handles keyboard navigation
 * - Controls edit/filter states
 */
function Zh(l, e, t) {
  let n, i, s, o, a, r, c, u, f, d
  const h = He(),
    m = jh()
  let {store: _} = e,
    {api: w} = e,
    {header: b} = e,
    {footer: p} = e,
    {overlay: z} = e,
    {select: T} = e,
    {multiselect: W} = e,
    {rowStyle: M} = e,
    {columnStyle: C} = e,
    {cellStyle: P} = e,
    {autoRowHeight: X} = e
  const {
    dynamic: A,
    flatData: B,
    _columns: V,
    split: fe,
    _sizes: L,
    selectedRows: Ye,
    editor: G,
    filter: pe,
    scroll: Se,
  } = _.getReactive()
  ce(l, A, (N) => t(66, (r = N))),
    ce(l, B, (N) => t(17, (a = N))),
    ce(l, V, (N) => t(67, (u = N))),
    ce(l, fe, (N) => t(68, (f = N))),
    ce(l, L, (N) => t(18, (c = N))),
    ce(l, Ye, (N) => t(29, (d = N))),
    ce(l, G, (N) => t(16, (s = N))),
    ce(l, pe, (N) => t(65, (o = N)))
  let K = 0,
    ue = 0,
    Ne,
    ye = [],
    ve = [],
    Ze = 0,
    ie,
    U,
    ge,
    Me,
    Fe = !1,
    Je = !1,
    J,
    oe,
    we = {row: {start: 0, end: 0}},
    E = 0,
    le = [],
    _e = 0,
    ke = 0,
    Pe = [],
    Be = [],
    je = [],
    Xe = 0,
    it = 0,
    pt = 0,
    mt,
    nn,
    At,
    Wt,
    Ft = 0,
    Ht = 0
  function Z(N) {
    t(62, (Ht = N.target.scrollTop)), t(61, (Ft = N.target.scrollLeft))
  }
  function ae(N) {
    t(8, (K = N.width)), t(46, (ue = N.height))
  }
  function Te(N) {
    N.shiftKey && N.preventDefault(), Pt.focus()
  }
  // Function to handle row selection and click events
  /* Maps grid events to handlers:
   * - dblclick: Opens cell editor
   * - click: Handles row selection
   * - toggle-row: Expands/collapses rows
   * - ignore-click: Prevents event bubbling
   */
  const at = {
    // Handles double click on a cell - opens editor for the cell
    dblclick: (N, Ke) => {
      const Ge = {id: N, column: Or(Ke, 'data-col-id')}
      h('action', {action: 'open-editor', data: Ge})
    },
    // Handles single click on a row - manages row selection behavior
    click: (N, Ke) => {
      if (T === !1) return
      const Ge = W && Ke.ctrlKey,
        et = W && Ke.shiftKey
      h('action', {action: 'select-row', data: {id: N, toggle: Ge, range: et}})
    },
    // Toggles row expansion/collapse for hierarchical data
    'toggle-row': (N) => {
      const Ke = _.getRow(N)
      h('action', {action: Ke.open ? 'close-row' : 'open-row', data: {id: N}})
    },
    'ignore-click': () => !1,
  }
  // Function to calculate column spans and positioning
  /* Calculates column spans:
   * - Handles complex spanning scenarios
   * - Adjusts column widths for spans
   * - Manages column indexes
   * - Returns span positioning data
   */
  function ct(N, Ke, Ge) {
    let et = Ke,
      yt = N
    if (ve.length) {
      // Handles complex column spanning logic
      // Adjusts column widths and positions based on colspan values
      let gt = ve.length
      for (let tt = N; tt >= 0; tt--)
        ve[tt][Ge].forEach((sn) => {
          sn.colspan > 1 && tt > N - sn.colspan && tt < gt && (gt = tt)
        })
      if (gt !== ve.length && gt < N) {
        for (let tt = gt; tt < N; tt++) et -= ve[tt].width
        yt = gt
      }
    }
    return {index: yt, delta: et}
  }
  let _t,
    ut = [],
    zt = 0
  // Handles auto row height calculations when enabled
  /* Manages automatic row height:
   * - Measures actual content height
   * - Updates row height cache
   * - Triggers grid resize
   * - Maintains total height calculations
   */
  function dr() {
    let N = 0,
      Ke = _e
    _t.childNodes.forEach((Ge, et) => {
      t(63, (ut[_e + et] = Ge.offsetHeight), ut), (N += Ge.offsetHeight), Ke++
    }),
      t(64, (zt = N)),
      t(56, (ke = Ke))
  }
  X &&
    kn(() => {
      dr()
    })
  let Pt
  // Focus management
  /* Controls grid focus state:
   * - Manages focus element
   * - Handles focus transitions
   * - Updates focus indicators
   */
  const hr = (N) => {
    !N && Pt ? (Pt.focus(), t(27, (ln = !0))) : t(27, (ln = null))
  }
  let ln = null
  function mr(N) {
    De.call(this, l, N)
  }
  function _r(N) {
    De.call(this, l, N)
  }
  function gr(N) {
    De.call(this, l, N)
  }
  function wr(N) {
    De.call(this, l, N)
  }
  function br(N) {
    De.call(this, l, N)
  }
  function kr(N) {
    be[N ? 'unshift' : 'push'](() => {
      ;(_t = N), t(25, _t)
    })
  }
  const pr = (N) => Te(N)
  function yr(N) {
    De.call(this, l, N)
  }
  // Grid measurement functions
  /* These utility functions:
   * - Provide grid dimensions
   * - Support responsive behaviors
   * - Aid in scroll calculations
   */
  const vr = () => K, // Returns grid width
    Sr = () => oe // Returns grid scroll position
  function Mr(N) {
    be[N ? 'unshift' : 'push'](() => {
      ;(Pt = N), t(26, Pt)
    })
  }
  const Tr = () => t(27, (ln = null)),
    Cr = () => t(27, (ln = !0)),
    Dr = (N) => w.exec('hotkey', N)
  return (
    (l.$$set = (N) => {
      'store' in N && t(43, (_ = N.store)),
        'api' in N && t(0, (w = N.api)),
        'header' in N && t(1, (b = N.header)),
        'footer' in N && t(2, (p = N.footer)),
        'overlay' in N && t(3, (z = N.overlay)),
        'select' in N && t(44, (T = N.select)),
        'multiselect' in N && t(45, (W = N.multiselect)),
        'rowStyle' in N && t(4, (M = N.rowStyle)),
        'columnStyle' in N && t(5, (C = N.columnStyle)),
        'cellStyle' in N && t(6, (P = N.cellStyle)),
        'autoRowHeight' in N && t(7, (X = N.autoRowHeight))
    }),
    (l.$$.update = () => {
      if (
        (l.$$.dirty[0] & /*$_sizes*/ 262144 && t(15, (n = c.rowHeight)),
        (l.$$.dirty[1] & /*hasAny, fullWidth*/ 786432) | (l.$$.dirty[2] & /*$_columns*/ 32) &&
          (t(49, (ie = !1)),
          t(50, (U = 0)),
          u.forEach((N) => {
            N.hidden || (N.flexgrow && t(49, (ie = ie || N.flexgrow)), t(50, (U += N.width)))
          }),
          t(11, (Me = U))),
        (l.$$.dirty[0] & /*clientWidth*/ 256) |
          (l.$$.dirty[1] & /*clientHeight, fullWidth*/ 557056) &&
          t(53, (Je = K && ue ? U > K : !1)),
        (l.$$.dirty[0] & /*header, $_sizes, footer, visibleRowsHeight, defaultRowHeight*/ 299014) |
          (l.$$.dirty[1] & /*clientHeight, hasHScroll*/ 4227072) &&
          (t(12, (oe = ue - (b ? c.headerHeight : 0) - (p ? c.footerHeight : 0) - (Je ? m : 0))),
          t(54, (J = Math.ceil(oe / n) + 1))),
        (l.$$.dirty[0] & /*autoRowHeight, defaultRowHeight, deltaTop, $data*/ 172160) |
          (l.$$.dirty[1] & /*visibleRows, requestData*/ 25165824) |
          (l.$$.dirty[2] & /*scrollTop, rowHeights, $dynamic*/ 19))
      ) {
        let N = 0
        if (X) {
          let Ge = Ht
          for (; Ge > 0; ) (Ge -= ut[N] || n), N++
          t(13, (E = Ht - Ge))
          for (let et = Math.max(0, N - Mn - 1); et < N; et++) t(13, (E -= ut[N - et] || n))
          N = Math.max(0, N - Mn)
        } else (N = Math.floor(Ht / n)), (N = Math.max(0, N - Mn)), t(13, (E = N * n))
        const Ke = Math.min(r ? r.rowsCount : a.length, N + J + Mn)
        ;(N != we.row.start || Ke != we.row.end) &&
          (t(55, (we = {row: {start: N, end: Ke}})), r && h('data-request', {requestData: we}))
      }
      if (
        (l.$$.dirty[0] & /*$data, defaultRowHeight, autoRowHeight, deltaTop*/ 172160) |
        (l.$$.dirty[1] & /*renderEnd*/ 33554432) |
        (l.$$.dirty[2] & /*$dynamic, renderedHeight*/ 20)
      ) {
        const N = r ? r.rowsCount : a.length,
          Ke = N * n
        X ? t(9, (Ne = zt + E + (N - ke) * n)) : t(9, (Ne = Ke))
      }
      if (
        ((l.$$.dirty[0] & /*leftWidth*/ 1024) |
          (l.$$.dirty[1] & /*leftColumns, centerColumns*/ 196608) |
          (l.$$.dirty[2] & /*$_columns, $split*/ 96) &&
          (t(47, (ye = u.slice(0, f.left).filter((N) => !N.hidden))),
          t(10, (Ze = 0)),
          ye.forEach((N) => {
            ;(N.fixed = 1), (N.left = Ze), t(10, (Ze += N.width))
          }),
          ye.length && t(47, (ye[ye.length - 1].fixed = -1), ye),
          t(48, (ve = u.slice(f.left).filter((N) => !N.hidden))),
          ve.forEach((N) => {
            N.fixed = 0
          })),
        (l.$$.dirty[0] & /*clientWidth, fullHeight*/ 768) |
          (l.$$.dirty[1] & /*clientHeight*/ 32768) && t(52, (Fe = K && ue ? Ne > ue : !1)),
        (l.$$.dirty[0] & /*clientWidth, contentWidth*/ 2304) |
          (l.$$.dirty[1] & /*hasAny, fullWidth, hasVScroll*/ 2883584) &&
          (ie && U <= K
            ? (t(51, (ge = t(11, (Me = K)))), t(11, (Me -= Fe ? m : 0)))
            : Me < K
            ? t(51, (ge = U + (Fe ? m : 0)))
            : t(51, (ge = -1))),
        (l.$$.dirty[0] & /*$data*/ 131072) |
          (l.$$.dirty[1] & /*requestData*/ 16777216) |
          (l.$$.dirty[2] & /*$dynamic, $filter*/ 24))
      ) {
        if (r) t(19, (le = a))
        else {
          let N = a
          o && (N = N.filter(o)), t(19, (le = N.slice(we.row.start, we.row.end)))
        }
        _e = we?.row.start
      }
      if (
        (l.$$.dirty[0] & /*clientWidth, deltaLeft*/ 16640) |
        (l.$$.dirty[1] & /*scrollLeft, centerColumns*/ 1073872896)
      ) {
        const N = Ft,
          Ke = Ft + K
        let Ge = 0,
          et = 0,
          yt = 0
        t(14, (Xe = t(23, (it = t(24, (pt = 0)))))),
          ve.forEach((Ml, sn) => {
            N > yt && ((Ge = sn), t(14, (Xe = t(23, (it = t(24, (pt = yt))))))),
              (yt = yt + Ml.width),
              Ke > yt && (et = sn + Bh)
          })
        const gt = ct(Ge, Xe, 'header'),
          tt = ct(Ge, Xe, 'footer')
        t(23, (it = gt.delta)),
          t(58, (nn = gt.index)),
          t(24, (pt = tt.delta)),
          t(59, (At = tt.index)),
          t(57, (mt = Ge)),
          t(60, (Wt = et))
      }
      ;(l.$$.dirty[0] & /*clientWidth*/ 256) |
        (l.$$.dirty[1] &
          /*hasAny, fullWidth, leftColumns, centerColumns, cs, ce, csH, csF*/ 1007616e3) &&
        (ie && U > K
          ? t(20, (Pe = t(21, (Be = t(22, (je = [...ye, ...ve]))))))
          : (t(20, (Pe = [...ye, ...ve.slice(mt, Wt + 1)])),
            t(21, (Be = [...ye, ...ve.slice(nn, Wt + 1)])),
            t(22, (je = [...ye, ...ve.slice(At, Wt + 1)])))),
        l.$$.dirty[1] & /*globalWidth*/ 1048576 && t(28, (i = ge ? `width:${ge}px;` : '')),
        l.$$.dirty[0] & /*$editor*/ 65536 && hr(s)
    }),
    [
      w,
      b,
      p,
      z,
      M,
      C,
      P,
      X,
      K,
      Ne,
      Ze,
      Me,
      oe,
      E,
      Xe,
      n,
      s,
      a,
      c,
      le,
      Pe,
      Be,
      je,
      it,
      pt,
      _t,
      Pt,
      ln,
      i,
      d,
      A,
      B,
      V,
      fe,
      L,
      Ye,
      G,
      pe,
      Se,
      Z,
      ae,
      Te,
      at,
      _,
      T,
      W,
      ue,
      ye,
      ve,
      ie,
      U,
      ge,
      Fe,
      Je,
      J,
      we,
      ke,
      mt,
      nn,
      At,
      Wt,
      Ft,
      Ht,
      ut,
      zt,
      o,
      r,
      u,
      f,
      mr,
      _r,
      gr,
      wr,
      br,
      kr,
      pr,
      yr,
      vr,
      Sr,
      Mr,
      Tr,
      Cr,
      Dr,
    ]
  )
}
let qh = class extends ee {
  constructor(e) {
    super(),
      $(
        this,
        e,
        Zh,
        Yh,
        x,
        {
          store: 43,
          api: 0,
          header: 1,
          footer: 2,
          overlay: 3,
          select: 44,
          multiselect: 45,
          rowStyle: 4,
          columnStyle: 5,
          cellStyle: 6,
          autoRowHeight: 7,
        },
        null,
        [-1, -1, -1, -1]
      )
  }
}
function Kh(l) {
  let e, t
  return (
    (e = new qh({
      props: {
        store: /*dataStore*/ l[10],
        api: /*api*/ l[9],
        header: /*header*/ l[5],
        footer: /*footer*/ l[6],
        overlay: /*overlay*/ l[7],
        rowStyle: /*rowStyle*/ l[0],
        columnStyle: /*columnStyle*/ l[1],
        cellStyle: /*cellStyle*/ l[2],
        select: /*select*/ l[3],
        multiselect: /*multiselect*/ l[4],
        autoRowHeight: /*autoRowHeight*/ l[8],
      },
    })),
    e.$on('action', /*actions*/ l[11]),
    e.$on('data-request', /*data_request_handler*/ l[25]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*header*/ 32 && (s.header = /*header*/ n[5]),
          i & /*footer*/ 64 && (s.footer = /*footer*/ n[6]),
          i & /*overlay*/ 128 && (s.overlay = /*overlay*/ n[7]),
          i & /*rowStyle*/ 1 && (s.rowStyle = /*rowStyle*/ n[0]),
          i & /*columnStyle*/ 2 && (s.columnStyle = /*columnStyle*/ n[1]),
          i & /*cellStyle*/ 4 && (s.cellStyle = /*cellStyle*/ n[2]),
          i & /*select*/ 8 && (s.select = /*select*/ n[3]),
          i & /*multiselect*/ 16 && (s.multiselect = /*multiselect*/ n[4]),
          i & /*autoRowHeight*/ 256 && (s.autoRowHeight = /*autoRowHeight*/ n[8]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Gh(l) {
  let e, t
  return (
    (e = new Mo({props: {words: fd, optional: !0, $$slots: {default: [Kh]}, $$scope: {ctx: l}}})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, _ref61) {
        let [i] = _ref61
        const s = {}
        i &
          /*$$scope, header, footer, overlay, rowStyle, columnStyle, cellStyle, select, multiselect, autoRowHeight*/ 536871423 &&
          (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Xh(l, e, t) {
  let n
  const i = He()
  let {data: s = []} = e,
    {columns: o = []} = e,
    {rowStyle: a = null} = e,
    {columnStyle: r = null} = e,
    {cellStyle: c = null} = e,
    {selected: u = null} = e,
    {selectedRows: f = []} = e,
    {select: d = !0} = e,
    {multiselect: h = !1} = e,
    {header: m = !0} = e,
    {footer: _ = !1} = e,
    {dynamic: w = null} = e,
    {editor: b = null} = e,
    {filter: p = null} = e,
    {overlay: z = null} = e,
    {autoRowHeight: T = !1} = e,
    {sizes: W = {}} = e,
    {split: M = {left: 0}} = e,
    {tree: C = !1} = e,
    {autoConfig: P = !1} = e,
    {init: X = null} = e
  // Grid state initialization
  const A = new Dd(cl)
  let B = A.in,
    V = new To(i)
  B.setNext(V)
  const fe = (G) => {
      B.exec(G.detail.action, G.detail.data)
    },
    // API methods for column/row management
    L = {
      // state
      getState: A.getState.bind(A),
      getReactiveState: A.getReactive.bind(A),
      getStores: () => ({data: A}), // events
      exec: B.exec,
      setNext: (G) => (V = V.setNext(G)),
      intercept: B.intercept.bind(B),
      on: B.on.bind(B),
      detach: B.detach.bind(B), // extra api
      getRow: (G) => A.getRow(G),
      getColumn: (G) => A.getColumn(G),
    }
  function Ye(G) {
    De.call(this, l, G)
  }
  return (
    (l.$$set = (G) => {
      'data' in G && t(14, (s = G.data)),
        'columns' in G && t(15, (o = G.columns)),
        'rowStyle' in G && t(0, (a = G.rowStyle)),
        'columnStyle' in G && t(1, (r = G.columnStyle)),
        'cellStyle' in G && t(2, (c = G.cellStyle)),
        'selected' in G && t(12, (u = G.selected)),
        'selectedRows' in G && t(16, (f = G.selectedRows)),
        'select' in G && t(3, (d = G.select)),
        'multiselect' in G && t(4, (h = G.multiselect)),
        'header' in G && t(5, (m = G.header)),
        'footer' in G && t(6, (_ = G.footer)),
        'dynamic' in G && t(17, (w = G.dynamic)),
        'editor' in G && t(18, (b = G.editor)),
        'filter' in G && t(19, (p = G.filter)),
        'overlay' in G && t(7, (z = G.overlay)),
        'autoRowHeight' in G && t(8, (T = G.autoRowHeight)),
        'sizes' in G && t(20, (W = G.sizes)),
        'split' in G && t(21, (M = G.split)),
        'tree' in G && t(22, (C = G.tree)),
        'autoConfig' in G && t(23, (P = G.autoConfig)),
        'init' in G && t(13, (X = G.init))
    }),
    (l.$$.update = () => {
      if (l.$$.dirty & /*autoConfig, columns, data*/ 8437760 && P && !o.length && s.length) {
        const G = s[0]
        for (let pe in G)
          if (pe != 'id' && pe[0] != '$') {
            let Se = {id: pe, header: pe[0].toUpperCase() + pe.substr(1)}
            typeof P == 'object' && (Se = {...Se, ...P}), o.push(Se)
          }
      }
      l.$$.dirty & /*selectedRows, selected*/ 69632 &&
        (f.length ? t(12, (u = f[0])) : u && f.push(u)),
        l.$$.dirty &
          /*data, editor, columns, split, sizes, selected, selectedRows, dynamic, filter, tree, _skin, init*/ 25161728 &&
          (A.init({
            data: s,
            editor: b,
            columns: o,
            split: M,
            sizes: W,
            selected: u,
            selectedRows: f,
            dynamic: w,
            filter: p,
            tree: C,
            _skin: n,
          }),
          X && (X(L), t(13, (X = null))))
    }),
    t(24, (n = ze('wx-theme'))),
    [a, r, c, d, h, m, _, z, T, L, A, fe, u, X, s, o, f, w, b, p, W, M, C, P, n, Ye]
  )
}
class Vh extends ee {
  constructor(e) {
    super(),
      $(this, e, Xh, Gh, x, {
        data: 14,
        columns: 15,
        rowStyle: 0,
        columnStyle: 1,
        cellStyle: 2,
        selected: 12,
        selectedRows: 16,
        select: 3,
        multiselect: 4,
        header: 5,
        footer: 6,
        dynamic: 17,
        editor: 18,
        filter: 19,
        overlay: 7,
        autoRowHeight: 8,
        sizes: 20,
        split: 21,
        tree: 22,
        autoConfig: 23,
        init: 13,
        api: 9,
      })
  }
  get api() {
    return this.$$.ctx[9]
  }
}
function sr(l, e) {
  l.forEach((t) => {
    e(t), t.data && t.data.length && sr(t.data, e)
  })
}
function or(l, e) {
  const t = []
  return (
    l.forEach((n) => {
      if (n.data) {
        const i = or(n.data, e)
        i.length && t.push({...n, data: i})
      } else e(n) && t.push(n)
    }),
    t
  )
}
let Uh = 1
function Jh(l) {
  return (
    sr(l, (e) => {
      e.id = e.id || Uh++
    }),
    l
  )
}
const Qh = {}
function xi(l) {
  return Qh[l]
}
function $i(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')), g(e, 'class', (t = 'wx-icon ' + /*item*/ l[0].icon + ' x2-xfznf6'))
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*item*/ 1 &&
        t !== (t = 'wx-icon ' + /*item*/ n[0].icon + ' x2-xfznf6') &&
        g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function xh(l) {
  let e,
    t = /*item*/ l[0].text + '',
    n
  return {
    c() {
      ;(e = D('span')), (n = re(t)), g(e, 'class', 'wx-value x2-xfznf6')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*item*/ 1 && t !== (t = /*item*/ i[0].text + '') && me(n, t)
    },
    i: I,
    o: I,
    d(i) {
      i && v(e)
    },
  }
}
function $h(l) {
  let e, t, n
  var i = xi(/*item*/ l[0].type)
  function s(o, a) {
    return {props: {item: /*item*/ o[0]}}
  }
  return (
    i && (e = Le(i, s(l))),
    {
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a & /*item*/ 1 && i !== (i = xi(/*item*/ o[0].type))) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s(o))), F(e.$$.fragment), k(e.$$.fragment, 1), R(e, t.parentNode, t))
            : (e = null)
        } else if (i) {
          const r = {}
          a & /*item*/ 1 && (r.item = /*item*/ o[0]), e.$set(r)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function es(l) {
  let e,
    t = /*item*/ l[0].subtext + '',
    n
  return {
    c() {
      ;(e = D('span')), (n = re(t)), g(e, 'class', 'wx-subtext x2-xfznf6')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*item*/ 1 && t !== (t = /*item*/ i[0].subtext + '') && me(n, t)
    },
    d(i) {
      i && v(e)
    },
  }
}
function ts(l) {
  let e
  return {
    c() {
      ;(e = D('i')), g(e, 'class', 'wx-sub-icon wxi-angle-right x2-xfznf6')
    },
    m(t, n) {
      S(t, e, n)
    },
    d(t) {
      t && v(e)
    },
  }
}
function em(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r,
    c,
    u,
    f,
    d = /*item*/ l[0].icon && $i(l)
  const h = [$h, xh],
    m = []
  function _(p, z) {
    return /*item*/ p[0].type ? 0 : 1
  }
  ;(n = _(l)), (i = m[n] = h[n](l))
  let w = /*item*/ l[0].subtext && es(l),
    b = /*item*/ l[0].data && ts()
  return {
    c() {
      ;(e = D('div')),
        d && d.c(),
        (t = Y()),
        i.c(),
        (s = Y()),
        w && w.c(),
        (o = Y()),
        b && b.c(),
        g(e, 'class', (a = 'wx-item ' + /*item*/ (l[0].css || '') + ' x2-xfznf6')),
        g(e, 'data-id', (r = /*item*/ l[0].id))
    },
    m(p, z) {
      S(p, e, z),
        d && d.m(e, null),
        H(e, t),
        m[n].m(e, null),
        H(e, s),
        w && w.m(e, null),
        H(e, o),
        b && b.m(e, null),
        (c = !0),
        u ||
          ((f = [q(e, 'mouseenter', /*onHover*/ l[1]), q(e, 'click', /*click_handler*/ l[4])]),
          (u = !0))
    },
    p(p, _ref62) {
      let [z] = _ref62
      /*item*/ p[0].icon
        ? d
          ? d.p(p, z)
          : ((d = $i(p)), d.c(), d.m(e, t))
        : d && (d.d(1), (d = null))
      let T = n
      ;(n = _(p)),
        n === T
          ? m[n].p(p, z)
          : (te(),
            y(m[T], 1, 1, () => {
              m[T] = null
            }),
            ne(),
            (i = m[n]),
            i ? i.p(p, z) : ((i = m[n] = h[n](p)), i.c()),
            k(i, 1),
            i.m(e, s)),
        /*item*/ p[0].subtext
          ? w
            ? w.p(p, z)
            : ((w = es(p)), w.c(), w.m(e, o))
          : w && (w.d(1), (w = null)),
        /*item*/ p[0].data ? b || ((b = ts()), b.c(), b.m(e, null)) : b && (b.d(1), (b = null)),
        (!c ||
          (z & /*item*/ 1 && a !== (a = 'wx-item ' + /*item*/ (p[0].css || '') + ' x2-xfznf6'))) &&
          g(e, 'class', a),
        (!c || (z & /*item*/ 1 && r !== (r = /*item*/ p[0].id))) && g(e, 'data-id', r)
    },
    i(p) {
      c || (k(i), (c = !0))
    },
    o(p) {
      y(i), (c = !1)
    },
    d(p) {
      p && v(e), d && d.d(), m[n].d(), w && w.d(), b && b.d(), (u = !1), Ee(f)
    },
  }
}
function tm(l, e, t) {
  let {item: n} = e,
    {showSub: i = !1} = e,
    {activeItem: s = null} = e
  function o() {
    t(2, (i = n.data ? n.id : !1)), t(3, (s = this))
  }
  function a(r) {
    De.call(this, l, r)
  }
  return (
    (l.$$set = (r) => {
      'item' in r && t(0, (n = r.item)),
        'showSub' in r && t(2, (i = r.showSub)),
        'activeItem' in r && t(3, (s = r.activeItem))
    }),
    [n, o, i, s, a]
  )
}
class nm extends ee {
  constructor(e) {
    super(), $(this, e, tm, em, x, {item: 0, showSub: 2, activeItem: 3})
  }
}
function ns(l, e, t) {
  const n = l.slice()
  return (n[24] = e[t]), n
}
function lm(l) {
  let e, t, n, i
  function s(c) {
    l[17](c)
  }
  function o(c) {
    l[18](c)
  }
  function a() {
    for (var _len2 = arguments.length, c = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      c[_key2] = arguments[_key2]
    }
    return /*click_handler_1*/ l[19](/*item*/ l[24], ...c)
  }
  let r = {item: /*item*/ l[24]}
  return (
    /*showSub*/ l[7] !== void 0 && (r.showSub = /*showSub*/ l[7]),
    /*activeItem*/ l[8] !== void 0 && (r.activeItem = /*activeItem*/ l[8]),
    (e = new nm({props: r})),
    be.push(() => rt(e, 'showSub', s)),
    be.push(() => rt(e, 'activeItem', o)),
    e.$on('click', a),
    {
      c() {
        F(e.$$.fragment)
      },
      m(c, u) {
        R(e, c, u), (i = !0)
      },
      p(c, u) {
        l = c
        const f = {}
        u & /*options*/ 1 && (f.item = /*item*/ l[24]),
          !t &&
            u & /*showSub*/ 128 &&
            ((t = !0), (f.showSub = /*showSub*/ l[7]), dt(() => (t = !1))),
          !n &&
            u & /*activeItem*/ 256 &&
            ((n = !0), (f.activeItem = /*activeItem*/ l[8]), dt(() => (n = !1))),
          e.$set(f)
      },
      i(c) {
        i || (k(e.$$.fragment, c), (i = !0))
      },
      o(c) {
        y(e.$$.fragment, c), (i = !1)
      },
      d(c) {
        O(e, c)
      },
    }
  )
}
function im(l) {
  let e
  return {
    c() {
      ;(e = D('div')), g(e, 'class', 'wx-separator x2-1tqohog')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    i: I,
    o: I,
    d(t) {
      t && v(e)
    },
  }
}
function ls(l) {
  let e, t
  return (
    (e = new rr({
      props: {
        css: /*css*/ l[2],
        options: /*item*/ l[24].data,
        at: 'right-overlap',
        parent: /*activeItem*/ l[8],
        context: /*context*/ l[1],
      },
    })),
    e.$on('click', /*click_handler*/ l[20]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*css*/ 4 && (s.css = /*css*/ n[2]),
          i & /*options*/ 1 && (s.options = /*item*/ n[24].data),
          i & /*activeItem*/ 256 && (s.parent = /*activeItem*/ n[8]),
          i & /*context*/ 2 && (s.context = /*context*/ n[1]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function is(l, e) {
  let t, n, i, s, o, a
  const r = [im, lm],
    c = []
  function u(d, h) {
    return /*item*/ d[24].type === 'separator' ? 0 : 1
  }
  ;(n = u(e)), (i = c[n] = r[n](e))
  let f = /*item*/ e[24].data && /*showSub*/ e[7] === /*item*/ e[24].id && ls(e)
  return {
    key: l,
    first: null,
    c() {
      ;(t = se()), i.c(), (s = Y()), f && f.c(), (o = se()), (this.first = t)
    },
    m(d, h) {
      S(d, t, h), c[n].m(d, h), S(d, s, h), f && f.m(d, h), S(d, o, h), (a = !0)
    },
    p(d, h) {
      e = d
      let m = n
      ;(n = u(e)),
        n === m
          ? c[n].p(e, h)
          : (te(),
            y(c[m], 1, 1, () => {
              c[m] = null
            }),
            ne(),
            (i = c[n]),
            i ? i.p(e, h) : ((i = c[n] = r[n](e)), i.c()),
            k(i, 1),
            i.m(s.parentNode, s)),
        /*item*/ e[24].data && /*showSub*/ e[7] === /*item*/ e[24].id
          ? f
            ? (f.p(e, h), h & /*options, showSub*/ 129 && k(f, 1))
            : ((f = ls(e)), f.c(), k(f, 1), f.m(o.parentNode, o))
          : f &&
            (te(),
            y(f, 1, 1, () => {
              f = null
            }),
            ne())
    },
    i(d) {
      a || (k(i), k(f), (a = !0))
    },
    o(d) {
      y(i), y(f), (a = !1)
    },
    d(d) {
      d && (v(t), v(s), v(o)), c[n].d(d), f && f.d(d)
    },
  }
}
function sm(l) {
  let e,
    t = [],
    n = /* @__PURE__ */ new Map(),
    i,
    s,
    o,
    a,
    r = de(/*options*/ l[0])
  const c = (u) => /*item*/ u[24].id
  for (let u = 0; u < r.length; u += 1) {
    let f = ns(l, r, u),
      d = c(f)
    n.set(d, (t[u] = is(d, f)))
  }
  return {
    c() {
      e = D('div')
      for (let u = 0; u < t.length; u += 1) t[u].c()
      g(e, 'data-wx-menu', 'true'),
        g(e, 'class', (i = 'wx-menu ' + /*css*/ l[2] + ' x2-1tqohog')),
        j(e, 'top', /*y*/ l[4] + 'px'),
        j(e, 'left', /*x*/ l[3] + 'px'),
        j(e, 'width', /*width*/ l[5])
    },
    m(u, f) {
      S(u, e, f)
      for (let d = 0; d < t.length; d += 1) t[d] && t[d].m(e, null)
      l[21](e),
        (s = !0),
        o ||
          ((a = [
            nt(Rn.call(null, e, {callback: /*cancel*/ l[11], modal: !0})),
            q(e, 'mouseleave', /*onLeave*/ l[10]),
          ]),
          (o = !0))
    },
    p(u, _ref63) {
      let [f] = _ref63
      f & /*css, options, activeItem, context, showSub, dispatch*/ 903 &&
        ((r = de(/*options*/ u[0])),
        te(),
        (t = kt(t, f, c, 1, u, r, n, e, en, is, null, ns)),
        ne()),
        (!s || (f & /*css*/ 4 && i !== (i = 'wx-menu ' + /*css*/ u[2] + ' x2-1tqohog'))) &&
          g(e, 'class', i),
        (!s || f & /*y*/ 16) && j(e, 'top', /*y*/ u[4] + 'px'),
        (!s || f & /*x*/ 8) && j(e, 'left', /*x*/ u[3] + 'px'),
        (!s || f & /*width*/ 32) && j(e, 'width', /*width*/ u[5])
    },
    i(u) {
      if (!s) {
        for (let f = 0; f < r.length; f += 1) k(t[f])
        s = !0
      }
    },
    o(u) {
      for (let f = 0; f < t.length; f += 1) y(t[f])
      s = !1
    },
    d(u) {
      u && v(e)
      for (let f = 0; f < t.length; f += 1) t[f].d()
      l[21](null), (o = !1), Ee(a)
    },
  }
}
function om(l, e, t) {
  const n = He()
  let {options: i} = e,
    {left: s = 0} = e,
    {top: o = 0} = e,
    {at: a = 'bottom'} = e,
    {parent: r = null} = e,
    {mount: c = null} = e,
    {context: u = null} = e,
    {css: f = ''} = e,
    d = -1e4,
    h = -1e4,
    m,
    _,
    w,
    b
  function p() {
    const A = qr(_, r, a, s, o)
    t(3, (d = A.x || d)), t(4, (h = A.y || h)), A.index, t(5, (m = A?.width || m))
  }
  c && c(p), ht(p)
  function z() {
    t(7, (w = !1))
  }
  function T() {
    n('click', {action: null})
  }
  function W(A) {
    ;(w = A), t(7, w)
  }
  function M(A) {
    ;(b = A), t(8, b)
  }
  const C = (A, B) => {
    if (!A.data && !B.defaultPrevented) {
      const V = {context: u, action: A, event: B}
      A.handler && A.handler(V), n('click', V), B.stopPropagation()
    }
  }
  function P(A) {
    De.call(this, l, A)
  }
  function X(A) {
    be[A ? 'unshift' : 'push'](() => {
      ;(_ = A), t(6, _)
    })
  }
  return (
    (l.$$set = (A) => {
      'options' in A && t(0, (i = A.options)),
        'left' in A && t(12, (s = A.left)),
        'top' in A && t(13, (o = A.top)),
        'at' in A && t(14, (a = A.at)),
        'parent' in A && t(15, (r = A.parent)),
        'mount' in A && t(16, (c = A.mount)),
        'context' in A && t(1, (u = A.context)),
        'css' in A && t(2, (f = A.css))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*options*/ 1 && Jh(i), l.$$.dirty & /*parent*/ 32768 && p()
    }),
    [i, u, f, d, h, m, _, w, b, n, z, T, s, o, a, r, c, W, M, C, P, X]
  )
}
let rr = class extends ee {
  constructor(e) {
    super(),
      $(this, e, om, sm, x, {
        options: 0,
        left: 12,
        top: 13,
        at: 14,
        parent: 15,
        mount: 16,
        context: 1,
        css: 2,
      })
  }
}
function rm(l) {
  let e, t, n, i
  const s = /*#slots*/ l[14].default,
    o = Ie(s, l, /*$$scope*/ l[15], null)
  return {
    c() {
      ;(e = D('div')), o && o.c(), g(e, 'data-menu-ignore', 'true')
    },
    m(a, r) {
      S(a, e, r),
        o && o.m(e, null),
        (t = !0),
        n || ((i = q(e, 'click', /*handler*/ l[2])), (n = !0))
    },
    p(a, r) {
      o &&
        o.p &&
        (!t || r & /*$$scope*/ 32768) &&
        Oe(
          o,
          s,
          a,
          /*$$scope*/ a[15],
          t ? Re(s, /*$$scope*/ a[15], r, null) : Ae(/*$$scope*/ a[15]),
          null
        )
    },
    i(a) {
      t || (k(o, a), (t = !0))
    },
    o(a) {
      y(o, a), (t = !1)
    },
    d(a) {
      a && v(e), o && o.d(a), (n = !1), i()
    },
  }
}
function ss(l) {
  let e, t
  return (
    (e = new yc({
      props: {
        $$slots: {
          default: [
            am,
            (_ref64) => {
              let {mount: n} = _ref64
              return {20: n}
            },
            (_ref65) => {
              let {mount: n} = _ref65
              return n ? 1048576 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*$$scope, parent, css, at, top, left, mount, item, filteredOptions*/ 1081595 &&
          (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function os(l) {
  let e, t
  return (
    (e = new rr({
      props: {
        css: /*css*/ l[1],
        at: /*at*/ l[0],
        top: /*top*/ l[7],
        left: /*left*/ l[6],
        mount: /*mount*/ l[20],
        parent: /*parent*/ l[5],
        context: /*item*/ l[4],
        options: /*filteredOptions*/ l[3],
      },
    })),
    e.$on('click', /*onClick*/ l[9]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*css*/ 2 && (s.css = /*css*/ n[1]),
          i & /*at*/ 1 && (s.at = /*at*/ n[0]),
          i & /*top*/ 128 && (s.top = /*top*/ n[7]),
          i & /*left*/ 64 && (s.left = /*left*/ n[6]),
          i & /*mount*/ 1048576 && (s.mount = /*mount*/ n[20]),
          i & /*parent*/ 32 && (s.parent = /*parent*/ n[5]),
          i & /*item*/ 16 && (s.context = /*item*/ n[4]),
          i & /*filteredOptions*/ 8 && (s.options = /*filteredOptions*/ n[3]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function am(l) {
  let e = /*parent*/ l[5],
    t,
    n,
    i = os(l)
  return {
    c() {
      i.c(), (t = se())
    },
    m(s, o) {
      i.m(s, o), S(s, t, o), (n = !0)
    },
    p(s, o) {
      o & /*parent*/ 32 && x(e, (e = /*parent*/ s[5]))
        ? (te(), y(i, 1, 1, I), ne(), (i = os(s)), i.c(), k(i, 1), i.m(t.parentNode, t))
        : i.p(s, o)
    },
    i(s) {
      n || (k(i), (n = !0))
    },
    o(s) {
      y(i), (n = !1)
    },
    d(s) {
      s && v(t), i.d(s)
    },
  }
}
function cm(l) {
  let e,
    t,
    n,
    i = /*SLOTS*/ l[8] && /*SLOTS*/ l[8].default && rm(l),
    s = /*parent*/ l[5] && ss(l)
  return {
    c() {
      i && i.c(), (e = Y()), s && s.c(), (t = se())
    },
    m(o, a) {
      i && i.m(o, a), S(o, e, a), s && s.m(o, a), S(o, t, a), (n = !0)
    },
    p(o, _ref66) {
      let [a] = _ref66
      /*SLOTS*/ o[8] && /*SLOTS*/ o[8].default && i.p(o, a),
        /*parent*/ o[5]
          ? s
            ? (s.p(o, a), a & /*parent*/ 32 && k(s, 1))
            : ((s = ss(o)), s.c(), k(s, 1), s.m(t.parentNode, t))
          : s &&
            (te(),
            y(s, 1, 1, () => {
              s = null
            }),
            ne())
    },
    i(o) {
      n || (k(i), k(s), (n = !0))
    },
    o(o) {
      y(i), y(s), (n = !1)
    },
    d(o) {
      o && (v(e), v(t)), i && i.d(o), s && s.d(o)
    },
  }
}
function um(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e
  const s = He(),
    o = e.$$slots
  let {options: a} = e,
    {at: r = 'bottom'} = e,
    {resolver: c = null} = e,
    {dataKey: u = 'contextId'} = e,
    {filter: f = null} = e,
    {css: d = ''} = e
  const h = W
  var m,
    _ = null,
    w = null
  let b = 0,
    p = 0
  function z(M) {
    t(5, (w = null)), s('click', M.detail)
  }
  function T(M, C) {
    let P = null
    for (; M && M.dataset && !P; ) (P = M.dataset[C]), (M = M.parentNode)
    return P ? ul(P) : null
  }
  function W(M, C) {
    if (!M) {
      t(5, (w = null))
      return
    }
    if (M.defaultPrevented) return
    const P = M.target
    ;(P && P.dataset && P.dataset.menuIgnore) ||
      (t(6, (b = M.clientX + 1)),
      t(7, (p = M.clientY + 1)),
      t(4, (_ = typeof C < 'u' ? C : T(P, u))),
      !(c && (t(4, (_ = c(_, M))), !_)) &&
        (_ !== null && f && t(3, (m = or(a, (X) => f(X, _)))), t(5, (w = P)), M.preventDefault()))
  }
  return (
    (l.$$set = (M) => {
      t(19, (e = We(We({}, e), qe(M)))),
        'options' in M && t(10, (a = M.options)),
        'at' in M && t(0, (r = M.at)),
        'resolver' in M && t(11, (c = M.resolver)),
        'dataKey' in M && t(12, (u = M.dataKey)),
        'filter' in M && t(13, (f = M.filter)),
        'css' in M && t(1, (d = M.css)),
        '$$scope' in M && t(15, (i = M.$$scope))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*options*/ 1024 && t(3, (m = a))
    }),
    (e = qe(e)),
    [r, d, h, m, _, w, b, p, o, z, a, c, u, f, n, i]
  )
}
class fm extends ee {
  constructor(e) {
    super(),
      $(this, e, um, cm, x, {
        options: 10,
        at: 0,
        resolver: 11,
        dataKey: 12,
        filter: 13,
        css: 1,
        handler: 2,
      })
  }
  get handler() {
    return this.$$.ctx[2]
  }
}
function dm(l) {
  let e, t, n, i
  const s = /*#slots*/ l[9].default,
    o = Ie(s, l, /*$$scope*/ l[8], null)
  return {
    c() {
      ;(e = D('div')), o && o.c(), g(e, 'data-menu-ignore', 'true')
    },
    m(a, r) {
      S(a, e, r),
        o && o.m(e, null),
        (t = !0),
        n ||
          ((i = q(e, 'contextmenu', function () {
            ot(/*handler*/ l[0]) && l[0].apply(this, arguments)
          })),
          (n = !0))
    },
    p(a, r) {
      ;(l = a),
        o &&
          o.p &&
          (!t || r & /*$$scope*/ 256) &&
          Oe(
            o,
            s,
            l,
            /*$$scope*/ l[8],
            t ? Re(s, /*$$scope*/ l[8], r, null) : Ae(/*$$scope*/ l[8]),
            null
          )
    },
    i(a) {
      t || (k(o, a), (t = !0))
    },
    o(a) {
      y(o, a), (t = !1)
    },
    d(a) {
      a && v(e), o && o.d(a), (n = !1), i()
    },
  }
}
function hm(l) {
  let e,
    t,
    n,
    i,
    s = /*SLOTS*/ l[7] && /*SLOTS*/ l[7].default && dm(l)
  function o(r) {
    l[10](r)
  }
  let a = {
    css: /*css*/ l[6],
    at: /*at*/ l[2],
    options: /*options*/ l[1],
    resolver: /*resolver*/ l[3],
    dataKey: /*dataKey*/ l[4],
    filter: /*filter*/ l[5],
  }
  return (
    /*handler*/ l[0] !== void 0 && (a.handler = /*handler*/ l[0]),
    (t = new fm({props: a})),
    be.push(() => rt(t, 'handler', o)),
    t.$on('click', /*click_handler*/ l[11]),
    {
      c() {
        s && s.c(), (e = Y()), F(t.$$.fragment)
      },
      m(r, c) {
        s && s.m(r, c), S(r, e, c), R(t, r, c), (i = !0)
      },
      p(r, _ref67) {
        let [c] = _ref67
        /*SLOTS*/ r[7] && /*SLOTS*/ r[7].default && s.p(r, c)
        const u = {}
        c & /*css*/ 64 && (u.css = /*css*/ r[6]),
          c & /*at*/ 4 && (u.at = /*at*/ r[2]),
          c & /*options*/ 2 && (u.options = /*options*/ r[1]),
          c & /*resolver*/ 8 && (u.resolver = /*resolver*/ r[3]),
          c & /*dataKey*/ 16 && (u.dataKey = /*dataKey*/ r[4]),
          c & /*filter*/ 32 && (u.filter = /*filter*/ r[5]),
          !n && c & /*handler*/ 1 && ((n = !0), (u.handler = /*handler*/ r[0]), dt(() => (n = !1))),
          t.$set(u)
      },
      i(r) {
        i || (k(s), k(t.$$.fragment, r), (i = !0))
      },
      o(r) {
        y(s), y(t.$$.fragment, r), (i = !1)
      },
      d(r) {
        r && v(e), s && s.d(r), O(t, r)
      },
    }
  )
}
function mm(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e
  const s = e.$$slots
  let {handler: o = null} = e,
    {options: a} = e,
    {at: r = 'bottom'} = e,
    {resolver: c = null} = e,
    {dataKey: u = 'contextId'} = e,
    {filter: f = null} = e,
    {css: d = ''} = e
  function h(_) {
    ;(o = _), t(0, o)
  }
  function m(_) {
    De.call(this, l, _)
  }
  return (
    (l.$$set = (_) => {
      t(12, (e = We(We({}, e), qe(_)))),
        'handler' in _ && t(0, (o = _.handler)),
        'options' in _ && t(1, (a = _.options)),
        'at' in _ && t(2, (r = _.at)),
        'resolver' in _ && t(3, (c = _.resolver)),
        'dataKey' in _ && t(4, (u = _.dataKey)),
        'filter' in _ && t(5, (f = _.filter)),
        'css' in _ && t(6, (d = _.css)),
        '$$scope' in _ && t(8, (i = _.$$scope))
    }),
    (e = qe(e)),
    [o, a, r, c, u, f, d, s, i, n, h, m]
  )
}
class _m extends ee {
  constructor(e) {
    super(),
      $(this, e, mm, hm, x, {
        handler: 0,
        options: 1,
        at: 2,
        resolver: 3,
        dataKey: 4,
        filter: 5,
        css: 6,
      })
  }
}
function gm(l) {
  let e
  return {
    c() {
      ;(e = D('i')), g(e, 'class', 'wx-toggle-placeholder x2-r092m')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    d(t) {
      t && v(e)
    },
  }
}
function wm(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')),
        g(
          e,
          'class',
          (t = 'wx-toggle-icon wxi-menu-' + /*row*/ (l[0].open ? 'down' : 'right') + ' x2-r092m')
        ),
        g(e, 'data-action', 'open-task')
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*row*/ 1 &&
        t !==
          (t = 'wx-toggle-icon wxi-menu-' + /*row*/ (n[0].open ? 'down' : 'right') + ' x2-r092m') &&
        g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function bm(l) {
  let e,
    t,
    n,
    i = /*row*/ l[0].text + '',
    s,
    o
  function a(u, f) {
    return /*row*/ u[0].data || /*row*/ u[0].lazy ? wm : gm
  }
  let r = a(l),
    c = r(l)
  return {
    c() {
      ;(e = D('div')),
        c.c(),
        (t = Y()),
        (n = D('div')),
        (s = re(l[1]?.template ? l[1]?.template(l[0]) : i)),
        g(n, 'class', 'wx-text x2-r092m'),
        g(e, 'class', 'wx-content x2-r092m'),
        g(e, 'style', (o = rs(/*row*/ l[0], /*col*/ l[1])))
    },
    m(u, f) {
      S(u, e, f), c.m(e, null), H(e, t), H(e, n), H(n, s)
    },
    p(u, f) {
      r === (r = a(u)) && c ? c.p(u, f) : (c.d(1), (c = r(u)), c && (c.c(), c.m(e, t))),
        f & /*row*/ 1 && i !== (i = /*row*/ u[0].text + '') && me(s, i),
        f & /*row, col*/ 3 && o !== (o = rs(/*row*/ u[0], /*col*/ u[1])) && g(e, 'style', o)
    },
    d(u) {
      u && v(e), c.d()
    },
  }
}
function km(l) {
  let e, t
  return (
    (e = new vl({
      props: {
        row: /*row*/ l[0],
        col: /*col*/ l[1],
        columnStyle: /*columnStyle*/ l[2],
        cellStyle: /*cellStyle*/ l[3],
        $$slots: {default: [bm]},
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, _ref68) {
        let [i] = _ref68
        const s = {}
        i & /*row*/ 1 && (s.row = /*row*/ n[0]),
          i & /*col*/ 2 && (s.col = /*col*/ n[1]),
          i & /*columnStyle*/ 4 && (s.columnStyle = /*columnStyle*/ n[2]),
          i & /*cellStyle*/ 8 && (s.cellStyle = /*cellStyle*/ n[3]),
          i & /*$$scope, row, col*/ 19 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function rs(l, e) {
  return `justify-content:${e.align};padding-left: ${(l.$level - 1) * 20}px`
}
function pm(l, e, t) {
  let {row: n} = e,
    {col: i} = e,
    {columnStyle: s} = e,
    {cellStyle: o} = e
  return (
    (l.$$set = (a) => {
      'row' in a && t(0, (n = a.row)),
        'col' in a && t(1, (i = a.col)),
        'columnStyle' in a && t(2, (s = a.columnStyle)),
        'cellStyle' in a && t(3, (o = a.cellStyle))
    }),
    [n, i, s, o]
  )
}
class ym extends ee {
  constructor(e) {
    super(), $(this, e, pm, km, x, {row: 0, col: 1, columnStyle: 2, cellStyle: 3})
  }
}
function as(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('div')),
        (t = D('i')),
        g(t, 'class', 'wx-add-icon wxi-plus x2-153hphv'),
        g(t, 'data-action', (n = /*col*/ l[1].action)),
        j(e, 'text-align', /*col*/ l[1].align)
    },
    m(i, s) {
      S(i, e, s), H(e, t)
    },
    p(i, s) {
      s & /*col*/ 2 && n !== (n = /*col*/ i[1].action) && g(t, 'data-action', n),
        s & /*col*/ 2 && j(e, 'text-align', /*col*/ i[1].align)
    },
    d(i) {
      i && v(e)
    },
  }
}
function vm(l) {
  let e,
    t = /*col*/ l[1].action == 'add-task' && as(l)
  return {
    c() {
      t && t.c(), (e = se())
    },
    m(n, i) {
      t && t.m(n, i), S(n, e, i)
    },
    p(n, i) {
      /*col*/ n[1].action == 'add-task'
        ? t
          ? t.p(n, i)
          : ((t = as(n)), t.c(), t.m(e.parentNode, e))
        : t && (t.d(1), (t = null))
    },
    d(n) {
      n && v(e), t && t.d(n)
    },
  }
}
function Sm(l) {
  let e, t
  return (
    (e = new vl({
      props: {
        row: /*row*/ l[0],
        col: /*col*/ l[1],
        columnStyle: /*columnStyle*/ l[2],
        cellStyle: /*cellStyle*/ l[3],
        $$slots: {default: [vm]},
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, _ref69) {
        let [i] = _ref69
        const s = {}
        i & /*row*/ 1 && (s.row = /*row*/ n[0]),
          i & /*col*/ 2 && (s.col = /*col*/ n[1]),
          i & /*columnStyle*/ 4 && (s.columnStyle = /*columnStyle*/ n[2]),
          i & /*cellStyle*/ 8 && (s.cellStyle = /*cellStyle*/ n[3]),
          i & /*$$scope, col*/ 18 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Mm(l, e, t) {
  let {row: n} = e,
    {col: i} = e,
    {columnStyle: s} = e,
    {cellStyle: o} = e
  return (
    (l.$$set = (a) => {
      'row' in a && t(0, (n = a.row)),
        'col' in a && t(1, (i = a.col)),
        'columnStyle' in a && t(2, (s = a.columnStyle)),
        'cellStyle' in a && t(3, (o = a.cellStyle))
    }),
    [n, i, s, o]
  )
}
class Tm extends ee {
  constructor(e) {
    super(), $(this, e, Mm, Sm, x, {row: 0, col: 1, columnStyle: 2, cellStyle: 3})
  }
}
// Initialize table component
function Cm(l) {
  let e, t, n, i, s, o, a, r, c
  return (
    (s = new Vh({
      props: {
        init: /*init*/ l[33],
        sizes: {rowHeight: /*$cellHeight*/ l[15], headerHeight: /*height*/ l[0] - 1},
        rowStyle: Dm,
        columnStyle: Wm,
        data: /*allTasks*/ l[13],
        columns: /*cols*/ l[6],
        selectedRows: [.../*sel*/ l[14]],
      },
    })),
    {
      // Table structure:
      c() {
        ;(e = D('div')),
          (t = D('div')),
          (n = D('div')),
          (i = D('div')),
          F(s.$$.fragment),
          g(i, 'style', /*tableStyle*/ l[3]),
          g(i, 'class', 'wx-table x2-dnsr36'),
          g(n, 'style', /*tableOuterStyle*/ l[4]),
          g(t, 'style', /*scrollYStyle*/ l[11]),
          g(t, 'class', 'x2-dnsr36'),
          Q(t, 'wx-scroll-y', /*scrollY*/ l[2] && !(/*showFull*/ l[7])),
          g(e, 'class', 'wx-table-wrapper x2-dnsr36'),
          j(e, 'flex', '0 0 ' + /*basis*/ l[12]),
          Vt(() => /*div3_elementresize_handler*/ l[54].call(e)),
          Q(e, 'wx-wrapper-scroll', /*scrollX*/ l[1]),
          Q(e, 'wx-wrapper-scroll-y', /*scrollY*/ l[2] && /*showFull*/ l[7])
      },
      m(u, f) {
        S(u, e, f),
          H(e, t),
          H(t, n),
          H(n, i),
          R(s, i, null),
          l[52](i),
          l[53](e),
          (o = sl(e, /*div3_elementresize_handler*/ l[54].bind(e))),
          (a = !0),
          r ||
            ((c = [
              q(window, 'touchend', /*endScroll*/ l[27]),
              nt(
                ud.call(null, i, {
                  start: /*startReorder*/ l[30],
                  touchStart: /*endScroll*/ l[27],
                  end: /*endReorder*/ l[31],
                  move: /*moveReorder*/ l[32],
                  getTask: /*api*/ l[16].getTask,
                })
              ),
              q(i, 'touchstart', /*onTouchstart*/ l[28]),
              q(i, 'touchmove', /*onTouchmove*/ l[29]),
              q(i, 'click', /*onClick*/ l[25]),
              q(i, 'dblclick', /*onDblClick*/ l[26]),
              q(t, 'scroll', /*onScroll*/ l[34]),
              q(e, 'scroll', /*onScroll*/ l[34]),
            ]),
            (r = !0))
      },
      p(u, f) {
        const d = {}
        f[0] & /*$cellHeight, height*/ 32769 &&
          (d.sizes = {rowHeight: /*$cellHeight*/ u[15], headerHeight: /*height*/ u[0] - 1}),
          f[0] & /*allTasks*/ 8192 && (d.data = /*allTasks*/ u[13]),
          f[0] & /*cols*/ 64 && (d.columns = /*cols*/ u[6]),
          f[0] & /*sel*/ 16384 && (d.selectedRows = [.../*sel*/ u[14]]),
          s.$set(d),
          (!a || f[0] & /*tableStyle*/ 8) && g(i, 'style', /*tableStyle*/ u[3]),
          (!a || f[0] & /*tableOuterStyle*/ 16) && g(n, 'style', /*tableOuterStyle*/ u[4]),
          (!a || f[0] & /*scrollYStyle*/ 2048) && g(t, 'style', /*scrollYStyle*/ u[11]),
          (!a || f[0] & /*scrollY, showFull*/ 132) &&
            Q(t, 'wx-scroll-y', /*scrollY*/ u[2] && !(/*showFull*/ u[7])),
          (!a || f[0] & /*basis*/ 4096) && j(e, 'flex', '0 0 ' + /*basis*/ u[12]),
          (!a || f[0] & /*scrollX*/ 2) && Q(e, 'wx-wrapper-scroll', /*scrollX*/ u[1]),
          (!a || f[0] & /*scrollY, showFull*/ 132) &&
            Q(e, 'wx-wrapper-scroll-y', /*scrollY*/ u[2] && /*showFull*/ u[7])
      },
      i(u) {
        a || (k(s.$$.fragment, u), (a = !0))
      },
      o(u) {
        y(s.$$.fragment, u), (a = !1)
      },
      d(u) {
        u && v(e), O(s), l[52](null), l[53](null), o(), (r = !1), Ee(c)
      },
    }
  )
}
const Dm = (l) => (l.$reorder ? 'wx-reorder-task' : ''),
  Wm = (l) => 'wx-text-' + l.align
function Hm(l, e, t) {
  let n,
    i,
    s,
    o,
    a,
    r,
    c,
    u,
    f,
    d,
    h,
    {readonly: m} = e,
    {compactMode: _} = e,
    {width: w = 0} = e,
    {columnWidth: b = 0} = e,
    {fullHeight: p = 0} = e,
    {childMoveBetweenGroups: preventChildMove = false} = e
  const z = ze('wx-i18n').getGroup('gantt'),
    T = ze('gantt-store'),
    {
      scrollTop: W,
      cellHeight: M,
      _selected: C,
      area: P,
      _tasks: X,
      _scales: A,
      columns: B,
      _sort: V,
    } = T.getReactiveState()
  ce(l, W, (Z) => t(45, (o = Z))),
    ce(l, M, (Z) => t(15, (h = Z))),
    ce(l, C, (Z) => t(48, (c = Z))),
    ce(l, P, (Z) => t(50, (f = Z))),
    ce(l, X, (Z) => t(51, (d = Z))),
    ce(l, A, (Z) => t(49, (u = Z))),
    ce(l, B, (Z) => t(47, (r = Z))),
    ce(l, V, (Z) => t(46, (a = Z)))
  let fe,
    L,
    Ye = null,
    G = !0,
    pe = null,
    Se,
    K,
    ue,
    Ne,
    ye,
    ve,
    Ze
  function ie(Z) {
    const ae = hn(Z)
    if (!ae) return
    let Te = Z.target.dataset.action
    if ((Te && Z.preventDefault(), Te == 'add-task'))
      T.exec(Te, {target: ae, task: {text: z('New Task')}, mode: 'child'})
    else if (Te == 'open-task') {
      const at = fe.find((ct) => ct.id === ae)
      T.exec(Te, {id: ae, mode: !at.open})
    } else
      T.exec('select-task', {id: ae, toggle: Z.ctrlKey || Z.metaKey, range: Z.shiftKey, show: !0})
  }
  function U(Z) {
    if (!m) {
      const ae = hn(Z)
      ae && T.exec('show-editor', {id: ae})
    }
  }
  function ge() {
    G = !1
  }
  function Me(Z) {
    ;(G = !0), (Ye = Z.touches[0].clientY + o)
  }
  function Fe(Z) {
    if (G) {
      const ae = Ye - Z.touches[0].clientY
      return T.exec('scroll-chart', {top: ae}), Z.preventDefault(), !1
    }
  }
  // Helper function to check if a task is child of another task
  function isChildOf(childTask, parentTask) {
    if (!childTask || !parentTask) return false
    if (!parentTask.type || parentTask.type !== 'summary') return false

    // Check if child task's parent ID matches parent task's ID
    return childTask.parent === parentTask.id
  }

  let Je
  function J(Z) {
    const ae = Z.id,
      {before: Te, after: at} = Z,
      ct = Z.onMove
    let _t = Te || at,
      ut = Te ? 'before' : 'after'
    if (ct) {
      const draggedTask = T.getTask(ae)
      const targetTask = T.getTask(_t)
      const allTasks = T.getReactiveState()._tasks

      // Return early if either task is undefined
      if (!targetTask || !draggedTask) {
        return
      }

      // Case 1: If dragged task is a child task
      // if (draggedTask.parent) {
      //   // Child tasks can only move within their parent
      //   if (draggedTask.parent !== targetTask.parent) {
      //     return
      //   }
      // }

      // Case 2: Prevent moving any task inside a parent/summary task
      if (ut === 'after' && targetTask.type === 'summary' && targetTask.open) {
        return
      }

      // Case 3: Prevent child tasks from becoming top-level tasks and vice versa
      if (
        (draggedTask.parent && !targetTask.parent) ||
        (!draggedTask.parent && targetTask.parent)
      ) {
        return
      }

      // Case 4: Prevent circular dependencies
      if (draggedTask.type === 'summary' && isChildOf(targetTask, draggedTask)) {
        return
      }

      if (ut == 'after') {
        const zt = T.getTask(_t)
        if (zt.data?.length && zt.open) {
          ut = 'before'
          _t = zt.data[0].id
        }
      }
      Je = {id: ae, [ut]: _t}
    } else {
      Je = null
    }

    T.exec('move-task', {id: ae, mode: ut, target: _t, inProgress: ct, task: T.getTask(_t), parent: T.getTask(_t)?.parent})
  }
  function oe(_ref70) {
    let {id: Z} = _ref70
    if (
      m ||
      (T.getTask(Z).open && T.exec('open-task', {id: Z, mode: !1}),
      t(41, (pe = fe.find((ae) => ae.id === Z))),
      !pe)
    )
      return !1
  }
  function we(_ref71) {
    let {id: Z, top: ae} = _ref71
    Je
      ? J({...Je, onMove: !1})
      : (T.exec('drag-task', {id: Z, top: ae + n, inProgress: !1}), t(41, (pe = null)))
  }
  function E(_ref72) {
    let {id: Z, top: ae, detail: Te} = _ref72
    Te && J({...Te, onMove: !0}), T.exec('drag-task', {id: Z, top: ae + n, inProgress: !0})
  }
  let le,
    _e,
    ke = !1,
    Pe = !1,
    Be = 0,
    je = 0,
    Xe
  function it(Z) {
    Z.intercept('scroll', () => !1),
      Z.intercept('select-row', () => !1),
      Z.intercept(
        'collapse-column',
        () => (_ ? t(7, (ke = !ke)) : T.exec('add-task', {task: {text: z('New Task')}}), !1)
      ),
      Z.intercept('sort-rows', (ae) => {
        const Te = ae.key,
          at = a
        let ct = at ? 'asc' : 'desc'
        return (
          at && at.key === Te && (ct = at.order === 'asc' ? 'desc' : 'asc'),
          T.exec('sort-tasks', {key: Te, order: ct}),
          !1
        )
      }),
      Z.on('resize-column', () => {
        Pe && mt(le), At()
      })
  }
  function pt(Z) {
    t(42, (Ze = Z.target.scrollTop)), T.exec('scroll-chart', {top: Ze})
  }
  function mt(Z) {
    t(43, (Pe = Z.some((ae) => Object.hasOwn(ae, 'flexgrow'))))
  }
  async function nn(Z) {
    await Dn(), t(5, (ve.scrollTop = Z), ve)
  }
  function At() {
    t(35, (b = le.reduce((Z, ae) => (ae.$width && (ae.$width = ae.width), Z + ae.width), 0)))
  }
  function Wt(Z) {
    be[Z ? 'unshift' : 'push'](() => {
      ;(Xe = Z), t(10, Xe)
    })
  }
  function Ft(Z) {
    be[Z ? 'unshift' : 'push'](() => {
      ;(ve = Z), t(5, ve)
    })
  }
  function Ht() {
    ;(Be = this.clientWidth), (je = this.clientHeight), t(8, Be), t(9, je)
  }
  return (
    (l.$$set = (Z) => {
      'readonly' in Z && t(36, (m = Z.readonly)),
        'compactMode' in Z && t(37, (_ = Z.compactMode)),
        'width' in Z && t(38, (w = Z.width)),
        'columnWidth' in Z && t(35, (b = Z.columnWidth)),
        'fullHeight' in Z && t(39, (p = Z.fullHeight))
    }),
    (l.$$.update = () => {
      if (
        (l.$$.dirty[1] & /*$rTasks, $area*/ 1572864 && t(40, (fe = d.slice(f.start, f.end))),
        l.$$.dirty[1] & /*$area*/ 524288 && t(44, (n = f.from)),
        l.$$.dirty[1] & /*$scales*/ 262144 && t(0, (L = u.height)),
        l.$$.dirty[1] & /*$selected*/ 131072 && t(14, (i = c.map((Z) => Z.id))),
        l.$$.dirty[1] & /*dragTask, tasks*/ 1536 &&
          t(13, (s = pe && !fe.find((Z) => Z.id === pe.id) ? [...fe, pe] : fe)),
        (l.$$.dirty[0] & /*cols, showFull*/ 192) |
          (l.$$.dirty[1] & /*$columns, compactMode, readonly*/ 65632))
      ) {
        t(6, (le = r.map((Te) => ((Te.header = z(Te.header)), Te)))), mt(le)
        const Z = le.findIndex((Te) => Te.id == 'text'),
          ae = le.findIndex((Te) => Te.id === 'action')
        t(6, (le[Z].cell = ym), le), t(6, le, le[ae] && (le[ae].cell = Tm))
        t(
          6,
          le,
          le[ae] &&
            (le[ae].header = {
              css: 'wx-action ' + (_ ? 'wx-expand' : 'wx-add-task'),
              collapsible: !0,
            })
        )
        _
        _
          ? (m && le[ae] && t(6, le, (le[ae].action = 'expand')),
            le.unshift(le.splice(ae, 1)[0]),
            t(6, (le = ke ? le : le.slice(0, 1))))
          : (m && le.splice(ae, 1), t(7, (ke = !1))),
          t(6, (le[le.length - 1].resize = !1), le),
          At()
      }
      if ((l.$$.dirty[0] & /*cols*/ 64) | (l.$$.dirty[1] & /*$sort*/ 32768)) {
        const {key: Z, order: ae} = a || {}
        t(6, (le = le.map((Te) => ((Te.$sort = ae && Te.id === Z ? {order: ae} : null), Te))))
      }
      if (
        ((l.$$.dirty[0] &
          /*showFull, w, scrollX, h, height, scrollY, tableStyle, tableOuterStyle*/ 927) |
          (l.$$.dirty[1] & /*compactMode, columnWidth, width, fullHeight*/ 464) &&
          (t(1, (Se = _ ? ke && b > Be : b > w)),
          t(3, (ue = t(11, (ye = !ke || Se ? `width:${Se ? b : w}px;` : '')))),
          t(2, (K = je < L + p)),
          t(4, (Ne = '')),
          K &&
            (t(4, (Ne = ue + `height:${p + L}px;`)),
            t(3, (ue += `height:${je}px;`)),
            ke && t(11, (ye = Ne))),
          t(12, (_e = ke ? '100%' : `${w}px`))),
        (l.$$.dirty[0] & /*showFull, w, cols*/ 448) |
          (l.$$.dirty[1] & /*columnWidth, width, hasFlexCol*/ 4240) &&
          (b < w || (ke && b < Be)) &&
          !Pe)
      ) {
        const Z = (Be - 50) / (b - 50)
        t(
          6,
          (le = le.map(
            (ae) => (
              ae.id != 'action' &&
                ((ae = {...ae}), ae.$width || (ae.$width = ae.width), (ae.width = ae.$width * Z)),
              ae
            )
          ))
        )
      }
      if (
        ((l.$$.dirty[0] & /*table*/ 1024) | (l.$$.dirty[1] & /*$scrollTop, scrollDelta*/ 24576) &&
          Xe &&
          (Xe.querySelector('.wx-body').style.top = -(o - n) + 'px'),
        (l.$$.dirty[0] & /*showFull*/ 128) | (l.$$.dirty[1] & /*compactMode, $scrollTop*/ 16448) &&
          _ &&
          !ke &&
          t(42, (Ze = o)),
        (l.$$.dirty[0] & /*scrollDiv, showFull, scrollY*/ 164) |
          (l.$$.dirty[1] & /*scrollYPos*/ 2048) &&
          ve &&
          (ke || !K))
      ) {
        const Z = K ? Ze : 0
        ve.scrollTop != Z && nn(Z)
      }
    }),
    [
      L,
      Se,
      K,
      ue,
      Ne,
      ve,
      le,
      ke,
      Be,
      je,
      Xe,
      ye,
      _e,
      s,
      i,
      h,
      T,
      W,
      M,
      C,
      P,
      X,
      A,
      B,
      V,
      ie,
      U,
      ge,
      Me,
      Fe,
      oe,
      we,
      E,
      it,
      pt,
      b,
      m,
      _,
      w,
      p,
      fe,
      pe,
      Ze,
      Pe,
      n,
      o,
      a,
      r,
      c,
      u,
      f,
      d,
      Wt,
      Ft,
      Ht,
    ]
  )
}
class zm extends ee {
  constructor(e) {
    super(),
      $(
        this,
        e,
        Hm,
        Cm,
        x,
        {readonly: 36, compactMode: 37, width: 38, columnWidth: 35, fullHeight: 39},
        null,
        [-1, -1, -1]
      )
  }
}
function Nm(l) {
  let e
  return {
    c() {
      ;(e = D('div')),
        j(e, 'width', '100%'),
        j(e, 'height', '100%'),
        j(
          e,
          'background',
          'url(' +
            bi(/*$cellWidth*/ l[3], /*$cellHeight*/ l[4], /*color*/ l[2], /*borders*/ l[0]) +
            ')'
        ),
        j(e, 'position', 'absolute')
    },
    m(t, n) {
      S(t, e, n), l[7](e)
    },
    p(t, _ref73) {
      let [n] = _ref73
      n & /*$cellWidth, $cellHeight, color, borders*/ 29 &&
        j(
          e,
          'background',
          'url(' +
            bi(/*$cellWidth*/ t[3], /*$cellHeight*/ t[4], /*color*/ t[2], /*borders*/ t[0]) +
            ')'
        )
    },
    i: I,
    o: I,
    d(t) {
      t && v(e), l[7](null)
    },
  }
}
function Lm(l, e, t) {
  let n,
    i,
    {borders: s = ''} = e
  const o = ze('gantt-store'),
    {cellWidth: a, cellHeight: r} = o.getReactiveState()
  ce(l, a, (d) => t(3, (n = d))), ce(l, r, (d) => t(4, (i = d)))
  let c,
    u = '#e4e4e4'
  kn(() => {
    if (typeof getComputedStyle < 'u') {
      const d = getComputedStyle(c).getPropertyValue('--wx-gantt-border')
      t(2, (u = d ? d.substring(d.indexOf('#')) : '#1d1e261a'))
    }
  })
  function f(d) {
    be[d ? 'unshift' : 'push'](() => {
      ;(c = d), t(1, c)
    })
  }
  return (
    (l.$$set = (d) => {
      'borders' in d && t(0, (s = d.borders))
    }),
    [s, c, u, n, i, a, r, f]
  )
}
class Em extends ee {
  constructor(e) {
    super(), $(this, e, Lm, Nm, x, {borders: 0})
  }
}
function cs(l, e, t) {
  const n = l.slice()
  return (n[44] = e[t]), n
}
function us(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r,
    c,
    u,
    f = !(/*readonly*/ l[0]) && fs(l)
  const d = [Rm, Im],
    h = []
  function m(w, b) {
    return /*task*/ w[44].type !== 'milestone' ? 0 : 1
  }
  ;(n = m(l)), (i = h[n] = d[n](l))
  let _ = !(/*readonly*/ l[0]) && ms(l)
  return {
    c() {
      ;(e = D('div')),
        f && f.c(),
        (t = Y()),
        i.c(),
        (s = Y()),
        _ && _.c(),
        g(
          e,
          'class',
          (o = 'wx-bar wx-' + /*taskTypeCss*/ l[24](/*task*/ l[44].type) + ' x2-1qryx5p')
        ),
        g(e, 'style', (a = bs(/*task*/ l[44]))),
        g(e, 'data-tooltip-id', (r = /*task*/ l[44].id)),
        g(e, 'data-id', (c = /*task*/ l[44].id)),
        Q(
          e,
          'wx-touch',
          /*touched*/ l[5] && /*taskMove*/ l[4] && /*task*/ l[44].id == /*taskMove*/ l[4].id
        ),
        Q(e, 'wx-selected', /*linkFrom*/ l[3] && /*linkFrom*/ l[3].id === /*task*/ l[44].id),
        Q(e, 'wx-reorder-task', /*task*/ l[44].$reorder)
    },
    m(w, b) {
      S(w, e, b), f && f.m(e, null), H(e, t), h[n].m(e, null), H(e, s), _ && _.m(e, null), (u = !0)
    },
    p(w, b) {
      /*readonly*/ w[0]
        ? f && (f.d(1), (f = null))
        : f
        ? f.p(w, b)
        : ((f = fs(w)), f.c(), f.m(e, t))
      let p = n
      ;(n = m(w)),
        n === p
          ? h[n].p(w, b)
          : (te(),
            y(h[p], 1, 1, () => {
              h[p] = null
            }),
            ne(),
            (i = h[n]),
            i ? i.p(w, b) : ((i = h[n] = d[n](w)), i.c()),
            k(i, 1),
            i.m(e, s)),
        /*readonly*/ w[0]
          ? _ && (_.d(1), (_ = null))
          : _
          ? _.p(w, b)
          : ((_ = ms(w)), _.c(), _.m(e, null)),
        (!u ||
          (b[0] & /*tasks*/ 4 &&
            o !==
              (o = 'wx-bar wx-' + /*taskTypeCss*/ w[24](/*task*/ w[44].type) + ' x2-1qryx5p'))) &&
          g(e, 'class', o),
        (!u || (b[0] & /*tasks*/ 4 && a !== (a = bs(/*task*/ w[44])))) && g(e, 'style', a),
        (!u || (b[0] & /*tasks*/ 4 && r !== (r = /*task*/ w[44].id))) && g(e, 'data-tooltip-id', r),
        (!u || (b[0] & /*tasks*/ 4 && c !== (c = /*task*/ w[44].id))) && g(e, 'data-id', c),
        (!u || b[0] & /*tasks, touched, taskMove, tasks*/ 52) &&
          Q(
            e,
            'wx-touch',
            /*touched*/ w[5] && /*taskMove*/ w[4] && /*task*/ w[44].id == /*taskMove*/ w[4].id
          ),
        (!u || b[0] & /*tasks, linkFrom, tasks*/ 12) &&
          Q(e, 'wx-selected', /*linkFrom*/ w[3] && /*linkFrom*/ w[3].id === /*task*/ w[44].id),
        (!u || b[0] & /*tasks, tasks*/ 4) && Q(e, 'wx-reorder-task', /*task*/ w[44].$reorder)
    },
    i(w) {
      u || (k(i), (u = !0))
    },
    o(w) {
      y(i), (u = !1)
    },
    d(w) {
      w && v(e), f && f.d(), h[n].d(), _ && _.d()
    },
  }
}
function fs(l) {
  let e
  return {
    c() {
      ;(e = D('div')),
        (e.innerHTML = '<div class="wx-inner x2-1qryx5p"></div>'),
        g(e, 'class', 'wx-link wx-left x2-1qryx5p'),
        Q(e, 'wx-visible', /*linkFrom*/ l[3]),
        Q(
          e,
          'wx-target',
          !(/*linkFrom*/ l[3]) || !(/*alreadyLinked*/ l[23](/*task*/ l[44].id, !0))
        ),
        Q(
          e,
          'wx-selected',
          /*linkFrom*/ l[3] && /*linkFrom*/ l[3].id === /*task*/ l[44].id && /*linkFrom*/ l[3].start
        )
    },
    m(t, n) {
      S(t, e, n)
    },
    p(t, n) {
      n[0] & /*linkFrom*/ 8 && Q(e, 'wx-visible', /*linkFrom*/ t[3]),
        n[0] & /*linkFrom, alreadyLinked, tasks*/ 8388620 &&
          Q(
            e,
            'wx-target',
            !(/*linkFrom*/ t[3]) || !(/*alreadyLinked*/ t[23](/*task*/ t[44].id, !0))
          ),
        n[0] & /*linkFrom, tasks*/ 12 &&
          Q(
            e,
            'wx-selected',
            /*linkFrom*/ t[3] &&
              /*linkFrom*/ t[3].id === /*task*/ t[44].id &&
              /*linkFrom*/ t[3].start
          )
    },
    d(t) {
      t && v(e)
    },
  }
}
function Im(l) {
  let e, t, n, i, s, o
  const a = [Am, Om],
    r = []
  function c(u, f) {
    return /*taskTemplate*/ u[1] ? 0 : 1
  }
  return (
    (n = c(l)),
    (i = r[n] = a[n](l)),
    {
      c() {
        ;(e = D('div')), (t = Y()), i.c(), (s = se()), g(e, 'class', 'wx-content x2-1qryx5p')
      },
      m(u, f) {
        S(u, e, f), S(u, t, f), r[n].m(u, f), S(u, s, f), (o = !0)
      },
      p(u, f) {
        let d = n
        ;(n = c(u)),
          n === d
            ? r[n].p(u, f)
            : (te(),
              y(r[d], 1, 1, () => {
                r[d] = null
              }),
              ne(),
              (i = r[n]),
              i ? i.p(u, f) : ((i = r[n] = a[n](u)), i.c()),
              k(i, 1),
              i.m(s.parentNode, s))
      },
      i(u) {
        o || (k(i), (o = !0))
      },
      o(u) {
        y(i), (o = !1)
      },
      d(u) {
        u && (v(e), v(t), v(s)), r[n].d(u)
      },
    }
  )
}
function Rm(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a = /*task*/ l[44].progress && ds(l),
    r = !(/*readonly*/ l[0]) && hs(l)
  const c = [Pm, Fm],
    u = []
  function f(d, h) {
    return /*taskTemplate*/ d[1] ? 0 : 1
  }
  return (
    (n = f(l)),
    (i = u[n] = c[n](l)),
    {
      c() {
        a && a.c(), (e = Y()), r && r.c(), (t = Y()), i.c(), (s = se())
      },
      m(d, h) {
        a && a.m(d, h), S(d, e, h), r && r.m(d, h), S(d, t, h), u[n].m(d, h), S(d, s, h), (o = !0)
      },
      p(d, h) {
        /*task*/ d[44].progress
          ? a
            ? a.p(d, h)
            : ((a = ds(d)), a.c(), a.m(e.parentNode, e))
          : a && (a.d(1), (a = null)),
          /*readonly*/ d[0]
            ? r && (r.d(1), (r = null))
            : r
            ? r.p(d, h)
            : ((r = hs(d)), r.c(), r.m(t.parentNode, t))
        let m = n
        ;(n = f(d)),
          n === m
            ? u[n].p(d, h)
            : (te(),
              y(u[m], 1, 1, () => {
                u[m] = null
              }),
              ne(),
              (i = u[n]),
              i ? i.p(d, h) : ((i = u[n] = c[n](d)), i.c()),
              k(i, 1),
              i.m(s.parentNode, s))
      },
      i(d) {
        o || (k(i), (o = !0))
      },
      o(d) {
        y(i), (o = !1)
      },
      d(d) {
        d && (v(e), v(t), v(s)), a && a.d(d), r && r.d(d), u[n].d(d)
      },
    }
  )
}
function Om(l) {
  let e,
    t = /*task*/ l[44].text + '',
    n
  return {
    c() {
      ;(e = D('div')), (n = re(t)), g(e, 'class', 'wx-text-out x2-1qryx5p')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s[0] & /*tasks*/ 4 && t !== (t = /*task*/ i[44].text + '') && me(n, t)
    },
    i: I,
    o: I,
    d(i) {
      i && v(e)
    },
  }
}
function Am(l) {
  let e, t, n
  var i = /*taskTemplate*/ l[1]
  function s(o, a) {
    return {props: {data: /*task*/ o[44]}}
  }
  return (
    i && ((e = Le(i, s(l))), e.$on('action', /*forward*/ l[25])),
    {
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a[0] & /*taskTemplate*/ 2 && i !== (i = /*taskTemplate*/ o[1])) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s(o))),
              e.$on('action', /*forward*/ o[25]),
              F(e.$$.fragment),
              k(e.$$.fragment, 1),
              R(e, t.parentNode, t))
            : (e = null)
        } else if (i) {
          const r = {}
          a[0] & /*tasks*/ 4 && (r.data = /*task*/ o[44]), e.$set(r)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function ds(l) {
  let e, t
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        g(t, 'class', 'wx-progress-percent x2-1qryx5p'),
        j(t, 'width', /*task*/ l[44].progress + '%'),
        g(e, 'class', 'wx-progress-wrapper x2-1qryx5p')
    },
    m(n, i) {
      S(n, e, i), H(e, t)
    },
    p(n, i) {
      i[0] & /*tasks*/ 4 && j(t, 'width', /*task*/ n[44].progress + '%')
    },
    d(n) {
      n && v(e)
    },
  }
}
function hs(l) {
  let e,
    t = /*task*/ l[44].progress > 100 ? 100 : l[44].progress + '',
    n
  return {
    c() {
      ;(e = D('div')),
        (n = re(t)),
        g(e, 'class', 'wx-progress-marker x2-1qryx5p'),
        j(e, 'left', 'calc(' + /*task*/ (l[44].progress > 100 ? 100 : l[44].progress) + '% - 10px)')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s[0] & /*tasks*/ 4 && t !== (t = /*task*/ (i[44].progress > 100 ? 100 : i[44].progress) + '') && me(n, t),
        s[0] & /*tasks*/ 4 && j(e, 'left', 'calc(' + /*task*/ (i[44].progress > 100 ? 100 : i[44].progress) + '% - 10px)')
    },
    d(i) {
      i && v(e)
    },
  }
}
function Fm(l) {
  let e,
    t = /*task*/ (l[44].text || '') + '',
    n
  return {
    c() {
      ;(e = D('div')), (n = re(t)), g(e, 'class', 'wx-content x2-1qryx5p')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s[0] & /*tasks*/ 4 && t !== (t = /*task*/ (i[44].text || '') + '') && me(n, t)
    },
    i: I,
    o: I,
    d(i) {
      i && v(e)
    },
  }
}
function Pm(l) {
  let e, t, n
  var i = /*taskTemplate*/ l[1]
  function s(o, a) {
    return {props: {data: /*task*/ o[44]}}
  }
  return (
    i && ((e = Le(i, s(l))), e.$on('action', /*forward*/ l[25])),
    {
      c() {
        e && F(e.$$.fragment), (t = se())
      },
      m(o, a) {
        e && R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        if (a[0] & /*taskTemplate*/ 2 && i !== (i = /*taskTemplate*/ o[1])) {
          if (e) {
            te()
            const r = e
            y(r.$$.fragment, 1, 0, () => {
              O(r, 1)
            }),
              ne()
          }
          i
            ? ((e = Le(i, s(o))),
              e.$on('action', /*forward*/ o[25]),
              F(e.$$.fragment),
              k(e.$$.fragment, 1),
              R(e, t.parentNode, t))
            : (e = null)
        } else if (i) {
          const r = {}
          a[0] & /*tasks*/ 4 && (r.data = /*task*/ o[44]), e.$set(r)
        }
      },
      i(o) {
        n || (e && k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        e && y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), e && O(e, o)
      },
    }
  )
}
function ms(l) {
  let e
  return {
    c() {
      ;(e = D('div')),
        (e.innerHTML = '<div class="wx-inner x2-1qryx5p"></div>'),
        g(e, 'class', 'wx-link wx-right x2-1qryx5p'),
        Q(e, 'wx-visible', /*linkFrom*/ l[3]),
        Q(
          e,
          'wx-target',
          !(/*linkFrom*/ l[3]) || !(/*alreadyLinked*/ l[23](/*task*/ l[44].id, !1))
        ),
        Q(
          e,
          'wx-selected',
          /*linkFrom*/ l[3] &&
            /*linkFrom*/ l[3].id === /*task*/ l[44].id &&
            !(/*linkFrom*/ l[3].start)
        )
    },
    m(t, n) {
      S(t, e, n)
    },
    p(t, n) {
      n[0] & /*linkFrom*/ 8 && Q(e, 'wx-visible', /*linkFrom*/ t[3]),
        n[0] & /*linkFrom, alreadyLinked, tasks*/ 8388620 &&
          Q(
            e,
            'wx-target',
            !(/*linkFrom*/ t[3]) || !(/*alreadyLinked*/ t[23](/*task*/ t[44].id, !1))
          ),
        n[0] & /*linkFrom, tasks*/ 12 &&
          Q(
            e,
            'wx-selected',
            /*linkFrom*/ t[3] &&
              /*linkFrom*/ t[3].id === /*task*/ t[44].id &&
              !(/*linkFrom*/ t[3].start)
          )
    },
    d(t) {
      t && v(e)
    },
  }
}
function _s(l) {
  let e, t
  return {
    c() {
      ;(e = D('div')),
        g(e, 'class', 'wx-baseline x2-1qryx5p'),
        g(e, 'style', (t = ks(/*task*/ l[44]))),
        Q(e, 'wx-milestone', /*task*/ l[44].type === 'milestone')
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i[0] & /*tasks*/ 4 && t !== (t = ks(/*task*/ n[44])) && g(e, 'style', t),
        i[0] & /*tasks*/ 4 && Q(e, 'wx-milestone', /*task*/ n[44].type === 'milestone')
    },
    d(n) {
      n && v(e)
    },
  }
}
function gs(l, e) {
  let t,
    n,
    i,
    s,
    o = !(/*task*/ e[44].$skip) && us(e),
    a = /*$baselines*/ e[7] && !(/*task*/ e[44].$skip_baseline) && _s(e)
  return {
    key: l,
    first: null,
    c() {
      ;(t = se()), o && o.c(), (n = Y()), a && a.c(), (i = se()), (this.first = t)
    },
    m(r, c) {
      S(r, t, c), o && o.m(r, c), S(r, n, c), a && a.m(r, c), S(r, i, c), (s = !0)
    },
    p(r, c) {
      ;(e = r),
        /*task*/ e[44].$skip
          ? o &&
            (te(),
            y(o, 1, 1, () => {
              o = null
            }),
            ne())
          : o
          ? (o.p(e, c), c[0] & /*tasks*/ 4 && k(o, 1))
          : ((o = us(e)), o.c(), k(o, 1), o.m(n.parentNode, n)),
        /*$baselines*/ e[7] && !(/*task*/ e[44].$skip_baseline)
          ? a
            ? a.p(e, c)
            : ((a = _s(e)), a.c(), a.m(i.parentNode, i))
          : a && (a.d(1), (a = null))
    },
    i(r) {
      s || (k(o), (s = !0))
    },
    o(r) {
      y(o), (s = !1)
    },
    d(r) {
      r && (v(t), v(n), v(i)), o && o.d(r), a && a.d(r)
    },
  }
}
function Ym(l) {
  let e,
    t = [],
    n = /* @__PURE__ */ new Map(),
    i,
    s,
    o,
    a,
    r = de(/*tasks*/ l[2])
  const c = (u) => /*task*/ u[44].id
  for (let u = 0; u < r.length; u += 1) {
    let f = cs(l, r, u),
      d = c(f)
    n.set(d, (t[u] = gs(d, f)))
  }
  return {
    c() {
      e = D('div')
      for (let u = 0; u < t.length; u += 1) t[u].c()
      g(e, 'class', 'wx-bars x2-1qryx5p'),
        j(e, 'line-height', /*tasks*/ (l[2].length ? /*tasks*/ l[2][0].$h : 0) + 'px'),
        Vt(() => /*div_elementresize_handler*/ l[29].call(e))
    },
    m(u, f) {
      S(u, e, f)
      for (let d = 0; d < t.length; d += 1) t[d] && t[d].m(e, null)
      ;(i = sl(e, /*div_elementresize_handler*/ l[29].bind(e))),
        (s = !0),
        o ||
          ((a = [
            q(window, 'mouseup', /*mouseup*/ l[18]),
            q(e, 'contextmenu', /*contextmenu*/ l[22]),
            q(e, 'mousedown', /*mousedown*/ l[14]),
            q(e, 'mousemove', /*mousemove*/ l[17]),
            q(e, 'touchstart', /*touchstart*/ l[15]),
            q(e, 'touchmove', /*touchmove*/ l[16]),
            q(e, 'touchend', /*touchend*/ l[19], {passive: !0}),
            q(e, 'click', /*onClick*/ l[21]),
            q(e, 'dblclick', /*onDblClick*/ l[20]),
            q(e, 'dragstart', jm),
          ]),
          (o = !0))
    },
    p(u, f) {
      f[0] &
        /*tasks, $baselines, taskTypeCss, touched, taskMove, linkFrom, alreadyLinked, readonly, taskTemplate, forward*/ 58720447 &&
        ((r = de(/*tasks*/ u[2])), te(), (t = kt(t, f, c, 1, u, r, n, e, en, gs, null, cs)), ne()),
        (!s || f[0] & /*tasks*/ 4) &&
          j(e, 'line-height', /*tasks*/ (u[2].length ? /*tasks*/ u[2][0].$h : 0) + 'px')
    },
    i(u) {
      if (!s) {
        for (let f = 0; f < r.length; f += 1) k(t[f])
        s = !0
      }
    },
    o(u) {
      for (let f = 0; f < t.length; f += 1) y(t[f])
      s = !1
    },
    d(u) {
      u && v(e)
      for (let f = 0; f < t.length; f += 1) t[f].d()
      i(), (o = !1), Ee(a)
    },
  }
}
function Bm() {
  document.body.style.userSelect = 'none'
}
function ws() {
  document.body.style.userSelect = ''
}
function bs(l) {
  return `left:${l.$x}px;top:${l.$y}px;width:${l.$w}px;height:${l.$h}px;`
}
function ks(l) {
  return `left:${l.$x_base}px;top:${l.$y_base}px;width:${l.$w_base}px;height:${l.$h_base}px;`
}
function calculateProgressFromDurationChange(originalDuration, newDuration, currentProgress) {
  // Get exact completed days from current progress (without rounding)
  const completedDays = (originalDuration * currentProgress) / 100

  // Calculate new progress percentage based on completed days and new duration
  // Allow progress to exceed 100% if duration becomes less than completed days
  const newProgress = (completedDays / newDuration) * 100

  // Only clamp the lower bound at 0, allow exceeding 100%
  return Math.max(newProgress, 0)
}

// Helper to get task duration in days remains same
function getTaskDurationDays(task) {
  const start = new Date(task.start)
  const end = new Date(task.end)
  return Math.ceil((end - start) / (1000 * 60 * 60 * 24))
}
const jm = () => !1
function Zm(l, e, t) {
  let n,
    i,
    s,
    o,
    a,
    r,
    c,
    {readonly: u} = e,
    {taskTemplate: f} = e
  const d = ze('gantt-store'),
    {_tasks: h, _links: m, area: _, _scales: w, taskTypes: b, baselines: p} = d.getReactiveState()
  ce(l, h, (J) => t(28, (r = J))),
    ce(l, m, (J) => t(35, (s = J))),
    ce(l, _, (J) => t(27, (a = J))),
    ce(l, w, (J) => t(26, (o = J))),
    ce(l, b, (J) => t(34, (i = J))),
    ce(l, p, (J) => t(7, (c = J)))
  let z,
    T = !1,
    W,
    M = null,
    C = null,
    P,
    X
  function A(J) {
    if (J.button !== 0) return
    const oe = wt(J)
    oe && V(oe, J)
  }
  function B(J) {
    const oe = wt(J)
    oe &&
      (X = setTimeout(() => {
        t(5, (P = !0)), V(oe, J.touches[0])
      }, 300))
  }
  function V(J, oe) {
    const {clientX: we} = oe,
      E = fn(J),
      le = d.getTask(E),
      _e = oe.target.classList
    if (!u) {
      if (_e.contains('wx-progress-marker')) {
        const {progress: ke} = d.getTask(E)
        ;(C = {id: E, x: we, progress: ke > 100 ? 100 : ke, dx: 0, node: J, marker: oe.target}),
          oe.target.classList.add('wx-progress-in-drag')
      } else {
        const ke = fe(J, oe, le) || 'move'
        t(4, (M = {id: E, mode: ke > 100 ? 100 : ke, x: we, dx: 0, l: le.$x, w: le.$w}))
      }
      Bm()
    }
  }
  function fe(J, oe, we) {
    if ((we || (we = d.getTask(fn(J))), we.type === 'milestone' || we.type == 'summary')) return ''
    const E = J.getBoundingClientRect(),
      le = (oe.clientX - E.left) / E.width
    let _e = 0.2 / (E.width > 200 ? E.width / 200 : 1)
    return le < _e ? 'start' : le > 1 - _e ? 'end' : ''
  }
  function L(J) {
    P ? (J.preventDefault(), G(J, J.touches[0])) : X && (clearTimeout(X), (X = null))
  }
  function Ye(J) {
    G(J, J)
  }
  function G(J, oe) {
    const {clientX: we} = oe
    if (!u)
      if (C) {
        const {node: E, x: le, id: _e} = C,
          ke = (C.dx = we - le),
          Pe = Math.round((ke / E.offsetWidth) * 100)
        let Be = C.progress + Pe
        ;(C.value = Be = Math.min(Math.max(0, Be), 100)),
          d.exec('update-task', {id: _e, task: {progress: Be}, inProgress: !0})
      } else if (M) {
        const {mode: E, l: le, w: _e, x: ke, id: Pe, start: Be} = M,
          je = we - ke
        if (
          (!Be && Math.abs(je) < 20) ||
          (E === 'start' && _e - je < n) ||
          (E === 'end' && _e + je < n) ||
          (E == 'move' && ((je < 0 && le + je < 0) || (je > 0 && le + _e + je > Fe)))
        )
          return
        t(4, (M.dx = je), M)
        let Xe, it
      const originalTask = d.getTask(Pe)
      const originalDuration = getTaskDurationDays(originalTask)
      const currentProgress = originalTask.progress || 0

      if (E === 'start') {
        Xe = le + je
        it = _e - je
      } else if (E === 'end') {
        Xe = le
        it = _e + je
      } else if (E === 'move') {
        Xe = le + je
        it = _e
      }

      let pt = {id: Pe, width: it, left: Xe, inProgress: !0}
      d.exec('drag-task', pt)

      // Calculate temporary duration based on current drag position
      const tempTask = d.getTask(Pe)
      const newDuration = getTaskDurationDays(tempTask)

      // Update progress in real-time if duration changed
      if (newDuration !== originalDuration) {
        const newProgress = calculateProgressFromDurationChange(
          originalDuration,
          newDuration,
          currentProgress
        )

        d.exec('update-task', {
          id: Pe,
          task: {
            progress: newProgress
          },
          inProgress: !0
        })
      }

      t(4, (M.start = !0), M)

      } else {
        const E = wt(J)
        if (E) {
          const le = fe(E, oe)
          E.style.cursor = le && !u ? 'col-resize' : 'pointer'
        }
      }
  }
  function pe() {
    K()
  }
  function Se() {
    t(5, (P = null)), X && (clearTimeout(X), (X = null)), K()
  }
  function K() {
    if (C) {
      const {dx: J, id: oe, marker: we, value: E} = C
      ;(C = null),
        typeof E < 'u' && J && d.exec('update-task', {id: oe, task: {progress: E}}),
        we.classList.remove('wx-progress-in-drag'),
        (T = !0),
        ws()
    } else if (M) {
      const {id: J, mode: oe, dx: we, l: E, w: le, start: _e} = M
      if ((t(4, (M = null)), _e)) {
        const ke = Math.round(we / n)
        if (!ke) {
          d.exec('drag-task', {id: J, width: le, left: E, inProgress: !1})
        } else {
          let Pe = {},
            Be = d.getTask(J)

          const originalDuration = getTaskDurationDays(Be)
          const currentProgress = Be.progress || 0

          if (oe == 'move') {
            Pe.start = Be.start
            Pe.end = Be.end
          } else {
            Pe[oe] = Be[oe]
          }

          // First update the task dates
          d.exec('update-task', {id: J, task: Pe, diff: ke})

          // Get updated task and calculate new duration
          const updatedTask = d.getTask(J)
          const newDuration = getTaskDurationDays(updatedTask)

          // Only update progress if duration actually changed
          if (newDuration !== originalDuration) {
            const newProgress = calculateProgressFromDurationChange(
              originalDuration,
              newDuration,
              currentProgress
            )

            // Update the task progress
            d.exec('update-task', {
              id: J,
              task: {
                progress: newProgress
              }
            })
          }
        }
        T = !0
      }
      ws()
    }
  }
  function ue(J) {
    if (!u) {
      const oe = hn(J.target)
      oe && !J.target.classList.contains('wx-link') && d.exec('show-editor', {id: oe})
    }
  }
  function Ne(J) {
    if (T) {
      T = !1
      return
    }
    const oe = hn(J.target)
    if (oe) {
      const we = J.target.classList
      if (we.contains('wx-link')) {
        const E = we.contains('wx-left')
        if (!W) {
          t(3, (W = {id: oe, start: E}))
          return
        }
        W.id !== oe &&
          !ie(oe, E) &&
          d.exec('add-link', {link: {source: W.id, target: oe, type: Ze(W.start, E)}})
      } else d.exec('select-task', {id: oe, toggle: J.ctrlKey || J.metaKey, range: J.shiftKey})
    }
    U()
  }
  function ye(J) {
    if (P || X) return J.preventDefault(), !1
  }
  const ve = ['e2s', 's2s', 'e2e', 's2e']
  function Ze(J, oe) {
    return ve[(J ? 1 : 0) + (oe ? 0 : 2)]
  }
  function ie(J, oe) {
    const we = W.id,
      E = W.start
    return J === we
      ? !0
      : s.find((le) => le.target == J && le.source == we && le.type === Ze(E, oe))
  }
  function U() {
    W && t(3, (W = null))
  }
  function ge(J) {
    let oe = i.some((we) => J === we.id) ? J : 'task'
    return oe !== 'task' && oe !== 'milestone' && oe !== 'summary' && (oe = `task ${oe}`), oe
  }
  function Me(J) {
    d.exec(J.detail.action, J.detail.data)
  }
  let Fe = 0
  function Je() {
    ;(Fe = this.offsetWidth), t(6, Fe)
  }
  return (
    (l.$$set = (J) => {
      'readonly' in J && t(0, (u = J.readonly)), 'taskTemplate' in J && t(1, (f = J.taskTemplate))
    }),
    (l.$$.update = () => {
      l.$$.dirty[0] & /*$rTasks, $area*/ 402653184 && t(2, (z = r.slice(a.start, a.end))),
        l.$$.dirty[0] & /*$scales*/ 67108864 && (n = o.lengthUnitWidth)
    }),
    [
      u,
      f,
      z,
      W,
      M,
      P,
      Fe,
      c,
      h,
      m,
      _,
      w,
      b,
      p,
      A,
      B,
      L,
      Ye,
      pe,
      Se,
      ue,
      Ne,
      ye,
      ie,
      ge,
      Me,
      o,
      a,
      r,
      Je,
    ]
  )
}
class qm extends ee {
  constructor(e) {
    super(), $(this, e, Zm, Ym, x, {readonly: 0, taskTemplate: 1}, null, [-1, -1])
  }
}
function ps(l, e, t) {
  const n = l.slice()
  return (n[5] = e[t]), n
}
function ys(l, e) {
  let t, n
  return {
    key: l,
    first: null,
    c() {
      ;(t = ll('polyline')),
        g(t, 'class', 'wx-line x2-wfzywr'),
        g(t, 'points', (n = /*link*/ e[5].$p)),
        (this.first = t)
    },
    m(i, s) {
      S(i, t, s)
    },
    p(i, s) {
      ;(e = i), s & /*$links*/ 4 && n !== (n = /*link*/ e[5].$p) && g(t, 'points', n)
    },
    d(i) {
      i && v(t)
    },
  }
}
function Km(l) {
  let e,
    t = [],
    n = /* @__PURE__ */ new Map(),
    i,
    s,
    o = de(/*$links*/ l[2])
  const a = (r) => /*link*/ r[5].id
  for (let r = 0; r < o.length; r += 1) {
    let c = ps(l, o, r),
      u = a(c)
    n.set(u, (t[r] = ys(u, c)))
  }
  return {
    c() {
      e = ll('svg')
      for (let r = 0; r < t.length; r += 1) t[r].c()
      g(e, 'class', 'wx-links x2-wfzywr'),
        g(e, 'width', (i = /*width*/ l[0] + 'px')),
        g(e, 'height', (s = /*height*/ l[1] + 'px'))
    },
    m(r, c) {
      S(r, e, c)
      for (let u = 0; u < t.length; u += 1) t[u] && t[u].m(e, null)
    },
    p(r, _ref74) {
      let [c] = _ref74
      c & /*$links*/ 4 &&
        ((o = de(/*$links*/ r[2])), (t = kt(t, c, a, 1, r, o, n, e, al, ys, null, ps))),
        c & /*width*/ 1 && i !== (i = /*width*/ r[0] + 'px') && g(e, 'width', i),
        c & /*height*/ 2 && s !== (s = /*height*/ r[1] + 'px') && g(e, 'height', s)
    },
    i: I,
    o: I,
    d(r) {
      r && v(e)
      for (let c = 0; c < t.length; c += 1) t[c].d()
    },
  }
}
function Gm(l, e, t) {
  let n,
    {width: i} = e,
    {height: s} = e
  const a = ze('gantt-store').getReactiveState()._links
  return (
    ce(l, a, (r) => t(2, (n = r))),
    (l.$$set = (r) => {
      'width' in r && t(0, (i = r.width)), 'height' in r && t(1, (s = r.height))
    }),
    [i, s, n, a]
  )
}
let Xm = class extends ee {
  constructor(e) {
    super(), $(this, e, Gm, Km, x, {width: 0, height: 1})
  }
}
function vs(l, e, t) {
  const n = l.slice()
  return (n[47] = e[t]), (n[49] = t), n
}
function Ss(l, e, t) {
  const n = l.slice()
  return (n[50] = e[t]), (n[52] = t), n
}
function Ms(l, e, t) {
  const n = l.slice()
  return (n[53] = e[t]), n
}
function Ts(l) {
  let e,
    t = de(/*markers*/ l[1]),
    n = []
  for (let i = 0; i < t.length; i += 1) n[i] = Cs(Ms(l, t, i))
  return {
    c() {
      e = D('div')
      for (let i = 0; i < n.length; i += 1) n[i].c()
      g(e, 'class', 'wx-markers x2-1ff484e'),
        j(e, 'height', /*markersHeight*/ l[10] + 'px'),
        j(e, 'left', -(/*scrollLeft*/ l[9]) + 'px')
    },
    m(i, s) {
      S(i, e, s)
      for (let o = 0; o < n.length; o += 1) n[o] && n[o].m(e, null)
    },
    p(i, s) {
      if (s[0] & /*markers*/ 2) {
        t = de(/*markers*/ i[1])
        let o
        for (o = 0; o < t.length; o += 1) {
          const a = Ms(i, t, o)
          n[o] ? n[o].p(a, s) : ((n[o] = Cs(a)), n[o].c(), n[o].m(e, null))
        }
        for (; o < n.length; o += 1) n[o].d(1)
        n.length = t.length
      }
      s[0] & /*markersHeight*/ 1024 && j(e, 'height', /*markersHeight*/ i[10] + 'px'),
        s[0] & /*scrollLeft*/ 512 && j(e, 'left', -(/*scrollLeft*/ i[9]) + 'px')
    },
    d(i) {
      i && v(e), $e(n, i)
    },
  }
}
function Cs(l) {
  let e,
    t,
    n = /*marker*/ l[53].text + '',
    i,
    s,
    o
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        (i = re(n)),
        (s = Y()),
        g(t, 'class', 'wx-content x2-1ff484e'),
        g(e, 'class', (o = 'wx-marker ' + /*marker*/ (l[53].css || 'wx-default') + ' x2-1ff484e')),
        j(e, 'left', /*marker*/ l[53].left + 'px')
    },
    m(a, r) {
      S(a, e, r), H(e, t), H(t, i), H(e, s)
    },
    p(a, r) {
      r[0] & /*markers*/ 2 && n !== (n = /*marker*/ a[53].text + '') && me(i, n),
        r[0] & /*markers*/ 2 &&
          o !== (o = 'wx-marker ' + /*marker*/ (a[53].css || 'wx-default') + ' x2-1ff484e') &&
          g(e, 'class', o),
        r[0] & /*markers*/ 2 && j(e, 'left', /*marker*/ a[53].left + 'px')
    },
    d(a) {
      a && v(e)
    },
  }
}
function Ds(l) {
  let e,
    t = de(/*holidays*/ l[11]),
    n = []
  for (let i = 0; i < t.length; i += 1) n[i] = Hs(Ss(l, t, i))
  return {
    c() {
      e = D('div')
      for (let i = 0; i < n.length; i += 1) n[i].c()
      g(e, 'class', 'wx-gantt-holidays x2-1ff484e'), j(e, 'height', '100%')
    },
    m(i, s) {
      S(i, e, s)
      for (let o = 0; o < n.length; o += 1) n[o] && n[o].m(e, null)
    },
    p(i, s) {
      if (s[0] & /*holidays*/ 2048) {
        t = de(/*holidays*/ i[11])
        let o
        for (o = 0; o < t.length; o += 1) {
          const a = Ss(i, t, o)
          n[o] ? n[o].p(a, s) : ((n[o] = Hs(a)), n[o].c(), n[o].m(e, null))
        }
        for (; o < n.length; o += 1) n[o].d(1)
        n.length = t.length
      }
    },
    d(i) {
      i && v(e), $e(n, i)
    },
  }
}
function Ws(l) {
  let e, t
  return {
    c() {
      ;(e = D('div')),
        g(e, 'class', (t = Ve(/*holiday*/ l[50].css) + ' x2-1ff484e')),
        j(e, 'width', /*holiday*/ l[50].width + 'px'),
        j(e, 'left', /*i*/ l[52] * /*holiday*/ l[50].width + 'px')
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i[0] & /*holidays*/ 2048 &&
        t !== (t = Ve(/*holiday*/ n[50].css) + ' x2-1ff484e') &&
        g(e, 'class', t),
        i[0] & /*holidays*/ 2048 && j(e, 'width', /*holiday*/ n[50].width + 'px'),
        i[0] & /*holidays*/ 2048 && j(e, 'left', /*i*/ n[52] * /*holiday*/ n[50].width + 'px')
    },
    d(n) {
      n && v(e)
    },
  }
}
function Hs(l) {
  let e,
    t = /*holiday*/ l[50] && Ws(l)
  return {
    c() {
      t && t.c(), (e = se())
    },
    m(n, i) {
      t && t.m(n, i), S(n, e, i)
    },
    p(n, i) {
      /*holiday*/ n[50]
        ? t
          ? t.p(n, i)
          : ((t = Ws(n)), t.c(), t.m(e.parentNode, e))
        : t && (t.d(1), (t = null))
    },
    d(n) {
      n && v(e), t && t.d(n)
    },
  }
}
function zs(l) {
  let e = [],
    t = /* @__PURE__ */ new Map(),
    n,
    i = de(/*$selected*/ l[8])
  const s = (o) => /*obj*/ o[47].id
  for (let o = 0; o < i.length; o += 1) {
    let a = vs(l, i, o),
      r = s(a)
    t.set(r, (e[o] = Ls(r, a)))
  }
  return {
    c() {
      for (let o = 0; o < e.length; o += 1) e[o].c()
      n = se()
    },
    m(o, a) {
      for (let r = 0; r < e.length; r += 1) e[r] && e[r].m(o, a)
      S(o, n, a)
    },
    p(o, a) {
      a[0] & /*$selected, selectStyle*/ 384 &&
        ((i = de(/*$selected*/ o[8])), (e = kt(e, a, s, 1, o, i, t, n.parentNode, al, Ls, n, vs)))
    },
    d(o) {
      o && v(n)
      for (let a = 0; a < e.length; a += 1) e[a].d(o)
    },
  }
}
function Ns(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('div')),
        g(e, 'class', 'wx-selected x2-1ff484e'),
        g(e, 'data-id', (t = /*obj*/ l[47].id)),
        g(e, 'style', (n = /*selectStyle*/ l[7][/*index*/ l[49]]))
    },
    m(i, s) {
      S(i, e, s)
    },
    p(i, s) {
      s[0] & /*$selected*/ 256 && t !== (t = /*obj*/ i[47].id) && g(e, 'data-id', t),
        s[0] & /*selectStyle, $selected*/ 384 &&
          n !== (n = /*selectStyle*/ i[7][/*index*/ i[49]]) &&
          g(e, 'style', n)
    },
    d(i) {
      i && v(e)
    },
  }
}
function Ls(l, e) {
  let t,
    n,
    i = /*obj*/ e[47].$y && Ns(e)
  return {
    key: l,
    first: null,
    c() {
      ;(t = se()), i && i.c(), (n = se()), (this.first = t)
    },
    m(s, o) {
      S(s, t, o), i && i.m(s, o), S(s, n, o)
    },
    p(s, o) {
      ;(e = s),
        /*obj*/ e[47].$y
          ? i
            ? i.p(e, o)
            : ((i = Ns(e)), i.c(), i.m(n.parentNode, n))
          : i && (i.d(1), (i = null))
    },
    d(s) {
      s && (v(t), v(n)), i && i.d(s)
    },
  }
}
function Vm(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r,
    c,
    u,
    f,
    d,
    h,
    m = /*markers*/ l[1].length && Ts(l),
    _ = /*holidays*/ l[11] && Ds(l)
  s = new Em({props: {borders: /*cellBorders*/ l[5]}})
  let w = /*$selected*/ l[8].length && zs(l)
  return (
    (r = new Xm({props: {width: /*fullWidth*/ l[2], height: /*fullHeight*/ l[3]}})),
    (u = new qm({props: {readonly: /*readonly*/ l[0], taskTemplate: /*taskTemplate*/ l[4]}})),
    {
      c() {
        ;(e = D('div')),
          m && m.c(),
          (t = Y()),
          (n = D('div')),
          _ && _.c(),
          (i = Y()),
          F(s.$$.fragment),
          (o = Y()),
          w && w.c(),
          (a = Y()),
          F(r.$$.fragment),
          (c = Y()),
          F(u.$$.fragment),
          g(n, 'class', 'wx-area x2-1ff484e'),
          j(n, 'width', /*fullWidth*/ l[2] + 'px'),
          j(n, 'height', /*fullHeight*/ l[3] + 'px'),
          g(e, 'class', 'wx-chart x2-1ff484e')
      },
      m(b, p) {
        S(b, e, p),
          m && m.m(e, null),
          H(e, t),
          H(e, n),
          _ && _.m(n, null),
          H(n, i),
          R(s, n, null),
          H(n, o),
          w && w.m(n, null),
          H(n, a),
          R(r, n, null),
          H(n, c),
          R(u, n, null),
          l[32](e),
          (f = !0),
          d ||
            ((h = [
              q(window, 'resize', /*dataRequest*/ l[23]),
              q(e, 'scroll', /*onScroll*/ l[22]),
              q(e, 'wheel', /*onWheel*/ l[24]),
            ]),
            (d = !0))
      },
      p(b, p) {
        /*markers*/ b[1].length
          ? m
            ? m.p(b, p)
            : ((m = Ts(b)), m.c(), m.m(e, t))
          : m && (m.d(1), (m = null)),
          /*holidays*/ b[11]
            ? _
              ? _.p(b, p)
              : ((_ = Ds(b)), _.c(), _.m(n, i))
            : _ && (_.d(1), (_ = null))
        const z = {}
        p[0] & /*cellBorders*/ 32 && (z.borders = /*cellBorders*/ b[5]),
          s.$set(z),
          /*$selected*/ b[8].length
            ? w
              ? w.p(b, p)
              : ((w = zs(b)), w.c(), w.m(n, a))
            : w && (w.d(1), (w = null))
        const T = {}
        p[0] & /*fullWidth*/ 4 && (T.width = /*fullWidth*/ b[2]),
          p[0] & /*fullHeight*/ 8 && (T.height = /*fullHeight*/ b[3]),
          r.$set(T)
        const W = {}
        p[0] & /*readonly*/ 1 && (W.readonly = /*readonly*/ b[0]),
          p[0] & /*taskTemplate*/ 16 && (W.taskTemplate = /*taskTemplate*/ b[4]),
          u.$set(W),
          (!f || p[0] & /*fullWidth*/ 4) && j(n, 'width', /*fullWidth*/ b[2] + 'px'),
          (!f || p[0] & /*fullHeight*/ 8) && j(n, 'height', /*fullHeight*/ b[3] + 'px')
      },
      i(b) {
        f || (k(s.$$.fragment, b), k(r.$$.fragment, b), k(u.$$.fragment, b), (f = !0))
      },
      o(b) {
        y(s.$$.fragment, b), y(r.$$.fragment, b), y(u.$$.fragment, b), (f = !1)
      },
      d(b) {
        b && v(e),
          m && m.d(),
          _ && _.d(),
          O(s),
          w && w.d(),
          O(r),
          O(u),
          l[32](null),
          (d = !1),
          Ee(h)
      },
    }
  )
}
let Es = 0
function Um(l, e, t) {
  let n,
    i,
    s,
    o,
    a,
    r,
    c,
    u,
    f,
    d,
    h,
    m,
    {readonly: _} = e,
    {markers: w} = e,
    {fullWidth: b} = e,
    {fullHeight: p} = e,
    {taskTemplate: z} = e,
    {cellBorders: T} = e,
    {highlightTime: W} = e
  const M = He(),
    C = ze('gantt-store'),
    {
      _selected: P,
      scrollLeft: X,
      scrollTop: A,
      cellWidth: B,
      cellHeight: V,
      _scales: fe,
      zoom: L,
      _start: Ye,
      context: G,
      _scrollSelected: pe,
    } = C.getReactiveState()
  ce(l, P, (E) => t(8, (f = E))),
    ce(l, X, (E) => t(31, (m = E))),
    ce(l, A, (E) => t(30, (h = E))),
    ce(l, B, (E) => t(38, (c = E))),
    ce(l, V, (E) => t(28, (r = E))),
    ce(l, fe, (E) => t(27, (s = E))),
    ce(l, L, (E) => t(36, (o = E))),
    ce(l, Ye, (E) => t(37, (a = E))),
    ce(l, G, (E) => t(39, (u = E))),
    ce(l, pe, (E) => t(29, (d = E)))
  let Se,
    K,
    ue = {},
    Ne = 0,
    ye = [],
    ve,
    Ze
  ht(() => {
    Me()
  }),
    kn(() => {
      t(6, (ue.scrollTop = K), ue),
        t(6, (ue.scrollLeft = Se), ue),
        K != ue.scrollTop && ge({top: !0}),
        Se != ue.scrollLeft && ge({left: !0})
    })
  function ie() {
    ge({left: !0, top: !0}, !0), Me()
  }
  function U(E) {
    M('scale-params', E || {date: Je(ue.scrollLeft)})
  }
  function ge(E, le) {
    const _e = {}
    E.top && (_e.top = ue.scrollTop),
      Ze && clearTimeout(Ze),
      E.left &&
        ((_e.left = ue.scrollLeft),
        le
          ? (Ze = setTimeout(function () {
              U()
            }, 100))
          : U()),
      C.exec('scroll-chart', _e)
  }
  function Me() {
    const E = ue.clientHeight || 0,
      le = Math.ceil(E / r) + 1,
      _e = Math.floor((ue.scrollTop || 0) / r),
      ke = Math.max(0, _e - Es),
      Pe = _e + le + Es,
      Be = ke * r
    // Request render for visible range
    C.exec('render-data', {start: ke, end: Pe, from: Be})
  }
  function Fe(E) {
    if (u) return
    const {clientHeight: le, clientWidth: _e} = ue
    if (E.$x < Se) t(9, (Se = E.$x - c))
    else if (E.$x + E.$w >= _e + Se) {
      const ke = _e < E.$w ? c : E.$w
      t(9, (Se = E.$x - _e + ke))
    }
    E.$y < K ? (K = E.$y - r) : E.$y + E.$h >= le + K && (K = E.$y - le + r)
  }
  function Je(E) {
    const le = s.lengthUnit === 'day' ? n / 24 : n
    return ft('hour')(bt(s.minUnit, a), Math.floor(E / le))
  }
  function J(E) {
    if (o && (E.ctrlKey || E.metaKey)) {
      E.preventDefault()
      const le = -Math.sign(E.deltaY),
        _e = E.clientX - ue.getBoundingClientRect().left,
        ke = _e + Se,
        Pe = Je(ke)
      U({offset: _e, date: Pe}), C.exec('zoom-scale', {dir: le, date: Pe, offset: _e})
    }
  }
  function oe(E) {
    const le = W(E.date, E.unit)
    return le ? {css: le, width: E.width} : null
  }
  function we(E) {
    be[E ? 'unshift' : 'push'](() => {
      ;(ue = E), t(6, ue)
    })
  }
  return (
    (l.$$set = (E) => {
      'readonly' in E && t(0, (_ = E.readonly)),
        'markers' in E && t(1, (w = E.markers)),
        'fullWidth' in E && t(2, (b = E.fullWidth)),
        'fullHeight' in E && t(3, (p = E.fullHeight)),
        'taskTemplate' in E && t(4, (z = E.taskTemplate)),
        'cellBorders' in E && t(5, (T = E.cellBorders)),
        'highlightTime' in E && t(25, (W = E.highlightTime))
    }),
    (l.$$.update = () => {
      if (
        (l.$$.dirty[0] & /*$scales*/ 134217728 && (n = s.lengthUnitWidth),
        l.$$.dirty[1] & /*$rScrollLeft*/ 1 && t(9, (Se = m)),
        l.$$.dirty[0] & /*$rScrollTop*/ 1073741824 && (K = h),
        l.$$.dirty[0] &
          /*$selected, $cellHeight, selectStyle, $scrollSelected, lastSelectedId*/ 872415616 &&
          f.length &&
          r &&
          (t(7, (ye = [])),
          f.forEach((E) => {
            ye.push([`height: ${r}px;top: ${E.$y - 3}px`])
          }),
          d))
      ) {
        const E = f[f.length - 1]
        ve !== E.id && (t(26, (ve = E.id)), Fe(E))
      }
      l.$$.dirty[0] & /*$cellHeight*/ 268435456 && r && Me(),
        l.$$.dirty[0] & /*fullHeight, chart*/ 72 &&
          t(10, (Ne = p > ue.clientHeight ? ue.clientHeight : p)),
        l.$$.dirty[0] & /*$scales, highlightTime*/ 167772160 &&
          t(
            11,
            (i =
              (s.minUnit === 'hour' || s.minUnit === 'day') && W
                ? s.rows[s.rows.length - 1].cells.map(oe)
                : null)
          )
    }),
    [
      _,
      w,
      b,
      p,
      z,
      T,
      ue,
      ye,
      f,
      Se,
      Ne,
      i,
      P,
      X,
      A,
      B,
      V,
      fe,
      L,
      Ye,
      G,
      pe,
      ie,
      Me,
      J,
      W,
      ve,
      s,
      r,
      d,
      h,
      m,
      we,
    ]
  )
}
class Jm extends ee {
  constructor(e) {
    super(),
      $(
        this,
        e,
        Um,
        Vm,
        x,
        {
          readonly: 0,
          markers: 1,
          fullWidth: 2,
          fullHeight: 3,
          taskTemplate: 4,
          cellBorders: 5,
          highlightTime: 25,
        },
        null,
        [-1, -1]
      )
  }
}
function Kn() {}
function Qm(l, e) {
  return l != l ? e == e : l !== e || (l && typeof l == 'object') || typeof l == 'function'
}
const Zt = []
function xm(l) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Kn
  let t
  const n = /* @__PURE__ */ new Set()
  function i(a) {
    if (Qm(l, a) && ((l = a), t)) {
      const r = !Zt.length
      for (const c of n) c[1](), Zt.push(c, l)
      if (r) {
        for (let c = 0; c < Zt.length; c += 2) Zt[c][0](Zt[c + 1])
        Zt.length = 0
      }
    }
  }
  function s(a) {
    i(a(l))
  }
  function o(a) {
    let r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Kn
    const c = [a, r]
    return (
      n.add(c),
      n.size === 1 && (t = e(i, s) || Kn),
      a(l),
      () => {
        n.delete(c), n.size === 0 && t && (t(), (t = null))
      }
    )
  }
  return {set: i, update: s, subscribe: o}
}
/* @__PURE__ */ new Date().valueOf()
function $m(l, e) {
  if (Object.keys(l).length !== Object.keys(e).length) return !1
  for (const t in e) {
    const n = l[t],
      i = e[t]
    if (!Ln(n, i)) return !1
  }
  return !0
}
function Ln(l, e) {
  if (typeof l == 'number' || typeof l == 'string' || typeof l == 'boolean' || l === null)
    return l === e
  if (
    typeof l != typeof e ||
    ((l === null || e === null) && l !== e) ||
    (l instanceof Date && e instanceof Date && l.getTime() !== e.getTime())
  )
    return !1
  if (typeof l == 'object')
    if (Array.isArray(l) && Array.isArray(e)) {
      if (l.length !== e.length) return !1
      for (let n = l.length - 1; n >= 0; n--) if (!Ln(l[n], e[n])) return !1
      return !0
    } else return $m(l, e)
  return l === e
}
function Tn(l, e) {
  return {...l}
}
function e1(l, e, t) {
  let n = !1
  const i = xm(l),
    {set: s} = i
  let o = Tn(l)
  return (
    (i.set = function (a) {
      Ln(o, a) || ((o = Tn(a)), s(a))
    }),
    (i.update = function (a) {
      const r = a(Tn(o))
      Ln(o, r) || ((o = Tn(r)), s(r))
    }),
    (i.reset = function (a) {
      ;(n = !1), (o = {}), i.set(a)
    }),
    i.subscribe((a) => {
      n ? a && e(a) : (n = !0)
    }),
    i
  )
}
function t1(l) {
  let e, t, n, i, s, o, a, r, c, u, f, d
  return {
    c() {
      ;(e = D('div')),
        (t = D('label')),
        (n = re(/*label*/ l[1])),
        (i = Y()),
        (s = D('div')),
        (o = D('button')),
        (o.innerHTML =
          '<svg class="wx-dec x2-1nc55he" width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2501 1.74994H0.750092V0.249939H11.2501V1.74994Z"></path></svg>'),
        (a = Y()),
        (r = D('input')),
        (c = Y()),
        (u = D('button')),
        (u.innerHTML = `<svg class="wx-inc x2-1nc55he" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2501
					6.74994H6.75009V11.2499H5.25009V6.74994H0.750092V5.24994H5.25009V0.749939H6.75009V5.24994H11.2501V6.74994Z"></path></svg>`),
        g(t, 'class', 'wx-label x2-1nc55he'),
        g(t, 'for', /*id*/ l[7]),
        g(o, 'class', 'wx-btn wx-btn-dec x2-1nc55he'),
        g(r, 'id', /*id*/ l[7]),
        g(r, 'type', 'text'),
        g(r, 'class', 'wx-input x2-1nc55he'),
        (r.required = !0),
        Q(r, 'wx-error', /*error*/ l[2]),
        g(u, 'class', 'wx-btn wx-btn-inc x2-1nc55he'),
        g(s, 'class', 'wx-controls x2-1nc55he'),
        g(e, 'class', 'wx-counter x2-1nc55he')
    },
    m(h, m) {
      S(h, e, m),
        H(e, t),
        H(t, n),
        H(e, i),
        H(e, s),
        H(s, o),
        H(s, a),
        H(s, r),
        Ue(r, /*value*/ l[0]),
        H(s, c),
        H(s, u),
        f ||
          ((d = [
            q(o, 'click', /*dec*/ l[3]),
            q(r, 'input', /*input_1_input_handler*/ l[11]),
            q(r, 'blur', /*blur*/ l[5]),
            q(r, 'input', /*input*/ l[6]),
            q(u, 'click', /*inc*/ l[4]),
          ]),
          (f = !0))
    },
    p(h, _ref75) {
      let [m] = _ref75
      m & /*label*/ 2 && me(n, /*label*/ h[1]),
        m & /*value*/ 1 && r.value !== /*value*/ h[0] && Ue(r, /*value*/ h[0]),
        m & /*error*/ 4 && Q(r, 'wx-error', /*error*/ h[2])
    },
    i: I,
    o: I,
    d(h) {
      h && v(e), (f = !1), Ee(d)
    },
  }
}
function n1(l, e, t) {
  let {label: n = ''} = e,
    {value: i = 0} = e,
    {step: s = 1} = e,
    {min: o = 1} = e,
    {max: a = 1 / 0} = e
  const r = He(),
    c = new RegExp('^[0-9]+$')
  let u = !1
  function f() {
    i <= o || (t(0, (i -= s)), r('change', {value: i}))
  }
  function d() {
    i >= a || (t(0, (i += s)), r('change', {value: i}))
  }
  function h() {
    const b = Math.round(Math.min(a, Math.max(i, o)) / s) * s
    t(0, (i = isNaN(b) ? 0 : b))
  }
  function m(b) {
    let p = b.target.value
    c.test(p) ? (t(2, (u = !1)), r('change', {value: p * 1})) : t(2, (u = !0))
  }
  const _ = Yc()
  function w() {
    ;(i = this.value), t(0, i)
  }
  return (
    (l.$$set = (b) => {
      'label' in b && t(1, (n = b.label)),
        'value' in b && t(0, (i = b.value)),
        'step' in b && t(8, (s = b.step)),
        'min' in b && t(9, (o = b.min)),
        'max' in b && t(10, (a = b.max))
    }),
    [i, n, u, f, d, h, m, _, s, o, a, w]
  )
}
class l1 extends ee {
  constructor(e) {
    super(), $(this, e, n1, t1, x, {label: 1, value: 0, step: 8, min: 9, max: 10})
  }
}
function Is(l, e, t) {
  const n = l.slice()
  return (n[6] = e[t]), n
}
function Rs(l, e, t) {
  const n = l.slice()
  return (n[13] = e[t]), n
}
function Os(l) {
  let e, t, n, i
  return (
    (t = new Ot({
      props: {
        label: /*links*/ l[6].title,
        position: 'top',
        $$slots: {default: [s1]},
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        ;(e = D('div')), F(t.$$.fragment), (n = Y()), g(e, 'class', 'wx-links x2-8406i3')
      },
      m(s, o) {
        S(s, e, o), R(t, e, null), H(e, n), (i = !0)
      },
      p(s, o) {
        const a = {}
        o & /*linksData*/ 1 && (a.label = /*links*/ s[6].title),
          o & /*$$scope, linksData*/ 131073 && (a.$$scope = {dirty: o, ctx: s}),
          t.$set(a)
      },
      i(s) {
        i || (k(t.$$.fragment, s), (i = !0))
      },
      o(s) {
        y(t.$$.fragment, s), (i = !1)
      },
      d(s) {
        s && v(e), O(t)
      },
    }
  )
}
function i1(l) {
  let e = /*option*/ l[16].label + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*option*/ 65536 && e !== (e = /*option*/ n[16].label + '') && me(t, e)
    },
    d(n) {
      n && v(t)
    },
  }
}
function As(l) {
  let e,
    t,
    n,
    i = /*obj*/ (l[13].task.text || '') + '',
    s,
    o,
    a,
    r,
    c,
    u,
    f,
    d,
    h,
    m,
    _
  function w() {
    for (var _len3 = arguments.length, b = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      b[_key3] = arguments[_key3]
    }
    return /*select_handler*/ l[9](/*obj*/ l[13], ...b)
  }
  return (
    (c = new go({
      props: {
        value: /*obj*/ l[13].link.type,
        placeholder: /*_*/ l[1]('Select link type'),
        options: /*list*/ l[3],
        $$slots: {
          default: [
            i1,
            (_ref76) => {
              let {option: b} = _ref76
              return {16: b}
            },
            (_ref77) => {
              let {option: b} = _ref77
              return b ? 65536 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    c.$on('select', w),
    {
      c() {
        ;(e = D('tr')),
          (t = D('td')),
          (n = D('div')),
          (s = re(i)),
          (o = Y()),
          (a = D('td')),
          (r = D('div')),
          F(c.$$.fragment),
          (u = Y()),
          (f = D('td')),
          (d = D('i')),
          (m = Y()),
          g(n, 'class', 'wx-task-name x2-8406i3'),
          g(t, 'class', 'wx-cell x2-8406i3'),
          g(r, 'class', 'wx-wrapper x2-8406i3'),
          g(a, 'class', 'wx-cell x2-8406i3'),
          g(d, 'class', 'wxi-delete wx-delete-icon x2-8406i3'),
          g(d, 'data-action', 'delete-link'),
          g(d, 'data-id', (h = /*obj*/ l[13].link.id)),
          g(f, 'class', 'wx-cell x2-8406i3')
      },
      m(b, p) {
        S(b, e, p),
          H(e, t),
          H(t, n),
          H(n, s),
          H(e, o),
          H(e, a),
          H(a, r),
          R(c, r, null),
          H(e, u),
          H(e, f),
          H(f, d),
          H(e, m),
          (_ = !0)
      },
      p(b, p) {
        ;(l = b),
          (!_ || p & /*linksData*/ 1) &&
            i !== (i = /*obj*/ (l[13].task.text || '') + '') &&
            me(s, i)
        const z = {}
        p & /*linksData*/ 1 && (z.value = /*obj*/ l[13].link.type),
          p & /*$$scope, option*/ 196608 && (z.$$scope = {dirty: p, ctx: l}),
          c.$set(z),
          (!_ || (p & /*linksData*/ 1 && h !== (h = /*obj*/ l[13].link.id))) && g(d, 'data-id', h)
      },
      i(b) {
        _ || (k(c.$$.fragment, b), (_ = !0))
      },
      o(b) {
        y(c.$$.fragment, b), (_ = !1)
      },
      d(b) {
        b && v(e), O(c)
      },
    }
  )
}
function s1(l) {
  let e,
    t,
    n,
    i,
    s = de(/*links*/ l[6].data),
    o = []
  for (let r = 0; r < s.length; r += 1) o[r] = As(Rs(l, s, r))
  const a = (r) =>
    y(o[r], 1, 1, () => {
      o[r] = null
    })
  return {
    c() {
      e = D('table')
      for (let r = 0; r < o.length; r += 1) o[r].c()
    },
    m(r, c) {
      S(r, e, c)
      for (let u = 0; u < o.length; u += 1) o[u] && o[u].m(e, null)
      ;(t = !0), n || ((i = q(e, 'click', /*onClick*/ l[4])), (n = !0))
    },
    p(r, c) {
      if (c & /*linksData, _, list, onSelect, option*/ 65579) {
        s = de(/*links*/ r[6].data)
        let u
        for (u = 0; u < s.length; u += 1) {
          const f = Rs(r, s, u)
          o[u]
            ? (o[u].p(f, c), k(o[u], 1))
            : ((o[u] = As(f)), o[u].c(), k(o[u], 1), o[u].m(e, null))
        }
        for (te(), u = s.length; u < o.length; u += 1) a(u)
        ne()
      }
    },
    i(r) {
      if (!t) {
        for (let c = 0; c < s.length; c += 1) k(o[c])
        t = !0
      }
    },
    o(r) {
      o = o.filter(Boolean)
      for (let c = 0; c < o.length; c += 1) y(o[c])
      t = !1
    },
    d(r) {
      r && v(e), $e(o, r), (n = !1), i()
    },
  }
}
function Fs(l) {
  let e,
    t,
    n = /*links*/ l[6].data.length && Os(l)
  return {
    c() {
      n && n.c(), (e = se())
    },
    m(i, s) {
      n && n.m(i, s), S(i, e, s), (t = !0)
    },
    p(i, s) {
      /*links*/ i[6].data.length
        ? n
          ? (n.p(i, s), s & /*linksData*/ 1 && k(n, 1))
          : ((n = Os(i)), n.c(), k(n, 1), n.m(e.parentNode, e))
        : n &&
          (te(),
          y(n, 1, 1, () => {
            n = null
          }),
          ne())
    },
    i(i) {
      t || (k(n), (t = !0))
    },
    o(i) {
      y(n), (t = !1)
    },
    d(i) {
      i && v(e), n && n.d(i)
    },
  }
}
function o1(l) {
  let e,
    t,
    n = de(/*linksData*/ l[0]),
    i = []
  for (let o = 0; o < n.length; o += 1) i[o] = Fs(Is(l, n, o))
  const s = (o) =>
    y(i[o], 1, 1, () => {
      i[o] = null
    })
  return {
    c() {
      for (let o = 0; o < i.length; o += 1) i[o].c()
      e = se()
    },
    m(o, a) {
      for (let r = 0; r < i.length; r += 1) i[r] && i[r].m(o, a)
      S(o, e, a), (t = !0)
    },
    p(o, _ref78) {
      let [a] = _ref78
      if (a & /*linksData, onClick, _, list, onSelect, option*/ 65595) {
        n = de(/*linksData*/ o[0])
        let r
        for (r = 0; r < n.length; r += 1) {
          const c = Is(o, n, r)
          i[r]
            ? (i[r].p(c, a), k(i[r], 1))
            : ((i[r] = Fs(c)), i[r].c(), k(i[r], 1), i[r].m(e.parentNode, e))
        }
        for (te(), r = n.length; r < i.length; r += 1) s(r)
        ne()
      }
    },
    i(o) {
      if (!t) {
        for (let a = 0; a < n.length; a += 1) k(i[a])
        t = !0
      }
    },
    o(o) {
      i = i.filter(Boolean)
      for (let a = 0; a < i.length; a += 1) y(i[a])
      t = !1
    },
    d(o) {
      o && v(e), $e(i, o)
    },
  }
}
function r1(l, e, t) {
  let n, i
  const s = ze('wx-i18n').getGroup('gantt'),
    o = ze('gantt-store'),
    {_activeTask: a, _links: r} = o.getReactiveState()
  ce(l, a, (m) => t(7, (n = m))), ce(l, r, (m) => t(8, (i = m)))
  let c
  const u = [
    {id: 'e2s', label: s('End-to-start')},
    {id: 's2s', label: s('Start-to-start')},
    {id: 'e2e', label: s('End-to-end')},
    {id: 's2e', label: s('Start-to-end')},
  ]
  function f(m) {
    const {action: _, id: w} = m.target.dataset
    _ && o.exec(_, {id: w})
  }
  function d(m, _) {
    const w = m.detail.selected.id
    o.exec('update-link', {id: _, link: {type: w}})
  }
  const h = (m, _) => d(_, m.link.id)
  return (
    (l.$$.update = () => {
      if (l.$$.dirty & /*$task, $links*/ 384 && n) {
        const m = i
            .filter((w) => w.target == n.id)
            .map((w) => ({link: w, task: o.getTask(w.source)})),
          _ = i.filter((w) => w.source == n.id).map((w) => ({link: w, task: o.getTask(w.target)}))
        t(
          0,
          (c = [
            {title: s('Predecessors'), data: m},
            {title: s('Successors'), data: _},
          ])
        )
      }
    }),
    [c, s, a, u, f, d, r, n, i, h]
  )
}
class a1 extends ee {
  constructor(e) {
    super(), $(this, e, r1, o1, x, {})
  }
}
function Ps(l, e, t) {
  const n = l.slice()
  return (n[19] = e[t]), (n[20] = e), (n[21] = t), n
}
function c1(l) {
  let e = /*_*/ l[5]('Delete') + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p: I,
    d(n) {
      n && v(t)
    },
  }
}
function u1(l) {
  let e = /*_*/ l[5]('Save') + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p: I,
    d(n) {
      n && v(t)
    },
  }
}
function f1(l) {
  let e, t
  return (
    (e = new a1({})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p: I,
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function d1(l) {
  let e, t
  return (
    (e = new Ot({
      props: {
        label:
          `${/*_*/ l[5](/*field*/ l[19].label)} ${/*$tdata*/ l[4][/*field*/ l[19].key]}%` || '',
        position: 'top',
        $$slots: {default: [b1]},
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*editorShape, $tdata*/ 18 &&
          (s.label =
            `${/*_*/ n[5](/*field*/ n[19].label)} ${/*$tdata*/ n[4][/*field*/ n[19].key]}%` || ''),
          i & /*$$scope, $tdata, editorShape*/ 16777234 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function h1(l) {
  let e, t
  return (
    (e = new Ot({
      props: {
        label: /*_*/ l[5](/*field*/ l[19].label) || '',
        position: 'top',
        $$slots: {default: [k1]},
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*editorShape*/ 2 && (s.label = /*_*/ n[5](/*field*/ n[19].label) || ''),
          i & /*$$scope, $tdata, editorShape*/ 16777234 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function m1(l) {
  let e, t
  return (
    (e = new Ot({
      props: {
        label: /*_*/ l[5](/*field*/ l[19].label) || '',
        position: 'top',
        $$slots: {
          default: [
            p1,
            (_ref79) => {
              let {id: n} = _ref79
              return {22: n}
            },
            (_ref80) => {
              let {id: n} = _ref80
              return n ? 4194304 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*editorShape*/ 2 && (s.label = /*_*/ n[5](/*field*/ n[19].label) || ''),
          i & /*$$scope, id, editorShape, $tdata*/ 20971538 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function _1(l) {
  let e, t
  return (
    (e = new Ot({
      props: {
        label: /*_*/ l[5](/*field*/ l[19].label) || '',
        position: 'top',
        $$slots: {
          default: [
            v1,
            (_ref81) => {
              let {id: n} = _ref81
              return {22: n}
            },
            (_ref82) => {
              let {id: n} = _ref82
              return n ? 4194304 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*editorShape*/ 2 && (s.label = /*_*/ n[5](/*field*/ n[19].label) || ''),
          i & /*$$scope, id, editorShape, $tdata*/ 20971538 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function g1(l) {
  let e, t
  return (
    (e = new Ot({
      props: {
        label: /*_*/ l[5](/*field*/ l[19].label) || '',
        position: 'top',
        $$slots: {
          default: [
            S1,
            (_ref83) => {
              let {id: n} = _ref83
              return {22: n}
            },
            (_ref84) => {
              let {id: n} = _ref84
              return n ? 4194304 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*editorShape*/ 2 && (s.label = /*_*/ n[5](/*field*/ n[19].label) || ''),
          i & /*$$scope, id, $tdata, editorShape*/ 20971538 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function w1(l) {
  let e, t
  return (
    (e = new Ot({
      props: {
        label: /*_*/ l[5](/*field*/ l[19].label) || '',
        position: 'top',
        $$slots: {
          default: [
            M1,
            (_ref85) => {
              let {id: n} = _ref85
              return {22: n}
            },
            (_ref86) => {
              let {id: n} = _ref86
              return n ? 4194304 : 0
            },
          ],
        },
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*editorShape*/ 2 && (s.label = /*_*/ n[5](/*field*/ n[19].label) || ''),
          i & /*$$scope, id, editorShape, $tdata*/ 20971538 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function b1(l) {
  let e, t, n
  const i = [{value: /*$tdata*/ l[4][/*field*/ l[19].key]}, /*field*/ l[19].config]
  let s = {}
  for (let o = 0; o < i.length; o += 1) s = We(s, i[o])
  return (
    (e = new hc({props: s})),
    e.$on('change', /*onProgressChange*/ l[11]),
    {
      c() {
        F(e.$$.fragment), (t = Y())
      },
      m(o, a) {
        R(e, o, a), S(o, t, a), (n = !0)
      },
      p(o, a) {
        const r =
          a & /*$tdata, editorShape*/ 18
            ? Ut(i, [
                {value: /*$tdata*/ o[4][/*field*/ o[19].key]},
                a & /*editorShape*/ 2 && Jt(/*field*/ o[19].config),
              ])
            : {}
        e.$set(r)
      },
      i(o) {
        n || (k(e.$$.fragment, o), (n = !0))
      },
      o(o) {
        y(e.$$.fragment, o), (n = !1)
      },
      d(o) {
        o && v(t), O(e, o)
      },
    }
  )
}
function k1(l) {
  let e, t, n
  return (
    (e = new l1({props: {value: /*$tdata*/ l[4][/*field*/ l[19].key]}})),
    e.$on('change', /*onDurationChange*/ l[10]),
    {
      c() {
        F(e.$$.fragment), (t = Y())
      },
      m(i, s) {
        R(e, i, s), S(i, t, s), (n = !0)
      },
      p(i, s) {
        const o = {}
        s & /*$tdata, editorShape*/ 18 && (o.value = /*$tdata*/ i[4][/*field*/ i[19].key]),
          e.$set(o)
      },
      i(i) {
        n || (k(e.$$.fragment, i), (n = !0))
      },
      o(i) {
        y(e.$$.fragment, i), (n = !1)
      },
      d(i) {
        i && v(t), O(e, i)
      },
    }
  )
}
function p1(l) {
  let e, t, n, i
  const s = [
    {id: /*id*/ l[22]},
    /*field*/ l[19].config,
    {placeholder: /*_*/ l[5](/*field*/ l[19].config.placeholder)},
  ]
  function o(r) {
    l[16](r, /*field*/ l[19])
  }
  let a = {}
  for (let r = 0; r < s.length; r += 1) a = We(a, s[r])
  return (
    /*$tdata*/ l[4][/*field*/ l[19].key] !== void 0 &&
      (a.value = /*$tdata*/ l[4][/*field*/ l[19].key]),
    (e = new $r({props: a})),
    be.push(() => rt(e, 'value', o)),
    {
      c() {
        F(e.$$.fragment), (n = Y())
      },
      m(r, c) {
        R(e, r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        l = r
        const u =
          c & /*id, editorShape, _*/ 4194338
            ? Ut(s, [
                c & /*id*/ 4194304 && {id: /*id*/ l[22]},
                c & /*editorShape*/ 2 && Jt(/*field*/ l[19].config),
                c & /*_, editorShape*/ 34 && {
                  placeholder: /*_*/ l[5](/*field*/ l[19].config.placeholder),
                },
              ])
            : {}
        !t &&
          c & /*$tdata, editorShape*/ 18 &&
          ((t = !0), (u.value = /*$tdata*/ l[4][/*field*/ l[19].key]), dt(() => (t = !1))),
          e.$set(u)
      },
      i(r) {
        i || (k(e.$$.fragment, r), (i = !0))
      },
      o(r) {
        y(e.$$.fragment, r), (i = !1)
      },
      d(r) {
        r && v(n), O(e, r)
      },
    }
  )
}
function y1(l) {
  let e = /*option*/ l[23].label + '',
    t
  return {
    c() {
      t = re(e)
    },
    m(n, i) {
      S(n, t, i)
    },
    p(n, i) {
      i & /*option*/ 8388608 && e !== (e = /*option*/ n[23].label + '') && me(t, e)
    },
    d(n) {
      n && v(t)
    },
  }
}
function v1(l) {
  let e, t, n, i
  const s = [
    {id: /*id*/ l[22]},
    {placeholder: /*_*/ l[5]('Select type')},
    {options: /*field*/ l[19].options},
    /*field*/ l[19].config,
    {title: ''},
  ]
  function o(r) {
    l[15](r, /*field*/ l[19])
  }
  let a = {
    $$slots: {
      default: [
        y1,
        (_ref87) => {
          let {option: r} = _ref87
          return {23: r}
        },
        (_ref88) => {
          let {option: r} = _ref88
          return r ? 8388608 : 0
        },
      ],
    },
    $$scope: {ctx: l},
  }
  for (let r = 0; r < s.length; r += 1) a = We(a, s[r])
  return (
    /*$tdata*/ l[4][/*field*/ l[19].key] !== void 0 &&
      (a.value = /*$tdata*/ l[4][/*field*/ l[19].key]),
    (e = new go({props: a})),
    be.push(() => rt(e, 'value', o)),
    {
      c() {
        F(e.$$.fragment), (n = Y())
      },
      m(r, c) {
        R(e, r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        l = r
        const u =
          c & /*id, _, editorShape*/ 4194338
            ? Ut(s, [
                c & /*id*/ 4194304 && {id: /*id*/ l[22]},
                c & /*_*/ 32 && {placeholder: /*_*/ l[5]('Select type')},
                c & /*editorShape*/ 2 && {options: /*field*/ l[19].options},
                c & /*editorShape*/ 2 && Jt(/*field*/ l[19].config),
                s[4],
              ])
            : {}
        c & /*$$scope, option*/ 25165824 && (u.$$scope = {dirty: c, ctx: l}),
          !t &&
            c & /*$tdata, editorShape*/ 18 &&
            ((t = !0), (u.value = /*$tdata*/ l[4][/*field*/ l[19].key]), dt(() => (t = !1))),
          e.$set(u)
      },
      i(r) {
        i || (k(e.$$.fragment, r), (i = !0))
      },
      o(r) {
        y(e.$$.fragment, r), (i = !1)
      },
      d(r) {
        r && v(n), O(e, r)
      },
    }
  )
}
function S1(l) {
  let e, t, n, i, s
  function o(r) {
    l[14](r, /*field*/ l[19])
  }
  let a = {id: /*id*/ l[22]}
  return (
    /*$tdata*/ l[4][/*field*/ l[19].key] !== void 0 &&
      (a.value = /*$tdata*/ l[4][/*field*/ l[19].key]),
    (t = new uc({props: a})),
    be.push(() => rt(t, 'value', o)),
    {
      c() {
        ;(e = D('div')), F(t.$$.fragment), (i = Y()), g(e, 'class', 'input_wrapper')
      },
      m(r, c) {
        S(r, e, c), R(t, e, null), S(r, i, c), (s = !0)
      },
      p(r, c) {
        l = r
        const u = {}
        c & /*id*/ 4194304 && (u.id = /*id*/ l[22]),
          !n &&
            c & /*$tdata, editorShape*/ 18 &&
            ((n = !0), (u.value = /*$tdata*/ l[4][/*field*/ l[19].key]), dt(() => (n = !1))),
          t.$set(u)
      },
      i(r) {
        s || (k(t.$$.fragment, r), (s = !0))
      },
      o(r) {
        y(t.$$.fragment, r), (s = !1)
      },
      d(r) {
        r && (v(e), v(i)), O(t)
      },
    }
  )
}
function M1(l) {
  let e, t, n, i
  const s = [
    {id: /*id*/ l[22]},
    /*field*/ l[19].config,
    {placeholder: /*_*/ l[5](/*field*/ l[19].config.placeholder)},
  ]
  function o(r) {
    l[13](r, /*field*/ l[19])
  }
  let a = {}
  for (let r = 0; r < s.length; r += 1) a = We(a, s[r])
  return (
    /*$tdata*/ l[4][/*field*/ l[19].key] !== void 0 &&
      (a.value = /*$tdata*/ l[4][/*field*/ l[19].key]),
    (e = new wo({props: a})),
    be.push(() => rt(e, 'value', o)),
    {
      c() {
        F(e.$$.fragment), (n = Y())
      },
      m(r, c) {
        R(e, r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        l = r
        const u =
          c & /*id, editorShape, _*/ 4194338
            ? Ut(s, [
                c & /*id*/ 4194304 && {id: /*id*/ l[22]},
                c & /*editorShape*/ 2 && Jt(/*field*/ l[19].config),
                c & /*_, editorShape*/ 34 && {
                  placeholder: /*_*/ l[5](/*field*/ l[19].config.placeholder),
                },
              ])
            : {}
        !t &&
          c & /*$tdata, editorShape*/ 18 &&
          ((t = !0), (u.value = /*$tdata*/ l[4][/*field*/ l[19].key]), dt(() => (t = !1))),
          e.$set(u)
      },
      i(r) {
        i || (k(e.$$.fragment, r), (i = !0))
      },
      o(r) {
        y(e.$$.fragment, r), (i = !1)
      },
      d(r) {
        r && v(n), O(e, r)
      },
    }
  )
}
function Ys(l) {
  let e, t, n, i
  const s = [w1, g1, _1, m1, h1, d1, f1],
    o = []
  function a(r, c) {
    return /*field*/ r[19].type === 'text'
      ? 0
      : /*field*/ r[19].type === 'date' &&
        (!(/*milestone*/ r[3]) ||
          /*field*/ (r[19].key !== 'end' && /*field*/ r[19].key !== 'base_end')) &&
        !(/*summary*/ r[2])
      ? 1
      : /*field*/ r[19].type === 'select' && /*field*/ r[19].options.length > 1
      ? 2
      : /*field*/ r[19].type === 'textarea'
      ? 3
      : /*field*/ r[19].type === 'counter' && !(/*summary*/ r[2]) && !(/*milestone*/ r[3])
      ? 4
      : /*field*/ r[19].type === 'slider' && !(/*milestone*/ r[3])
      ? 5
      : /*field*/ r[19].type === 'links'
      ? 6
      : -1
  }
  return (
    ~(e = a(l)) && (t = o[e] = s[e](l)),
    {
      c() {
        t && t.c(), (n = se())
      },
      m(r, c) {
        ~e && o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        let u = e
        ;(e = a(r)),
          e === u
            ? ~e && o[e].p(r, c)
            : (t &&
                (te(),
                y(o[u], 1, 1, () => {
                  o[u] = null
                }),
                ne()),
              ~e
                ? ((t = o[e]),
                  t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
                  k(t, 1),
                  t.m(n.parentNode, n))
                : (t = null))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), ~e && o[e].d(r)
      },
    }
  )
}
function T1(l) {
  let e, t, n, i, s, o, a, r, c, u, f, d, h
  ;(o = new mn({
    props: {
      type: 'danger',
      click: /*deleteTask*/ l[8],
      $$slots: {default: [c1]},
      $$scope: {ctx: l},
    },
  })),
    (r = new mn({
      props: {type: 'primary', click: /*hide*/ l[9], $$slots: {default: [u1]}, $$scope: {ctx: l}},
    }))
  let m = de(/*editorShape*/ l[1]),
    _ = []
  for (let b = 0; b < m.length; b += 1) _[b] = Ys(Ps(l, m, b))
  const w = (b) =>
    y(_[b], 1, 1, () => {
      _[b] = null
    })
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        (n = D('i')),
        (i = Y()),
        (s = D('div')),
        F(o.$$.fragment),
        (a = Y()),
        F(r.$$.fragment),
        (c = Y()),
        (u = D('div'))
      for (let b = 0; b < _.length; b += 1) _[b].c()
      g(n, 'class', 'wxi-close x2-j8yl6f'),
        g(t, 'class', 'wx-header x2-j8yl6f'),
        g(u, 'class', 'wx-form x2-j8yl6f'),
        g(e, 'class', 'wx-sidebar x2-j8yl6f'),
        Q(e, 'wx-compact', /*compactMode*/ l[0])
    },
    m(b, p) {
      S(b, e, p),
        H(e, t),
        H(t, n),
        H(t, i),
        H(t, s),
        R(o, s, null),
        H(s, a),
        R(r, s, null),
        H(e, c),
        H(e, u)
      for (let z = 0; z < _.length; z += 1) _[z] && _[z].m(u, null)
      ;(f = !0), d || ((h = q(n, 'click', /*hide*/ l[9])), (d = !0))
    },
    p(b, _ref89) {
      let [p] = _ref89
      const z = {}
      p & /*$$scope*/ 16777216 && (z.$$scope = {dirty: p, ctx: b}), o.$set(z)
      const T = {}
      if (
        (p & /*$$scope*/ 16777216 && (T.$$scope = {dirty: p, ctx: b}),
        r.$set(T),
        p &
          /*_, editorShape, id, $tdata, milestone, summary, option, onDurationChange, onProgressChange*/ 12586046)
      ) {
        m = de(/*editorShape*/ b[1])
        let W
        for (W = 0; W < m.length; W += 1) {
          const M = Ps(b, m, W)
          _[W]
            ? (_[W].p(M, p), k(_[W], 1))
            : ((_[W] = Ys(M)), _[W].c(), k(_[W], 1), _[W].m(u, null))
        }
        for (te(), W = m.length; W < _.length; W += 1) w(W)
        ne()
      }
      ;(!f || p & /*compactMode*/ 1) && Q(e, 'wx-compact', /*compactMode*/ b[0])
    },
    i(b) {
      if (!f) {
        k(o.$$.fragment, b), k(r.$$.fragment, b)
        for (let p = 0; p < m.length; p += 1) k(_[p])
        f = !0
      }
    },
    o(b) {
      y(o.$$.fragment, b), y(r.$$.fragment, b), (_ = _.filter(Boolean))
      for (let p = 0; p < _.length; p += 1) y(_[p])
      f = !1
    },
    d(b) {
      b && v(e), O(o), O(r), $e(_, b), (d = !1), h()
    },
  }
}
function C1(l, e, t) {
  let n,
    i,
    s,
    o,
    {compactMode: a} = e,
    {editorShape: r} = e
  const c = ze('wx-i18n').getGroup('gantt'),
    u = ze('gantt-store'),
    f = u.getReactiveState()._activeTask
  ce(l, f, (M) => t(12, (s = M)))
  let d = e1({}, (M) => {
    M.start && M.end && (M.start >= M.end ? (M.end = null) : (M.duration = null)),
      M.base_start &&
        M.base_end &&
        (M.base_start >= M.base_end ? (M.base_end = null) : (M.base_duration = null)),
      u.exec('update-task', {id: s.id, task: M, inProgress: w})
  })
  ce(l, d, (M) => t(4, (o = M)))
  function h() {
    u.exec('delete-task', {id: s.id}), m()
  }
  function m() {
    u.exec('show-editor', {id: null})
  }
  function _(M) {
    d.update((C) => ((C.duration = M.detail.value), (C.end = null), (C.start = s.start), C))
  }
  let w = !1
  function b(M) {
    ;(w = M.detail.input),
      w
        ? d.update((C) => ((C.progress = M.detail.value), C))
        : u.exec('update-task', {id: s.id, task: {...s, progress: M.detail.value}})
  }
  function p(M, C) {
    l.$$.not_equal(o[C.key], M) && ((o[C.key] = M), d.set(o))
  }
  function z(M, C) {
    l.$$.not_equal(o[C.key], M) && ((o[C.key] = M), d.set(o))
  }
  function T(M, C) {
    l.$$.not_equal(o[C.key], M) && ((o[C.key] = M), d.set(o))
  }
  function W(M, C) {
    l.$$.not_equal(o[C.key], M) && ((o[C.key] = M), d.set(o))
  }
  return (
    (l.$$set = (M) => {
      'compactMode' in M && t(0, (a = M.compactMode)),
        'editorShape' in M && t(1, (r = M.editorShape))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*$task*/ 4096 && d.reset({...s}),
        l.$$.dirty & /*$task*/ 4096 && t(3, (n = s?.type === 'milestone')),
        l.$$.dirty & /*$task*/ 4096 && t(2, (i = s?.type === 'summary'))
    }),
    [a, r, i, n, o, c, f, d, h, m, _, b, s, p, z, T, W]
  )
}
class D1 extends ee {
  constructor(e) {
    super(), $(this, e, C1, T1, x, {compactMode: 0, editorShape: 1})
  }
}
function Bs(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')), g(e, 'class', (t = 'wx-button-icon ' + /*icon*/ l[1] + ' x2-npj3j5'))
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*icon*/ 2 &&
        t !== (t = 'wx-button-icon ' + /*icon*/ n[1] + ' x2-npj3j5') &&
        g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function W1(l) {
  let e,
    t,
    n,
    i,
    s = /*icon*/ l[1] && Bs(l)
  return {
    c() {
      ;(e = D('button')),
        s && s.c(),
        g(e, 'class', (t = 'wx-button ' + /*appearance*/ l[0] + ' x2-npj3j5'))
    },
    m(o, a) {
      S(o, e, a), s && s.m(e, null), n || ((i = q(e, 'click', /*click_handler*/ l[3])), (n = !0))
    },
    p(o, _ref90) {
      let [a] = _ref90
      /*icon*/ o[1]
        ? s
          ? s.p(o, a)
          : ((s = Bs(o)), s.c(), s.m(e, null))
        : s && (s.d(1), (s = null)),
        a & /*appearance*/ 1 &&
          t !== (t = 'wx-button ' + /*appearance*/ o[0] + ' x2-npj3j5') &&
          g(e, 'class', t)
    },
    i: I,
    o: I,
    d(o) {
      o && v(e), s && s.d(), (n = !1), i()
    },
  }
}
function H1(l, e, t) {
  const n = He()
  let {appearance: i = 'primary'} = e,
    {icon: s = ''} = e
  const o = () => n('click')
  return (
    (l.$$set = (a) => {
      'appearance' in a && t(0, (i = a.appearance)), 'icon' in a && t(1, (s = a.icon))
    }),
    [i, s, n, o]
  )
}
class ar extends ee {
  constructor(e) {
    super(), $(this, e, H1, W1, x, {appearance: 0, icon: 1})
  }
}
function z1(l) {
  let e, t, n, i, s
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        g(t, 'class', 'wx-resizer-line x2-1myw878'),
        g(e, 'class', (n = 'wx-resizer wx-resizer-' + /*dir*/ l[0] + ' x2-1myw878')),
        j(e, 'left', /*b*/ l[2].p[0]),
        j(e, 'top', /*b*/ l[2].p[1]),
        j(e, 'width', /*b*/ l[2].size[0]),
        j(e, 'height', /*b*/ l[2].size[1]),
        j(e, 'right', /*b*/ l[2].p2[0]),
        j(e, 'bottom', /*b*/ l[2].p2[1]),
        j(e, 'cursor', /*cursor*/ l[1]),
        Q(e, 'wx-resizer-active', /*active*/ l[3])
    },
    m(o, a) {
      S(o, e, a), H(e, t), i || ((s = q(e, 'mousedown', /*down*/ l[4])), (i = !0))
    },
    p(o, _ref91) {
      let [a] = _ref91
      a & /*dir*/ 1 &&
        n !== (n = 'wx-resizer wx-resizer-' + /*dir*/ o[0] + ' x2-1myw878') &&
        g(e, 'class', n),
        a & /*b*/ 4 && j(e, 'left', /*b*/ o[2].p[0]),
        a & /*b*/ 4 && j(e, 'top', /*b*/ o[2].p[1]),
        a & /*b*/ 4 && j(e, 'width', /*b*/ o[2].size[0]),
        a & /*b*/ 4 && j(e, 'height', /*b*/ o[2].size[1]),
        a & /*b*/ 4 && j(e, 'right', /*b*/ o[2].p2[0]),
        a & /*b*/ 4 && j(e, 'bottom', /*b*/ o[2].p2[1]),
        a & /*cursor*/ 2 && j(e, 'cursor', /*cursor*/ o[1]),
        a & /*dir, active*/ 9 && Q(e, 'wx-resizer-active', /*active*/ o[3])
    },
    i: I,
    o: I,
    d(o) {
      o && v(e), (i = !1), s()
    },
  }
}
function N1(l, e, t) {
  let {position: n = 'after'} = e,
    {size: i = 4} = e,
    {dir: s = 'x'} = e,
    {value: o = 0} = e,
    {minValue: a = 0} = e,
    {maxValue: r = 0} = e
  const c = He()
  let u,
    f = {}
  function d(W) {
    let M = 0
    n == 'center' ? (M = i / 2) : n == 'before' && (M = i)
    const C = {size: [i + 'px', 'auto'], p: [W - M + 'px', '0px'], p2: ['auto', '0px']}
    if (s != 'x') for (let P in C) C[P] = C[P].reverse()
    return C
  }
  let h = 0,
    m,
    _ = !1
  function w(W) {
    return s == 'x' ? W.clientX : W.clientY
  }
  function b(W) {
    ;(h = w(W)),
      (m = o),
      t(3, (_ = !0)),
      (document.body.style.cursor = u),
      (document.body.style.userSelect = 'none'),
      window.addEventListener('mousemove', z),
      window.addEventListener('mouseup', T)
  }
  let p
  function z(W) {
    const M = m + w(W) - h
    ;(!a || a <= M) &&
      (!r || r >= M) &&
      (t(5, (o = M)), p && clearTimeout(p), (p = setTimeout(c('move', o), 500)))
  }
  function T() {
    ;(document.body.style.cursor = ''),
      (document.body.style.userSelect = ''),
      c('finish', o),
      t(3, (_ = !1)),
      window.removeEventListener('mousemove', z),
      window.removeEventListener('mouseup', T)
  }
  return (
    (l.$$set = (W) => {
      'position' in W && t(6, (n = W.position)),
        'size' in W && t(7, (i = W.size)),
        'dir' in W && t(0, (s = W.dir)),
        'value' in W && t(5, (o = W.value)),
        'minValue' in W && t(8, (a = W.minValue)),
        'maxValue' in W && t(9, (r = W.maxValue))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*value, dir*/ 33 &&
        (t(2, (f = d(o))), t(1, (u = s == 'x' ? 'ew-resize' : 'ns-resize')))
    }),
    [s, u, f, _, b, o, n, i, a, r]
  )
}
class L1 extends ee {
  constructor(e) {
    super(),
      $(this, e, N1, z1, x, {position: 6, size: 7, dir: 0, value: 5, minValue: 8, maxValue: 9})
  }
}
function js(l) {
  let e, t, n, i
  e = new zm({
    props: {
      compactMode: /*compactMode*/ l[7],
      columnWidth: /*gridColumnWidth*/ l[9],
      width: /*gridWidth*/ l[5],
      readonly: /*readonly*/ l[1],
      fullHeight: /*fullHeight*/ l[10],
    },
  })
  let s = !(/*compactMode*/ l[7]) && Zs(l)
  return {
    c() {
      F(e.$$.fragment), (t = Y()), s && s.c(), (n = se())
    },
    m(o, a) {
      R(e, o, a), S(o, t, a), s && s.m(o, a), S(o, n, a), (i = !0)
    },
    p(o, a) {
      const r = {}
      a[0] & /*compactMode*/ 128 && (r.compactMode = /*compactMode*/ o[7]),
        a[0] & /*gridColumnWidth*/ 512 && (r.columnWidth = /*gridColumnWidth*/ o[9]),
        a[0] & /*gridWidth*/ 32 && (r.width = /*gridWidth*/ o[5]),
        a[0] & /*readonly*/ 2 && (r.readonly = /*readonly*/ o[1]),
        a[0] & /*fullHeight*/ 1024 && (r.fullHeight = /*fullHeight*/ o[10]),
        e.$set(r),
        /*compactMode*/ o[7]
          ? s &&
            (te(),
            y(s, 1, 1, () => {
              s = null
            }),
            ne())
          : s
          ? (s.p(o, a), a[0] & /*compactMode*/ 128 && k(s, 1))
          : ((s = Zs(o)), s.c(), k(s, 1), s.m(n.parentNode, n))
    },
    i(o) {
      i || (k(e.$$.fragment, o), k(s), (i = !0))
    },
    o(o) {
      y(e.$$.fragment, o), y(s), (i = !1)
    },
    d(o) {
      o && (v(t), v(n)), O(e, o), s && s.d(o)
    },
  }
}
function Zs(l) {
  let e, t
  return (
    (e = new L1({props: {value: /*gridWidth*/ l[5], minValue: '50', maxValue: '800'}})),
    e.$on('move', /*resizeGrid*/ l[22]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i[0] & /*gridWidth*/ 32 && (s.value = /*gridWidth*/ n[5]), e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function qs(l) {
  let e, t
  return (
    (e = new D1({props: {compactMode: /*compactMode*/ l[7], editorShape: /*editorShape*/ l[3]}})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i[0] & /*compactMode*/ 128 && (s.compactMode = /*compactMode*/ n[7]),
          i[0] & /*editorShape*/ 8 && (s.editorShape = /*editorShape*/ n[3]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Ks(l) {
  let e, t, n
  return (
    (t = new ar({props: {icon: 'wxi-plus'}})),
    t.$on('click', /*addTask*/ l[21]),
    {
      c() {
        ;(e = D('div')), F(t.$$.fragment), g(e, 'class', 'wx-icon x2-1dzadpy')
      },
      m(i, s) {
        S(i, e, s), R(t, e, null), (n = !0)
      },
      p: I,
      i(i) {
        n || (k(t.$$.fragment, i), (n = !0))
      },
      o(i) {
        y(t.$$.fragment, i), (n = !1)
      },
      d(i) {
        i && v(e), O(t)
      },
    }
  )
}
function E1(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r,
    c,
    u,
    f,
    d = /*$rColumns*/ l[8].length && js(l)
  ;(s = new ad({props: {highlightTime: /*highlightTime*/ l[4]}})),
    (a = new Jm({
      props: {
        markers: /*markersData*/ l[12],
        readonly: /*readonly*/ l[1],
        fullWidth: /*fullWidth*/ l[6],
        fullHeight: /*fullHeight*/ l[10],
        taskTemplate: /*taskTemplate*/ l[0],
        cellBorders: /*cellBorders*/ l[2],
        highlightTime: /*highlightTime*/ l[4],
      },
    })),
    a.$on('scale-params', /*setParams*/ l[20])
  let h = /*$rActiveTask*/ l[13] && !(/*readonly*/ l[1]) && qs(l),
    m = /*compactMode*/ l[7] && !(/*$rActiveTask*/ l[13]) && !(/*readonly*/ l[1]) && Ks(l)
  return {
    c() {
      ;(e = D('div')),
        (t = D('div')),
        d && d.c(),
        (n = Y()),
        (i = D('div')),
        F(s.$$.fragment),
        (o = Y()),
        F(a.$$.fragment),
        (r = Y()),
        h && h.c(),
        (c = Y()),
        m && m.c(),
        g(i, 'class', 'wx-content x2-1dzadpy'),
        g(t, 'tabindex', '0'),
        g(t, 'class', 'wx-layout x2-1dzadpy'),
        Vt(() => /*div1_elementresize_handler*/ l[28].call(t)),
        g(e, 'class', 'wx-gantt x2-1dzadpy')
    },
    m(_, w) {
      S(_, e, w),
        H(e, t),
        d && d.m(t, null),
        H(t, n),
        H(t, i),
        R(s, i, null),
        H(i, o),
        R(a, i, null),
        H(t, r),
        h && h.m(t, null),
        H(t, c),
        m && m.m(t, null),
        (u = sl(t, /*div1_elementresize_handler*/ l[28].bind(t))),
        (f = !0)
    },
    p(_, w) {
      /*$rColumns*/ _[8].length
        ? d
          ? (d.p(_, w), w[0] & /*$rColumns*/ 256 && k(d, 1))
          : ((d = js(_)), d.c(), k(d, 1), d.m(t, n))
        : d &&
          (te(),
          y(d, 1, 1, () => {
            d = null
          }),
          ne())
      const b = {}
      w[0] & /*highlightTime*/ 16 && (b.highlightTime = /*highlightTime*/ _[4]), s.$set(b)
      const p = {}
      w[0] & /*markersData*/ 4096 && (p.markers = /*markersData*/ _[12]),
        w[0] & /*readonly*/ 2 && (p.readonly = /*readonly*/ _[1]),
        w[0] & /*fullWidth*/ 64 && (p.fullWidth = /*fullWidth*/ _[6]),
        w[0] & /*fullHeight*/ 1024 && (p.fullHeight = /*fullHeight*/ _[10]),
        w[0] & /*taskTemplate*/ 1 && (p.taskTemplate = /*taskTemplate*/ _[0]),
        w[0] & /*cellBorders*/ 4 && (p.cellBorders = /*cellBorders*/ _[2]),
        w[0] & /*highlightTime*/ 16 && (p.highlightTime = /*highlightTime*/ _[4]),
        a.$set(p),
        /*$rActiveTask*/ _[13] && !(/*readonly*/ _[1])
          ? h
            ? (h.p(_, w), w[0] & /*$rActiveTask, readonly*/ 8194 && k(h, 1))
            : ((h = qs(_)), h.c(), k(h, 1), h.m(t, c))
          : h &&
            (te(),
            y(h, 1, 1, () => {
              h = null
            }),
            ne()),
        /*compactMode*/ _[7] && !(/*$rActiveTask*/ _[13]) && !(/*readonly*/ _[1])
          ? m
            ? (m.p(_, w), w[0] & /*compactMode, $rActiveTask, readonly*/ 8322 && k(m, 1))
            : ((m = Ks(_)), m.c(), k(m, 1), m.m(t, null))
          : m &&
            (te(),
            y(m, 1, 1, () => {
              m = null
            }),
            ne())
    },
    i(_) {
      f || (k(d), k(s.$$.fragment, _), k(a.$$.fragment, _), k(h), k(m), (f = !0))
    },
    o(_) {
      y(d), y(s.$$.fragment, _), y(a.$$.fragment, _), y(h), y(m), (f = !1)
    },
    d(_) {
      _ && v(e), d && d.d(), O(s), O(a), h && h.d(), m && m.d(), u()
    },
  }
}
let I1 = 650
function R1(l, e, t) {
  let n,
    i,
    s,
    o,
    a,
    r,
    {taskTemplate: c} = e,
    {markers: u} = e,
    {readonly: f} = e,
    {cellBorders: d} = e,
    {editorShape: h} = e,
    {highlightTime: m} = e
  const _ = ze('gantt-store'),
    w = ze('wx-i18n').getGroup('gantt'),
    {
      _tasks: b,
      _scales: p,
      _activeTask: z,
      cellWidth: T,
      cellHeight: W,
      columns: M,
    } = _.getReactiveState()
  ce(l, b, (U) => t(25, (s = U))),
    ce(l, p, (U) => t(26, (o = U))),
    ce(l, z, (U) => t(13, (r = U))),
    ce(l, T, (U) => t(27, (a = U))),
    ce(l, W, (U) => t(24, (i = U))),
    ce(l, M, (U) => t(8, (n = U)))
  let C,
    P,
    X,
    A,
    B,
    V,
    fe = !1
  const L = new ResizeObserver(Ye)
  L.observe(document.body)
  function Ye(U) {
    for (let ge of U) ge.target === document.body && (t(7, (fe = ge.contentRect.width <= I1)), ue())
  }
  rl(() => {
    L.disconnect()
  })
  let G,
    pe = !0,
    Se,
    K
  async function ue() {
    if ((await Dn(), V > B)) {
      const U = {minWidth: V - C}
      pe || (Se && (U.date = Se), typeof K < 'u' && (U.offset = K)), _.exec('expand-scale', U)
    }
    pe && (pe = !1)
  }
  function Ne(U) {
    ;(Se = U.detail.date), (K = U.detail.offset)
  }
  function ye(U, ge) {
    let Me
    return (
      ge.every((Fe) => Fe.width && !Fe.flexgrow)
        ? (Me = ge.reduce((Fe, Je) => ((Fe += parseInt(Je.width)), Fe), 0))
        : (Me = 440),
      t(9, (P = Me)),
      U && (Me = parseInt(ge.find((Fe) => Fe.id === 'action')?.width) || 50),
      Me
    )
  }
  function ve() {
    _.exec('add-task', {task: {text: w('New Task')}})
  }
  function Ze(U) {
    const ge = U.detail
    t(5, (C = ge))
  }
  function ie() {
    ;(V = this.offsetWidth), t(11, V)
  }
  return (
    (l.$$set = (U) => {
      'taskTemplate' in U && t(0, (c = U.taskTemplate)),
        'markers' in U && t(23, (u = U.markers)),
        'readonly' in U && t(1, (f = U.readonly)),
        'cellBorders' in U && t(2, (d = U.cellBorders)),
        'editorShape' in U && t(3, (h = U.editorShape)),
        'highlightTime' in U && t(4, (m = U.highlightTime))
    }),
    (l.$$.update = () => {
      if (l.$$.dirty[0] & /*$rScales, markers, $rCellWidth*/ 209715200) {
        const {start: U, diff: ge} = o
        t(12, (G = u.map((Me) => ((Me.left = ge(Me.start, U) * a), Me))))
      }
      l.$$.dirty[0] & /*compactMode, $rColumns*/ 384 && t(5, (C = ye(fe, n))),
        l.$$.dirty[0] & /*$rScales, $rTasks, $rCellHeight, gridWidth, fullWidth*/ 117440608 &&
          (t(6, (X = o.width)), t(10, (A = s.length * i)), (B = C + X), ue())
    }),
    [c, f, d, h, m, C, X, fe, n, P, A, V, G, r, b, p, z, T, W, M, Ne, ve, Ze, u, i, s, o, a, ie]
  )
}
class O1 extends ee {
  constructor(e) {
    super(),
      $(
        this,
        e,
        R1,
        E1,
        x,
        {
          taskTemplate: 0,
          markers: 23,
          readonly: 1,
          cellBorders: 2,
          editorShape: 3,
          highlightTime: 4,
        },
        null,
        [-1, -1]
      )
  }
}
function A1(l) {
  let e, t
  return (
    (e = new O1({
      props: {
        taskTemplate: /*taskTemplate*/ l[0],
        markers: /*markers*/ l[1],
        readonly: /*readonly*/ l[2],
        cellBorders: /*cellBorders*/ l[3],
        editorShape: /*editorShape*/ l[4],
        highlightTime: /*highlightTime*/ l[5],
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*taskTemplate*/ 1 && (s.taskTemplate = /*taskTemplate*/ n[0]),
          i & /*markers*/ 2 && (s.markers = /*markers*/ n[1]),
          i & /*readonly*/ 4 && (s.readonly = /*readonly*/ n[2]),
          i & /*cellBorders*/ 8 && (s.cellBorders = /*cellBorders*/ n[3]),
          i & /*editorShape*/ 16 && (s.editorShape = /*editorShape*/ n[4]),
          i & /*highlightTime*/ 32 && (s.highlightTime = /*highlightTime*/ n[5]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function F1(l) {
  let e, t
  return (
    (e = new Mo({props: {words: dl, optional: !0, $$slots: {default: [A1]}, $$scope: {ctx: l}}})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, _ref92) {
        let [i] = _ref92
        const s = {}
        i &
          /*$$scope, taskTemplate, markers, readonly, cellBorders, editorShape, highlightTime*/ 134217791 &&
          (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function P1(l, e, t) {
  let {taskTemplate: n = null} = e,
    {markers: i = []} = e,
    {
      taskTypes: s = [
        {id: 'task', label: 'Task'},
        {id: 'summary', label: 'Summary task'},
        {id: 'milestone', label: 'Milestone'},
      ],
    } = e,
    {tasks: o = []} = e,
    {selected: a = []} = e,
    {activeTask: r = null} = e,
    {links: c = []} = e,
    {
      scales: u = [
        {unit: 'month', step: 1, format: 'MMMM yyy'},
        {unit: 'day', step: 1, format: 'd'},
      ],
    } = e,
    {columns: f = Gf} = e,
    {start: d = null} = e,
    {end: h = null} = e,
    {lengthUnit: m = 'day'} = e,
    {cellWidth: _ = 100} = e,
    {cellHeight: w = 38} = e,
    {scaleHeight: b = 36} = e,
    {readonly: p = !1} = e,
    {cellBorders: z = 'full'} = e,
    {editorShape: T = Qo} = e,
    {zoom: W = !1} = e,
    {baselines: M = !1} = e,
    {highlightTime: C = null} = e,
    {init: P = null} = e
  const X = He(),
    A = new Uf(cl)
  let B = new To(X),
    V = A.in
  V.setNext(B)
  const fe = {
    // state
    getState: A.getState.bind(A),
    getReactiveState: A.getReactive.bind(A),
    getStores: () => ({data: A}), // events
    exec: V.exec,
    setNext: (L) => (B = B.setNext(L)),
    intercept: V.intercept.bind(V),
    on: V.on.bind(V),
    detach: V.detach.bind(V), //specific
    getTask: (L) => A.getTask(L),
  }
  return (
    It('gantt-store', {
      getReactiveState: A.getReactive.bind(A),
      exec: V.exec.bind(V),
      getTask: A.getTask.bind(A),
    }),
    (l.$$set = (L) => {
      'taskTemplate' in L && t(0, (n = L.taskTemplate)),
        'markers' in L && t(1, (i = L.markers)),
        'taskTypes' in L && t(7, (s = L.taskTypes)),
        'tasks' in L && t(8, (o = L.tasks)),
        'selected' in L && t(9, (a = L.selected)),
        'activeTask' in L && t(10, (r = L.activeTask)),
        'links' in L && t(11, (c = L.links)),
        'scales' in L && t(12, (u = L.scales)),
        'columns' in L && t(13, (f = L.columns)),
        'start' in L && t(14, (d = L.start)),
        'end' in L && t(15, (h = L.end)),
        'lengthUnit' in L && t(16, (m = L.lengthUnit)),
        'cellWidth' in L && t(17, (_ = L.cellWidth)),
        'cellHeight' in L && t(18, (w = L.cellHeight)),
        'scaleHeight' in L && t(19, (b = L.scaleHeight)),
        'readonly' in L && t(2, (p = L.readonly)),
        'cellBorders' in L && t(3, (z = L.cellBorders)),
        'editorShape' in L && t(4, (T = L.editorShape)),
        'zoom' in L && t(20, (W = L.zoom)),
        'baselines' in L && t(21, (M = L.baselines)),
        'highlightTime' in L && t(5, (C = L.highlightTime)),
        'init' in L && t(6, (P = L.init))
    }),
    (l.$$.update = () => {
      l.$$.dirty &
        /*tasks, links, start, columns, end, lengthUnit, cellWidth, cellHeight, scaleHeight, scales, taskTypes, zoom, selected, activeTask, baselines, init*/ 4194240 &&
        (A.init({
          tasks: o,
          links: c,
          start: d,
          columns: f,
          end: h,
          lengthUnit: m,
          cellWidth: _,
          cellHeight: w,
          scaleHeight: b,
          scales: u,
          taskTypes: s,
          zoom: W,
          selected: a,
          activeTask: r,
          baselines: M,
        }),
        P && (P(fe), t(6, (P = null))))
    }),
    [n, i, p, z, T, C, P, s, o, a, r, c, u, f, d, h, m, _, w, b, W, M, fe]
  )
}
class mg extends ee {
  constructor(e) {
    super(),
      $(this, e, P1, F1, x, {
        taskTemplate: 0,
        markers: 1,
        taskTypes: 7,
        tasks: 8,
        selected: 9,
        activeTask: 10,
        links: 11,
        scales: 12,
        columns: 13,
        start: 14,
        end: 15,
        lengthUnit: 16,
        cellWidth: 17,
        cellHeight: 18,
        scaleHeight: 19,
        readonly: 2,
        cellBorders: 3,
        editorShape: 4,
        zoom: 20,
        baselines: 21,
        highlightTime: 5,
        init: 6,
        api: 22,
      })
  }
  get api() {
    return this.$$.ctx[22]
  }
}
const Xt = []
document.addEventListener('keydown', (l) => {
  if (
    Xt.length &&
    (l.ctrlKey || l.altKey || l.metaKey || l.shiftKey || l.key.length > 1 || l.key === ' ')
  ) {
    const e = []
    l.ctrlKey && e.push('ctrl'),
      l.altKey && e.push('alt'),
      l.metaKey && e.push('meta'),
      l.shiftKey && e.push('shift')
    let t = l.key.toLocaleLowerCase()
    l.key === ' ' && (t = 'space'), e.push(t)
    const n = e.join('+')
    for (let i = Xt.length - 1; i >= 0; i--) {
      const s = Xt[i],
        o = s.store.get(n) || s.store.get(t),
        a = l.target.tagName
      if (o && a !== 'INPUT' && a !== 'TEXTAREA' && s.isActive()) {
        o(l), l.preventDefault()
        return
      }
    }
  }
})
const cr = {}
function q1(l) {
  return cr[l] || l
}
function tn(l, e) {
  cr[l] = e
}
function K1(l) {
  let e, t, n
  return {
    c() {
      ;(e = D('div')),
        (t = re(' ')),
        g(e, 'class', (n = 'wx-separator' + /*menu*/ (l[0] ? '-menu' : '') + ' x2-1eu7qav'))
    },
    m(i, s) {
      S(i, e, s), H(e, t)
    },
    p(i, _ref94) {
      let [s] = _ref94
      s & /*menu*/ 1 &&
        n !== (n = 'wx-separator' + /*menu*/ (i[0] ? '-menu' : '') + ' x2-1eu7qav') &&
        g(e, 'class', n)
    },
    i: I,
    o: I,
    d(i) {
      i && v(e)
    },
  }
}
function G1(l, e, t) {
  let {menu: n = !1} = e
  return (
    (l.$$set = (i) => {
      'menu' in i && t(0, (n = i.menu))
    }),
    [n]
  )
}
class ur extends ee {
  constructor(e) {
    super(), $(this, e, G1, K1, x, {menu: 0})
  }
}
function X1(l) {
  let e
  return {
    c() {
      ;(e = D('div')), g(e, 'class', 'wx-spacer x2-1mbb7ow')
    },
    m(t, n) {
      S(t, e, n)
    },
    p: I,
    i: I,
    o: I,
    d(t) {
      t && v(e)
    },
  }
}
class fr extends ee {
  constructor(e) {
    super(), $(this, e, null, X1, x, {})
  }
}
function V1(l) {
  let e, t, n, i, s, o
  const a = [{text: /*text*/ l[3]}, {menu: /*menu*/ l[1]}, /*item*/ l[0]]
  function r(f) {
    l[8](f)
  }
  var c = /*itemComponent*/ l[2]
  function u(f, d) {
    let h = {}
    for (let m = 0; m < a.length; m += 1) h = We(h, a[m])
    return (
      d !== void 0 &&
        d & /*text, menu, item*/ 11 &&
        (h = We(
          h,
          Ut(a, [
            d & /*text*/ 8 && {text: /*text*/ f[3]},
            d & /*menu*/ 2 && {menu: /*menu*/ f[1]},
            d & /*item*/ 1 && Jt(/*item*/ f[0]),
          ])
        )),
      /*$value*/ f[4] !== void 0 && (h.value = /*$value*/ f[4]),
      {props: h}
    )
  }
  return (
    c && ((t = Le(c, u(l))), be.push(() => rt(t, 'value', r)), t.$on('click', /*onClick*/ l[5])),
    {
      c() {
        ;(e = D('div')),
          t && F(t.$$.fragment),
          g(e, 'class', (i = 'wx-tb-element ' + /*item*/ (l[0].css || '') + ' x2-ptl7r2')),
          g(e, 'data-id', (s = /*item*/ l[0].id)),
          Q(e, 'wx-spacer', /*item*/ l[0].spacer),
          Q(e, 'wx-menu', /*menu*/ l[1])
      },
      m(f, d) {
        S(f, e, d), t && R(t, e, null), (o = !0)
      },
      p(f, d) {
        if (d & /*itemComponent*/ 4 && c !== (c = /*itemComponent*/ f[2])) {
          if (t) {
            te()
            const h = t
            y(h.$$.fragment, 1, 0, () => {
              O(h, 1)
            }),
              ne()
          }
          c
            ? ((t = Le(c, u(f, d))),
              be.push(() => rt(t, 'value', r)),
              t.$on('click', /*onClick*/ f[5]),
              F(t.$$.fragment),
              k(t.$$.fragment, 1),
              R(t, e, null))
            : (t = null)
        } else if (c) {
          const h =
            d & /*text, menu, item*/ 11
              ? Ut(a, [
                  d & /*text*/ 8 && {text: /*text*/ f[3]},
                  d & /*menu*/ 2 && {menu: /*menu*/ f[1]},
                  d & /*item*/ 1 && Jt(/*item*/ f[0]),
                ])
              : {}
          !n && d & /*$value*/ 16 && ((n = !0), (h.value = /*$value*/ f[4]), dt(() => (n = !1))),
            t.$set(h)
        }
        ;(!o ||
          (d & /*item*/ 1 &&
            i !== (i = 'wx-tb-element ' + /*item*/ (f[0].css || '') + ' x2-ptl7r2'))) &&
          g(e, 'class', i),
          (!o || (d & /*item*/ 1 && s !== (s = /*item*/ f[0].id))) && g(e, 'data-id', s),
          (!o || d & /*item, item*/ 1) && Q(e, 'wx-spacer', /*item*/ f[0].spacer),
          (!o || d & /*item, menu*/ 3) && Q(e, 'wx-menu', /*menu*/ f[1])
      },
      i(f) {
        o || (t && k(t.$$.fragment, f), (o = !0))
      },
      o(f) {
        t && y(t.$$.fragment, f), (o = !1)
      },
      d(f) {
        f && v(e), t && O(t)
      },
    }
  )
}
function U1(l) {
  let e, t
  return (
    (e = new ur({props: {menu: /*menu*/ l[1]}})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*menu*/ 2 && (s.menu = /*menu*/ n[1]), e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function J1(l) {
  let e, t
  return (
    (e = new fr({props: {menu: /*menu*/ l[1]}})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*menu*/ 2 && (s.menu = /*menu*/ n[1]), e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Q1(l) {
  let e, t, n, i
  const s = [J1, U1, V1],
    o = []
  function a(r, c) {
    return /*item*/ r[0].comp == 'spacer' ? 0 : /*item*/ r[0].comp == 'separator' ? 1 : 2
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, _ref95) {
        let [c] = _ref95
        let u = e
        ;(e = a(r)),
          e === u
            ? o[e].p(r, c)
            : (te(),
              y(o[u], 1, 1, () => {
                o[u] = null
              }),
              ne(),
              (t = o[e]),
              t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
              k(t, 1),
              t.m(n.parentNode, n))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function x1(l, e, t) {
  let n
  const i = He()
  let {item: s = {}} = e,
    {menu: o = !1} = e,
    {values: a} = e,
    r
  function c() {
    s.handler && s.handler(s), i('click', {item: s})
  }
  let u = cl(null)
  ce(l, u, (m) => t(4, (n = m)))
  let f = !1
  u.subscribe((m) => {
    f || i('change', {value: m, item: s})
  })
  let d = ''
  function h(m) {
    ;(n = m), u.set(n)
  }
  return (
    (l.$$set = (m) => {
      'item' in m && t(0, (s = m.item)),
        'menu' in m && t(1, (o = m.menu)),
        'values' in m && t(7, (a = m.values))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*item*/ 1 && t(2, (r = q1(s.comp || 'label'))),
        l.$$.dirty & /*item, values*/ 129 &&
          s.key &&
          ((f = !0), a ? Cl(u, (n = a[s.key]), n) : Cl(u, (n = void 0), n), (f = !1)),
        l.$$.dirty & /*menu, item*/ 3 && t(3, (d = (o && s.menuText) || s.text))
    }),
    [s, o, r, d, n, c, u, a, h]
  )
}
class Sl extends ee {
  constructor(e) {
    super(), $(this, e, x1, Q1, x, {item: 0, menu: 1, values: 7})
  }
}
function Gs(l, e, t) {
  const n = l.slice()
  return (n[11] = e[t]), n
}
function $1(l) {
  let e,
    t,
    n,
    i,
    s = de(/*item*/ l[0].items),
    o = []
  for (let c = 0; c < s.length; c += 1) o[c] = Xs(Gs(l, s, c))
  const a = (c) =>
    y(o[c], 1, 1, () => {
      o[c] = null
    })
  let r = /*item*/ l[0].text && Vs(l)
  return {
    c() {
      e = D('div')
      for (let c = 0; c < o.length; c += 1) o[c].c()
      ;(t = Y()), r && r.c(), (n = se()), g(e, 'class', 'wx-tb-body x2-155fw4u')
    },
    m(c, u) {
      S(c, e, u)
      for (let f = 0; f < o.length; f += 1) o[f] && o[f].m(e, null)
      S(c, t, u), r && r.m(c, u), S(c, n, u), (i = !0)
    },
    p(c, u) {
      if (u & /*item, values, onClick*/ 19) {
        s = de(/*item*/ c[0].items)
        let f
        for (f = 0; f < s.length; f += 1) {
          const d = Gs(c, s, f)
          o[f]
            ? (o[f].p(d, u), k(o[f], 1))
            : ((o[f] = Xs(d)), o[f].c(), k(o[f], 1), o[f].m(e, null))
        }
        for (te(), f = s.length; f < o.length; f += 1) a(f)
        ne()
      }
      /*item*/ c[0].text
        ? r
          ? r.p(c, u)
          : ((r = Vs(c)), r.c(), r.m(n.parentNode, n))
        : r && (r.d(1), (r = null))
    },
    i(c) {
      if (!i) {
        for (let u = 0; u < s.length; u += 1) k(o[u])
        i = !0
      }
    },
    o(c) {
      o = o.filter(Boolean)
      for (let u = 0; u < o.length; u += 1) y(o[u])
      i = !1
    },
    d(c) {
      c && (v(e), v(t), v(n)), $e(o, c), r && r.d(c)
    },
  }
}
function e_(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a,
    r,
    c = /*item*/ l[0].icon && Us(l),
    u = /*item*/ l[0].text && Js(l),
    f = /*item*/ l[0].text && !(/*item*/ l[0].icon) && Qs(),
    d = !(/*collapsed*/ l[3]) && xs(l)
  return {
    c() {
      ;(e = D('div')),
        c && c.c(),
        (t = Y()),
        u && u.c(),
        (n = Y()),
        f && f.c(),
        (i = Y()),
        d && d.c(),
        (s = se()),
        g(e, 'class', 'wx-collapsed x2-155fw4u')
    },
    m(h, m) {
      S(h, e, m),
        c && c.m(e, null),
        H(e, t),
        u && u.m(e, null),
        H(e, n),
        f && f.m(e, null),
        S(h, i, m),
        d && d.m(h, m),
        S(h, s, m),
        (o = !0),
        a || ((r = q(e, 'click', /*show*/ l[5])), (a = !0))
    },
    p(h, m) {
      /*item*/ h[0].icon
        ? c
          ? c.p(h, m)
          : ((c = Us(h)), c.c(), c.m(e, t))
        : c && (c.d(1), (c = null)),
        /*item*/ h[0].text
          ? u
            ? u.p(h, m)
            : ((u = Js(h)), u.c(), u.m(e, n))
          : u && (u.d(1), (u = null)),
        /*item*/ h[0].text && !(/*item*/ h[0].icon)
          ? f || ((f = Qs()), f.c(), f.m(e, null))
          : f && (f.d(1), (f = null)),
        /*collapsed*/ h[3]
          ? d &&
            (te(),
            y(d, 1, 1, () => {
              d = null
            }),
            ne())
          : d
          ? (d.p(h, m), m & /*collapsed*/ 8 && k(d, 1))
          : ((d = xs(h)), d.c(), k(d, 1), d.m(s.parentNode, s))
    },
    i(h) {
      o || (k(d), (o = !0))
    },
    o(h) {
      y(d), (o = !1)
    },
    d(h) {
      h && (v(e), v(i), v(s)), c && c.d(), u && u.d(), f && f.d(), d && d.d(h), (a = !1), r()
    },
  }
}
function t_(l) {
  let e, t
  return (
    (e = new Sl({props: {item: /*sub*/ l[11], values: /*values*/ l[1]}})),
    e.$on('click', /*onClick*/ l[4]),
    e.$on('change', /*change_handler_2*/ l[9]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*item*/ 1 && (s.item = /*sub*/ n[11]),
          i & /*values*/ 2 && (s.values = /*values*/ n[1]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function n_(l) {
  let e, t
  return (
    (e = new Yn({props: {item: /*sub*/ l[11], values: /*values*/ l[1]}})),
    e.$on('click', /*onClick*/ l[4]),
    e.$on('change', /*change_handler_1*/ l[8]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*item*/ 1 && (s.item = /*sub*/ n[11]),
          i & /*values*/ 2 && (s.values = /*values*/ n[1]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function Xs(l) {
  let e, t, n, i
  const s = [n_, t_],
    o = []
  function a(r, c) {
    return /*sub*/ r[11].items ? 0 : 1
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        let u = e
        ;(e = a(r)),
          e === u
            ? o[e].p(r, c)
            : (te(),
              y(o[u], 1, 1, () => {
                o[u] = null
              }),
              ne(),
              (t = o[e]),
              t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
              k(t, 1),
              t.m(n.parentNode, n))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function Vs(l) {
  let e,
    t = /*item*/ l[0].text + '',
    n
  return {
    c() {
      ;(e = D('div')), (n = re(t)), g(e, 'class', 'wx-label x2-155fw4u')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*item*/ 1 && t !== (t = /*item*/ i[0].text + '') && me(n, t)
    },
    d(i) {
      i && v(e)
    },
  }
}
function Us(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')), g(e, 'class', (t = 'icon ' + /*item*/ l[0].icon + ' x2-155fw4u'))
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*item*/ 1 && t !== (t = 'icon ' + /*item*/ n[0].icon + ' x2-155fw4u') && g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function Js(l) {
  let e,
    t = /*item*/ l[0].text + '',
    n
  return {
    c() {
      ;(e = D('div')), (n = re(t)), g(e, 'class', 'wx-label-text')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*item*/ 1 && t !== (t = /*item*/ i[0].text + '') && me(n, t)
    },
    d(i) {
      i && v(e)
    },
  }
}
function Qs(l) {
  let e
  return {
    c() {
      ;(e = D('i')), g(e, 'class', 'wx-label-arrow wxi-angle-down')
    },
    m(t, n) {
      S(t, e, n)
    },
    d(t) {
      t && v(e)
    },
  }
}
function xs(l) {
  let e, t
  return (
    (e = new pn({
      props: {width: '', cancel: /*cancel*/ l[6], $$slots: {default: [l_]}, $$scope: {ctx: l}},
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*$$scope, item, values, menu*/ 16391 && (s.$$scope = {dirty: i, ctx: n}), e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function l_(l) {
  let e, t, n
  return (
    (t = new Yn({
      props: {
        item: {.../*item*/ l[0], text: '', collapsed: !1},
        values: /*values*/ l[1],
        menu: /*menu*/ l[2],
      },
    })),
    t.$on('change', /*change_handler*/ l[7]),
    t.$on('click', /*onClick*/ l[4]),
    {
      c() {
        ;(e = D('div')), F(t.$$.fragment), g(e, 'class', 'wx-drop-group')
      },
      m(i, s) {
        S(i, e, s), R(t, e, null), (n = !0)
      },
      p(i, s) {
        const o = {}
        s & /*item*/ 1 && (o.item = {.../*item*/ i[0], text: '', collapsed: !1}),
          s & /*values*/ 2 && (o.values = /*values*/ i[1]),
          s & /*menu*/ 4 && (o.menu = /*menu*/ i[2]),
          t.$set(o)
      },
      i(i) {
        n || (k(t.$$.fragment, i), (n = !0))
      },
      o(i) {
        y(t.$$.fragment, i), (n = !1)
      },
      d(i) {
        i && v(e), O(t)
      },
    }
  )
}
function i_(l) {
  let e, t, n, i, s
  const o = [e_, $1],
    a = []
  function r(c, u) {
    return /*item*/ c[0].collapsed && !(/*menu*/ c[2]) ? 0 : 1
  }
  return (
    (t = r(l)),
    (n = a[t] = o[t](l)),
    {
      c() {
        ;(e = D('div')),
          n.c(),
          g(e, 'class', (i = 'wx-tb-group ' + /*item*/ (l[0].css || '') + ' x2-155fw4u')),
          Q(e, 'wx-column', /*item*/ l[0].layout == 'column'),
          Q(e, 'wx-group-collapsed', /*item*/ l[0].collapsed && !(/*menu*/ l[2]))
      },
      m(c, u) {
        S(c, e, u), a[t].m(e, null), (s = !0)
      },
      p(c, _ref96) {
        let [u] = _ref96
        let f = t
        ;(t = r(c)),
          t === f
            ? a[t].p(c, u)
            : (te(),
              y(a[f], 1, 1, () => {
                a[f] = null
              }),
              ne(),
              (n = a[t]),
              n ? n.p(c, u) : ((n = a[t] = o[t](c)), n.c()),
              k(n, 1),
              n.m(e, null)),
          (!s ||
            (u & /*item*/ 1 &&
              i !== (i = 'wx-tb-group ' + /*item*/ (c[0].css || '') + ' x2-155fw4u'))) &&
            g(e, 'class', i),
          (!s || u & /*item, item*/ 1) && Q(e, 'wx-column', /*item*/ c[0].layout == 'column'),
          (!s || u & /*item, item, menu*/ 5) &&
            Q(e, 'wx-group-collapsed', /*item*/ c[0].collapsed && !(/*menu*/ c[2]))
      },
      i(c) {
        s || (k(n), (s = !0))
      },
      o(c) {
        y(n), (s = !1)
      },
      d(c) {
        c && v(e), a[t].d()
      },
    }
  )
}
function s_(l, e, t) {
  const n = He()
  let {item: i} = e,
    {values: s = null} = e,
    {menu: o = !1} = e,
    a = !1
  const r = (m) => {
      u(), n('click', m.detail)
    },
    c = () => t(3, (a = !1)),
    u = () => t(3, (a = !0))
  function f(m) {
    De.call(this, l, m)
  }
  function d(m) {
    De.call(this, l, m)
  }
  function h(m) {
    De.call(this, l, m)
  }
  return (
    (l.$$set = (m) => {
      'item' in m && t(0, (i = m.item)),
        'values' in m && t(1, (s = m.values)),
        'menu' in m && t(2, (o = m.menu))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*item*/ 1 && i.collapsed && t(3, (a = !0))
    }),
    [i, s, o, a, r, c, u, f, d, h]
  )
}
class Yn extends ee {
  constructor(e) {
    super(), $(this, e, s_, i_, x, {item: 0, values: 1, menu: 2})
  }
}
function $s(l, e, t) {
  const n = l.slice()
  return (n[13] = e[t]), n
}
function eo(l) {
  let e, t
  return (
    (e = new pn({
      props: {
        width: /*width*/ l[3] + 'px',
        cancel: /*cancel*/ l[6],
        $$slots: {default: [a_]},
        $$scope: {ctx: l},
      },
    })),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*width*/ 8 && (s.width = /*width*/ n[3] + 'px'),
          i & /*$$scope, items, values*/ 65541 && (s.$$scope = {dirty: i, ctx: n}),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function o_(l) {
  let e, t
  return (
    (e = new Sl({props: {item: /*item*/ l[13], values: /*values*/ l[2], menu: !0}})),
    e.$on('click', /*menuClick*/ l[8]),
    e.$on('change', /*change_handler_1*/ l[10]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*items*/ 1 && (s.item = /*item*/ n[13]),
          i & /*values*/ 4 && (s.values = /*values*/ n[2]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function r_(l) {
  let e, t
  return (
    (e = new Yn({props: {item: /*item*/ l[13], values: /*values*/ l[2], menu: !0}})),
    e.$on('click', /*menuClick*/ l[8]),
    e.$on('change', /*change_handler*/ l[9]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*items*/ 1 && (s.item = /*item*/ n[13]),
          i & /*values*/ 4 && (s.values = /*values*/ n[2]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function to(l) {
  let e, t, n, i
  const s = [r_, o_],
    o = []
  function a(r, c) {
    return /*item*/ r[13].items ? 0 : 1
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        let u = e
        ;(e = a(r)),
          e === u
            ? o[e].p(r, c)
            : (te(),
              y(o[u], 1, 1, () => {
                o[u] = null
              }),
              ne(),
              (t = o[e]),
              t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
              k(t, 1),
              t.m(n.parentNode, n))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function a_(l) {
  let e,
    t,
    n = de(/*items*/ l[0]),
    i = []
  for (let o = 0; o < n.length; o += 1) i[o] = to($s(l, n, o))
  const s = (o) =>
    y(i[o], 1, 1, () => {
      i[o] = null
    })
  return {
    c() {
      e = D('div')
      for (let o = 0; o < i.length; o += 1) i[o].c()
      g(e, 'class', 'wx-drop-menu x2-7mtmlh')
    },
    m(o, a) {
      S(o, e, a)
      for (let r = 0; r < i.length; r += 1) i[r] && i[r].m(e, null)
      t = !0
    },
    p(o, a) {
      if (a & /*items, values, menuClick*/ 261) {
        n = de(/*items*/ o[0])
        let r
        for (r = 0; r < n.length; r += 1) {
          const c = $s(o, n, r)
          i[r]
            ? (i[r].p(c, a), k(i[r], 1))
            : ((i[r] = to(c)), i[r].c(), k(i[r], 1), i[r].m(e, null))
        }
        for (te(), r = n.length; r < i.length; r += 1) s(r)
        ne()
      }
    },
    i(o) {
      if (!t) {
        for (let a = 0; a < n.length; a += 1) k(i[a])
        t = !0
      }
    },
    o(o) {
      i = i.filter(Boolean)
      for (let a = 0; a < i.length; a += 1) y(i[a])
      t = !1
    },
    d(o) {
      o && v(e), $e(i, o)
    },
  }
}
function c_(l) {
  let e, t, n, i, s
  t = new mn({props: {icon: 'wxi-dots-h', click: /*showMenu*/ l[7]}})
  let o = /*popup*/ l[4] && eo(l)
  return {
    c() {
      ;(e = D('div')),
        F(t.$$.fragment),
        (n = Y()),
        o && o.c(),
        g(e, 'class', (i = 'wx-menu ' + /*css*/ (l[1] || '') + ' x2-7mtmlh')),
        g(e, 'data-id', '$menu')
    },
    m(a, r) {
      S(a, e, r), R(t, e, null), H(e, n), o && o.m(e, null), l[11](e), (s = !0)
    },
    p(a, _ref97) {
      let [r] = _ref97
      /*popup*/ a[4]
        ? o
          ? (o.p(a, r), r & /*popup*/ 16 && k(o, 1))
          : ((o = eo(a)), o.c(), k(o, 1), o.m(e, null))
        : o &&
          (te(),
          y(o, 1, 1, () => {
            o = null
          }),
          ne()),
        (!s || (r & /*css*/ 2 && i !== (i = 'wx-menu ' + /*css*/ (a[1] || '') + ' x2-7mtmlh'))) &&
          g(e, 'class', i)
    },
    i(a) {
      s || (k(t.$$.fragment, a), k(o), (s = !0))
    },
    o(a) {
      y(t.$$.fragment, a), y(o), (s = !1)
    },
    d(a) {
      a && v(e), O(t), o && o.d(), l[11](null)
    },
  }
}
function u_(l, e, t) {
  let {items: n = []} = e,
    {css: i} = e,
    {values: s} = e
  const o = He()
  let {width: a} = e,
    r,
    c
  function u() {
    t(4, (r = null))
  }
  function f() {
    t(4, (r = !0))
  }
  function d(w) {
    u(), o('click', w.detail)
  }
  function h(w) {
    De.call(this, l, w)
  }
  function m(w) {
    De.call(this, l, w)
  }
  function _(w) {
    be[w ? 'unshift' : 'push'](() => {
      ;(c = w), t(5, c)
    })
  }
  return (
    (l.$$set = (w) => {
      'items' in w && t(0, (n = w.items)),
        'css' in w && t(1, (i = w.css)),
        'values' in w && t(2, (s = w.values)),
        'width' in w && t(3, (a = w.width))
    }),
    [n, i, s, a, r, c, u, f, d, h, m, _]
  )
}
class f_ extends ee {
  constructor(e) {
    super(), $(this, e, u_, c_, x, {items: 0, css: 1, values: 2, width: 3})
  }
}
function no(l, e, t) {
  const n = l.slice()
  return (n[20] = e[t]), (n[22] = t), n
}
function d_(l) {
  let e, t
  return (
    (e = new Sl({props: {item: /*item*/ l[20], values: /*values*/ l[0]}})),
    e.$on('click', /*click_handler_1*/ l[10]),
    e.$on('change', /*handleChange*/ l[7]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*visibleItems*/ 64 && (s.item = /*item*/ n[20]),
          i & /*values*/ 1 && (s.values = /*values*/ n[0]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function h_(l) {
  let e, t
  return (
    (e = new Yn({props: {item: /*item*/ l[20], values: /*values*/ l[0]}})),
    e.$on('click', /*click_handler*/ l[9]),
    e.$on('change', /*handleChange*/ l[7]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*visibleItems*/ 64 && (s.item = /*item*/ n[20]),
          i & /*values*/ 1 && (s.values = /*values*/ n[0]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function lo(l) {
  let e, t, n, i
  const s = [h_, d_],
    o = []
  function a(r, c) {
    return /*item*/ r[20].items ? 0 : 1
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, c) {
        let u = e
        ;(e = a(r)),
          e === u
            ? o[e].p(r, c)
            : (te(),
              y(o[u], 1, 1, () => {
                o[u] = null
              }),
              ne(),
              (t = o[e]),
              t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
              k(t, 1),
              t.m(n.parentNode, n))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function io(l) {
  let e, t
  return (
    (e = new f_({
      props: {items: /*menuItems*/ l[5], css: /*menuCss*/ l[1], values: /*values*/ l[0]},
    })),
    e.$on('click', /*click_handler_2*/ l[11]),
    e.$on('change', /*handleChange*/ l[7]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*menuItems*/ 32 && (s.items = /*menuItems*/ n[5]),
          i & /*menuCss*/ 2 && (s.css = /*menuCss*/ n[1]),
          i & /*values*/ 1 && (s.values = /*values*/ n[0]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function m_(l) {
  let e,
    t,
    n,
    i,
    s = de(/*visibleItems*/ l[6]),
    o = []
  for (let c = 0; c < s.length; c += 1) o[c] = lo(no(l, s, c))
  const a = (c) =>
    y(o[c], 1, 1, () => {
      o[c] = null
    })
  let r = /*menuItems*/ l[5].length && io(l)
  return {
    c() {
      e = D('div')
      for (let c = 0; c < o.length; c += 1) o[c].c()
      ;(t = Y()),
        r && r.c(),
        g(e, 'class', (n = 'wx-toolbar ' + /*css*/ l[2] + ' x2-b19ms9')),
        Q(e, 'wx-wrap', /*overflow*/ l[3] === 'wrap')
    },
    m(c, u) {
      S(c, e, u)
      for (let f = 0; f < o.length; f += 1) o[f] && o[f].m(e, null)
      H(e, t), r && r.m(e, null), l[12](e), (i = !0)
    },
    p(c, _ref98) {
      let [u] = _ref98
      if (u & /*visibleItems, values, handleChange*/ 193) {
        s = de(/*visibleItems*/ c[6])
        let f
        for (f = 0; f < s.length; f += 1) {
          const d = no(c, s, f)
          o[f] ? (o[f].p(d, u), k(o[f], 1)) : ((o[f] = lo(d)), o[f].c(), k(o[f], 1), o[f].m(e, t))
        }
        for (te(), f = s.length; f < o.length; f += 1) a(f)
        ne()
      }
      /*menuItems*/ c[5].length
        ? r
          ? (r.p(c, u), u & /*menuItems*/ 32 && k(r, 1))
          : ((r = io(c)), r.c(), k(r, 1), r.m(e, null))
        : r &&
          (te(),
          y(r, 1, 1, () => {
            r = null
          }),
          ne()),
        (!i || (u & /*css*/ 4 && n !== (n = 'wx-toolbar ' + /*css*/ c[2] + ' x2-b19ms9'))) &&
          g(e, 'class', n),
        (!i || u & /*css, overflow*/ 12) && Q(e, 'wx-wrap', /*overflow*/ c[3] === 'wrap')
    },
    i(c) {
      if (!i) {
        for (let u = 0; u < s.length; u += 1) k(o[u])
        k(r), (i = !0)
      }
    },
    o(c) {
      o = o.filter(Boolean)
      for (let u = 0; u < o.length; u += 1) y(o[u])
      y(r), (i = !1)
    },
    d(c) {
      c && v(e), $e(o, c), r && r.d(), l[12](null)
    },
  }
}
function __(l, e, t) {
  let {items: n = []} = e,
    {menuCss: i = ''} = e,
    {css: s} = e,
    {values: o = null} = e,
    {overflow: a = 'menu'} = e
  const r = He()
  function c(C) {
    o && (t(0, (o[C.detail.item.key] = C.detail.value), o), t(0, o)), r('change', C.detail)
  }
  let u,
    f = -1,
    d = [],
    h
  function m() {
    if (a === 'wrap') return
    const C = u.clientWidth
    if (u.scrollWidth > C) {
      if (a === 'collapse') return w()
      const A = u.children
      let B = 0
      for (let V = 0; V < n.length; V++) {
        if (((B += A[V].clientWidth), n[V].comp == 'separator' && (B += 8), B > C - 40)) {
          if (f === V) return
          ;(f = V), t(5, (d = []))
          for (let fe = V; fe < n.length; fe++) d.push(n[fe]), (A[fe].style.visibility = 'hidden')
          V > 0 && n[V - 1].comp == 'separator' && (A[V - 1].style.visibility = 'hidden')
          break
        }
        A[V].style.visibility = ''
      }
    } else {
      const A = C - _()
      if (A <= 0) return
      if (a === 'collapse') return b(A)
      if (d.length) {
        f = null
        const B = u.children
        for (let V = 0; V < n.length; V++) B[V].style.visibility = ''
        t(5, (d = []))
      }
    }
  }
  function _() {
    const C = u.children
    let P = 0
    for (let X = 0; X < n.length; X++)
      n[X].comp != 'spacer' && ((P += C[X].clientWidth), n[X].comp == 'separator' && (P += 8))
    return P
  }
  function w() {
    for (let C = n.length - 1; C >= 0; C--)
      if (n[C].items && !n[C].collapsed) {
        t(8, (n[C].collapsed = !0), n),
          t(8, (n[C].$width = u.children[C].offsetWidth), n),
          Dn().then(m)
        return
      }
  }
  function b(C) {
    for (let P = 0; P < n.length; P++)
      if (n[P].collapsed && n[P].$width) {
        n[P].$width - u.children[P].offsetWidth < C + 10 &&
          (t(8, (n[P].collapsed = !1), n), Dn().then(m))
        return
      }
  }
  function p(C) {
    C.forEach((P) => {
      P.id || (P.id = Rt())
    })
  }
  ht(() => {
    const C = new ResizeObserver(() => m())
    return (
      C.observe(u),
      () => {
        C && C.unobserve(u)
      }
    )
  })
  function z(C) {
    De.call(this, l, C)
  }
  function T(C) {
    De.call(this, l, C)
  }
  function W(C) {
    De.call(this, l, C)
  }
  function M(C) {
    be[C ? 'unshift' : 'push'](() => {
      ;(u = C), t(4, u)
    })
  }
  return (
    (l.$$set = (C) => {
      'items' in C && t(8, (n = C.items)),
        'menuCss' in C && t(1, (i = C.menuCss)),
        'css' in C && t(2, (s = C.css)),
        'values' in C && t(0, (o = C.values)),
        'overflow' in C && t(3, (a = C.overflow))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*items*/ 256 && (p(n), t(6, (h = n)))
    }),
    [o, i, s, a, u, d, h, c, n, z, T, W, M]
  )
}
class g_ extends ee {
  constructor(e) {
    super(), $(this, e, __, m_, x, {items: 8, menuCss: 1, css: 2, values: 0, overflow: 3})
  }
}
function w_(l) {
  let e, t
  return (
    (e = new mn({
      props: {
        icon: /*icon*/ l[0],
        type: /*type*/ l[3],
        css: /*css*/ l[2],
        text: /*text*/ l[1],
        disabled: /*disabled*/ l[4],
      },
    })),
    e.$on('click', /*click_handler_1*/ l[7]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*icon*/ 1 && (s.icon = /*icon*/ n[0]),
          i & /*type*/ 8 && (s.type = /*type*/ n[3]),
          i & /*css*/ 4 && (s.css = /*css*/ n[2]),
          i & /*text*/ 2 && (s.text = /*text*/ n[1]),
          i & /*disabled*/ 16 && (s.disabled = /*disabled*/ n[4]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function b_(l) {
  let e, t, n, i, s, o, a
  return {
    c() {
      ;(e = D('div')),
        (t = D('i')),
        (i = Y()),
        (s = re(/*text*/ l[1])),
        g(
          t,
          'class',
          (n = /*icon*/ (l[0] || 'wxi-empty') + ' ' + /*css*/ (l[2] || '') + ' x2-b4dkf1')
        ),
        g(e, 'class', 'wx-item x2-b4dkf1')
    },
    m(r, c) {
      S(r, e, c),
        H(e, t),
        H(e, i),
        H(e, s),
        o || ((a = q(e, 'click', /*click_handler*/ l[6])), (o = !0))
    },
    p(r, c) {
      c & /*icon, css*/ 5 &&
        n !== (n = /*icon*/ (r[0] || 'wxi-empty') + ' ' + /*css*/ (r[2] || '') + ' x2-b4dkf1') &&
        g(t, 'class', n),
        c & /*text*/ 2 && me(s, /*text*/ r[1])
    },
    i: I,
    o: I,
    d(r) {
      r && v(e), (o = !1), a()
    },
  }
}
function k_(l) {
  let e, t, n, i
  const s = [b_, w_],
    o = []
  function a(r, c) {
    return /*menu*/ r[5] ? 0 : 1
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, _ref99) {
        let [c] = _ref99
        let u = e
        ;(e = a(r)),
          e === u
            ? o[e].p(r, c)
            : (te(),
              y(o[u], 1, 1, () => {
                o[u] = null
              }),
              ne(),
              (t = o[e]),
              t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
              k(t, 1),
              t.m(n.parentNode, n))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function p_(l, e, t) {
  let {icon: n} = e,
    {text: i = ''} = e,
    {css: s} = e,
    {type: o} = e,
    {disabled: a} = e,
    {menu: r} = e
  function c(f) {
    De.call(this, l, f)
  }
  function u(f) {
    De.call(this, l, f)
  }
  return (
    (l.$$set = (f) => {
      'icon' in f && t(0, (n = f.icon)),
        'text' in f && t(1, (i = f.text)),
        'css' in f && t(2, (s = f.css)),
        'type' in f && t(3, (o = f.type)),
        'disabled' in f && t(4, (a = f.disabled)),
        'menu' in f && t(5, (r = f.menu))
    }),
    [n, i, s, o, a, r, c, u]
  )
}
class y_ extends ee {
  constructor(e) {
    super(), $(this, e, p_, k_, x, {icon: 0, text: 1, css: 2, type: 3, disabled: 4, menu: 5})
  }
}
function v_(l) {
  let e,
    t = /*value*/ (l[1] || /*text*/ l[0]) + '',
    n
  return {
    c() {
      ;(e = D('div')), (n = re(t)), g(e, 'class', 'wx-label x2-agyr5c')
    },
    m(i, s) {
      S(i, e, s), H(e, n)
    },
    p(i, s) {
      s & /*value, text*/ 3 && t !== (t = /*value*/ (i[1] || /*text*/ i[0]) + '') && me(n, t)
    },
    i: I,
    o: I,
    d(i) {
      i && v(e)
    },
  }
}
function S_(l) {
  let e, t
  const n = /*#slots*/ l[4].default,
    i = Ie(n, l, /*$$scope*/ l[3], null)
  return {
    c() {
      ;(e = D('div')), i && i.c(), g(e, 'class', 'wx-label x2-agyr5c')
    },
    m(s, o) {
      S(s, e, o), i && i.m(e, null), (t = !0)
    },
    p(s, o) {
      i &&
        i.p &&
        (!t || o & /*$$scope*/ 8) &&
        Oe(
          i,
          n,
          s,
          /*$$scope*/ s[3],
          t ? Re(n, /*$$scope*/ s[3], o, null) : Ae(/*$$scope*/ s[3]),
          null
        )
    },
    i(s) {
      t || (k(i, s), (t = !0))
    },
    o(s) {
      y(i, s), (t = !1)
    },
    d(s) {
      s && v(e), i && i.d(s)
    },
  }
}
function M_(l) {
  let e, t, n, i
  const s = [S_, v_],
    o = []
  function a(r, c) {
    return /*SLOTS*/ r[2] ? 0 : 1
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, _ref100) {
        let [c] = _ref100
        t.p(r, c)
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function T_(l, e, t) {
  let {$$slots: n = {}, $$scope: i} = e,
    {text: s} = e,
    {value: o} = e
  const a = e.$$slots
  return (
    (l.$$set = (r) => {
      t(5, (e = We(We({}, e), qe(r)))),
        'text' in r && t(0, (s = r.text)),
        'value' in r && t(1, (o = r.value)),
        '$$scope' in r && t(3, (i = r.$$scope))
    }),
    (e = qe(e)),
    [s, o, a, i, n]
  )
}
class C_ extends ee {
  constructor(e) {
    super(), $(this, e, T_, M_, x, {text: 0, value: 1})
  }
}
function D_(l) {
  let e, t
  return (
    (e = new mn({
      props: {
        icon: /*icon*/ l[0],
        type: /*type*/ l[3],
        css: /*css*/ l[2],
        title: /*text*/ l[1],
        disabled: /*disabled*/ l[4],
      },
    })),
    e.$on('click', /*click_handler_1*/ l[7]),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, i) {
        const s = {}
        i & /*icon*/ 1 && (s.icon = /*icon*/ n[0]),
          i & /*type*/ 8 && (s.type = /*type*/ n[3]),
          i & /*css*/ 4 && (s.css = /*css*/ n[2]),
          i & /*text*/ 2 && (s.title = /*text*/ n[1]),
          i & /*disabled*/ 16 && (s.disabled = /*disabled*/ n[4]),
          e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function W_(l) {
  let e,
    t,
    n,
    i,
    s,
    o = /*icon*/ l[0] && so(l)
  return {
    c() {
      ;(e = D('div')),
        o && o.c(),
        (t = Y()),
        (n = re(/*text*/ l[1])),
        g(e, 'class', 'wx-item x2-ng2v87')
    },
    m(a, r) {
      S(a, e, r),
        o && o.m(e, null),
        H(e, t),
        H(e, n),
        i || ((s = q(e, 'click', /*click_handler*/ l[6])), (i = !0))
    },
    p(a, r) {
      /*icon*/ a[0] ? (o ? o.p(a, r) : ((o = so(a)), o.c(), o.m(e, t))) : o && (o.d(1), (o = null)),
        r & /*text*/ 2 && me(n, /*text*/ a[1])
    },
    i: I,
    o: I,
    d(a) {
      a && v(e), o && o.d(), (i = !1), s()
    },
  }
}
function so(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')), g(e, 'class', (t = /*icon*/ l[0] + ' ' + /*css*/ l[2] + ' x2-ng2v87'))
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*icon, css*/ 5 &&
        t !== (t = /*icon*/ n[0] + ' ' + /*css*/ n[2] + ' x2-ng2v87') &&
        g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function H_(l) {
  let e, t, n, i
  const s = [W_, D_],
    o = []
  function a(r, c) {
    return /*menu*/ r[5] ? 0 : 1
  }
  return (
    (e = a(l)),
    (t = o[e] = s[e](l)),
    {
      c() {
        t.c(), (n = se())
      },
      m(r, c) {
        o[e].m(r, c), S(r, n, c), (i = !0)
      },
      p(r, _ref101) {
        let [c] = _ref101
        let u = e
        ;(e = a(r)),
          e === u
            ? o[e].p(r, c)
            : (te(),
              y(o[u], 1, 1, () => {
                o[u] = null
              }),
              ne(),
              (t = o[e]),
              t ? t.p(r, c) : ((t = o[e] = s[e](r)), t.c()),
              k(t, 1),
              t.m(n.parentNode, n))
      },
      i(r) {
        i || (k(t), (i = !0))
      },
      o(r) {
        y(t), (i = !1)
      },
      d(r) {
        r && v(n), o[e].d(r)
      },
    }
  )
}
function z_(l, e, t) {
  let {icon: n} = e,
    {text: i} = e,
    {css: s} = e,
    {type: o} = e,
    {disabled: a} = e,
    {menu: r} = e
  function c(f) {
    De.call(this, l, f)
  }
  function u(f) {
    De.call(this, l, f)
  }
  return (
    (l.$$set = (f) => {
      'icon' in f && t(0, (n = f.icon)),
        'text' in f && t(1, (i = f.text)),
        'css' in f && t(2, (s = f.css)),
        'type' in f && t(3, (o = f.type)),
        'disabled' in f && t(4, (a = f.disabled)),
        'menu' in f && t(5, (r = f.menu))
    }),
    [n, i, s, o, a, r, c, u]
  )
}
class N_ extends ee {
  constructor(e) {
    super(), $(this, e, z_, H_, x, {icon: 0, text: 1, css: 2, type: 3, disabled: 4, menu: 5})
  }
}
function oo(l) {
  let e, t
  return {
    c() {
      ;(e = D('i')), g(e, 'class', (t = Ve(/*icon*/ l[2]) + ' x2-g7c8cw'))
    },
    m(n, i) {
      S(n, e, i)
    },
    p(n, i) {
      i & /*icon*/ 4 && t !== (t = Ve(/*icon*/ n[2]) + ' x2-g7c8cw') && g(e, 'class', t)
    },
    d(n) {
      n && v(e)
    },
  }
}
function L_(l) {
  let e,
    t,
    n,
    i,
    s,
    o,
    a = /*icon*/ l[2] && oo(l)
  return {
    c() {
      ;(e = D('div')),
        a && a.c(),
        (t = Y()),
        (n = re(/*text*/ l[0])),
        g(e, 'class', (i = 'wx-label ' + /*css*/ l[1] + ' x2-g7c8cw'))
    },
    m(r, c) {
      S(r, e, c),
        a && a.m(e, null),
        H(e, t),
        H(e, n),
        s || ((o = q(e, 'click', /*handleClick*/ l[3])), (s = !0))
    },
    p(r, _ref102) {
      let [c] = _ref102
      /*icon*/ r[2] ? (a ? a.p(r, c) : ((a = oo(r)), a.c(), a.m(e, t))) : a && (a.d(1), (a = null)),
        c & /*text*/ 1 && me(n, /*text*/ r[0]),
        c & /*css*/ 2 && i !== (i = 'wx-label ' + /*css*/ r[1] + ' x2-g7c8cw') && g(e, 'class', i)
    },
    i: I,
    o: I,
    d(r) {
      r && v(e), a && a.d(), (s = !1), o()
    },
  }
}
function E_(l, e, t) {
  const n = He()
  let {id: i = ''} = e,
    {text: s = ''} = e,
    {css: o = ''} = e,
    {icon: a = ''} = e
  function r() {
    n('click', {id: i})
  }
  return (
    (l.$$set = (c) => {
      'id' in c && t(4, (i = c.id)),
        'text' in c && t(0, (s = c.text)),
        'css' in c && t(1, (o = c.css)),
        'icon' in c && t(2, (a = c.icon))
    }),
    [s, o, a, r, i]
  )
}
class I_ extends ee {
  constructor(e) {
    super(), $(this, e, E_, L_, x, {id: 4, text: 0, css: 1, icon: 2})
  }
}
tn('button', y_)
tn('separator', ur)
tn('spacer', fr)
tn('label', C_)
tn('item', I_)
tn('icon', N_)
function R_(l) {
  let e, t
  return (
    (e = new g_({props: {items: /*buttons*/ l[1]}})),
    {
      c() {
        F(e.$$.fragment)
      },
      m(n, i) {
        R(e, n, i), (t = !0)
      },
      p(n, _ref103) {
        let [i] = _ref103
        const s = {}
        i & /*buttons*/ 2 && (s.items = /*buttons*/ n[1]), e.$set(s)
      },
      i(n) {
        t || (k(e.$$.fragment, n), (t = !0))
      },
      o(n) {
        y(e.$$.fragment, n), (t = !1)
      },
      d(n) {
        O(e, n)
      },
    }
  )
}
function O_(l, e, t) {
  let n,
    i = I,
    s = () => (i(), (i = Lt(w, (p) => t(8, (n = p)))), w),
    o,
    a = I,
    r = () => (a(), (a = Lt(m, (p) => t(6, (o = p)))), m)
  l.$$.on_destroy.push(() => i()), l.$$.on_destroy.push(() => a())
  let {api: c = null} = e,
    {items: u = [...sd]} = e,
    f = ze('wx-i18n')
  f || ((f = On(dl)), It('wx-i18n', f))
  const d = ze('wx-i18n').getGroup('gantt')
  u = u.map(
    (p) => (
      (p = {...p}),
      (p.handler = (z) => {
        xo(c, z.id, null, d), b()
      }),
      p.text && (p.text = d(p.text)),
      p.menuText && (p.menuText = d(p.menuText)),
      p
    )
  )
  let h, m, _, w
  function b() {
    t(3, (u = u.map((p) => ({...p, disabled: !1})))),
      o?.length
        ? t(
            1,
            (_ = u.map((p) => {
              if (!p.check) return p
              const z = o.some((T) => !p.check(T, n))
              return {...p, disabled: z}
            }))
          )
        : t(1, (_ = [u[0]]))
  }
  return (
    (l.$$set = (p) => {
      'api' in p && t(4, (c = p.api)), 'items' in p && t(3, (u = p.items))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*api, rState, items*/ 56 &&
        (c
          ? (t(5, (h = c.getReactiveState())),
            r(t(0, (m = h._selected))),
            s(t(2, (w = h._tasks))),
            b())
          : t(1, (_ = [u[0]]))),
        l.$$.dirty & /*$rSelected*/ 64 && b()
    }),
    [m, _, w, u, c, h, o]
  )
}
class gg extends ee {
  constructor(e) {
    super(), $(this, e, O_, R_, x, {api: 4, items: 3})
  }
}
function A_(l) {
  let e, t, n, i, s, o, a
  function r(d) {
    l[18](d)
  }
  let c = {
    filter: /*filterMenu*/ l[9],
    options: /*cOptions*/ l[6],
    dataKey: 'id',
    resolver: /*itemResolver*/ l[7],
    at: /*at*/ l[1],
  }
  /*handler*/ l[0] !== void 0 && (c.handler = /*handler*/ l[0]),
    (e = new _m({props: c})),
    be.push(() => rt(e, 'handler', r)),
    e.$on('click', /*menuAction*/ l[8])
  const u = /*#slots*/ l[17].default,
    f = Ie(u, l, /*$$scope*/ l[16], null)
  return {
    c() {
      F(e.$$.fragment), (n = Y()), (i = D('span')), f && f.c(), g(i, 'data-menu-ignore', 'true')
    },
    m(d, h) {
      R(e, d, h),
        S(d, n, h),
        S(d, i, h),
        f && f.m(i, null),
        (s = !0),
        o ||
          ((a = q(i, 'contextmenu', function () {
            ot(/*handler*/ l[0]) && l[0].apply(this, arguments)
          })),
          (o = !0))
    },
    p(d, _ref104) {
      let [h] = _ref104
      l = d
      const m = {}
      h & /*cOptions*/ 64 && (m.options = /*cOptions*/ l[6]),
        h & /*at*/ 2 && (m.at = /*at*/ l[1]),
        !t && h & /*handler*/ 1 && ((t = !0), (m.handler = /*handler*/ l[0]), dt(() => (t = !1))),
        e.$set(m),
        f &&
          f.p &&
          (!s || h & /*$$scope*/ 65536) &&
          Oe(
            f,
            u,
            l,
            /*$$scope*/ l[16],
            s ? Re(u, /*$$scope*/ l[16], h, null) : Ae(/*$$scope*/ l[16]),
            null
          )
    },
    i(d) {
      s || (k(e.$$.fragment, d), k(f, d), (s = !0))
    },
    o(d) {
      y(e.$$.fragment, d), y(f, d), (s = !1)
    },
    d(d) {
      d && (v(n), v(i)), O(e, d), f && f.d(d), (o = !1), a()
    },
  }
}
function F_(l, e, t) {
  let n,
    i,
    s = I,
    o = () => (s(), (s = Lt(fe, (ie) => t(22, (i = ie)))), fe),
    a,
    r = I,
    c = () => (r(), (r = Lt(V, (ie) => t(23, (a = ie)))), V),
    u,
    f = I,
    d = () => (f(), (f = Lt(B, (ie) => t(24, (u = ie)))), B),
    h,
    m = I,
    _ = () => (m(), (m = Lt(L, (ie) => t(15, (h = ie)))), L)
  l.$$.on_destroy.push(() => s()),
    l.$$.on_destroy.push(() => r()),
    l.$$.on_destroy.push(() => f()),
    l.$$.on_destroy.push(() => m())
  let {$$slots: w = {}, $$scope: b} = e,
    {options: p = [...id]} = e,
    {api: z = null} = e,
    {resolver: T = null} = e,
    {filter: W = null} = e,
    {handler: M = () => {}} = e,
    {at: C = 'point'} = e
  const P = He()
  let X = null,
    A,
    B,
    V,
    fe,
    L,
    Ye,
    G = ze('wx-i18n')
  G || ((G = On({...dl, ...So})), It('wx-i18n', G))
  const pe = ze('wx-i18n').getGroup('gantt')
  function Se() {
    const ie = p.find((U) => U.id === 'convert-task')
    ie &&
      ((ie.data = []),
      u.forEach((U) => {
        ie.data.push(ie.dataFactory(U))
      })),
      t(6, (Ye = K(p)))
  }
  function K(ie) {
    return ie.map(
      (U) => ((U = {...U}), U.text && (U.text = pe(U.text)), U.data && (U.data = K(U.data)), U)
    )
  }
  function ue(ie, U) {
    let ge = ie ? z.getTask(ie) : null
    if (T) {
      const Me = T(ie, U)
      ge = Me === !0 ? ge : Me
    }
    return (
      ge && (a.includes(ge.id) || ((n = [ge]), z.exec('select-task', {id: ge.id})), (X = ge.id)), ge
    )
  }
  function Ne() {
    M()
  }
  function ye(ie) {
    const U = ie.detail.action
    U && (xo(z, U.id, X, pe), P('click', ie.detail))
  }
  function ve(ie, U) {
    let ge = W ? W(ie, U) : !0
    if (ie.check && ge) {
      const Me = n.some((Fe) => !ie.check(Fe, i))
      ie.css = Me ? 'disabled' : ''
    }
    return ge
  }
  function Ze(ie) {
    ;(M = ie), t(0, M)
  }
  return (
    (l.$$set = (ie) => {
      'options' in ie && t(10, (p = ie.options)),
        'api' in ie && t(11, (z = ie.api)),
        'resolver' in ie && t(12, (T = ie.resolver)),
        'filter' in ie && t(13, (W = ie.filter)),
        'handler' in ie && t(0, (M = ie.handler)),
        'at' in ie && t(1, (C = ie.at)),
        '$$scope' in ie && t(16, (b = ie.$$scope))
    }),
    (l.$$.update = () => {
      l.$$.dirty & /*api, rState, handler*/ 18433 &&
        z &&
        (t(14, (A = z.getReactiveState())),
        d(t(2, (B = A.taskTypes))),
        o(t(4, (fe = A._tasks))),
        c(t(3, (V = A.selected))),
        _(t(5, (L = A._selected))),
        Se(),
        z.on('scroll-chart', () => Ne()),
        z.on('drag-task', () => {
          M()
        })),
        l.$$.dirty & /*$rSelectedTasks*/ 32768 && (n = h || [])
    }),
    [M, C, B, V, fe, L, Ye, ue, ye, ve, p, z, T, W, A, h, b, w, Ze]
  )
}
class wg extends ee {
  constructor(e) {
    super(),
      $(this, e, F_, A_, x, {options: 10, api: 11, resolver: 12, filter: 13, handler: 0, at: 1})
  }
}
function og(l) {
  let e, t
  return {
    c() {
      ;(e = new ol(!1)), (t = se()), (e.a = t)
    },
    m(n, i) {
      e.m(/*html*/ l[0], n, i), S(n, t, i)
    },
    p(n, _ref109) {
      let [i] = _ref109
      i & /*html*/ 1 && e.p(/*html*/ n[0])
    },
    i: I,
    o: I,
    d(n) {
      n && (v(t), e.d())
    },
  }
}
function rg(l, e, t) {
  let {html: n = ''} = e
  return (
    (l.$$set = (i) => {
      'html' in i && t(0, (n = i.html))
    }),
    [n]
  )
}
class vg extends ee {
  constructor(e) {
    super(), $(this, e, rg, og, x, {html: 0})
  }
}

class EventBusRouter {
  constructor(dispatch) {
    this._nextHandler = null
    this._dispatch = dispatch
    this.exec = this.exec.bind(this)
  }
  async exec(name, ev) {
    const res = await this._dispatch(name, ev)
    if (res && this._nextHandler) await this._nextHandler.exec(name, ev)
    return ev
  }
  setNext(next) {
    return (this._nextHandler = next)
  }
}

function toStringExpensive(r) {
  let content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ''
  if (typeof r === 'string') return r
  else if (typeof r?.type === 'function') r = r?.type(r.props)
  else if (typeof r?.type === 'string') {
    content += buildTag(r)
    if (r?.props?.children) {
      if (Array.isArray(r?.props?.children)) {
        r?.props?.children?.forEach((child) => {
          content += toStringExpensive(child)
        })
      } else {
        content += toStringExpensive(r?.props?.children)
      }
    }
    content += `</${r.type}>`
  } else if (r?.props?.children) {
    if (Array.isArray(r?.props?.children)) {
      r?.props?.children.forEach((child) => {
        content += toStringExpensive(child)
      })
    } else {
      content += toStringExpensive(r?.props?.children)
    }
  }
  return content
}

// const cache = new Map();

function buildTag(r) {
  let tag = `<${r.type}`
  for (const key in r.props) {
    if (key === 'children') continue
    if (key === 'style') {
      tag += ` style="`
      for (const style in r.props.style) {
        tag += `${style}:${r.props.style[style]};`
      }
      tag += `"`
    }
    // if (key === "onClick") {
    // const fn = r.props[key];
    // const name = cache[fn];
    // if (!name) {
    //   const id = Math.random().toString(36).substring(7);
    //   cache[fn] = id;
    //   window[id] = fn;
    // }
    // tag += ` onclick="window['${cache[fn]}'](event)"`;
    // } else
    if (key === 'className') tag += ` class="${r.props[key]}"`
    else tag += ` ${key}="${r.props[key]}"`
  }
  tag += '>'
  return tag
}
function template(template, host) {
  return new Proxy(host, {
    construct(target, _ref) {
      let [config] = _ref
      const props = config.props || {}
      props.html = toStringExpensive(template(config.props))
      config.props = props
      return new target(config)
    },
  })
}

var jsxRuntime = {exports: {}}

var reactJsxRuntime_production_min = {}

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min

function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min
  hasRequiredReactJsxRuntime_production_min = 1
  var f = require$$0,
    k = Symbol.for('react.element'),
    l = Symbol.for('react.fragment'),
    m = Object.prototype.hasOwnProperty,
    n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    p = {key: !0, ref: !0, __self: !0, __source: !0}
  function q(c, a, g) {
    var b,
      d = {},
      e = null,
      h = null
    void 0 !== g && (e = '' + g)
    void 0 !== a.key && (e = '' + a.key)
    void 0 !== a.ref && (h = a.ref)
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b])
    if (c && c.defaultProps) for (b in ((a = c.defaultProps), a)) void 0 === d[b] && (d[b] = a[b])
    return {$$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current}
  }
  reactJsxRuntime_production_min.Fragment = l
  reactJsxRuntime_production_min.jsx = q
  reactJsxRuntime_production_min.jsxs = q
  return reactJsxRuntime_production_min
}

var reactJsxRuntime_development = {}

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development

function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development
  hasRequiredReactJsxRuntime_development = 1

  if (process.env.NODE_ENV !== 'production') {
    ;(function () {
      var React = require$$0

      // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types.
      var REACT_ELEMENT_TYPE = Symbol.for('react.element')
      var REACT_PORTAL_TYPE = Symbol.for('react.portal')
      var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment')
      var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode')
      var REACT_PROFILER_TYPE = Symbol.for('react.profiler')
      var REACT_PROVIDER_TYPE = Symbol.for('react.provider')
      var REACT_CONTEXT_TYPE = Symbol.for('react.context')
      var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref')
      var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense')
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list')
      var REACT_MEMO_TYPE = Symbol.for('react.memo')
      var REACT_LAZY_TYPE = Symbol.for('react.lazy')
      var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen')
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator
      var FAUX_ITERATOR_SYMBOL = '@@iterator'
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null
        }

        var maybeIterator =
          (MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL]) ||
          maybeIterable[FAUX_ITERATOR_SYMBOL]

        if (typeof maybeIterator === 'function') {
          return maybeIterator
        }

        return null
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED

      function error(format) {
        {
          {
            for (
              var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1;
              _key2 < _len2;
              _key2++
            ) {
              args[_key2 - 1] = arguments[_key2]
            }

            printWarning('error', format, args)
          }
        }
      }

      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame
          var stack = ReactDebugCurrentFrame.getStackAddendum()

          if (stack !== '') {
            format += '%s'
            args = args.concat([stack])
          }

          var argsWithFormat = args.map(function (item) {
            return String(item)
          }) // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format) // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610

          Function.prototype.apply.call(console[level], console, argsWithFormat)
        }
      }

      // -----------------------------------------------------------------------------

      var enableScopeAPI = false // Experimental Create Event Handle API.
      var enableCacheElement = false
      var enableTransitionTracing = false // No known bugs, but needs performance testing

      var enableLegacyHidden = false // Enables unstable_avoidThisFallback feature in Fiber
      // stuff. Intended to enable React core members to more easily debug scheduling
      // issues in DEV builds.

      var enableDebugTracing = false // Track which Fiber(s) schedule render work.

      var REACT_MODULE_REFERENCE

      {
        REACT_MODULE_REFERENCE = Symbol.for('react.module.reference')
      }

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

        if (
          type === REACT_FRAGMENT_TYPE ||
          type === REACT_PROFILER_TYPE ||
          enableDebugTracing ||
          type === REACT_STRICT_MODE_TYPE ||
          type === REACT_SUSPENSE_TYPE ||
          type === REACT_SUSPENSE_LIST_TYPE ||
          enableLegacyHidden ||
          type === REACT_OFFSCREEN_TYPE ||
          enableScopeAPI ||
          enableCacheElement ||
          enableTransitionTracing
        ) {
          return true
        }

        if (typeof type === 'object' && type !== null) {
          if (
            type.$$typeof === REACT_LAZY_TYPE ||
            type.$$typeof === REACT_MEMO_TYPE ||
            type.$$typeof === REACT_PROVIDER_TYPE ||
            type.$$typeof === REACT_CONTEXT_TYPE ||
            type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE ||
            type.getModuleId !== undefined
          ) {
            return true
          }
        }

        return false
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName

        if (displayName) {
          return displayName
        }

        var functionName = innerType.displayName || innerType.name || ''
        return functionName !== '' ? wrapperName + '(' + functionName + ')' : wrapperName
      } // Keep in sync with react-reconciler/getComponentNameFromFiber

      function getContextName(type) {
        return type.displayName || 'Context'
      } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

      function getComponentNameFromType(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null
        }

        {
          if (typeof type.tag === 'number') {
            error(
              'Received an unexpected object in getComponentNameFromType(). ' +
                'This is likely a bug in React. Please file an issue.'
            )
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null
        }

        if (typeof type === 'string') {
          return type
        }

        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment'

          case REACT_PORTAL_TYPE:
            return 'Portal'

          case REACT_PROFILER_TYPE:
            return 'Profiler'

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode'

          case REACT_SUSPENSE_TYPE:
            return 'Suspense'

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList'
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type
              return getContextName(context) + '.Consumer'

            case REACT_PROVIDER_TYPE:
              var provider = type
              return getContextName(provider._context) + '.Provider'

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef')

            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null

              if (outerName !== null) {
                return outerName
              }

              return getComponentNameFromType(type.type) || 'Memo'

            case REACT_LAZY_TYPE: {
              var lazyComponent = type
              var payload = lazyComponent._payload
              var init = lazyComponent._init

              try {
                return getComponentNameFromType(init(payload))
              } catch (x) {
                return null
              }
            }

            // eslint-disable-next-line no-fallthrough
          }
        }

        return null
      }

      var assign = Object.assign

      // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.
      var disabledDepth = 0
      var prevLog
      var prevInfo
      var prevWarn
      var prevError
      var prevGroup
      var prevGroupCollapsed
      var prevGroupEnd

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log
            prevInfo = console.info
            prevWarn = console.warn
            prevError = console.error
            prevGroup = console.group
            prevGroupCollapsed = console.groupCollapsed
            prevGroupEnd = console.groupEnd // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true,
            } // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props,
            })
          }

          disabledDepth++
        }
      }
      function reenableLogs() {
        {
          disabledDepth--

          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true,
            } // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog,
              }),
              info: assign({}, props, {
                value: prevInfo,
              }),
              warn: assign({}, props, {
                value: prevWarn,
              }),
              error: assign({}, props, {
                value: prevError,
              }),
              group: assign({}, props, {
                value: prevGroup,
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed,
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd,
              }),
            })
          }

          if (disabledDepth < 0) {
            error(
              'disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.'
            )
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher
      var prefix
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error()
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/)
              prefix = (match && match[1]) || ''
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.

          return '\n' + prefix + name
        }
      }
      var reentry = false
      var componentFrameCache

      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map
        componentFrameCache = new PossiblyWeakMap()
      }

      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return ''
        }

        {
          var frame = componentFrameCache.get(fn)

          if (frame !== undefined) {
            return frame
          }
        }

        var control
        reentry = true
        var previousPrepareStackTrace = Error.prepareStackTrace // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined
        var previousDispatcher

        {
          previousDispatcher = ReactCurrentDispatcher.current // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null
          disableLogs()
        }

        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function () {
              throw Error()
            } // $FlowFixMe

            Object.defineProperty(Fake.prototype, 'props', {
              set: function () {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error()
              },
            })

            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, [])
              } catch (x) {
                control = x
              }

              Reflect.construct(fn, [], Fake)
            } else {
              try {
                Fake.call()
              } catch (x) {
                control = x
              }

              fn.call(Fake.prototype)
            }
          } else {
            try {
              throw Error()
            } catch (x) {
              control = x
            }

            fn()
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n')
            var controlLines = control.stack.split('\n')
            var s = sampleLines.length - 1
            var c = controlLines.length - 1

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--
                    c-- // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ') // If our component frame is labeled "<anonymous>"
                      // but we have a user-provided "displayName"
                      // splice it in to make the stack more readable.

                      if (fn.displayName && _frame.includes('<anonymous>')) {
                        _frame = _frame.replace('<anonymous>', fn.displayName)
                      }

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame)
                        }
                      } // Return the line we found.

                      return _frame
                    }
                  } while (s >= 1 && c >= 0)
                }

                break
              }
            }
          }
        } finally {
          reentry = false

          {
            ReactCurrentDispatcher.current = previousDispatcher
            reenableLogs()
          }

          Error.prepareStackTrace = previousPrepareStackTrace
        } // Fallback to just using the name if we couldn't make it throw.

        var name = fn ? fn.displayName || fn.name : ''
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : ''

        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame)
          }
        }

        return syntheticFrame
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false)
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype
        return !!(prototype && prototype.isReactComponent)
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return ''
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type))
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type)
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense')

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList')
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render)

            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn)

            case REACT_LAZY_TYPE: {
              var lazyComponent = type
              var payload = lazyComponent._payload
              var init = lazyComponent._init

              try {
                // Lazy may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn)
              } catch (x) {}
            }
          }
        }

        return ''
      }

      var hasOwnProperty = Object.prototype.hasOwnProperty

      var loggedTypeFailures = {}
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner
            var stack = describeUnknownElementTypeFrameInDEV(
              element.type,
              element._source,
              owner ? owner.type : null
            )
            ReactDebugCurrentFrame.setExtraStackFrame(stack)
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null)
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(hasOwnProperty)

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0 // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  var err = Error(
                    (componentName || 'React class') +
                      ': ' +
                      location +
                      ' type `' +
                      typeSpecName +
                      '` is invalid; ' +
                      'it must be a function, usually from the `prop-types` package, but received `' +
                      typeof typeSpecs[typeSpecName] +
                      '`.' +
                      'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
                  )
                  err.name = 'Invariant Violation'
                  throw err
                }

                error$1 = typeSpecs[typeSpecName](
                  values,
                  typeSpecName,
                  componentName,
                  location,
                  null,
                  'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED'
                )
              } catch (ex) {
                error$1 = ex
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element)

                error(
                  '%s: type specification of %s' +
                    ' `%s` is invalid; the type checker ' +
                    'function must return `null` or an `Error` but returned a %s. ' +
                    'You may have forgotten to pass an argument to the type checker ' +
                    'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
                    'shape all require an argument).',
                  componentName || 'React class',
                  location,
                  typeSpecName,
                  typeof error$1
                )

                setCurrentlyValidatingElement(null)
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true
                setCurrentlyValidatingElement(element)

                error('Failed %s type: %s', location, error$1.message)

                setCurrentlyValidatingElement(null)
              }
            }
          }
        }
      }

      var isArrayImpl = Array.isArray // eslint-disable-next-line no-redeclare

      function isArray(a) {
        return isArrayImpl(a)
      }

      /*
       * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
       * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
       *
       * The functions in this module will throw an easier-to-understand,
       * easier-to-debug exception with a clear errors message message explaining the
       * problem. (Instead of a confusing exception thrown inside the implementation
       * of the `value` object).
       */
      // $FlowFixMe only called in DEV, so void return is not possible.
      function typeName(value) {
        {
          // toStringTag is needed for namespaced types like Temporal.Instant
          var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag
          var type =
            (hasToStringTag && value[Symbol.toStringTag]) || value.constructor.name || 'Object'
          return type
        }
      } // $FlowFixMe only called in DEV, so void return is not possible.

      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value)
            return false
          } catch (e) {
            return true
          }
        }
      }

      function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //

        return '' + value
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error(
              'The provided key is an unsupported type %s.' +
                ' This value must be coerced to a string before before using it here.',
              typeName(value)
            )

            return testStringCoercion(value) // throw (to help callers find troubleshooting comments)
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true,
      }
      var specialPropKeyWarningShown
      var specialPropRefWarningShown
      var didWarnAboutStringRefs

      {
        didWarnAboutStringRefs = {}
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get

            if (getter && getter.isReactWarning) {
              return false
            }
          }
        }

        return config.ref !== undefined
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get

            if (getter && getter.isReactWarning) {
              return false
            }
          }
        }

        return config.key !== undefined
      }

      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (
            typeof config.ref === 'string' &&
            ReactCurrentOwner.current &&
            self &&
            ReactCurrentOwner.current.stateNode !== self
          ) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type)

            if (!didWarnAboutStringRefs[componentName]) {
              error(
                'Component "%s" contains the string ref "%s". ' +
                  'Support for string refs will be removed in a future major release. ' +
                  'This case cannot be automatically converted to an arrow function. ' +
                  'We ask you to manually fix this case by using useRef() or createRef() instead. ' +
                  'Learn more about using refs safely here: ' +
                  'https://reactjs.org/link/strict-mode-string-ref',
                getComponentNameFromType(ReactCurrentOwner.current.type),
                config.ref
              )

              didWarnAboutStringRefs[componentName] = true
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function () {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true

              error(
                '%s: `key` is not a prop. Trying to access it will result ' +
                  'in `undefined` being returned. If you need to access the same ' +
                  'value within the child component, you should pass it as a different ' +
                  'prop. (https://reactjs.org/link/special-props)',
                displayName
              )
            }
          }

          warnAboutAccessingKey.isReactWarning = true
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true,
          })
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function () {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true

              error(
                '%s: `ref` is not a prop. Trying to access it will result ' +
                  'in `undefined` being returned. If you need to access the same ' +
                  'value within the child component, you should pass it as a different ' +
                  'prop. (https://reactjs.org/link/special-props)',
                displayName
              )
            }
          }

          warnAboutAccessingRef.isReactWarning = true
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true,
          })
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */

      var ReactElement = function (type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner,
        }

        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {} // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false,
          }) // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self,
          }) // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source,
          })

          if (Object.freeze) {
            Object.freeze(element.props)
            Object.freeze(element)
          }
        }

        return element
      }
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */

      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName // Reserved names are extracted

          var props = {}
          var key = null
          var ref = null // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            {
              checkKeyStringCoercion(maybeKey)
            }

            key = '' + maybeKey
          }

          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key)
            }

            key = '' + config.key
          }

          if (hasValidRef(config)) {
            ref = config.ref
            warnIfStringRefCannotBeAutoConverted(config, self)
          } // Remaining properties are added to a new props object

          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName]
            }
          } // Resolve default props

          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps

            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName]
              }
            }
          }

          if (key || ref) {
            var displayName =
              typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type

            if (key) {
              defineKeyPropWarningGetter(props, displayName)
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName)
            }
          }

          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props)
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner
            var stack = describeUnknownElementTypeFrameInDEV(
              element.type,
              element._source,
              owner ? owner.type : null
            )
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack)
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null)
          }
        }
      }

      var propTypesMisspellWarningShown

      {
        propTypesMisspellWarningShown = false
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return (
            typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE
          )
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type)

            if (name) {
              return '\n\nCheck the render method of `' + name + '`.'
            }
          }

          return ''
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          return ''
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */

      var ownerHasKeyUseWarning = {}

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum()

          if (!info) {
            var parentName =
              typeof parentType === 'string'
                ? parentType
                : parentType.displayName || parentType.name

            if (parentName) {
              info = '\n\nCheck the top-level render call using <' + parentName + '>.'
            }
          }

          return info
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */

      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return
          }

          element._store.validated = true
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType)

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = ''

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner =
              ' It was passed a child from ' + getComponentNameFromType(element._owner.type) + '.'
          }

          setCurrentlyValidatingElement$1(element)

          error(
            'Each child in a list should have a unique "key" prop.' +
              '%s%s See https://reactjs.org/link/warning-keys for more information.',
            currentComponentErrorInfo,
            childOwner
          )

          setCurrentlyValidatingElement$1(null)
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */

      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return
          }

          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i]

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType)
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node)

            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node)
                var step

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType)
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */

      function validatePropTypes(element) {
        {
          var type = element.type

          if (type === null || type === undefined || typeof type === 'string') {
            return
          }

          var propTypes

          if (typeof type === 'function') {
            propTypes = type.propTypes
          } else if (
            typeof type === 'object' &&
            (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
              // Inner props are checked in the reconciler.
              type.$$typeof === REACT_MEMO_TYPE)
          ) {
            propTypes = type.propTypes
          } else {
            return
          }

          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type)
            checkPropTypes(propTypes, element.props, 'prop', name, element)
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentNameFromType(type)

            error(
              'Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?',
              _name || 'Unknown'
            )
          }

          if (
            typeof type.getDefaultProps === 'function' &&
            !type.getDefaultProps.isReactClassApproved
          ) {
            error(
              'getDefaultProps is only used on classic React.createClass ' +
                'definitions. Use a static property named `defaultProps` instead.'
            )
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */

      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props)

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i]

            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment)

              error(
                'Invalid prop `%s` supplied to `React.Fragment`. ' +
                  'React.Fragment can only have `key` and `children` props.',
                key
              )

              setCurrentlyValidatingElement$1(null)
              break
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment)

            error('Invalid attribute `ref` supplied to `React.Fragment`.')

            setCurrentlyValidatingElement$1(null)
          }
        }
      }

      var didWarnAboutKeySpread = {}
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type) // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = ''

            if (
              type === undefined ||
              (typeof type === 'object' && type !== null && Object.keys(type).length === 0)
            ) {
              info +=
                ' You likely forgot to export your component from the file ' +
                "it's defined in, or you might have mixed up default and named imports."
            }

            var sourceInfo = getSourceInfoErrorAddendum()

            if (sourceInfo) {
              info += sourceInfo
            } else {
              info += getDeclarationErrorAddendum()
            }

            var typeString

            if (type === null) {
              typeString = 'null'
            } else if (isArray(type)) {
              typeString = 'array'
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = '<' + (getComponentNameFromType(type.type) || 'Unknown') + ' />'
              info = ' Did you accidentally export a JSX literal instead of a component?'
            } else {
              typeString = typeof type
            }

            error(
              'React.jsx: type is invalid -- expected a string (for ' +
                'built-in components) or a class/function (for composite ' +
                'components) but got: %s.%s',
              typeString,
              info
            )
          }

          var element = jsxDEV(type, props, key, source, self) // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)

          if (validType) {
            var children = props.children

            if (children !== undefined) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type)
                  }

                  if (Object.freeze) {
                    Object.freeze(children)
                  }
                } else {
                  error(
                    'React.jsx: Static children should always be an array. ' +
                      'You are likely explicitly calling React.jsxs or React.jsxDEV. ' +
                      'Use the Babel transform instead.'
                  )
                }
              } else {
                validateChildKeys(children, type)
              }
            }
          }

          {
            if (hasOwnProperty.call(props, 'key')) {
              var componentName = getComponentNameFromType(type)
              var keys = Object.keys(props).filter(function (k) {
                return k !== 'key'
              })
              var beforeExample =
                keys.length > 0
                  ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}'
                  : '{key: someKey}'

              if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}'

                error(
                  'A props object containing a "key" prop is being spread into JSX:\n' +
                    '  let props = %s;\n' +
                    '  <%s {...props} />\n' +
                    'React keys must be passed directly to JSX without using spread:\n' +
                    '  let props = %s;\n' +
                    '  <%s key={someKey} {...props} />',
                  beforeExample,
                  componentName,
                  afterExample,
                  componentName
                )

                didWarnAboutKeySpread[componentName + beforeExample] = true
              }
            }
          }

          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element)
          } else {
            validatePropTypes(element)
          }

          return element
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.

      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true)
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false)
        }
      }

      var jsx = jsxWithValidationDynamic // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic

      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE
      reactJsxRuntime_development.jsx = jsx
      reactJsxRuntime_development.jsxs = jsxs
    })()
  }
  return reactJsxRuntime_development
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = requireReactJsxRuntime_production_min()
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development()
}

var jsxRuntimeExports = jsxRuntime.exports

/* eslint-disable react-hooks/exhaustive-deps */

function GanttComponent(props) {
  let gantt_container = useRef()
  const ws = useState(() => ({}))[0]
  const [widget, setWidget] = useState(null)
  const once = useRef(false)
  useImperativeHandle(props.api, () => ({
    getState: () => ws.api.getState(),
    getReactiveState: () => ws.api.getReactiveState(),
    getStores: () => ws.api.getStores(),
    exec: (name, data) => ws.api.exec(name, data),
    setNext: (ev) => ws.api.setNext(ev),
    intercept: (name, data) => ws.api.intercept(name, data),
    on: (name, handler) => ws.api.on(name, handler),
    detach: (name, handler) => ws.api.detach(name, handler),
    getTask: (id) => ws.api.getTask(id),
  }))
  // Initialize gantt with props
  useEffect(() => {
    const evs = new EventBusRouter((name, ev) => {
      const camelCase = name.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase())
      const eventName = 'on' + camelCase[0].toUpperCase() + camelCase.slice(1)
      if (props[eventName]) return props[eventName](ev)
      return true
    })
    let obj
    const initProps = {
      ...props,
    }
    if (initProps.taskTemplate && typeof initProps.taskTemplate === 'function') {
      initProps.taskTemplate = template(initProps.taskTemplate, vg)
    }

    const externalContext = new Map([['wx-theme', 'willow']])
    // Create gantt instance
    obj = new mg({
      target: gantt_container.current,
      context: externalContext,
      props: {
        ...initProps,
        init: (a) => {
          ws.api = a
          a.setNext(evs)
          if (props.init) props.init(a)
        },
      },
    })
    setWidget(obj)
    return () => {
      if (obj)
        try {
          obj.$destroy()
        } catch (e) {}
      if (gantt_container.current) gantt_container.current.innerHTML = ''
    }
  }, [])
  const {
    taskTemplate,
    markers,
    taskTypes,
    tasks,
    selected,
    activeTask,
    links,
    scales,
    columns,
    start,
    end,
    lengthUnit,
    cellWidth,
    cellHeight,
    scaleHeight,
    readonly,
    cellBorders,
    editorShape,
    zoom,
    baselines,
    highlightTime,
  } = props
  useEffect(() => {
    if (!once.current) {
      once.current = true
      return
    }
    if (ws.api && widget) {
      // exclude init from props
      const {init, ...updateProps} = props
      if (updateProps.taskTemplate && typeof updateProps.taskTemplate !== 'string')
        updateProps.taskTemplate = template(updateProps.taskTemplate, vg)
      widget.$$set(updateProps)
    }
  }, [
    taskTemplate,
    markers,
    taskTypes,
    tasks,
    selected,
    activeTask,
    links,
    scales,
    columns,
    start,
    end,
    lengthUnit,
    cellWidth,
    cellHeight,
    scaleHeight,
    readonly,
    cellBorders,
    editorShape,
    zoom,
    baselines,
    highlightTime,
  ])
  return /*#__PURE__*/ jsxRuntimeExports.jsx('div', {
    className: props.containerClassName ? ' ' + props.containerClassName : '',
    ref: gantt_container,
    style: {
      height: '100%',
      width: '100%',
    },
  })
}

/* eslint-disable react-hooks/exhaustive-deps */

function ContextMenuComponent(props) {
  let table_container = useRef()
  const [state] = useState({})
  const [widget, setWidget] = useState(null)
  const once = useRef(false)
  useImperativeHandle(
    props.handler,
    () =>
      function (ev) {
        return widget.$$.ctx[widget.$$.props.handler](ev)
      }
  )
  const {api} = props
  useEffect(() => {
    const obj = new wg({
      target: table_container.current,
      props: {
        ...props,
      },
    })
    state.handler = obj.$$.ctx[obj.$$.props.handler]
    if (props.init) props.init(state.handler)
    setWidget(() => obj)
    return () => {
      if (obj)
        try {
          obj.$destroy()
        } catch (e) {}
      if (table_container.current) table_container.current.innerHTML = ''
    }
  }, [api])
  useEffect(() => {
    if (!once.current) {
      once.current = true
      return
    }
    if (api && widget) {
      // exclude init from props
      const {init, ...updateProps} = props
      widget.$$set(updateProps)
    }
  }, [api])
  return /*#__PURE__*/ jsxRuntimeExports.jsx('div', {
    className: 'wx-willow-theme',
    ref: table_container,
  })
}

/* eslint-disable react-hooks/exhaustive-deps */

function ToolbarComponent(props) {
  let table_container = useRef()
  const [state] = useState({})
  const [widget, setWidget] = useState(null)
  const once = useRef(false)
  useImperativeHandle(
    props.open,
    () =>
      function (ev) {
        return widget.$$.ctx[widget.$$.props.open](ev)
      }
  )
  useEffect(() => {
    const obj = new gg({
      target: table_container.current,
      props: {
        ...props,
      },
    })
    state.open = obj.$$.ctx[obj.$$.props.open]
    if (props.init) props.init(state.open)
    setWidget(() => obj)
    return () => {
      if (obj)
        try {
          obj.$destroy()
        } catch (e) {}
      if (table_container.current) table_container.current.innerHTML = ''
    }
  }, [])
  const {api} = props
  useEffect(() => {
    if (!once.current) {
      once.current = true
      return
    }
    if (api && widget) {
      // exclude init from props
      const {init, ...updateProps} = props
      widget.$$set(updateProps)
    }
  }, [api])
  return /*#__PURE__*/ jsxRuntimeExports.jsx('div', {
    ref: table_container,
  })
}

function Willow(props) {
  if (!props.children) return
  return /*#__PURE__*/ jsxRuntimeExports.jsx('div', {
    className: 'wx-willow-theme',
    style: {
      height: '100%',
    },
    children: props.children,
  })
}

export {
  ContextMenuComponent as ContextMenu,
  GanttComponent as Chart,
  ToolbarComponent as Toolbar,
  Willow,
  Willow as WillowDark,
  Gf as defaultColumns,
  Qo as defaultEditorShape,
  id as defaultMenuOptions,
  sd as defaultToolbarButtons,
}
